(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8480],{

/***/ 11534:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/2D-front.10386668.svg","height":30,"width":21});

/***/ }),

/***/ 10108:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/2D-plan.e3ef5f8e.svg","height":30,"width":21});

/***/ }),

/***/ 3089:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/2D-side.8db96089.svg","height":30,"width":21});

/***/ }),

/***/ 59363:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/3D-BIM.97bd8cd9.svg","height":30,"width":21});

/***/ }),

/***/ 65317:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/3D.ed0a4d74.svg","height":30,"width":20});

/***/ }),

/***/ 24425:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/cutout.a8f7a575.svg","height":30,"width":21});

/***/ }),

/***/ 20822:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/empty-star.70152174.svg","height":17,"width":17});

/***/ }),

/***/ 41165:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/full-star.9055e288.svg","height":17,"width":17});

/***/ }),

/***/ 56878:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/half-star.dae99d0d.svg","height":17,"width":17});

/***/ }),

/***/ 93056:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/parts-diagram.68741125.svg","height":17,"width":14});

/***/ }),

/***/ 10502:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/warning.42d8cafb.svg","height":20,"width":20});

/***/ }),

/***/ 30525:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Eb": function() { return /* binding */ getAnalyticsData; },
/* harmony export */   "ME": function() { return /* binding */ replaceAddToCartDatalayerPush; },
/* harmony export */   "_D": function() { return /* binding */ gtmAddToCartEvent; },
/* harmony export */   "mw": function() { return /* binding */ addToCompareAnalytics; },
/* harmony export */   "vQ": function() { return /* binding */ quantityOutOfStockAnalytics; }
/* harmony export */ });
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34326);

const getAnalyticsData = function(type, url) {
    let needsJSON = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var ref, ref1, ref2, ref3, ref4;
    const title = type.toLowerCase().trim();
    let eventAction;
    let internalLinkZoneName;
    let internalLinkURL;
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    if (title === "notify me") {
        var ref5;
        internalLinkZoneName = "".concat(page === null || page === void 0 ? void 0 : (ref5 = page.category) === null || ref5 === void 0 ? void 0 : ref5.pageType, ":modal:availability notification");
        eventAction = "".concat(internalLinkZoneName, ":").concat(title);
    } else if (title === "local store or showroom") {
        var ref6;
        eventAction = "".concat(page === null || page === void 0 ? void 0 : (ref6 = page.category) === null || ref6 === void 0 ? void 0 : ref6.pageType, ":product details:add-on services:").concat(title);
        internalLinkURL = "".concat(url.toLowerCase().trim());
    } else if (title === "where to buy") {
        internalLinkURL = "".concat(window.location.origin + url);
    }
    const eventInfo = {
        eventAction: eventAction || "".concat(page === null || page === void 0 ? void 0 : (ref = page.category) === null || ref === void 0 ? void 0 : ref.pageType, ":product details:").concat(title),
        eventName: eventAction || "".concat(page === null || page === void 0 ? void 0 : (ref1 = page.category) === null || ref1 === void 0 ? void 0 : ref1.pageType, ":product details:").concat(title),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "".concat(title),
        internalLinkPosition: "".concat(page === null || page === void 0 ? void 0 : (ref2 = page.category) === null || ref2 === void 0 ? void 0 : ref2.pageType),
        internalLinkType: "".concat(page === null || page === void 0 ? void 0 : (ref3 = page.category) === null || ref3 === void 0 ? void 0 : ref3.pageType, ":").concat(title),
        internalLinkZoneName: internalLinkZoneName || "".concat(page === null || page === void 0 ? void 0 : (ref4 = page.category) === null || ref4 === void 0 ? void 0 : ref4.pageType, ":product details"),
        internalLinkURL: internalLinkURL || "n/a",
        clickInternalLinks: "true"
    };
    if (needsJSON) {
        return eventInfo;
    }
    return JSON.stringify(eventInfo);
};
const replaceAddToCartDatalayerPush = (replaceAddToCartCtaLabel, replaceAddToCartCtaLink, analyticData)=>{
    const eventInfo = getAnalyticsData(replaceAddToCartCtaLabel, replaceAddToCartCtaLink, true);
    const page = window.adobeDataLayer.getState("page");
    analyticData = JSON.parse(analyticData);
    const productInfo = analyticData === null || analyticData === void 0 ? void 0 : analyticData.productInfo;
    window.adobeDataLayer.push({
        event: "cmp:click",
        eventInfo,
        productInfo,
        page
    });
};
const addToCompareAnalytics = (isChecked)=>'{"eventAction":"pdp:product details: '.concat(isChecked ? "remove" : "add to", ' compare","eventName":"pdp:product details: ').concat(isChecked ? "remove" : "add to", ' compare","eventType":"n/a","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"').concat(isChecked ? "remove" : "add to", ' compare","internalLinkPosition":"pdp","internalLinkType":"pdp:').concat(isChecked ? "remove" : "add to", ' compare","internalLinkZoneName":"pdp:product details","internalLinkURL":"n/a","clickInternalLinks":"true"}');
const quantityOutOfStockAnalytics = (productInfo, pincode)=>{
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "pdp:product details:check availability",
        eventName: "pdp:product details:check availability",
        eventType: "navigation",
        internalLinkName: "check availability",
        internalLinkPosition: "pdp",
        internalLinkType: "pdp:".concat(pincode),
        internalLinkZoneName: "pdp:product details",
        internalLinkURL: "n/a"
    };
    const outOfStockInfo = {
        availability: "out_of_stock",
        errorMessage: "This product is currently unavailable. Please check back later.",
        productStatus: "out of stock",
        pincode: pincode
    };
    productInfo = {
        ...productInfo,
        ...outOfStockInfo
    };
    const customDataLayer = {
        productInfo
    };
    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__.pushAnalyticsObjToDataLayer)(eventInfo, "cmp:click", {}, customDataLayer);
};
const generateEventId = ()=>{
    return "".concat(Date.now(), "_").concat(Math.random().toString(36).slice(2));
};
const gtmAddToCartEvent = async (param)=>{
    let { productInfo , utmPayload  } = param;
    const { utm_source ="" , utm_medium =""  } = utmPayload || {};
    const { productSalePrice ="" , category ="" , quantity ="" , productName ="" , productID =""  } = productInfo || {};
    const eventId = generateEventId();
    window.dataLayer.push({
        "event": "add_to_cart",
        "event_id": eventId,
        "source": utm_source,
        "medium": utm_medium,
        "ecommerce": {
            "currency": "INR",
            "value": productSalePrice,
            "items": [
                {
                    "item_id": productID,
                    "item_name": productName,
                    "item_category": category,
                    "quantity": quantity
                }
            ]
        }
    });
    const eventTime = Math.floor(Date.now() / 1000);
    const anonymousId = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__.getAnonymousId)();
    const oktaToken = localStorage.getItem("okta-token-storage");
    let emailId = "";
    if (oktaToken && oktaToken !== "{}") {
        var ref;
        const oktaObject = JSON.parse(oktaToken);
        const claim = (oktaObject === null || oktaObject === void 0 ? void 0 : (ref = oktaObject.accessToken) === null || ref === void 0 ? void 0 : ref.claims) || {};
        emailId = claim === null || claim === void 0 ? void 0 : claim.sub;
    }
    await fetch("https://graph.facebook.com/v25.0/".concat("331133875864147", "/events?access_token=").concat("EAAaqfp2QIY4BRqxJg2gSPHX5fa8LgtuyQauj2XcDverFLHiK79oCTD9HIgolAYlt7gb0qNXiXkZBZBhBrv9X9AC1kjvO7ZBvFOIBp0vbHjJK4MTWy0ym4CB2pyI7DfFJzl0I8NeOsJw1gt8aQlgfIyuNWbouhpuhloVMODFZAVhuha9bEmxAOZA2P1ZBeZA4frodgZDZD"), {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            data: [
                {
                    event_name: "AddToCart",
                    event_time: eventTime,
                    event_id: eventId,
                    action_source: "website",
                    "user_data": {
                        "client_user_agent": navigator.userAgent,
                        ...emailId !== "" && {
                            em: [
                                await (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__.shaEncrypt)(emailId.toLowerCase())
                            ]
                        },
                        ...anonymousId !== "" && {
                            external_id: anonymousId
                        }
                    },
                    custom_data: {
                        value: productSalePrice,
                        currency: "INR",
                        content_ids: [
                            productID
                        ],
                        contents: [
                            {
                                id: productID,
                                quantity: quantity
                            }
                        ]
                    }
                }
            ]
        })
    });
};


/***/ }),

/***/ 2535:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34326);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55111);
/* harmony import */ var react_number_format__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57333);
/* harmony import */ var html_react_parser__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25935);
/* harmony import */ var _components_ProductDetail_v3_ProductDetailView_productDetailsView_module_scss__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(14427);
/* harmony import */ var _components_ProductDetail_v3_ProductDetailView_productDetailsView_module_scss__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_components_ProductDetail_v3_ProductDetailView_productDetailsView_module_scss__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _components_ProductDetail_v3_ProductAccordionList__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(57114);
/* harmony import */ var _hooks_useWindowResize__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11859);
/* harmony import */ var _i18n_usePdpi18n__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(58886);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_9__);











const Loader = (props)=>{
    var ref, ref1, ref2;
    const { test , pdpData: productInfo , skuId , initialImgAlt , initialImgUrl , config ={} , isDiscontinued =false , // staticTexts = {},
    sku ="" , ProductPriceSpiderIncluded_s =false , currencySign ="" , persona ="" , addToCartProps: { specialOrder ="" , backOrder =""  } = {} , isProjectPack ="" , disableEcommerce =true , productAnalyticsData ={} , replaceAddToCart =false , disableRatings =false , replaceAddToCartCtaLink ="" , replaceAddToCartCtaLabel ="" , linkNewTab =false , pdpJson ={} , productType ="" , installationDataFromProp =[] , designServiceDataFromProp =[] , installationData =[] , locale ="" , productData ={} , businessUnitName ="" , discontinuedProductb ="" , ProductRequiredAccessoriesGroupsList =[] , superSku ="" , designServiceData =[] , productServices =[] , getZipCode =()=>{} , currencyCode =""  } = props;
    const [width, height] = (0,_hooks_useWindowResize__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)();
    const badgeText = {
        new: lodash_get__WEBPACK_IMPORTED_MODULE_9___default()(config, "general.newBadgeName", ""),
        onSale: lodash_get__WEBPACK_IMPORTED_MODULE_9___default()(config, "general.saleBadgeName", ""),
        exclusive: lodash_get__WEBPACK_IMPORTED_MODULE_9___default()(config, "general.exclusiveBadgeName", ""),
        discontinued: lodash_get__WEBPACK_IMPORTED_MODULE_9___default()(config, "general.discontinuedBadgeName", "")
    };
    const { ProductBrandName_s: pdpBrnadName = "" , ProductDescriptionProductShort_s: pdpShotDesc = "" , sku_s: productID = "" , ProductLocalCategory_s: productCategory = "" , masterSKU_s: masterSku = "" , "priceList.ANY.finalPrice_d": anyFinalPrice = "" , "priceList.GST.finalPrice_d": gstFinalPrice = "" , ProductNarrativeDescription_s: ProductNarrativeDescription_s , productName_s: productName = "" , "Color.GST.Details_ss": colorDetails = []  } = productInfo;
    const staticTexts = (0,_i18n_usePdpi18n__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(pdpJson, badgeText, pdpBrnadName);
    const variant = colorDetails.find((item)=>item.startsWith(skuId));
    const variantData = variant ? variant.split("|") : [];
    let discountedPrice = 0;
    let price = 0;
    if (variantData.length > 0) {
        discountedPrice = variantData[3];
        price = variantData[2];
    } else {
        discountedPrice = gstFinalPrice;
        price = anyFinalPrice;
    }
    const discountPercent = Math.round((price - discountedPrice) / price * 100);
    const { pdpDesktopImage , pdpMobileImage  } = pdpJson;
    const [initImage] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(pdpDesktopImage && initialImgUrl ? pdpDesktopImage.replace("/}", "/".concat(initialImgUrl, "}")).replace("&fmt=webp", "") : "");
    const initMobileImage = pdpMobileImage && initialImgUrl ? pdpMobileImage.replace("/}", "/".concat(initialImgUrl, "}")).replace("&fmt=webp", "") : "";
    const [initImageAlt] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(initialImgAlt);
    const categoryTmp = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_2__.sanitizeTextForAnalytics)(productCategory);
    const category = categoryTmp === null || categoryTmp === void 0 ? void 0 : categoryTmp.split(" ").map((a)=>{
        return a.charAt(0).toUpperCase() + (a === null || a === void 0 ? void 0 : a.slice(1));
    }).join(" ");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_components_ProductDetail_v3_ProductDetailView_productDetailsView_module_scss__WEBPACK_IMPORTED_MODULE_10___default().productDetailsV3Wrapper),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "product-detail-page min-vh-100",
            "data-testid": "product-detail-page",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "container",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "header-section kf-react-plp-container",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "product-detail-page__breadcrumb",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("nav", {
                                    "aria-label": "Breadcrumb",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ol", {
                                        role: "list",
                                        style: {
                                            padding: 0
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                role: "listitem",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                    href: "/",
                                                    children: " Home / "
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                role: "listitem",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                    href: "/",
                                                    children: category ? category : "Parts"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                role: "listitem",
                                                className: "cursor-disabled",
                                                children: [
                                                    " ",
                                                    " / ",
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                        href: "/",
                                                        children: category ? pdpBrnadName || productName : "Parts"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "product-detail-page__print-share-container",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    role: "list",
                                    className: "print-and-share",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            role: "listitem",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                tabIndex: "0",
                                                className: "gbh-data-layer",
                                                "data-gbh-data-layer": "",
                                                "data-gbh-data-layer-custom": "",
                                                "aria-label": "Click here to print ",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                    src: "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTdweCIgaGVpZ2h0PSIxN3B4IiB2aWV3Qm94PSIwIDAgMTcgMTciIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+UHJpbnQtSWNvbjwvdGl0bGU+CiAgICA8ZyBpZD0iUGFnZS0xIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0iUHJpbnQiIGZpbGw9IiM3NTc1NzUiIGZpbGwtcnVsZT0ibm9uemVybyI+CiAgICAgICAgICAgIDxwYXRoIGQ9Ik0xNCwwIEwxNCw0IEwxNyw0IEwxNywxMiBMMTQsMTIgTDE0LDE3IEwzLDE3IEwzLDEyIEwwLDEyIEwwLDQgTDMsNCBMMywwIEwxNCwwIFogTTEzLDEyIEw0LDEyIEw0LDE2IEwxMywxNiBMMTMsMTIgWiBNMyw1IEwxLDUgTDEsMTEgTDE2LDExIEwxNiw1IEwxNCw1IEwxNCw4IEwzLDggTDMsNSBaIE0xMywxIEw0LDEgTDQsNyBMMTMsNyBMMTMsMSBaIiBpZD0iUHJpbnQtSWNvbiI+PC9wYXRoPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+",
                                                    alt: "",
                                                    role: "presentation",
                                                    width: "20",
                                                    height: "20"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            role: "listitem",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                tabIndex: "0",
                                                "aria-label": "Click here to share ",
                                                className: "share-button",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                    src: "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTRweCIgaGVpZ2h0PSIxN3B4IiB2aWV3Qm94PSIwIDAgMTQgMTciIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+c2hhcmU8L3RpdGxlPgogICAgPGcgaWQ9IlBhZ2UtMSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9InNoYXJlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLjAwMDAwMCwgMC42MjAzNzIpIiBmaWxsPSIjNzU3NTc1IiBmaWxsLXJ1bGU9Im5vbnplcm8iPgogICAgICAgICAgICA8cGF0aCBkPSJNMy41LDYuODc5NjI4MyBMMy41LDcuODc5NjI4MyBMMSw3Ljg3OTYyODMgTDEsMTQuODc5NjI4MyBMMTMsMTQuODc5NjI4MyBMMTMsNy44Nzk2MjgzIEwxMC41LDcuODc5NjI4MyBMMTAuNSw2Ljg3OTYyODMgTDE0LDYuODc5NjI4MyBMMTQsMTUuODc5NjI4MyBMMCwxNS44Nzk2MjgzIEwwLDYuODc5NjI4MyBMMy41LDYuODc5NjI4MyBaIE03LC04Ljg4MTc4NDJlLTE2IEw3LjQ0MiwwLjM3OSBMNy41LDAuMzc5NjI4MzAxIEw3LjUsMC40MjgwMDAwMDEgTDEwLjgyNTM5NTcsMy4yNzg5MTA1OSBMMTAuMTc0NjA0Myw0LjAzODE2NzE5IEw3LjUsMS43NDYgTDcuNSwxMS4zNzk2MjgzIEw2LjUsMTEuMzc5NjI4MyBMNi41LDEuNzQ2IEwzLjgyNTM5NTY5LDQuMDM4MTY3MTkgTDMuMTc0NjA0MzEsMy4yNzg5MTA1OSBMNi41LDAuNDI4MDAwMDAxIEw2LjUsMC4zNzk2MjgzMDEgTDYuNTU4LDAuMzc5IEw3LC04Ljg4MTc4NDJlLTE2IFoiIGlkPSJDb21iaW5lZC1TaGFwZSI+PC9wYXRoPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+",
                                                    alt: "",
                                                    role: "presentation",
                                                    width: "20",
                                                    height: "20"
                                                })
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "product-overview print-overview",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "product-detail-page__image-gallery print-overview-left",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "image-reel row",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "col-12",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "pdp-image-reel__image-stack-view",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                                className: "pl-0 list-inline pdp-image-reel__image-stack-list",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                    className: "pdp-image-reel__image-list",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "pdp-image-reel__image-display",
                                                        children: initImage ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("picture", {
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("source", {
                                                                    srcSet: initMobileImage,
                                                                    media: "(max-width: 768px)"
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("source", {
                                                                    srcSet: initImage,
                                                                    media: "(min-width: 769px)"
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                    role: "button",
                                                                    src: initImage,
                                                                    alt: initImageAlt,
                                                                    tabIndex: "0",
                                                                    className: "print",
                                                                    fetchpriority: "high"
                                                                })
                                                            ]
                                                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                            className: "shimmer-loading__para shimmer height-400"
                                                        })
                                                    })
                                                })
                                            })
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "product-detail-page__content-section print-overview-right",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "row no-gutters product-detail-page__main",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "col-12",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "product-detail-page__price-value",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                            className: "shimmer-loading__para shimmer width-170"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h1", {
                                                    className: "product-detail-page__title-desc",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                            className: "product-detail-page__title",
                                                            children: pdpBrnadName
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                            className: "product-detail-page__description",
                                                            children: pdpShotDesc
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                    className: "product-detail-page__sku-id",
                                                    children: [
                                                        " ",
                                                        productID
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "row no-gutters product-detail-page__price-main",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "col-12 product-detail-page__price",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "product-detail-page__price-value",
                                                tabIndex: "0",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_number_format__WEBPACK_IMPORTED_MODULE_4__/* .NumericFormat */ .h3, {
                                                        value: discountedPrice > 0 ? discountedPrice : price,
                                                        displayType: "text",
                                                        thousandSeparator: true,
                                                        prefix: _constants__WEBPACK_IMPORTED_MODULE_3__["default"].CURRENCY_SIGN,
                                                        decimalScale: 2,
                                                        fixedDecimalScale: true
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "product-detail-page__price-alltaxes-text",
                                                        children: "Inclusive of all taxes"
                                                    }),
                                                    discountedPrice > 0 && discountedPrice !== price && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "col-12 product-detail-page__discount",
                                                        style: {
                                                            display: "flex",
                                                            alignItems: "baseline",
                                                            marginBottom: "10px",
                                                            marginTop: "10px"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                className: "product-detail-page__list-text",
                                                                children: "MRP"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                className: "product-detail-page__discount-price",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_number_format__WEBPACK_IMPORTED_MODULE_4__/* .NumericFormat */ .h3, {
                                                                    value: price,
                                                                    displayType: "text",
                                                                    thousandSeparator: true,
                                                                    prefix: _constants__WEBPACK_IMPORTED_MODULE_3__["default"].CURRENCY_SIGN,
                                                                    decimalScale: 2,
                                                                    fixedDecimalScale: true
                                                                })
                                                            }),
                                                            discountPercent > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                                className: "product-detail-page__percent-off",
                                                                children: [
                                                                    discountPercent + "% ",
                                                                    "OFF"
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "row no-gutters product-detail-page__finish-sample",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "col-12 product-detail-page__finish",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "product-detail-page__finish_value",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    className: "shimmer-loading__para shimmer width-170"
                                                })
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "row no-gutters product-detail-page__color-swatch-main",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "col-12 product-detail-page__color-swatch",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "color-swatch",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        className: "color-swatch",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                            className: "shimmer-loading__para shimmer"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "color-swatch",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        className: "color-swatch",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                            className: "shimmer-loading__para shimmer"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "color-swatch",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        className: "color-swatch",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                            className: "shimmer-loading__para shimmer"
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "row no-gutters width-150",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                class: "shimmer-loading__para shimmer"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                class: "shimmer-loading__para shimmer mb20"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                class: "shimmer-loading__para shimmer shimmer-loading__input"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        class: "row no-gutters buy-area width-150 mb40",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            class: "shimmer-loading__para shimmer shimmer-loading__input"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "product-detail-page__narrative-description",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "shimmer-loading__para shimmer height-fit-content",
                                            children: ProductNarrativeDescription_s
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "product-detail-page__product-accordion-list",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "shimmer height-60"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "shimmer height-60"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "shimmer height-60"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "shimmer height-60"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "shimmer height-60"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ProductDetail_v3_ProductAccordionList__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                        productData: productInfo,
                                        productInfo: productAnalyticsData.stringProductInfo,
                                        productSku: sku,
                                        config: config,
                                        isDiscontinued: isDiscontinued,
                                        staticTexts: staticTexts,
                                        accordionList: pdpJson === null || pdpJson === void 0 ? void 0 : pdpJson.accordianLabels,
                                        installationSupportLinks: pdpJson === null || pdpJson === void 0 ? void 0 : pdpJson.installationSupportLinks,
                                        installationDataFromProp: installationDataFromProp,
                                        designServiceDataFromProp: designServiceDataFromProp,
                                        businessUnitName: businessUnitName,
                                        ProductPriceSpiderIncluded_s: ProductPriceSpiderIncluded_s,
                                        discontinuedProductb: discontinuedProductb,
                                        ProductRequiredAccessoriesGroupsList: ProductRequiredAccessoriesGroupsList,
                                        superSku: superSku,
                                        currencySign: currencySign,
                                        productCategory: productCategory,
                                        designServiceData: designServiceData,
                                        productServices: productServices,
                                        productType: productType,
                                        getZipCode: getZipCode,
                                        installationData: installationData,
                                        persona: persona,
                                        currencyCode: currencyCode,
                                        locale: locale,
                                        width: width,
                                        replaceAddToCart: replaceAddToCart,
                                        disableRatings: disableRatings,
                                        replaceAddToCartCtaLink: replaceAddToCartCtaLink,
                                        replaceAddToCartCtaLabel: replaceAddToCartCtaLabel,
                                        linkNewTab: linkNewTab,
                                        disableEcommerce: disableEcommerce,
                                        isProjectPack: isProjectPack,
                                        bundleItems: [],
                                        isSSr: true
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "productonDisplay",
                                                id: "spendSaveDisplayDiv",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "left-side",
                                                        children: pdpJson.productDisplayTitle
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "main-right",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "right-side"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "purchase-design",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "purchase-design__left-side",
                                                        children: (pdpJson === null || pdpJson === void 0 ? void 0 : pdpJson.designServices.length) > 0 && (0,html_react_parser__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)((ref = pdpJson === null || pdpJson === void 0 ? void 0 : pdpJson.designServices[0]) === null || ref === void 0 ? void 0 : ref.designPlanTitle)
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "purchase-design__right-side",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "design-service",
                                                                children: (pdpJson === null || pdpJson === void 0 ? void 0 : pdpJson.designServices.length) > 0 && (0,html_react_parser__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)((ref1 = pdpJson === null || pdpJson === void 0 ? void 0 : pdpJson.designServices[0]) === null || ref1 === void 0 ? void 0 : ref1.designPlanSectionHeading)
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "expert-design",
                                                                children: (pdpJson === null || pdpJson === void 0 ? void 0 : pdpJson.designServices.length) > 0 && (0,html_react_parser__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)((ref2 = pdpJson === null || pdpJson === void 0 ? void 0 : pdpJson.designServices[0]) === null || ref2 === void 0 ? void 0 : ref2.designPlanDescription)
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "add-installation-noservice",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "noservice-title",
                                                        children: pdpJson === null || pdpJson === void 0 ? void 0 : pdpJson.localProTitle
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "noservice__right-side",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "header",
                                                                children: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(pdpJson === null || pdpJson === void 0 ? void 0 : pdpJson.localProHeading)
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "desc",
                                                                children: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(pdpJson === null || pdpJson === void 0 ? void 0 : pdpJson.serviceavailable)
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Loader);


/***/ }),

/***/ 57114:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ v3_ProductAccordionList; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./utils/helper.js + 2 modules
var helper = __webpack_require__(34326);
;// CONCATENATED MODULE: ./src/components/ProductDetail/v3/ProductAccordionList/analytics.js

const addDownloadFilesAnalytics = function() {
    let productInfo = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", selectedFiles = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], hasError = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    // add analytics
    const selectedFileList = [];
    selectedFiles.forEach((selectedObj)=>{
        const fileNameAndFileType = (selectedObj.title + "." + selectedObj.type).toLowerCase();
        selectedFileList.push(fileNameAndFileType);
    });
    const selectedUrlList = selectedFiles.map((selectedObj)=>selectedObj.url.toLowerCase());
    if (selectedFileList.length && window.adobeDataLayer) {
        var ref;
        const { adobeDataLayer: { getState  } = {}  } = window;
        const page = getState && getState("page") || {};
        const eventInfo = {
            eventAction: "pdp:design files:download",
            eventName: "pdp:design files:download",
            eventType: "navigation",
            eventMsg: hasError ? "download failed" : "success",
            eventStatus: hasError ? "failure" : "success",
            internalLinkName: selectedFileList.join(":"),
            internalLinkPosition: "pdp",
            internalLinkType: "pdp:download",
            internalLinkZoneName: "pdp:design files",
            internalLinkURL: selectedUrlList.join(":"),
            clickInternalLinks: "true"
        };
        const dataLayerProductInfo = productInfo ? (ref = JSON.parse(productInfo)) === null || ref === void 0 ? void 0 : ref.productInfo : null;
        window.adobeDataLayer.push({
            event: "cmp:click",
            eventInfo,
            page,
            productInfo: dataLayerProductInfo
        });
    }
};
const addDownloadFilesAnalyticsInstSup = function() {
    let productInfo = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", type = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", errMsg = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", link = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "";
    var ref;
    const title = type.toLowerCase().trim();
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const eventInfo = {
        eventAction: "pdp:installation & support:guides:".concat(title),
        eventName: "pdp:installation & support:guides:".concat(title),
        eventType: "navigation",
        eventMsg: errMsg || "success",
        eventStatus: errMsg ? "failure" : "success",
        internalLinkName: "".concat(title, " | ").concat(link.replace("https://www.us.kohler.com/webassets", "")),
        internalLinkPosition: "pdp",
        internalLinkType: "pdp:installation & support:".concat(title),
        internalLinkZoneName: "pdp:installation & support",
        internalLinkURL: link,
        clickInternalLinks: "true"
    };
    const dataLayerProductInfo = productInfo ? (ref = JSON.parse(productInfo)) === null || ref === void 0 ? void 0 : ref.productInfo : null;
    window.adobeDataLayer.push({
        event: "cmp:click",
        eventInfo,
        page,
        productInfo: dataLayerProductInfo
    });
};
const getEventInfoProdAccordion = function() {
    let type = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", needsJSON = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, link = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", errMsg = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "";
    var ref, ref1, ref2, ref3, ref4;
    const text = type.toLowerCase().trim();
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const eventMsg = text === "view more" ? "n/a" : errMsg || "success";
    const eventStatus = text === "view more" ? "n/a" : errMsg ? "failure" : "success";
    const internalLinkName = "".concat(text).concat(text === "specifications sheet" ? " | ".concat(link.replace("https://www.us.kohler.com/webassets", "")) : "");
    const eventInfo = {
        eventAction: "".concat(page === null || page === void 0 ? void 0 : (ref = page.category) === null || ref === void 0 ? void 0 : ref.pageType, ":specs:").concat(text),
        eventName: "".concat(page === null || page === void 0 ? void 0 : (ref1 = page.category) === null || ref1 === void 0 ? void 0 : ref1.pageType, ":specs:").concat(text),
        eventType: "navigation",
        eventMsg,
        eventStatus,
        internalLinkName,
        internalLinkPosition: "".concat(page === null || page === void 0 ? void 0 : (ref2 = page.category) === null || ref2 === void 0 ? void 0 : ref2.pageType),
        internalLinkType: "".concat(page === null || page === void 0 ? void 0 : (ref3 = page.category) === null || ref3 === void 0 ? void 0 : ref3.pageType, ":specs:").concat(text),
        internalLinkZoneName: "".concat(page === null || page === void 0 ? void 0 : (ref4 = page.category) === null || ref4 === void 0 ? void 0 : ref4.pageType, ":specs"),
        internalLinkURL: link,
        clickInternalLinks: "true"
    };
    if (needsJSON) {
        return eventInfo;
    }
    return JSON.stringify(eventInfo);
};
const accordianAnalyticsData = function() {
    let type = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", isExpanded = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, needsJSON = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    const title = type.toLowerCase().trim();
    const eventInfo = {
        eventAction: "pdp:product details:filters ".concat(isExpanded ? "collapse" : "expand"),
        eventName: "pdp:product details:filters ".concat(isExpanded ? "collapse" : "expand"),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "".concat(isExpanded ? "collapse" : "expand"),
        internalLinkPosition: "pdp",
        internalLinkType: "pdp:".concat(title),
        internalLinkZoneName: "pdp:product details",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    if (needsJSON) {
        return eventInfo;
    }
    return JSON.stringify(eventInfo);
};
const getEventInfoInstSup = function() {
    let title = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", type = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", avoidTitle = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, url = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "";
    const addedTitle = avoidTitle ? "" : ":" + sanitizeTextForAnalytics(title);
    return JSON.stringify({
        eventAction: "pdp:installation and support:".concat(type).concat(addedTitle),
        eventName: "pdp:installation and support:".concat(type).concat(addedTitle),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: sanitizeTextForAnalytics(title),
        internalLinkPosition: "pdp",
        internalLinkType: "pdp:navigation",
        internalLinkZoneName: "pdp:installation and support",
        internalLinkURL: url ? (url.indexOf("http") === -1 ? window.location.origin : "") + url : "n/a",
        clickInternalLinks: "true"
    });
};

;// CONCATENATED MODULE: ./components/ProductDetail/v3/ProductAccordionList/analytics.js

const analytics_accordianAnalyticsData = function() {
    let type = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", isExpanded = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, needsJSON = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    const title = type.toLowerCase().trim();
    const eventInfo = {
        eventAction: "pdp:product details:accordion ".concat(isExpanded ? "collapse" : "expand"),
        eventName: "pdp:product details:accordion ".concat(isExpanded ? "collapse" : "expand"),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "".concat(isExpanded ? "collapse" : "expand"),
        internalLinkPosition: "pdp",
        internalLinkType: "pdp:".concat(title),
        internalLinkZoneName: "pdp:product details",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    if (needsJSON) {
        return eventInfo;
    }
    return JSON.stringify(eventInfo);
};
const analytics_getEventInfoInstSup = function() {
    let title = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", type = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", avoidTitle = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, url = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "";
    if (true) {
        const addedTitle = avoidTitle ? "" : (type ? ":" : "") + (0,helper.sanitizeTextForAnalytics)(title);
        return JSON.stringify({
            eventAction: "pdp:installation and support:".concat(type).concat(addedTitle),
            eventName: "pdp:installation and support:".concat(type).concat(addedTitle),
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: (0,helper.sanitizeTextForAnalytics)(title),
            internalLinkPosition: "pdp",
            internalLinkType: "pdp:navigation",
            internalLinkZoneName: "pdp:installation and support",
            internalLinkURL: url ? (url.indexOf("http") === -1 ? window.location.origin : "") + url : "n/a",
            clickInternalLinks: "true"
        });
    }
};
const analytics_getEventInfoProdAccordion = function() {
    let type = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", needsJSON = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, link = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", errMsg = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "";
    if (true) {
        var ref, ref1, ref2, ref3, ref4;
        const text = type.toLowerCase().trim();
        const { adobeDataLayer: { getState  } = {}  } = window;
        const page = getState && getState("page") || {};
        const eventMsg = text === "view more" ? "n/a" : errMsg || "success";
        const eventStatus = text === "view more" ? "n/a" : errMsg ? "failure" : "success";
        const internalLinkName = "".concat(text).concat(text === "specifications sheet" ? " | ".concat(link.replace("https://www.us.kohler.com/webassets", "")) : "");
        const eventInfo = {
            eventAction: "".concat(page === null || page === void 0 ? void 0 : (ref = page.category) === null || ref === void 0 ? void 0 : ref.pageType, ":specs:").concat(text),
            eventName: "".concat(page === null || page === void 0 ? void 0 : (ref1 = page.category) === null || ref1 === void 0 ? void 0 : ref1.pageType, ":specs:").concat(text),
            eventType: "navigation",
            eventMsg,
            eventStatus,
            internalLinkName,
            internalLinkPosition: "".concat(page === null || page === void 0 ? void 0 : (ref2 = page.category) === null || ref2 === void 0 ? void 0 : ref2.pageType),
            internalLinkType: "".concat(page === null || page === void 0 ? void 0 : (ref3 = page.category) === null || ref3 === void 0 ? void 0 : ref3.pageType, ":specs:").concat(text),
            internalLinkZoneName: "".concat(page === null || page === void 0 ? void 0 : (ref4 = page.category) === null || ref4 === void 0 ? void 0 : ref4.pageType, ":specs"),
            internalLinkURL: link,
            clickInternalLinks: "true"
        };
        if (needsJSON) {
            return eventInfo;
        }
        return JSON.stringify(eventInfo);
    }
};


// EXTERNAL MODULE: ./store/features/genericSlice.js
var genericSlice = __webpack_require__(88751);
// EXTERNAL MODULE: ./src/components/core/Button/Button.jsx
var Button = __webpack_require__(82476);
// EXTERNAL MODULE: ./src/components/core/Checkbox/Checkbox.jsx + 1 modules
var Checkbox = __webpack_require__(34846);
// EXTERNAL MODULE: ./public/icons/2D-plan.svg
var _2D_plan = __webpack_require__(10108);
// EXTERNAL MODULE: ./public/icons/2D-front.svg
var _2D_front = __webpack_require__(11534);
// EXTERNAL MODULE: ./public/icons/2D-side.svg
var _2D_side = __webpack_require__(3089);
// EXTERNAL MODULE: ./public/icons/3D.svg
var _3D = __webpack_require__(65317);
// EXTERNAL MODULE: ./public/icons/3D-BIM.svg
var _3D_BIM = __webpack_require__(59363);
// EXTERNAL MODULE: ./public/icons/cutout.svg
var cutout = __webpack_require__(24425);
;// CONCATENATED MODULE: ./src/components/ProductDetail/v3/ProductAccordionList/designFiles.jsx














const DesignFiles = (props)=>{
    const { files ={} , staticTexts ={} , sku ="" , productInfo =""  } = props;
    const [selectedFiles, setSelectedFiles] = (0,react.useState)([]);
    const [loading, setLoading] = (0,react.useState)(false);
    const dispatch = (0,es/* useDispatch */.I0)();
    const handleSelect = (checked, clickedItem, title)=>{
        clickedItem.title = title;
        if (checked) setSelectedFiles([
            ...selectedFiles,
            clickedItem
        ]);
        else setSelectedFiles(selectedFiles.filter((item)=>item.url !== clickedItem.url));
    };
    const handleSelectAll = (checked)=>{
        if (checked) {
            const selected = [];
            files.twoDimension.plan.forEach((obj)=>{
                const newObj = obj;
                newObj.title = "2D Plan";
                selected.push(newObj);
            });
            files.twoDimension.front.forEach((obj)=>{
                const newObj = obj;
                newObj.title = "2D Front";
                selected.push(newObj);
            });
            files.twoDimension.side.forEach((obj)=>{
                const newObj = obj;
                newObj.title = "2D Side";
                selected.push(newObj);
            });
            files.threeDimension.forEach((obj)=>{
                const newObj = obj;
                newObj.title = "3D File";
                selected.push(newObj);
            });
            files.bim.forEach((obj)=>{
                const newObj = obj;
                newObj.title = "Bim";
                selected.push(newObj);
            });
            files.cutout.forEach((obj)=>{
                const newObj = obj;
                newObj.title = "Cutout";
                selected.push(newObj);
            });
            setSelectedFiles(selected);
        } else setSelectedFiles([]);
    };
    const handleDownloadError = ()=>{
        setLoading(false);
        dispatch((0,genericSlice/* showToast */.CF)("Download failed"));
        addDownloadFilesAnalytics(productInfo, selectedFiles, true);
    };
    const handleDownload = ()=>{
        const urlList = selectedFiles.map((item)=>item.url);
        if (selectedFiles.length > 1) {
            setLoading(true);
            (0,helper.handleZipDownload)(urlList, sku, ()=>{
                setLoading(false);
                addDownloadFilesAnalytics(productInfo, selectedFiles);
            }, handleDownloadError);
        } else if (urlList[0]) {
            window.open(urlList[0], "_blank");
            addDownloadFilesAnalytics(productInfo, selectedFiles);
        }
    };
    const designFilesLength = files.twoDimension.plan.length + files.twoDimension.front.length + files.twoDimension.side.length + files.threeDimension.length + files.bim.length + files.cutout.length;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "pdp-technical-tile__download-section",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "pdp-technical-tile__select-all",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    id: "selectAllfiles",
                    tabIndex: -1,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                        inline: true,
                        textClassName: "checkbox_default_text",
                        tabIndex: 0,
                        value: staticTexts.selectAll,
                        checked: designFilesLength > 0 && selectedFiles.length === designFilesLength,
                        onChange: (e)=>handleSelectAll(e.target.checked),
                        disabled: !designFilesLength
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "pdp-technical-tile__button-container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    role: "button",
                    loading: loading,
                    customClass: "pdp-technical-tile__download-btn",
                    size: "small",
                    onClick: ()=>handleDownload(),
                    flexible: true,
                    label: "".concat(staticTexts.download, " ").concat(selectedFiles.length > 0 ? selectedFiles.length + " " + (selectedFiles.length === 1 ? staticTexts.file : staticTexts.files) : ""),
                    disabled: selectedFiles.length === 0,
                    useDefaultClass: true
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "pdp-technical-tile__files",
                children: [
                    files.twoDimension.plan.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "pdp-technical-tile__file-type",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        className: "pt-0",
                                        alt: "",
                                        "aria-hidden": "true",
                                        src: _2D_plan/* default */.Z === null || _2D_plan/* default */.Z === void 0 ? void 0 : _2D_plan/* default.src */.Z.src
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "pdp-technical-tile__file-type__title",
                                        children: staticTexts.twoDplan
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "input-group",
                                children: files.twoDimension.plan.map((item, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                        inline: true,
                                        textClassName: "checkbox_default_text",
                                        value: item.type,
                                        checkBoxAria: "".concat(staticTexts.twoDplan, "  ").concat(item.type),
                                        checked: selectedFiles.find((obj)=>obj.url === item.url) ? true : false,
                                        onChange: (e)=>handleSelect(e.target.checked, item, "2D Plan")
                                    }, i))
                            })
                        ]
                    }),
                    files.twoDimension.front.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "pdp-technical-tile__file-type",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        className: "pt-0",
                                        alt: "",
                                        "aria-hidden": "true",
                                        src: _2D_front/* default */.Z === null || _2D_front/* default */.Z === void 0 ? void 0 : _2D_front/* default.src */.Z.src
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "pdp-technical-tile__file-type__title",
                                        children: staticTexts.twoDfront
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "input-group",
                                children: files.twoDimension.front.map((item, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                        inline: true,
                                        textClassName: "checkbox_default_text",
                                        value: item.type,
                                        checkBoxAria: "".concat(staticTexts.twoDfront, " ").concat(item.type),
                                        checked: selectedFiles.find((obj)=>obj.url === item.url) ? true : false,
                                        onChange: (e)=>handleSelect(e.target.checked, item, "2D Front")
                                    }, i))
                            })
                        ]
                    }),
                    files.twoDimension.side.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "pdp-technical-tile__file-type",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        className: "pt-0",
                                        alt: "",
                                        "aria-hidden": "true",
                                        src: _2D_side/* default */.Z === null || _2D_side/* default */.Z === void 0 ? void 0 : _2D_side/* default.src */.Z.src
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "pdp-technical-tile__file-type__title",
                                        children: staticTexts.twoDside
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "input-group",
                                children: files.twoDimension.side.map((item, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                        inline: true,
                                        textClassName: "checkbox_default_text",
                                        value: item.type,
                                        checkBoxAria: "".concat(staticTexts.twoDside, " ").concat(item.type),
                                        checked: selectedFiles.find((obj)=>obj.url === item.url) ? true : false,
                                        onChange: (e)=>handleSelect(e.target.checked, item, "2D Side")
                                    }, i))
                            })
                        ]
                    }),
                    files.threeDimension.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "pdp-technical-tile__file-type",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        className: "pt-0",
                                        alt: "",
                                        "aria-hidden": "true",
                                        src: _3D/* default */.Z === null || _3D/* default */.Z === void 0 ? void 0 : _3D/* default.src */.Z.src
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "pdp-technical-tile__file-type__title",
                                        children: staticTexts.threeDfile
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "input-group",
                                children: files.threeDimension.map((item, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                        inline: true,
                                        textClassName: "checkbox_default_text",
                                        value: item.type,
                                        checkBoxAria: "".concat(staticTexts.threeDfile, " ").concat(item.type),
                                        checked: selectedFiles.find((obj)=>obj.url === item.url) ? true : false,
                                        onChange: (e)=>handleSelect(e.target.checked, item, "3D File")
                                    }, i))
                            })
                        ]
                    }),
                    files.bim.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "pdp-technical-tile__file-type",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        className: "pt-0",
                                        alt: "",
                                        "aria-hidden": "true",
                                        src: _3D_BIM/* default */.Z === null || _3D_BIM/* default */.Z === void 0 ? void 0 : _3D_BIM/* default.src */.Z.src
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "pdp-technical-tile__file-type__title",
                                        children: staticTexts.bimFile
                                    })
                                ]
                            }),
                            files.bim.map((item, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                    inline: true,
                                    textClassName: "checkbox_default_text",
                                    value: item.type,
                                    checkBoxAria: "".concat(staticTexts.bimFile, " ").concat(item.type),
                                    checked: selectedFiles.find((obj)=>obj.url === item.url) ? true : false,
                                    onChange: (e)=>handleSelect(e.target.checked, item, "Bim")
                                }, i))
                        ]
                    }),
                    files.cutout.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "pdp-technical-tile__file-type",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        className: "pt-0",
                                        alt: "",
                                        "aria-hidden": "true",
                                        src: cutout/* default */.Z === null || cutout/* default */.Z === void 0 ? void 0 : cutout/* default.src */.Z.src
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "pdp-technical-tile__file-type__title",
                                        children: staticTexts.cutoutTemplate
                                    })
                                ]
                            }),
                            files.cutout.map((item, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                    inline: true,
                                    textClassName: "checkbox_default_text",
                                    checkBoxAria: "".concat(staticTexts.cutoutTemplate, " ").concat(item.type),
                                    value: item.type,
                                    checked: selectedFiles.find((obj)=>obj.url === item.url) ? true : false,
                                    onChange: (e)=>handleSelect(e.target.checked, item, "Cutout")
                                }, i))
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var ProductAccordionList_designFiles = (DesignFiles);

// EXTERNAL MODULE: ./constants/config.js
var config = __webpack_require__(19514);
// EXTERNAL MODULE: ./src/components/VideoWrapper/VideoWrapper.jsx + 1 modules
var VideoWrapper = __webpack_require__(38279);
// EXTERNAL MODULE: ./components/core/Modal/Modal.jsx + 2 modules
var Modal = __webpack_require__(95357);
// EXTERNAL MODULE: ./src/components/VideoWrapper/index.module.scss
var index_module = __webpack_require__(76631);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
;// CONCATENATED MODULE: ./src/components/VideoWrapper/VideoModal.jsx






const VideoModal = (props)=>{
    const { isWhiteCloseIcon ="" , videoId ="" , onClose =()=>{}  } = props;
    const [showModal, setShowModal] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        setShowModal(true);
        (0,helper.preventBodyScroll)(true);
        return ()=>(0,helper.preventBodyScroll)(false);
    }, []);
    const closeModal = ()=>{
        setShowModal(false);
        onClose();
        (0,helper.preventBodyScroll)(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: showModal && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (index_module_default()).videoModalWrapper,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "video-modal__content",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
                    onModalClose: closeModal,
                    showModal: showModal,
                    isWhiteCloseIcon: isWhiteCloseIcon,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoWrapper/* default */.Z, {
                        videoId: videoId,
                        isPopup: showModal,
                        width: "100%"
                    })
                })
            })
        })
    });
};
/* harmony default export */ var VideoWrapper_VideoModal = (VideoModal);

// EXTERNAL MODULE: ./src/components/PartsViewer/v1/PartsViewer.jsx
var PartsViewer = __webpack_require__(96005);
;// CONCATENATED MODULE: ./public/icons/video-file.svg
/* harmony default export */ var video_file = ({"src":"/_next/static/media/video-file.17b65f7d.svg","height":14,"width":12});
// EXTERNAL MODULE: ./public/icons/parts-diagram.svg
var parts_diagram = __webpack_require__(93056);
// EXTERNAL MODULE: ./public/icons/download-dark-gray.svg
var download_dark_gray = __webpack_require__(91883);
;// CONCATENATED MODULE: ./src/components/ProductDetail/v3/ProductAccordionList/installationSupport.jsx










const InstallationSupport = (props)=>{
    var ref, ref1;
    const { files ={} , staticTexts ={} , productInfo ={}  } = props;
    const [videoModal, setVideoModal] = (0,react.useState)({
        show: false,
        id: ""
    });
    const [partsModal, setPartsModal] = (0,react.useState)({
        show: false,
        id: ""
    });
    const [general, setGeneral] = (0,react.useState)(null);
    const partsRef = (0,react.useRef)(null);
    const videoRef = (0,react.useRef)(null);
    (0,react.useEffect)(()=>{
        (0,config/* getConfig */.i)().then((config)=>{
            setGeneral(config === null || config === void 0 ? void 0 : config.general);
        });
    }, []);
    const handleDownload = (e, link, title)=>{
        e.stopPropagation();
        const linkUrl = link.trim();
        let errMsg;
        try {
            window.open(linkUrl, "_blank");
        } catch (err) {
            errMsg = err.message;
        }
        addDownloadFilesAnalyticsInstSup(productInfo, title, errMsg, linkUrl);
    };
    const closeModal = (type)=>{
        if (type === "parts") {
            (0,helper.scrollToElement)(partsRef);
            setPartsModal({
                show: false,
                id: ""
            });
        } else if (type === "video") {
            (0,helper.scrollToElement)(videoRef);
            setVideoModal({
                show: false,
                id: ""
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            partsModal.show && /*#__PURE__*/ (0,jsx_runtime.jsx)(PartsViewer/* default */.Z, {
                productId: files.productId,
                partId: partsModal.id,
                showModal: partsModal.show,
                page: "pdp",
                onClose: ()=>closeModal("parts"),
                analyticsCustomData: productInfo
            }),
            videoModal.show && /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoWrapper_VideoModal, {
                videoId: videoModal.id,
                onClose: ()=>closeModal("video")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "pdp-install-support__download-section",
                children: [
                    (files.guides.installationGuides.length > 0 || files.guides.supportGuides.length > 0 || files.videos.length > 0 || files.partsLinks.length > 0) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "pdp-support-files__install-support",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "pdp-support-files__install",
                                children: (files.guides.installationGuides.length > 0 || files.guides.supportGuides.length > 0) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "pdp-technical-tile__files --technical-info --installation ".concat(files.guides.supportGuides.length > 0 ? "--technical-info__border" : ""),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "pdp-support-files__sub-heading",
                                            children: staticTexts.guides
                                        }),
                                        (files === null || files === void 0 ? void 0 : (ref = files.guides) === null || ref === void 0 ? void 0 : ref.installationGuides) && files.guides.installationGuides.map((item, i)=>{
                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("section", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "pdp-technical-tile__file",
                                                    onClick: (e)=>handleDownload(e, item.url, item.title),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            alt: "",
                                                            "aria-hidden": "true",
                                                            src: download_dark_gray/* default */.Z === null || download_dark_gray/* default */.Z === void 0 ? void 0 : download_dark_gray/* default.src */.Z.src
                                                        }),
                                                        item.title
                                                    ]
                                                })
                                            }, i);
                                        }),
                                        (files === null || files === void 0 ? void 0 : (ref1 = files.guides) === null || ref1 === void 0 ? void 0 : ref1.supportGuides) && files.guides.supportGuides.map((item, i)=>{
                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("section", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "pdp-technical-tile__file",
                                                    onClick: (e)=>handleDownload(e, item.url, item.title),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            alt: "",
                                                            "aria-hidden": "true",
                                                            src: download_dark_gray/* default */.Z === null || download_dark_gray/* default */.Z === void 0 ? void 0 : download_dark_gray/* default.src */.Z.src
                                                        }),
                                                        item.title
                                                    ]
                                                })
                                            }, i);
                                        })
                                    ]
                                })
                            }),
                            files.videos.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "pdp-support-files__support ".concat(files.guides.installationGuides.length + files.guides.supportGuides.length === 0 ? "mt-0" : ""),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "pdp-support-files__sub-heading",
                                        children: staticTexts.installVideo
                                    }),
                                    files.videos.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "pdp-support-files__videos",
                                        role: "list",
                                        ref: videoRef,
                                        children: files.videos.map((item, i)=>{
                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("section", {
                                                role: "listitem",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "pdp-support-files__links gbh-data-layer pdp-support-files__file-type",
                                                    "data-gbh-data-layer": analytics_getEventInfoInstSup(item.title, "installation video"),
                                                    "data-gbh-data-layer-custom": productInfo,
                                                    onClick: ()=>setVideoModal({
                                                            show: true,
                                                            id: item.id
                                                        }),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            alt: "",
                                                            "aria-hidden": "true",
                                                            src: video_file === null || video_file === void 0 ? void 0 : video_file.src
                                                        }),
                                                        item.title
                                                    ]
                                                })
                                            }, item.id);
                                        })
                                    })
                                ]
                            }),
                            files.partsLinks.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "pdp-support-files__parts-links ".concat(files.guides.installationGuides.length + files.guides.supportGuides.length + files.videos.length === 0 ? "mt-0" : ""),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "pdp-support-files__sub-heading",
                                        children: staticTexts.partsDiagram
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "pdp-support-files__parts-link",
                                        role: "list",
                                        ref: partsRef,
                                        children: files.partsLinks.map((item, i)=>{
                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("section", {
                                                role: "listitem",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    role: "button",
                                                    tabIndex: "0",
                                                    className: "pdp-support-files__links gbh-data-layer",
                                                    "data-gbh-data-layer": analytics_getEventInfoInstSup(item.title, "interactive parts diagram", true),
                                                    "data-gbh-data-layer-custom": productInfo,
                                                    onClick: ()=>setPartsModal({
                                                            show: true,
                                                            id: item.id
                                                        }),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            alt: "",
                                                            "aria-hidden": "true",
                                                            src: parts_diagram/* default */.Z === null || parts_diagram/* default */.Z === void 0 ? void 0 : parts_diagram/* default.src */.Z.src
                                                        }),
                                                        item.title
                                                    ]
                                                })
                                            }, item.id);
                                        })
                                    })
                                ]
                            }),
                            files.pdfPartsLinks.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "pdp-support-files__install pdf-support-files",
                                role: "list",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "pdp-technical-tile__files --technical-info --installation ".concat(files.pdfPartsLinks.length > 0 ? "--technical-info__border" : ""),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "pdp-support-files__sub-heading",
                                            children: staticTexts.partsDiagram
                                        }),
                                        files.pdfPartsLinks.map((item, i)=>{
                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("section", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "pdp-technical-tile__file",
                                                    onClick: (e)=>handleDownload(e, item.id, item.title),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            alt: "",
                                                            "aria-hidden": "true",
                                                            src: download_dark_gray/* default */.Z === null || download_dark_gray/* default */.Z === void 0 ? void 0 : download_dark_gray/* default.src */.Z.src
                                                        }),
                                                        item.title
                                                    ]
                                                })
                                            }, i);
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    files.supportLinks.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "pdp-support-files__support-links",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "pdp-support-files__sub-heading",
                                children: staticTexts.helpfulLinks
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "pdp-support-files__support-link",
                                role: "list",
                                children: files.supportLinks.map((item, i)=>{
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("section", {
                                        role: "listitem",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: "pdp-support-files__links gbh-data-layer",
                                            "data-gbh-data-layer": analytics_getEventInfoInstSup(item.ctaLabel, "", false, item.ctaLink),
                                            "data-gbh-data-layer-custom": productInfo,
                                            href: (0,helper.getShortenedUrlwithGeneral)(item === null || item === void 0 ? void 0 : item.ctaLink, general),
                                            target: item.newTab ? "_blank" : "",
                                            rel: "noreferrer",
                                            children: (0,helper.decodeHtmlCharacters)(item.ctaLabel)
                                        })
                                    }, i);
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var ProductAccordionList_installationSupport = (InstallationSupport);

// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react-number-format/dist/react-number-format.es.js
var react_number_format_es = __webpack_require__(57333);
// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(85518);
// EXTERNAL MODULE: ./utils/location.js
var utils_location = __webpack_require__(97433);
// EXTERNAL MODULE: ./utils/addTocart.js
var addTocart = __webpack_require__(27522);
// EXTERNAL MODULE: ./components/core/Input/Input.jsx
var Input = __webpack_require__(3372);
// EXTERNAL MODULE: ./components/ProductDetail/v3/analytics.js
var analytics = __webpack_require__(3155);
// EXTERNAL MODULE: ./src/components/ProductDetail/v3/AddanInstallation/index.module.scss
var AddanInstallation_index_module = __webpack_require__(14804);
var AddanInstallation_index_module_default = /*#__PURE__*/__webpack_require__.n(AddanInstallation_index_module);
// EXTERNAL MODULE: ./store/features/cartSlice.js
var cartSlice = __webpack_require__(46201);
;// CONCATENATED MODULE: ./src/components/ProductDetail/v3/AddanInstallation/analytics.js
const getEventInfo = (type, url, installationServiceName)=>{
    const internalLinkURL = url ? (url.indexOf("http") === -1 ? window.location.origin : "") + url : "n/a";
    return JSON.stringify({
        eventAction: "pdp:cross-sell:kohler professional services:".concat(type),
        eventName: "pdp:cross-sell:kohler professional services:".concat(type),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "change",
        internalLinkPosition: "pdp",
        internalLinkType: "pdp:".concat(installationServiceName === null || installationServiceName === void 0 ? void 0 : installationServiceName.toLowerCase()),
        internalLinkURL,
        internalLinkZoneName: "pdp:cross-sell:kohler professional services",
        clickInternalLinks: "true"
    });
};
const addDataLayerOnCheckAvailability = (errMessage, installationServiceName, checkZipCode, productInfo)=>{
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    // const installationServiceName =
    //   installationServiceData?.sectionHeading || ""
    const eventInfo = {
        eventAction: "pdp:cross-sell:kohler professional services:check availability",
        eventName: "pdp:cross-sell:kohler professional services:check availability",
        eventType: "navigation",
        eventMsg: errMessage ? errMessage.toLowerCase() : "n/a",
        eventStatus: errMessage ? "failure" : "success",
        internalLinkName: "search",
        internalLinkPosition: "pdp",
        internalLinkType: "pdp:".concat(installationServiceName === null || installationServiceName === void 0 ? void 0 : installationServiceName.toLowerCase(), ":").concat(checkZipCode),
        internalLinkURL: "n/a",
        internalLinkZoneName: "pdp:cross-sell:kohler professional services",
        clickInternalLinks: "true"
    };
    window.adobeDataLayer.push({
        event: "cmp:click",
        eventInfo,
        productInfo,
        page
    });
};

;// CONCATENATED MODULE: ./src/components/ProductDetail/v3/AddanInstallation/index.jsx



















const waitTimeForAddAnInstallationSectionToLoad = 500;
const AddanInstallation = (props)=>{
    var ref, ref1, ref2, ref3;
    const { key ="" , staticTexts: { zipcodeEmptyError ="" , validZipcode ="" , eligibleZipCodeError ="" , bathroomDesignService ="" , yourCart ="" , serviceItemsAdded ="" , forText ="" , change ="" , zipCodeGuidText ="" , percentOff ="" , zipcode ="" , search ="" , eligibleZipCodeSuccess ="" , ariaLabel: { serviceLearnMore ="" , serviceAddToCart =""  } = {} , addService =""  } = {} , disableEcommerce =false , currencySign ="" , currencyCode ="" , locale ="" , getZipCode =()=>{} , installtionAPIData =[] , installationServiceData ={} , pdpType ="" , sku =""  } = props;
    const dispatch = (0,es/* useDispatch */.I0)();
    const addAnInstallationRef = (0,react.useRef)(null);
    const [isCheckAvailability, setIsCheckAvailability] = (0,react.useState)(true);
    const [userZipCode, setUserZipCode] = (0,react.useState)("");
    const [isNearest, setIsNearest] = (0,react.useState)(null);
    const [isNearestError, setIsNearestError] = (0,react.useState)(false);
    const [checkZipCode, setCheckZipCode] = (0,react.useState)("");
    const [zipCodeError, setZipCodeError] = (0,react.useState)({
        show: false,
        message: ""
    });
    const [general, setGeneral] = (0,react.useState)({});
    const [cartUrl, setCartUrl] = (0,react.useState)("");
    const [installationServiceDataCtaLink, setInstallationServiceDataCtaLink] = (0,react.useState)("");
    (0,react.useEffect)(()=>{
        (0,config/* getConfig */.i)().then((config)=>{
            const { general  } = config;
            setGeneral(general);
        });
    }, []);
    (0,react.useEffect)(()=>{
        if (!isEmpty_default()(general)) {
            var _cartLandingPagePath;
            (0,helper.getShortenedUrl)((_cartLandingPagePath = general.cartLandingPagePath) !== null && _cartLandingPagePath !== void 0 ? _cartLandingPagePath : "/").then((res)=>setCartUrl(res));
        }
    }, [
        general
    ]);
    (0,react.useEffect)(()=>{
        const { ctaLink =""  } = installationServiceData;
        if (ctaLink) {
            (0,helper.getShortenedUrl)(ctaLink).then((url)=>setInstallationServiceDataCtaLink(url));
        }
    }, [
        installationServiceData.ctaLink
    ]);
    let percentDiscount;
    let percentType;
    const installServiceTitle = get_default()(installtionAPIData[0], "name[".concat(locale, "]"), "");
    const masterVariant = get_default()(installtionAPIData[0], "masterVariant", []);
    const masterVariantPrice = get_default()(masterVariant, "prices", []);
    const installationPrice = Number(get_default()(masterVariantPrice.find((item)=>item.value.currencyCode === currencyCode), "value.centAmount", 0) / 100).toFixed(2);
    const isDiscount = get_default()(masterVariantPrice[0], "discounted", {});
    const installationDiscountedPrice = !isEmpty_default()(isDiscount) ? Number(get_default()(masterVariantPrice.find((item)=>item.discounted.value.currencyCode === currencyCode), "discounted.value.centAmount", 0) / 100).toFixed(2) : 0;
    if ((isDiscount === null || isDiscount === void 0 ? void 0 : (ref = isDiscount.discount) === null || ref === void 0 ? void 0 : (ref1 = ref.obj) === null || ref1 === void 0 ? void 0 : ref1.value.type) === "absolute") {
        percentDiscount = installationDiscountedPrice > 0 && Number(get_default()(masterVariantPrice.find((item)=>item.discounted.value.currencyCode === currencyCode), "discounted.discount.obj.value.money[0].centAmount", 0) / 100);
        percentType = "absolute";
    } else {
        percentDiscount = installationDiscountedPrice > 0 && Number(get_default()(masterVariantPrice.find((item)=>item.discounted.value.currencyCode === currencyCode), "discounted.discount.obj.value.permyriad", 0) / 100);
        percentType = "relative";
    }
    const designServicePrice = Number(get_default()(masterVariantPrice.find((item)=>item.value.currencyCode === currencyCode), "value.centAmount", 0) / 100).toFixed(2);
    const designServiceDiscountedPrice = !isEmpty_default()(isDiscount) ? Number(get_default()(masterVariantPrice.find((item)=>item.discounted.value.currencyCode === currencyCode), "discounted.value.centAmount", 0) / 100).toFixed(2) : 0;
    const masterVariantAttributes = get_default()(masterVariant, "attributes", []);
    const ProductWebFeatures = get_default()(masterVariantAttributes.find((attr)=>attr.name === "ProductWebFeatures"), "value", []);
    const customerFacingSKU = get_default()(masterVariantAttributes.find((attr)=>attr.name === "CustomerFacingSKU"), "value", []);
    const productBrand = get_default()(masterVariantAttributes.find((attr)=>attr.name === "CustomerFacingBrand"), "value", []);
    const discountPriceState = designServiceDiscountedPrice > 0 ? "percentOff|" + percentDiscount : "regular price";
    let desc = "";
    ProductWebFeatures.slice(0, 3).forEach((item)=>{
        desc += item[locale] || "";
        if (desc && desc[desc.length - 1] !== ".") {
            desc += ". ";
        }
    });
    (0,react.useEffect)(()=>{
        setTimeout(()=>{
            addDataLayerToFindAProLinkAddOnServices();
        }, waitTimeForAddAnInstallationSectionToLoad);
    }, []);
    const addDataLayerToFindAProLinkAddOnServices = ()=>{
        if (addAnInstallationRef.current) {
            const findAProAnchorLink = addAnInstallationRef.current.querySelector("a");
            if (findAProAnchorLink) {
                findAProAnchorLink.classList.add("gbh-data-layer");
                const eventInfo = JSON.stringify({
                    eventAction: "pdp:add-on services:find a pro",
                    eventMsg: "n/a",
                    eventName: "pdp:add-on services:find a pro",
                    eventStatus: "n/a",
                    eventType: "navigation",
                    internalLinkName: "find a pro",
                    internalLinkPosition: "pdp",
                    internalLinkType: "pdp:find a pro",
                    internalLinkURL: findAProAnchorLink.getAttribute("href"),
                    internalLinkZoneName: "pdp:add-on services"
                });
                findAProAnchorLink.setAttribute("data-gbh-data-layer", eventInfo);
                findAProAnchorLink.setAttribute("data-gbh-data-layer-custom", getProductInfo());
            }
        }
    };
    const handleCheckAvailability = async ()=>{
        setZipCodeError({
            show: false,
            message: ""
        });
        let valid = true;
        let errMsg = "";
        if (isEmpty_default()(checkZipCode)) {
            errMsg = zipcodeEmptyError;
            setZipCodeError({
                show: true,
                message: errMsg
            });
            valid = false;
        } else if (!(0,helper.validateField)("zipcode", checkZipCode)) {
            errMsg = validZipcode;
            setZipCodeError({
                show: true,
                message: errMsg
            });
            valid = false;
        } else if (!await (0,utils_location/* validateZip */.$8)(checkZipCode)) {
            errMsg = validZipcode;
            setZipCodeError({
                show: true,
                message: errMsg
            });
            valid = false;
        }
        if (valid) {
            getZipCode(checkZipCode, handleZipCodeCallBack);
        } else {
            addDataLayerOnCheckAvailability(errMsg, (installationServiceData === null || installationServiceData === void 0 ? void 0 : installationServiceData.sectionHeading) || "", checkZipCode, productInfo);
        }
    };
    const handleZipCodeCallBack = (isServiceAvailable)=>{
        setIsNearest(isServiceAvailable);
        setIsCheckAvailability(!isServiceAvailable);
        setIsNearestError(!isServiceAvailable);
        setUserZipCode(isServiceAvailable ? checkZipCode : "");
        var ref;
        const textMsg = isServiceAvailable ? null : (0,helper.cleanText)((ref = installationServiceData === null || installationServiceData === void 0 ? void 0 : installationServiceData.errorMessage) !== null && ref !== void 0 ? ref : eligibleZipCodeError);
        const plainTextMsg = textMsg ? (0,helper.sanitizeTextForAnalytics)(textMsg) : "";
        addDataLayerOnCheckAvailability(plainTextMsg, (installationServiceData === null || installationServiceData === void 0 ? void 0 : installationServiceData.sectionHeading) || "", checkZipCode, productInfo);
        if (isServiceAvailable) {
            sessionStorage.setItem("zipCodeError", "");
            sessionStorage.setItem("verifiedZip", checkZipCode);
        } else {
            sessionStorage.setItem("verifiedZip", "");
            sessionStorage.setItem("zipCodeError", checkZipCode);
        }
        setTimeout(()=>{
            document.querySelector(".product-detail-page__right-sticky").scrollIntoView({
                behavior: "smooth",
                block: "end",
                inline: "nearest"
            });
        }, 100);
    };
    const beforeUnLoad = ()=>{
        sessionStorage.setItem("zipCodeError", "");
        sessionStorage.setItem("onChangeZip", "");
    };
    (0,react.useEffect)(()=>{
        window.addEventListener("beforeunload", beforeUnLoad);
        return ()=>{
            window.removeEventListener("beforeunload", beforeUnLoad);
        };
    }, []);
    (0,react.useEffect)(()=>{
        const isVerifiedZip = sessionStorage.getItem("verifiedZip");
        const zipCodeError = sessionStorage.getItem("zipCodeError");
        const onChangeZip = sessionStorage.getItem("onChangeZip");
        if (isVerifiedZip) {
            setIsNearest(true);
            setIsCheckAvailability(false);
            setIsNearestError(false);
            setUserZipCode(isVerifiedZip);
        } else if (zipCodeError) {
            setIsNearest(false);
            setIsCheckAvailability(true);
            setIsNearestError(true);
            setCheckZipCode(zipCodeError);
        }
        setCheckZipCode(onChangeZip);
    }, []);
    const handleClickChange = ()=>{
        setIsCheckAvailability(true);
        setIsNearest(false);
        setUserZipCode("");
        setCheckZipCode("");
    };
    const handleChangeZipCode = (e)=>{
        const zipCodeVal = e.target.value;
        const regExp = /^[0-9\b]+$/;
        setIsNearestError(false);
        if (regExp.test(zipCodeVal) || zipCodeVal === "") {
            sessionStorage.setItem("onChangeZip", zipCodeVal);
            sessionStorage.setItem("verifiedZip", "");
            setCheckZipCode(zipCodeVal);
        } else if (!zipCodeVal || (0,helper.validateField)("zipcode", zipCodeVal)) {
            setZipCodeError({
                show: false,
                message: ""
            });
        }
    };
    const description = (ref2 = (0,helper.sanitizeTextForAnalytics)(desc)) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase();
    const serviceProductName = (0,helper.sanitizeTextForAnalytics)(bathroomDesignService);
    const globalPromotionPrice = designServiceDiscountedPrice > 0 ? designServiceDiscountedPrice : designServicePrice;
    const productInfo = {
        productBrand: general === null || general === void 0 ? void 0 : (ref3 = general.siteName) === null || ref3 === void 0 ? void 0 : ref3.toLowerCase(),
        description: description || "n/a",
        frequency: "n/a",
        globalPromotionPrice: globalPromotionPrice || "n/a",
        isRecommended: "n/a",
        isSendNow: "n/a",
        isSubscription: "n/a",
        priceState: discountPriceState,
        productBasePrice: designServicePrice || "n/a",
        productCategory: "install service",
        productColor: "n/a",
        productCoupondiscount: "n/a",
        productID: customerFacingSKU || "n/a",
        productName: serviceProductName || "n/a",
        productPartnerBuyNow: "n/a",
        productRoom: "install service",
        productSalePrice: globalPromotionPrice,
        productSaleable: "true",
        productStatus: "in stock",
        productSuperSku: false,
        productTileName: serviceProductName || "n/a",
        quantity: 1,
        defaultImageName: "n/a",
        ratings: "n/a",
        numberOfReviews: "n/a",
        pdpType: pdpType,
        productFindingMethod: "n/a",
        productCollectionsName: "install service"
    };
    const handleAddToCartCallBack = (res)=>{
        (0,analytics/* dataLayerAddToCart */.fE)({
            res,
            productInfo
        }, installationServiceData.sectionHeading);
    };
    const handleAddToCart = ()=>{
        const item = {
            sku: sku,
            quantity: 1,
            userZipCode: userZipCode,
            brand: productBrand
        };
        const { quantity  } = item;
        const itemCountMessage = "".concat(quantity, " ").concat(serviceItemsAdded, " ");
        const ToasterMsg = "".concat(itemCountMessage, "<a href=").concat(cartUrl, ">").concat(yourCart, "</a>.");
        (0,addTocart/* addToCartItem */.q)([
            {
                ...item,
                isBundle: false,
                backorder: false
            }
        ]).then((response)=>{
            const body = {
                actions: response
            };
            dispatch((0,cartSlice/* addToCart */.Xq)(body)).unwrap().then((res)=>{
                if (res) {
                    handleAddToCartCallBack(res);
                    if (lib/* isMobile */.tq) {
                        dispatch((0,genericSlice/* showToast */.CF)({
                            message: ToasterMsg,
                            isVisible: true
                        }));
                    } else {
                        dispatch((0,genericSlice/* showPreviewCart */.z0)());
                    }
                }
            });
        });
    };
    const getProductInfo = ()=>{
        return JSON.stringify({
            productInfo
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (AddanInstallation_index_module_default()).addAnInstallationWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "row no-gutters product-detail-page__installation",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "pdp-add-an-installation col-12",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "pdp-add-an-installation__left title",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                className: "pdp-add-an-installation__title",
                                children: [
                                    installationServiceData.sectionHeading !== null ? installationServiceData.sectionHeading : installServiceTitle,
                                    isNearest ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            " ".concat(forText, "  ").concat(userZipCode),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                role: "button",
                                                tabIndex: "0",
                                                className: "pdp-add-an-installation__eligible-service-edit gbh-data-layer",
                                                "data-gbh-data-layer": getEventInfo("edit", "", (installationServiceData === null || installationServiceData === void 0 ? void 0 : installationServiceData.sectionHeading) || ""),
                                                "data-gbh-data-layer-custom": getProductInfo(),
                                                onClick: handleClickChange,
                                                children: " ".concat(change)
                                            })
                                        ]
                                    }) : null
                                ]
                            }),
                            !isNearest ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "guidText",
                                children: zipCodeGuidText
                            }) : null
                        ]
                    }),
                    isNearest ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "pdp-add-an-installation__right",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "pdp-add-an-installation__price",
                            children: [
                                installationPrice && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "pdp-add-an-installation__original-price",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                        value: installationDiscountedPrice > 0 ? installationDiscountedPrice : installationPrice,
                                        displayType: "text",
                                        thousandSeparator: true,
                                        prefix: currencySign,
                                        decimalScale: 2,
                                        fixedDecimalScale: true
                                    })
                                }),
                                installationDiscountedPrice > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "pdp-add-an-installation__discount-price",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            className: "pdp-add-an-installation__percent-discount",
                                            children: [
                                                percentType === "absolute" ? currencySign + percentDiscount : percentDiscount + "%",
                                                " ".concat(percentOff)
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                            value: installationPrice,
                                            displayType: "text",
                                            thousandSeparator: true,
                                            prefix: currencySign,
                                            decimalScale: 2,
                                            fixedDecimalScale: true
                                        })
                                    ]
                                })
                            ]
                        })
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "pdp-add-an-installation__left",
                        children: [
                            isCheckAvailability ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "pdp-add-an-installation__zipcode-availability",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                                id: "zipcode_".concat(key),
                                                type: "text",
                                                maxLength: 5,
                                                ariaRequried: true,
                                                placeholder: "".concat(zipcode),
                                                label: "".concat(zipcode),
                                                value: checkZipCode,
                                                onKeyDown: (e)=>e.key === "Enter" && handleCheckAvailability(),
                                                customClass: "".concat(zipCodeError.show ? "pdp-add-an-installation__zipcode-input-error" : ""),
                                                onChange: (e)=>handleChangeZipCode(e)
                                            }),
                                            checkZipCode ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                role: "button",
                                                label: search,
                                                size: "small ghost",
                                                type: "primary",
                                                onClick: handleCheckAvailability,
                                                disabled: checkZipCode.length < 5,
                                                useDefaultClass: true
                                            }) : null
                                        ]
                                    }),
                                    zipCodeError.show ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "zipcode-error",
                                        children: zipCodeError.message
                                    }) : null
                                ]
                            }) : isNearest ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                role: "alert",
                                "aria-live": "polite",
                                className: "pdp-add-an-installation__eligible-service-message",
                                ref: addAnInstallationRef,
                                children: (0,helper.sanitizeInnerHtml)(eligibleZipCodeSuccess)
                            }) : null,
                            isNearestError ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "zipcode-error",
                                children: (0,helper.sanitizeInnerHtml)(eligibleZipCodeError)
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "pdp-add-an-installation__right buttonGroup",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "pdp-add-an-installation__button-tab",
                            children: [
                                !isNearestError ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: installationServiceDataCtaLink,
                                    className: "pdp-add-an-installation__learn-more gbh-data-layer",
                                    target: installationServiceData.newTab ? "_blank" : "_self",
                                    "aria-label": serviceLearnMore,
                                    "data-gbh-data-layer": getEventInfo("learn more", installationServiceDataCtaLink !== null && installationServiceDataCtaLink !== void 0 ? installationServiceDataCtaLink : "/", (installationServiceData === null || installationServiceData === void 0 ? void 0 : installationServiceData.sectionHeading) || ""),
                                    "data-gbh-data-layer-custom": getProductInfo(),
                                    rel: "noreferrer",
                                    children: installationServiceData.ctaLabel
                                }) : null,
                                isNearest && !disableEcommerce ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    role: "button",
                                    ariaLabel: serviceAddToCart,
                                    label: addService,
                                    size: "small",
                                    type: "primary",
                                    disabled: !isNearest,
                                    onClick: handleAddToCart,
                                    useDefaultClass: true
                                }) : null
                            ]
                        })
                    })
                ]
            })
        })
    });
};
AddanInstallation.defaultProps = {
    currencySign: "",
    price: "",
    staticTexts: {
        learnMore: "",
        addToCart: ""
    }
};
AddanInstallation.propTypes = {
    currencySign: (prop_types_default()).string.isRequired,
    price: (prop_types_default()).string.isRequired,
    staticTexts: prop_types_default().shape({
        learnMore: (prop_types_default()).string.isRequired,
        addToCart: (prop_types_default()).string.isRequired
    })
};
/* harmony default export */ var v3_AddanInstallation = ((0,lib/* withOrientationChange */.Qe)(AddanInstallation));

;// CONCATENATED MODULE: ./src/components/ProductDetail/v3/DesignServices/analytics.js
const analytics_getEventInfo = (type, url)=>{
    return JSON.stringify({
        eventAction: "pdp:cross-sell:kohler professional services:".concat(type),
        eventName: "pdp:cross-sell:kohler professional services:".concat(type),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: type,
        internalLinkPosition: "pdp",
        internalLinkType: "pdp:bathroom design services",
        internalLinkZoneName: "pdp:cross-sell:kohler professional services",
        internalLinkURL: url ? (url.indexOf("http") === -1 ? window.location.origin : "") + url : "n/a",
        clickInternalLinks: "true"
    });
};

// EXTERNAL MODULE: ./src/components/ProductDetail/v3/DesignServices/index.module.scss
var DesignServices_index_module = __webpack_require__(35825);
var DesignServices_index_module_default = /*#__PURE__*/__webpack_require__.n(DesignServices_index_module);
;// CONCATENATED MODULE: ./src/components/ProductDetail/v3/DesignServices/index.jsx
















const DesignServices = (props)=>{
    var ref, ref1, ref2, ref3;
    const { width =0 , staticTexts ={} , designServiceAPIData =[] , locale ="" , currencyCode ="" , currencySign ="" , designServiceListData ={} , pdpType ="" , replaceAddToCart =false , replaceAddToCartCtaLink ="" , replaceAddToCartCtaLabel ="" , linkNewTab =false , disableEcommerce =false , cart ={} , sku =""  } = props;
    const dispatch = (0,es/* useDispatch */.I0)();
    const quantity = 1;
    const [general, setGeneral] = (0,react.useState)({});
    const [cartUrl, setCartUrl] = (0,react.useState)("");
    const [ctaLink, setCtaLink] = (0,react.useState)("");
    (0,react.useEffect)(()=>{
        (0,config/* getConfig */.i)().then((config)=>{
            const { general  } = config;
            setGeneral(general);
        });
    }, []);
    (0,react.useEffect)(()=>{
        if (!isEmpty_default()(general)) {
            var _cartLandingPagePath;
            (0,helper.getShortenedUrl)((_cartLandingPagePath = general.cartLandingPagePath) !== null && _cartLandingPagePath !== void 0 ? _cartLandingPagePath : "/").then((res)=>setCartUrl(res));
        }
    }, [
        general
    ]);
    (0,react.useEffect)(()=>{
        if (designServiceListData === null || designServiceListData === void 0 ? void 0 : designServiceListData.ctaLink) {
            (0,helper.getShortenedUrl)(designServiceListData.ctaLink).then((res)=>setCtaLink(res));
        }
    }, [
        designServiceListData.ctaLink
    ]);
    const addtoCart = (item)=>{
        const { quantity  } = item;
        const { serviceItemsAdded , yourCart  } = staticTexts;
        const itemCountMessage = "".concat(quantity, " ").concat(serviceItemsAdded, " ");
        const ToasterMsg = "".concat(itemCountMessage, "<a href=").concat(cartUrl, ">").concat(yourCart, "</a>.");
        (0,addTocart/* addToCartItem */.q)([
            {
                ...item,
                isBundle: false,
                backorder: false
            }
        ]).then((response)=>{
            const body = {
                actions: response
            };
            dispatch((0,cartSlice/* addToCart */.Xq)(body)).unwrap().then((res)=>{
                if (res) {
                    if (lib/* isMobile */.tq) {
                        dispatch((0,genericSlice/* showToast */.CF)({
                            message: ToasterMsg,
                            isVisible: true
                        }));
                    } else {
                        dispatch((0,genericSlice/* showPreviewCart */.z0)());
                    }
                }
            });
        });
    };
    let percentDiscount;
    let percentType;
    const designServiceTitle = get_default()(designServiceAPIData[0], "name[".concat(locale, "]"), false);
    const masterVariant = get_default()(designServiceAPIData[0], "masterVariant", []);
    const masterVariantPrice = get_default()(masterVariant, "prices", []);
    const designServicePrice = Number(get_default()(masterVariantPrice.find((item)=>item.value.currencyCode === currencyCode), "value.centAmount", 0) / 100).toFixed(2);
    const isDiscount = get_default()(masterVariantPrice[0], "discounted", {});
    const designServiceDiscountedPrice = !isEmpty_default()(isDiscount) ? Number(get_default()(masterVariantPrice.find((item)=>item.discounted.value.currencyCode === currencyCode), "discounted.value.centAmount", 0) / 100).toFixed(2) : 0;
    if ((isDiscount === null || isDiscount === void 0 ? void 0 : (ref = isDiscount.discount) === null || ref === void 0 ? void 0 : (ref1 = ref.obj) === null || ref1 === void 0 ? void 0 : ref1.value.type) === "absolute") {
        percentDiscount = designServiceDiscountedPrice > 0 && Number(get_default()(masterVariantPrice.find((item)=>item.discounted.value.currencyCode === currencyCode), "discounted.discount.obj.value.money[0].centAmount", 0) / 100);
        percentType = "absolute";
    } else {
        percentDiscount = designServiceDiscountedPrice > 0 && Number(get_default()(masterVariantPrice.find((item)=>item.discounted.value.currencyCode === currencyCode), "discounted.discount.obj.value.permyriad", 0) / 100);
        percentType = "relative";
    }
    const masterVariantAttributes = get_default()(masterVariant, "attributes", []);
    const ProductWebFeatures = get_default()(masterVariantAttributes.find((attr)=>attr.name === "ProductWebFeatures"), "value", []);
    let desc = "";
    ProductWebFeatures.slice(0, 3).forEach((item)=>{
        desc += item[locale];
        if (desc && desc[desc.length - 1] !== ".") {
            desc += ". ";
        }
    });
    const customerFacingSKU = get_default()(masterVariantAttributes.find((attr)=>attr.name === "CustomerFacingSKU"), "value", []);
    const productBrand = get_default()(masterVariantAttributes.find((attr)=>attr.name === "CustomerFacingBrand"), "value", []);
    const discountPriceState = designServiceDiscountedPrice > 0 ? "percentOff|" + percentDiscount : "regular price";
    const handleAddToCart = ()=>{
        addtoCart({
            sku: sku,
            quantity: quantity,
            brand: productBrand
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (DesignServices_index_module_default()).designServicesWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "pdp-design-services",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "pdp-design-services__left",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "pdp-design-services__title",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            children: designServiceTitle ? designServiceTitle : staticTexts.bathroomDesignService
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "pdp-design-services__right",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "pdp-design-services__price",
                        children: [
                            designServicePrice && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "pdp-design-services__original-price",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                    value: designServiceDiscountedPrice > 0 ? designServiceDiscountedPrice : designServicePrice,
                                    displayType: "text",
                                    thousandSeparator: true,
                                    prefix: currencySign,
                                    decimalScale: 2,
                                    fixedDecimalScale: true
                                })
                            }),
                            designServiceDiscountedPrice > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "pdp-design-services__discount-price",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "pdp-design-services__percent-discount",
                                        children: [
                                            percentType === "absolute" ? currencySign + percentDiscount : percentDiscount + "%",
                                            " ",
                                            staticTexts.percentOff
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                        value: designServicePrice,
                                        displayType: "text",
                                        thousandSeparator: true,
                                        prefix: currencySign,
                                        decimalScale: 2,
                                        fixedDecimalScale: true
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "pdp-design-services__left ".concat(width < 768 || width >= 1024 && width <= 1600 ? "--full-width" : ""),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "pdp-design-services__description",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            children: ProductWebFeatures.slice(0, 3).map((item, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    className: "pdp-design-services__list-item",
                                    children: item[locale]
                                }, i))
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "pdp-design-services__right ".concat(width < 768 || width >= 1024 && width <= 1600 ? "--full-width" : ""),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "pdp-design-services__button-tab",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: ctaLink,
                                className: "pdp-design-services__learn-more gbh-data-layer",
                                target: designServiceListData.newTab ? "_blank" : "_self",
                                "aria-label": staticTexts.ariaLabel.designServiceLearnMore,
                                "data-gbh-data-layer": analytics_getEventInfo("learn more", designServiceListData.ctaLink),
                                "data-gbh-data-layer-custom": '{"productInfo":{"productBrand":"'.concat(general === null || general === void 0 ? void 0 : (ref2 = general.siteName) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase(), '","description":"').concat((0,helper.sanitizeTextForAnalytics)(desc) || "n/a", '","frequency":"n/a","globalPromotionPrice":"').concat(designServiceDiscountedPrice > 0 ? designServiceDiscountedPrice : designServicePrice, '","isRecommended":"n/a","isSendNow":"n/a","isSubscription":"n/a","priceState":"').concat(discountPriceState, '","productBasePrice":"').concat(designServicePrice || "n/a", '","productCategory":"design services","productColor":"n/a","productCoupondiscount":"n/a","productID":"').concat(customerFacingSKU || "n/a", '","productName":"').concat((0,helper.sanitizeTextForAnalytics)(staticTexts.bathroomDesignService) || "n/a", '","productPartnerBuyNow":"n/a","productRoom":"design services","productSalePrice":"').concat(designServiceDiscountedPrice > 0 ? designServiceDiscountedPrice : designServicePrice, '","productSaleable":"true","productStatus":"in stock","productSuperSku":false,"productTileName":"').concat((0,helper.sanitizeTextForAnalytics)(staticTexts.bathroomDesignService) || "n/a", '","quantity":1,"defaultImageName":"n/a","ratings":"n/a","numberOfReviews":"n/a","pdpType":"').concat(pdpType, '","productFindingMethod":"n/a","productCollectionsName":"design services"}}'),
                                rel: "noreferrer",
                                children: designServiceListData.ctaLabel
                            }),
                            replaceAddToCart ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                role: "button",
                                ariaLabel: replaceAddToCartCtaLabel,
                                label: replaceAddToCartCtaLabel,
                                size: "small",
                                type: "primary",
                                to: replaceAddToCartCtaLink,
                                target: linkNewTab ? "_blank" : "_self"
                            }) : "",
                            !disableEcommerce ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                className: "gbh-data-layer",
                                "data-gbh-data-layer": analytics_getEventInfo("add to cart", "".concat(window.location.origin).concat(window.location.pathname)),
                                "data-gbh-data-layer-custom": '{"page":{"cart":{"cartID":"'.concat(cart === null || cart === void 0 ? void 0 : cart.id, '"}},"productInfo":{"productBrand":"').concat(general === null || general === void 0 ? void 0 : (ref3 = general.siteName) === null || ref3 === void 0 ? void 0 : ref3.toLowerCase(), '","description":"').concat((0,helper.sanitizeTextForAnalytics)(desc) || "n/a", '","frequency":"n/a","globalPromotionPrice":"').concat(designServiceDiscountedPrice > 0 ? designServiceDiscountedPrice : designServicePrice, '","isRecommended":"n/a","isSendNow":"n/a","isSubscription":"n/a","priceState":"').concat(discountPriceState, '","productBasePrice":"').concat(designServicePrice || "n/a", '","productCategory":"design services","productColor":"n/a","productCoupondiscount":"n/a","productID":"').concat(customerFacingSKU || "n/a", '","productName":"').concat((0,helper.sanitizeTextForAnalytics)(staticTexts.bathroomDesignService) || "n/a", '","productPartnerBuyNow":"n/a","productRoom":"design services","productSalePrice":"').concat(designServiceDiscountedPrice > 0 ? designServiceDiscountedPrice : designServicePrice, '","productSaleable":"true","productStatus":"in stock","productSuperSku":false,"productTileName":"').concat((0,helper.sanitizeTextForAnalytics)(staticTexts.bathroomDesignService) || "n/a", '","quantity":1,"defaultImageName":"n/a","ratings":"n/a","numberOfReviews":"n/a","pdpType":"').concat(pdpType, '","productFindingMethod":"n/a","productCollectionsName":"design services"}}'),
                                role: "button",
                                ariaLabel: staticTexts.ariaLabel.addProductService,
                                label: staticTexts.addService,
                                size: "small",
                                type: "primary",
                                onClick: handleAddToCart,
                                useDefaultClass: true
                            }) : ""
                        ]
                    })
                })
            ]
        })
    });
};
DesignServices.defaultProps = {
    description: [],
    currencySign: "",
    price: "",
    staticTexts: {
        learnMore: "",
        addToCart: ""
    }
};
DesignServices.propTypes = {
    description: prop_types_default().arrayOf((prop_types_default()).string).isRequired,
    currencySign: (prop_types_default()).string.isRequired,
    price: (prop_types_default()).string.isRequired,
    staticTexts: prop_types_default().shape({
        learnMore: (prop_types_default()).string.isRequired,
        addToCart: (prop_types_default()).string.isRequired
    })
};
/* harmony default export */ var v3_DesignServices = ((0,lib/* withOrientationChange */.Qe)(DesignServices));

// EXTERNAL MODULE: ./node_modules/react-collapsible/dist/index.js
var dist = __webpack_require__(97893);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
// EXTERNAL MODULE: ./utils/index.js
var utils = __webpack_require__(20558);
;// CONCATENATED MODULE: ./src/components/ProductDetail/v3/ProductAccordionList/productAccordion.jsx




const productAccordion = (props)=>{
    const { title ="" , analyticTitleData =null , analyticTitleCustomData =null , showOnPrint =false , handleOpen =()=>{} , handleClose =()=>{} , isOpen =false , children =undefined  } = props;
    const CollapsibleHeader = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "collapsible__header gbh-data-layer",
            "data-gbh-data-layer": analyticTitleData,
            "data-gbh-data-layer-custom": analyticTitleCustomData,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    role: "heading",
                    "aria-level": "2",
                    children: title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "plus",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "line line-1"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "line line-2"
                        })
                    ]
                })
            ]
        });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "pdp-support-files container-fluid ".concat(!showOnPrint ? "no-print" : ""),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "pdp-support-files__content collapsible-accordion",
            "data-testid": "product-accordion-".concat(title),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((dist_default()), {
                trigger: /*#__PURE__*/ (0,jsx_runtime.jsx)(CollapsibleHeader, {}),
                onTriggerOpening: handleOpen,
                onTriggerClosing: handleClose,
                triggerOpenedClassName: "collapsible__trigger--open",
                open: isOpen,
                openedClassName: "collapsible--open",
                transitionTime: 400,
                tabIndex: "0",
                easing: "ease-in-out",
                triggerElementProps: {
                    id: (0,utils/* accordionUniqueId */.M0)("collapsible-trigger", 9999, 1000)
                },
                contentElementId: (0,utils/* accordionUniqueId */.M0)("collapsible-content", 9999, 1000),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "row no-gutters px-0",
                    "data-testid": "colapse-data-".concat(title),
                    "aria-disabled": isOpen,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "pdp-support-files__download-section col-12",
                        children: children
                    })
                })
            })
        })
    });
};
/* harmony default export */ var ProductAccordionList_productAccordion = (productAccordion);

// EXTERNAL MODULE: ./node_modules/dompurify/dist/purify.js
var purify = __webpack_require__(27856);
var purify_default = /*#__PURE__*/__webpack_require__.n(purify);
;// CONCATENATED MODULE: ./components/ProductDetail/v3/ProductAccordionList/AdditionalInfo.jsx




const DOMPurify =  true ? purify_default()(window) : 0;
const AdditionalInfo = (param)=>{
    let { data =[] , productAccordionText  } = param;
    const addInfoRef = (0,react.useRef)(null);
    const addMailAnalytics = (text, link)=>{
        const eventInfo = {
            clickInternalLinks: "true",
            eventAction: "pdp:additional information:email",
            eventName: "pdp:additional information:email",
            eventType: "navigation",
            internalLinkName: text,
            internalLinkPosition: "pdp",
            internalLinkType: "pdp:contact customer care",
            internalLinkZoneName: "pdp:additional information",
            internalLinkURL: link
        };
        const page = window.adobeDataLayer.getState("page");
        var _productInfo;
        window.adobeDataLayer.push({
            event: "cmp:click",
            eventInfo,
            page,
            productInfo: (_productInfo = page.productInfo) !== null && _productInfo !== void 0 ? _productInfo : null
        });
    };
    (0,react.useEffect)(()=>{
        // to add analytics for cutsomer care email
        const elem = addInfoRef.current.querySelectorAll('a[href^="mailto"]');
        if (elem[0]) {
            elem[0].addEventListener("click", ()=>addMailAnalytics(elem[0].innerText, elem[0].getAttribute("href")));
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
        ref: addInfoRef,
        className: "pdp-additional-info",
        children: data.map((item, i)=>item.data ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                        className: "pdp-spec-detail__title",
                        children: item.title
                    }),
                    item.title === productAccordionText.additionalInfo.contact || item.title === productAccordionText.additionalInfo.disclaimer || item.title === productAccordionText.additionalInfo.spareParts ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "pdp-features-technologies__list-item",
                        dangerouslySetInnerHTML: {
                            __html: DOMPurify ? DOMPurify.sanitize((0,helper.decodeHtmlCharacters)(item.data)) : (0,helper.decodeHtmlCharacters)(item.data)
                        }
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "pdp-features-technologies__list-item",
                        children: item.data
                    })
                ]
            }, i) : null)
    });
};
/* harmony default export */ var ProductAccordionList_AdditionalInfo = (AdditionalInfo);

;// CONCATENATED MODULE: ./components/ProductDetail/v3/ProductAccordionList/Policies.jsx


const Policies = (param)=>{
    let { staticTexts: text = {} , config ={}  } = param;
    const { legalPageData: { map: links = {}  } = {}  } = config;
    var _returnPolicy, _productWarranty;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
        className: "pdp-policies pdp-additional-info",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                        className: "pdp-spec-detail__title",
                        children: text.returnTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "pdp-features-technologies__list-item",
                        children: text.returnDesc
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: "pdp-spec-detail__title",
                        href: (_returnPolicy = links.returnPolicy) !== null && _returnPolicy !== void 0 ? _returnPolicy : "#",
                        target: "_blank",
                        rel: "noreferrer",
                        children: text.findMore
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                        className: "pdp-spec-detail__title",
                        children: text.warrantyTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "pdp-features-technologies__list-item",
                        children: text.warrantyDesc
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: "pdp-spec-detail__title",
                        href: (_productWarranty = links.productWarranty) !== null && _productWarranty !== void 0 ? _productWarranty : "#",
                        target: "_blank",
                        rel: "noreferrer",
                        children: text.findMore
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var ProductAccordionList_Policies = (Policies);

// EXTERNAL MODULE: ./components/core/Accordion/Accordion.module.scss
var Accordion_module = __webpack_require__(96724);
var Accordion_module_default = /*#__PURE__*/__webpack_require__.n(Accordion_module);
// EXTERNAL MODULE: ./components/ProductDetail/v3/ProductAccordionList/index.module.scss
var ProductAccordionList_index_module = __webpack_require__(92555);
var ProductAccordionList_index_module_default = /*#__PURE__*/__webpack_require__.n(ProductAccordionList_index_module);
;// CONCATENATED MODULE: ./components/ProductDetail/v3/ProductAccordionList/index.jsx
/* eslint-disable camelcase */ 
















const ProductAccordionList = (props)=>{
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17;
    const { width =0 , config ={} , productData ={} , productSku ="" , productInfo ={} , isDiscontinued =false , persona ="" , staticTexts ={} , accordionList =[] , installationDataFromProp =[] , designServiceDataFromProp =[] , disableEcommerce =false , isProjectPack =false , currencySign ="" , businessUnitName ="" , ProductPriceSpiderIncluded_s ="" , discontinuedProductb ="" , ProductRequiredAccessoriesGroupsList =[] , superSku ="" , designServiceData =[] , currencyCode ="" , locale ="" , replaceAddToCart =()=>{} , disableRatings =false , replaceAddToCartCtaLink =()=>{} , replaceAddToCartCtaLabel =()=>{} , linkNewTab =false , getZipCode =()=>{} , installationData =[] , installationSupportLinks =[] , productType ="" , productServices =[] , bundleItems =[] , bundleAdditionalFeatures =[] , isSSr =false  } = props;
    const { productAccordionText ={}  } = staticTexts;
    const defaultExpand = {
        feature: true,
        specs: false,
        designFile: false,
        installationSupport: false,
        addOnService: false,
        additionalInfo: false,
        policies: false,
        additionalBundleFeatures: false
    };
    const designFiles = {
        twoDimension: {
            plan: [],
            front: [],
            side: []
        },
        threeDimension: [],
        bim: [],
        cutout: []
    };
    const techFiles = [];
    var ref18;
    const installFiles = {
        productId: (ref18 = productData["ProductProductNo_s"]) !== null && ref18 !== void 0 ? ref18 : "",
        guides: {
            installationGuides: [],
            supportGuides: []
        },
        partsLinks: [],
        pdfPartsLinks: [],
        videos: [],
        supportLinks: []
    };
    const designFileType = {
        twoDimension: [
            {
                type: "DWG",
                fromProductData: "DWGPlanView",
                angleView: "plan"
            },
            {
                type: "DXF",
                fromProductData: "DXFPlanView",
                angleView: "plan"
            },
            {
                type: "DWG",
                fromProductData: "DWGFrontView",
                angleView: "front"
            },
            {
                type: "DXF",
                fromProductData: "DXFFrontView",
                angleView: "front"
            },
            {
                type: "DWG",
                fromProductData: "DWGSideView",
                angleView: "side"
            },
            {
                type: "DXF",
                fromProductData: "DXFSideView",
                angleView: "side"
            }
        ],
        threeDimension: [
            {
                type: "DWG",
                fromProductData: "3DDWGSymbol"
            },
            {
                type: "DXF",
                fromProductData: "3DDXFSymbol"
            },
            {
                type: "3DS",
                fromProductData: "3D3DS"
            },
            {
                type: "OBJ",
                fromProductData: "3DOBJ"
            },
            {
                type: "SKP",
                fromProductData: "3DSketchup"
            }
        ],
        bim: [
            {
                type: "RFA",
                fromProductData: "3DRevit"
            }
        ],
        cutout: [
            {
                type: "DXF",
                fromProductData: "CutOutDXF"
            }
        ]
    };
    const [isExpanded, setIsExpanded] = (0,react.useState)(defaultExpand);
    const [viewMore, setViewMore] = (0,react.useState)({
        [productAccordionText.features]: false,
        [productAccordionText.technologies]: false,
        [productAccordionText.hydrotherapy]: false,
        [productAccordionText.material]: false,
        [productAccordionText.rebates]: false,
        [productAccordionText.installation]: false,
        [productAccordionText.props65Warning]: false
    });
    const [currentSku, setCurrentSku] = (0,react.useState)(productSku);
    const [countryLists, setCountryLists] = (0,react.useState)([
        {
            text: "India",
            value: "IN"
        }
    ]);
    const [count, setCount] = (0,react.useState)(5);
    const handleViewRemaining = ()=>{
        setCount(bundleItems.length);
    };
    const dispatch = (0,es/* useDispatch */.I0)();
    const fetchCountry = async ()=>{
        try {
            const { payload: countryList = []  } = await dispatch((0,genericSlice/* getCountryList */.Jp)());
            if (countryList.length) {
                setCountryLists(countryList);
            }
        } catch (error) {
            log.error(error);
        }
    };
    (0,react.useEffect)(()=>{
        fetchCountry();
    }, []);
    (0,react.useEffect)(()=>{
        if (productSku !== "" && currentSku !== productSku) {
            setCurrentSku(productSku);
            setTimeout(()=>{
                setIsExpanded(defaultExpand);
            }, 500);
        }
    }, [
        productSku
    ]);
    const SetListData = (param)=>/*#__PURE__*/ {
        let { listData =[] , showType  } = param;
        return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    className: "pdp-features-technologies__feature-list",
                    children: listData.map((item, i)=>(i < 5 || i > 4 && viewMore[showType]) && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "pdp-features-technologies__list-item",
                            children: item.replace(/"/g, " inch")
                        }, i))
                }),
                listData.length > 5 && !viewMore[showType] && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: "pdp-features-technologies__view-more gbh-data-layer",
                    "data-gbh-data-layer": analytics_getEventInfoProdAccordion(productAccordionText.viewMore),
                    "data-gbh-data-layer-custom": productInfo,
                    onClick: ()=>setViewMore({
                            ...viewMore,
                            [showType]: true
                        }),
                    children: productAccordionText.viewMore
                })
            ]
        });
    };
    const handleSpecsDownload = (e, title, link)=>{
        e.stopPropagation();
        if (true) {
            var ref;
            let errMsg;
            const url = link.trim();
            try {
                window.open(url, "_blank");
            } catch (err) {
                errMsg = err.message;
            }
            const eventInfo = analytics_getEventInfoProdAccordion(title, true, url, errMsg);
            const dataLayerProductInfo = productInfo ? (ref = JSON.parse(productInfo)) === null || ref === void 0 ? void 0 : ref.productInfo : null;
            const { adobeDataLayer: { getState  } = {}  } = window;
            const page = getState && getState("page") || {};
            window.adobeDataLayer.push({
                event: "cmp:click",
                page,
                eventInfo,
                productInfo: dataLayerProductInfo
            });
        }
    };
    const organizeData = (data, name, placeHolder, type)=>data.map((item, i)=>{
            let obj = {
                title: name ? name[i] : "".concat(placeHolder, " ").concat(data.length > 1 ? i + 1 : "")
            };
            if (type === "part") {
                obj = {
                    ...obj,
                    id: item
                };
            } else {
                obj = {
                    ...obj,
                    type,
                    url: item
                };
            }
            return obj;
        });
    Object.keys(designFileType).forEach((fileType)=>{
        designFileType[fileType] && designFileType[fileType].forEach((file)=>{
            if (productData["ProductResource.".concat(file.fromProductData, ".resourceFullWebURL_ss")]) {
                if (fileType === "twoDimension") {
                    designFiles[fileType][file.angleView].push({
                        type: file.type,
                        url: productData["ProductResource.".concat(file.fromProductData, ".resourceFullWebURL_ss")][0]
                    });
                } else {
                    designFiles[fileType].push({
                        type: file.type,
                        url: productData["ProductResource.".concat(file.fromProductData, ".resourceFullWebURL_ss")][0]
                    });
                }
            }
        });
    });
    const designFilesLength = designFiles.twoDimension.plan.length + designFiles.twoDimension.front.length + designFiles.twoDimension.side.length + designFiles.threeDimension.length + designFiles.bim.length + designFiles.cutout.length;
    const getListValue = (arrayVal, stringVal)=>{
        if (productData[arrayVal]) {
            return productData[arrayVal];
        } else if (productData[stringVal]) {
            return [
                productData[stringVal]
            ];
        } else {
            return [];
        }
    };
    const featuresData = getListValue("ProductWebFeatures_ss", "ProductWebFeatures_s");
    const techData = getListValue("ProductWebTechnology_ss", "ProductWebTechnology_s");
    const webmaterialData = getListValue("ProductWebMaterial_ss", "ProductWebMaterial_s");
    const webInstallationData = getListValue("ProductWebInstallation_ss", "ProductWebInstallation_s");
    const prop65WarningData = getListValue("ProductCaliforniaProp65WarningDisclaimer_ss", "ProductCaliforniaProp65WarningDisclaimer_s");
    const webRebatesData = getListValue("ProductWebRebates_ss", "ProductWebRebates_s");
    const webHydrotherapyData = getListValue("ProductWebHydrotherapy_ss", "ProductWebHydrotherapy_s");
    const badges = getListValue("ProductBadgeInfo_ss", "ProductBadgeInfo_s");
    // check for technical files
    if (productData["ProductResource.SpecPDFFileName.resourceFullWebURL_ss"]) {
        techFiles.push(...organizeData(productData["ProductResource.SpecPDFFileName.resourceFullWebURL_ss"], productData["ProductResource.SpecPDFFileName.resourceTitle_ss"], productAccordionText.specsSheet, "PDF"));
    }
    if (productData["ProductResource.EnvironProdDecl.resourceFullWebURL_ss"]) {
        techFiles.push(...organizeData(productData["ProductResource.EnvironProdDecl.resourceFullWebURL_ss"], productData["ProductResource.EnvironProdDecl.resourceTitle_ss"], productAccordionText.envDeclaration, "PDF"));
    }
    const specDataLength = techData.length + webmaterialData.length + webInstallationData.length + prop65WarningData.length + webRebatesData.length + webHydrotherapyData.length + techFiles.length;
    const specsDetails = [
        {
            specTitle: productAccordionText.technologies,
            specList: techData
        },
        {
            specTitle: productAccordionText.hydrotherapy,
            specList: webHydrotherapyData
        },
        {
            specTitle: productAccordionText.material,
            specList: webmaterialData
        },
        {
            specTitle: productAccordionText.rebates,
            specList: webRebatesData
        },
        {
            specTitle: productAccordionText.installation,
            specList: webInstallationData
        },
        {
            specTitle: productAccordionText.props65Warning,
            specList: prop65WarningData
        }
    ];
    const additionalInfo = [
        {
            title: (ref = productAccordionText.additionalInfo) === null || ref === void 0 ? void 0 : ref.productCode,
            data: productSku
        },
        {
            title: (ref1 = productAccordionText.additionalInfo) === null || ref1 === void 0 ? void 0 : ref1.countryOfOrigin,
            data: (ref2 = countryLists === null || countryLists === void 0 ? void 0 : countryLists.find((list)=>{
                return list.value === (productData === null || productData === void 0 ? void 0 : productData.SKUCountryofOrigin_s);
            })) === null || ref2 === void 0 ? void 0 : ref2.text
        },
        {
            title: (ref3 = productAccordionText.additionalInfo) === null || ref3 === void 0 ? void 0 : ref3.dimensions,
            data: productData["ProductOverallLengthCm_d"] && parseFloat(productData["ProductOverallLengthCm_d"]) > 0 && "".concat(parseFloat(productData["ProductOverallLengthCm_d"]), " \xd7 ").concat(parseFloat(productData["ProductOverallWidthCm_d"]), " \xd7 ").concat(parseFloat(productData["ProductOverallHeightCm_d"]))
        },
        {
            title: productData["RegionSupplyChain_ss"],
            data: (ref4 = productAccordionText.additionalInfo) === null || ref4 === void 0 ? void 0 : ref4.importedBy
        },
        {
            title: (ref5 = productAccordionText.additionalInfo) === null || ref5 === void 0 ? void 0 : ref5.qty,
            data: (ref6 = productAccordionText.additionalInfo) === null || ref6 === void 0 ? void 0 : ref6.oneUnit
        },
        {
            title: (ref7 = productAccordionText.additionalInfo) === null || ref7 === void 0 ? void 0 : ref7.package,
            data: productData["ProductPackageContents_s"]
        },
        {
            title: (ref8 = productAccordionText.additionalInfo) === null || ref8 === void 0 ? void 0 : ref8.contact,
            data: (ref9 = productAccordionText.additionalInfo) === null || ref9 === void 0 ? void 0 : ref9.customerCare
        },
        {
            title: (ref10 = productAccordionText.additionalInfo) === null || ref10 === void 0 ? void 0 : ref10.spareParts,
            data: (ref11 = productAccordionText.additionalInfo) === null || ref11 === void 0 ? void 0 : ref11.sparePartsMsg
        },
        {
            title: (ref12 = productAccordionText.additionalInfo) === null || ref12 === void 0 ? void 0 : ref12.disclaimer,
            data: (ref13 = productAccordionText.additionalInfo) === null || ref13 === void 0 ? void 0 : ref13.disclaimerMsg
        }
    ];
    const Features = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "pdp-features-technologies__content",
            "aria-hidden": isExpanded.feature ? "false" : "true",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "pdp-features-technologies__container",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SetListData, {
                        listData: featuresData,
                        showType: productAccordionText.features
                    }),
                    watersense.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "pdp-features-technologies__icons",
                        children: watersense.map((icon, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: icon,
                                alt: "watersense icon"
                            }, i))
                    })
                ]
            })
        });
    const Specs = ()=>{
        /*#__PURE__*/ return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "pdp-technical-tile__files --specs-info",
                    children: techFiles.map((item, i)=>{
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("section", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "pdp-technical-tile__file",
                                role: "link",
                                tabIndex: 0,
                                onClick: (e)=>handleSpecsDownload(e, item.title, item.url),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        alt: "",
                                        "aria-hidden": "true",
                                        src: download_dark_gray/* default */.Z === null || download_dark_gray/* default */.Z === void 0 ? void 0 : download_dark_gray/* default.src */.Z.src
                                    }),
                                    item.title
                                ]
                            })
                        }, i);
                    })
                }),
                specsDetails.map((subCategory, i)=>subCategory.specList.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "pdp-spec-detail__container",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "pdp-spec-detail__title",
                                children: subCategory.specTitle
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SetListData, {
                                listData: subCategory.specList,
                                showType: subCategory.specTitle
                            })
                        ]
                    }, i))
            ]
        });
    };
    const DesignComponent = ()=>!isDiscontinued && designServiceDataFromProp.map((list, i)=>{
            const { productType: productTypes = []  } = list;
            return productTypes.includes(productType) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "row no-gutters product-detail-page__design-services",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v3_DesignServices, {
                    staticTexts: staticTexts,
                    currencySign: currencySign,
                    pdpType: (0,helper.pdpTypeFormat)({
                        businessUnitName: businessUnitName,
                        ProductPriceSpiderIncluded_s: ProductPriceSpiderIncluded_s,
                        discontinuedProductb: discontinuedProductb,
                        ProductRequiredAccessoriesGroupsList: ProductRequiredAccessoriesGroupsList,
                        superSku: superSku
                    }),
                    sku: list.sku,
                    designServiceAPIData: designServiceData.filter((item)=>item.masterVariant.sku === list.sku),
                    persona: persona,
                    designServiceListData: list,
                    currencyCode: currencyCode,
                    locale: locale,
                    width: width,
                    replaceAddToCart: replaceAddToCart,
                    disableRatings: disableRatings,
                    replaceAddToCartCtaLink: replaceAddToCartCtaLink,
                    replaceAddToCartCtaLabel: replaceAddToCartCtaLabel,
                    linkNewTab: linkNewTab,
                    disableEcommerce: disableEcommerce
                })
            }, i);
        });
    const InstallComponent = ()=>!isDiscontinued && installationDataFromProp.map((list, index)=>{
            return productServices && productServices.includes(list.sku) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(v3_AddanInstallation, {
                staticTexts: staticTexts,
                currencySign: currencySign,
                locale: locale,
                persona: persona,
                getZipCode: getZipCode,
                installtionAPIData: installationData.filter((item)=>item.masterVariant.sku === list.sku),
                sku: list.sku,
                installationServiceData: list,
                currencyCode: currencyCode,
                pdpType: (0,helper.pdpTypeFormat)({
                    businessUnitName,
                    ProductPriceSpiderIncluded_s,
                    discontinuedProductb,
                    ProductRequiredAccessoriesGroupsList,
                    superSku
                }),
                width: width,
                replaceAddToCart: replaceAddToCart,
                disableRatings: disableRatings,
                replaceAddToCartCtaLink: replaceAddToCartCtaLink,
                replaceAddToCartCtaLabel: replaceAddToCartCtaLabel,
                linkNewTab: linkNewTab,
                disableEcommerce: disableEcommerce
            }, index) : null;
        });
    const AddOnService = (props)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DesignComponent, {
                    replaceAddToCart: replaceAddToCart,
                    disableRatings: disableRatings,
                    replaceAddToCartCtaLink: replaceAddToCartCtaLink,
                    replaceAddToCartCtaLabel: replaceAddToCartCtaLabel,
                    linkNewTab: linkNewTab,
                    disableEcommerce: disableEcommerce
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(InstallComponent, {
                    replaceAddToCart: replaceAddToCart,
                    disableRatings: disableRatings,
                    replaceAddToCartCtaLink: replaceAddToCartCtaLink,
                    replaceAddToCartCtaLabel: replaceAddToCartCtaLabel,
                    linkNewTab: linkNewTab,
                    disableEcommerce: disableEcommerce
                })
            ]
        });
    // check for installation & support files
    if (productData["ProductResource.InstallationWithoutSPPDF.resourceFullWebURL_ss"]) {
        installFiles.guides.installationGuides = organizeData(productData["ProductResource.InstallationWithoutSPPDF.resourceFullWebURL_ss"], productData["ProductResource.InstallationWithoutSPPDF.resourceTitle_ss"], productAccordionText.installationGuide, "PDF");
    }
    if (productData["ProductResource.HomeownersGuide.resourceFullWebURL_ss"]) {
        installFiles.guides.supportGuides = organizeData(productData["ProductResource.HomeownersGuide.resourceFullWebURL_ss"], productData["ProductResource.HomeownersGuide.resourceTitle_ss"], productAccordionText.homeOwnerGuide, "PDF");
    }
    if (productData["ProductResource.YouTubeInstallVideo.resourceName_ss"]) {
        installFiles.videos = organizeData(productData["ProductResource.YouTubeInstallVideo.resourceName_ss"], productData["ProductResource.YouTubeInstallVideo.resourceTitle_ss"], productAccordionText.installationVideo, "part");
    }
    if (productData["ProductResource.InteractiveSVG.resourceName_ss"]) {
        installFiles.partsLinks = organizeData(productData["ProductResource.InteractiveSVG.resourceName_ss"], productData["ProductResource.InteractiveSVG.resourceTitle_ss"], productAccordionText.partsDiagram, "part");
    }
    if (productData["ProductResource.PartsPDFFileName.resourceFullWebURL_ss"]) {
        installFiles.pdfPartsLinks = organizeData(productData["ProductResource.PartsPDFFileName.resourceFullWebURL_ss"], productData["ProductResource.PartsPDFFileName.resourceTitle_ss"], productAccordionText.partsDiagram, "part");
    }
    // Get support pages links from content fragment
    installFiles.supportLinks = (installationSupportLinks === null || installationSupportLinks === void 0 ? void 0 : installationSupportLinks.length) ? installationSupportLinks : [];
    const installationFilesLength = installFiles.guides.installationGuides.length + installFiles.guides.supportGuides.length + installFiles.partsLinks.length + installFiles.videos.length + installFiles.supportLinks.length;
    let listValue = [
        "Features",
        "Specs",
        "Installation & Support",
        "Design Files",
        "Available Services"
    ];
    if (persona === "TVS" || persona === "TPR") {
        listValue = [
            "Features",
            "Specs",
            "Design Files",
            "Installation & Support",
            "Available Services"
        ];
    } else if (accordionList.length > 0) {
        var ref19;
        listValue = accordionList.map((obj)=>{
            return (0,helper.decodeHtmlCharacters)((ref19 = obj === null || obj === void 0 ? void 0 : obj.value) !== null && ref19 !== void 0 ? ref19 : "");
        });
    }
    const isInstallService = installationDataFromProp.filter((obj)=>productServices && productServices.includes(obj.sku));
    const isDesignService = designServiceDataFromProp.filter((obj)=>obj.productType.includes(productType));
    const { feature , specs , designFile , installationSupport , addOnService  } = isExpanded;
    const componentList = {
        Features: {
            element: /*#__PURE__*/ (0,jsx_runtime.jsx)(Features, {}),
            title: productAccordionText.features,
            isExpanded: isExpanded.feature,
            keyValue: "feature",
            showAccordion: featuresData.length > 0,
            analyticData: analytics_accordianAnalyticsData(productAccordionText.features, isExpanded.feature)
        },
        Specs: {
            element: /*#__PURE__*/ (0,jsx_runtime.jsx)(Specs, {}),
            title: productAccordionText.specs,
            isExpanded: isSSr ? true : isExpanded.specs,
            keyValue: "specs",
            showAccordion: specDataLength > 0,
            analyticData: analytics_accordianAnalyticsData(productAccordionText.specs, isExpanded.specs)
        },
        "Design Files": {
            element: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductAccordionList_designFiles, {
                files: designFiles,
                staticTexts: productAccordionText,
                productInfo: productInfo,
                sku: productSku
            }),
            title: productAccordionText.designFiles,
            isExpanded: isSSr ? true : isExpanded.designFile,
            showAccordion: designFilesLength > 0,
            keyValue: "designFile",
            analyticData: analytics_accordianAnalyticsData(productAccordionText.designFiles, isExpanded.designFile)
        },
        "Installation & Support": {
            element: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductAccordionList_installationSupport, {
                files: installFiles,
                staticTexts: productAccordionText,
                productInfo: productInfo,
                sku: true,
                productSku: true
            }),
            title: productAccordionText.installationSupport,
            isExpanded: isSSr ? true : isExpanded.installationSupport,
            showAccordion: installationFilesLength > 0,
            keyValue: "installationSupport",
            analyticData: analytics_accordianAnalyticsData(productAccordionText.installationSupport, isExpanded.installationSupport)
        },
        "Available Services": {
            element: /*#__PURE__*/ (0,jsx_runtime.jsx)(AddOnService, {
                files: installFiles,
                staticTexts: productAccordionText,
                productInfo: productInfo,
                sku: productSku,
                replaceAddToCart: props.replaceAddToCart,
                disableRatings: props.disableRatings,
                replaceAddToCartCtaLink: props.replaceAddToCartCtaLink,
                replaceAddToCartCtaLabel: props.replaceAddToCartCtaLabel,
                linkNewTab: props.linkNewTab,
                disableEcommerce: props.disableEcommerce
            }),
            title: productAccordionText.addOnServices,
            isExpanded: isSSr ? true : isExpanded.addOnService,
            showAccordion: !isDiscontinued && !disableEcommerce && (isInstallService.length > 0 || isDesignService.length > 0) && !isProjectPack,
            keyValue: "addOnService",
            analyticData: analytics_accordianAnalyticsData(productAccordionText.addOnServices, isExpanded.addOnService)
        },
        "Additional Information": {
            element: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductAccordionList_AdditionalInfo, {
                data: additionalInfo,
                productAccordionText: productAccordionText
            }),
            title: (ref14 = productAccordionText.additionalInfo) === null || ref14 === void 0 ? void 0 : ref14.title,
            isExpanded: isSSr ? true : isExpanded.additionalInfo,
            keyValue: "additionalInformation",
            showAccordion: !bundleItems.length,
            analyticData: analytics_accordianAnalyticsData((ref15 = productAccordionText.additionalInfo) === null || ref15 === void 0 ? void 0 : ref15.title, isExpanded.additionalInfo)
        },
        "Returns & Warranty": {
            element: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductAccordionList_Policies, {
                staticTexts: productAccordionText.policies,
                config: config
            }),
            title: (ref16 = productAccordionText.policies) === null || ref16 === void 0 ? void 0 : ref16.title,
            isExpanded: isSSr ? true : isExpanded.policies,
            keyValue: "policies",
            showAccordion: true,
            analyticData: analytics_accordianAnalyticsData((ref17 = productAccordionText.policies) === null || ref17 === void 0 ? void 0 : ref17.title, isExpanded.policies)
        }
    };
    const watersense = badges.map(function() {
        let badge = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
        const watersenseList = badge.split("|");
        return watersenseList[2] || [];
    });
    const setAccordianState = (type, isOpen)=>{
        if (!isOpen) {
            setTimeout(()=>{
                setIsExpanded({
                    ...isExpanded,
                    [type]: isOpen
                });
            }, 500);
        } else {
            setIsExpanded({
                ...isExpanded,
                [type]: isOpen
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((Accordion_module_default()).accordionWrapper, " ").concat((ProductAccordionList_index_module_default()).productAccordionListWrapper),
        children: Object.keys(productData).length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "pdp-support-files__container product-specifications",
            children: [
                bundleAdditionalFeatures.length > 0 && bundleAdditionalFeatures.map((item, index)=>{
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(ProductAccordionList_productAccordion, {
                        title: item === null || item === void 0 ? void 0 : item.title,
                        isOpen: false,
                        showOnPrint: false,
                        handleOpen: ()=>setAccordianState(item.title, true),
                        handleClose: ()=>setAccordianState(item.title, false),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            className: "pdp-features-technologies__feature-list",
                            children: item.descriptions.map((element, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    className: "pdp-features-technologies__list-item",
                                    children: element
                                }, index))
                        })
                    }, index);
                }),
                listValue.map((list)=>{
                    var ref, ref1;
                    return ((ref = componentList[list]) === null || ref === void 0 ? void 0 : ref.showAccordion) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductAccordionList_productAccordion, {
                        title: componentList[list].title,
                        isOpen: (ref1 = componentList[list]) === null || ref1 === void 0 ? void 0 : ref1.isExpanded,
                        showOnPrint: list === "Features" || list === "Specs",
                        handleOpen: ()=>setAccordianState(componentList[list].keyValue, true),
                        handleClose: ()=>setAccordianState(componentList[list].keyValue, false),
                        analyticTitleData: componentList[list].analyticData,
                        analyticTitleCustomData: productInfo,
                        children: componentList[list].element
                    }, componentList[list].keyValue) : null;
                }),
                bundleItems.slice(0, count).map((item)=>{
                    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22;
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(ProductAccordionList_productAccordion, {
                        title: ((ref = productAccordionText.additionalInfo) === null || ref === void 0 ? void 0 : ref.title) + " - ".concat(item.sku),
                        isOpen: false,
                        showOnPrint: false,
                        handleOpen: ()=>setAccordianState(item.sku, true),
                        handleClose: ()=>setAccordianState(item.sku, false),
                        analyticTitleData: analytics_accordianAnalyticsData(((ref1 = productAccordionText.additionalInfo) === null || ref1 === void 0 ? void 0 : ref1.title) + " - ".concat(item.sku), isExpanded[item.sku]),
                        analyticTitleCustomData: productInfo,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductAccordionList_AdditionalInfo, {
                            data: [
                                {
                                    title: (ref2 = productAccordionText.additionalInfo) === null || ref2 === void 0 ? void 0 : ref2.productCode,
                                    data: item.sku
                                },
                                {
                                    title: (ref3 = productAccordionText.additionalInfo) === null || ref3 === void 0 ? void 0 : ref3.countryOfOrigin,
                                    data: (ref4 = countryLists === null || countryLists === void 0 ? void 0 : countryLists.find((list)=>{
                                        var ref;
                                        return list.value === ((ref = item.additionalInfo) === null || ref === void 0 ? void 0 : ref.country);
                                    })) === null || ref4 === void 0 ? void 0 : ref4.text
                                },
                                {
                                    title: (ref5 = productAccordionText.additionalInfo) === null || ref5 === void 0 ? void 0 : ref5.dimensions,
                                    data: ((ref6 = item.additionalInfo) === null || ref6 === void 0 ? void 0 : ref6.length) && parseFloat((ref7 = item.additionalInfo) === null || ref7 === void 0 ? void 0 : ref7.length) > 0 && "".concat(parseFloat((ref8 = item.additionalInfo) === null || ref8 === void 0 ? void 0 : ref8.length), " \xd7 ").concat(parseFloat((ref9 = item.additionalInfo) === null || ref9 === void 0 ? void 0 : ref9.width), " \xd7 ").concat(parseFloat((ref10 = item.additionalInfo) === null || ref10 === void 0 ? void 0 : ref10.height))
                                },
                                {
                                    title: (ref11 = item.additionalInfo) === null || ref11 === void 0 ? void 0 : ref11.regionSupplyChain,
                                    data: (ref12 = productAccordionText.additionalInfo) === null || ref12 === void 0 ? void 0 : ref12.importedBy
                                },
                                {
                                    title: (ref13 = productAccordionText.additionalInfo) === null || ref13 === void 0 ? void 0 : ref13.qty,
                                    data: (ref14 = productAccordionText.additionalInfo) === null || ref14 === void 0 ? void 0 : ref14.oneUnit
                                },
                                {
                                    title: (ref15 = productAccordionText.additionalInfo) === null || ref15 === void 0 ? void 0 : ref15.package,
                                    data: (ref16 = item.additionalInfo) === null || ref16 === void 0 ? void 0 : ref16.packageContent
                                },
                                {
                                    title: (ref17 = productAccordionText.additionalInfo) === null || ref17 === void 0 ? void 0 : ref17.contact,
                                    data: (ref18 = productAccordionText.additionalInfo) === null || ref18 === void 0 ? void 0 : ref18.customerCare
                                },
                                {
                                    title: (ref19 = productAccordionText.additionalInfo) === null || ref19 === void 0 ? void 0 : ref19.spareParts,
                                    data: (ref20 = productAccordionText.additionalInfo) === null || ref20 === void 0 ? void 0 : ref20.sparePartsMsg
                                },
                                {
                                    title: (ref21 = productAccordionText.additionalInfo) === null || ref21 === void 0 ? void 0 : ref21.disclaimer,
                                    data: (ref22 = productAccordionText.additionalInfo) === null || ref22 === void 0 ? void 0 : ref22.disclaimerMsg
                                }
                            ],
                            productAccordionText: productAccordionText
                        })
                    }, item.sku);
                }),
                bundleItems.length > 5 && count === 5 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    label: "".concat(staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.viewRemaining, " (").concat(bundleItems.length - 5, ")"),
                    onClick: handleViewRemaining,
                    flexible: true,
                    size: "small",
                    type: "ghost",
                    role: "button",
                    customClass: "bundle-additional-info"
                })
            ]
        })
    });
//   }
};
/* harmony default export */ var v3_ProductAccordionList = (ProductAccordionList);


/***/ }),

/***/ 95310:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ v3_ProductDetail; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/qs/lib/index.js
var lib = __webpack_require__(80129);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 10 modules
var esm = __webpack_require__(52786);
// EXTERNAL MODULE: ./i18n/usePdpi18n.js
var usePdpi18n = __webpack_require__(58886);
// EXTERNAL MODULE: ./utils/cart.js + 1 modules
var utils_cart = __webpack_require__(33273);
// EXTERNAL MODULE: ./utils/product.js
var product = __webpack_require__(29843);
// EXTERNAL MODULE: ./constants/config.js
var constants_config = __webpack_require__(19514);
// EXTERNAL MODULE: ./utils/helper.js + 2 modules
var helper = __webpack_require__(34326);
// EXTERNAL MODULE: ./constants/index.js + 1 modules
var constants = __webpack_require__(55111);
// EXTERNAL MODULE: ./src/components/ProductDetail/v3/productDetailsHelper.js
var productDetailsHelper = __webpack_require__(50023);
// EXTERNAL MODULE: ./components/ProductDetail/v3/AddToCart/utils.js
var utils = __webpack_require__(29885);
// EXTERNAL MODULE: ./store/features/genericSlice.js
var genericSlice = __webpack_require__(88751);
// EXTERNAL MODULE: ./constants/api.js
var api = __webpack_require__(73350);
// EXTERNAL MODULE: ./store/features/authSlice.js
var authSlice = __webpack_require__(24899);
// EXTERNAL MODULE: ./store/features/cartSlice.js
var cartSlice = __webpack_require__(46201);
// EXTERNAL MODULE: ./store/features/pdpSlice.js
var pdpSlice = __webpack_require__(44561);
// EXTERNAL MODULE: ./store/features/compareSlice.js
var compareSlice = __webpack_require__(39915);
// EXTERNAL MODULE: ./store/features/favoritesSlice.js + 1 modules
var favoritesSlice = __webpack_require__(5702);
// EXTERNAL MODULE: ./node_modules/react-scroll/modules/index.js
var modules = __webpack_require__(66261);
// EXTERNAL MODULE: ./hooks/useWindowResize.js
var useWindowResize = __webpack_require__(11859);
// EXTERNAL MODULE: ./components/ProductDetail/v3/ProductDetailView/productDetailsView.module.scss
var productDetailsView_module = __webpack_require__(14427);
var productDetailsView_module_default = /*#__PURE__*/__webpack_require__.n(productDetailsView_module);
// EXTERNAL MODULE: ./components/core/PageLoader/PageLoader.jsx + 1 modules
var PageLoader = __webpack_require__(41600);
;// CONCATENATED MODULE: ./src/components/ProductDetail/v2/ProgressiveLoader/PdpProgressiveLoader.jsx


const PdpProgressiveLoader = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "progressive-loader",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "progressive-loader__container",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "row progressive-loader__filter-row",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-12 progressive-loader__filter-block",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "progressive-loader__filter-heading"
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "row progressive-loader__filter-contents",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "col-12 progressive-loader__filter-contents-block",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "col-1 col-lg-1 col-md-1 progressive-loader__filter-details-block",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "progressive-loader__filter-contents-heading"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "progressive-loader__filter-contents-share"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-6 col-lg-6 col-md-6 progressive-loader__plp-contents-block",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "progressive-loader__plp-products",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "progressive-loader__plp-products-image"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-5 col-lg-5 col-md-5 progressive-loader__plp-details-block",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "progressive-loader__plp-products-details",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "progressive-loader__plp-products-details-image1"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "progressive-loader__plp-products-details-image2"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var ProgressiveLoader_PdpProgressiveLoader = (PdpProgressiveLoader);

// EXTERNAL MODULE: ./components/core/Modal/Modal.jsx + 2 modules
var Modal = __webpack_require__(95357);
// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var react_slick_lib = __webpack_require__(46066);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./public/images/image-missing.png
var image_missing = __webpack_require__(36513);
;// CONCATENATED MODULE: ./styles/images/zoom-close-icon.svg
/* harmony default export */ var zoom_close_icon = ({"src":"/_next/static/media/zoom-close-icon.91e663a4.svg","height":50,"width":50});
;// CONCATENATED MODULE: ./styles/images/zoom-video-icon.svg
/* harmony default export */ var zoom_video_icon = ({"src":"/_next/static/media/zoom-video-icon.dddeb007.svg","height":60,"width":60});
;// CONCATENATED MODULE: ./styles/images/tap-image-zoom.svg
/* harmony default export */ var tap_image_zoom = ({"src":"/_next/static/media/tap-image-zoom.870cb4c5.svg","height":58,"width":224});
// EXTERNAL MODULE: ./src/components/VideoWrapper/VideoWrapper.jsx + 1 modules
var VideoWrapper = __webpack_require__(38279);
;// CONCATENATED MODULE: ./components/ImageGallery/v2/constants.js
const PDP_GALLERY_SLIDER_CONFIG = {
    dots: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    swipeToSlide: true,
    swipe: true,
    arrows: true,
    infinite: false,
    centerMode: false,
    focusOnSelect: false
};

;// CONCATENATED MODULE: ./components/ImageGallery/v2/utlis.js

const openModal = ()=>{};
let count = 0;
const openModalAction = function(image) {
    let isVideo = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    console.log("called");
    document.body.classList.add("zoom-image-scroll");
    count++;
    const element = document.querySelector(".product-detail-page");
    element === null || element === void 0 ? void 0 : element.classList.add("zoom-image-product-section");
    document.getElementById("imageoverlay").style.display = "block";
    if (count >= 3) {
        console.log("entry");
        const elementImage = document.querySelector("#imageoverlay");
        elementImage === null || elementImage === void 0 ? void 0 : elementImage.classList.add("zoom-activated");
    }
    document.body.classList.add("zoom-image-scroll");
    initZoomviewer(image, isVideo);
};
const initZoomviewer = function(assetID) {
    let isVideo = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    count++;
    console.log("zoomInitCalled", assetID);
    const zoomViewer = new window.s7viewers.ZoomViewer();
    zoomViewer.setContainerId("s7viewer");
    zoomViewer.setParam("serverurl", "https://s7d1.scene7.com/is/image/");
    zoomViewer.setAsset("PAWEB/".concat(assetID));
    zoomViewer.init();
    console.log("zoomIni", zoomViewer);
    const zoomVideo = document.querySelector(".zoom-video");
    if (zoomVideo) {
        document.getElementById("zoomVideo").style.display = "none";
    }
    if (isVideo) {
        document.getElementById("s7viewer").style.display = "none";
    } else {
        if (zoomVideo) {
            document.getElementById("zoomVideo").style.display = "none";
        }
        document.getElementById("s7viewer").style.display = "block";
    }
    if (count >= 3) {
        const elementImage = document.querySelector("#imageoverlay");
        elementImage === null || elementImage === void 0 ? void 0 : elementImage.classList.add("zoom-activated");
    }
};
const closeZoomImage = ()=>{
    const zoomVideo = document.querySelector(".zoom-video");
    if (zoomVideo) {
        document.getElementById("zoomVideo").style.display = "none";
    }
    document.body.classList.remove("zoom-image-scroll");
    const element = document.querySelector(".product-detail-page");
    element === null || element === void 0 ? void 0 : element.classList.remove("zoom-image-product-section");
    document.getElementById("imageoverlay").style.display = "none";
};
const zoomVideoImage = ()=>{
    document.getElementById("s7viewer").style.display = "none";
    const zoomVideo = document.querySelector(".zoom-video");
    if (zoomVideo) {
        document.getElementById("zoomVideo").style.display = "block";
    }
};
const getSlickSettings = (width)=>{
    const { desktopSliderImages  } = constants.PDP_SLIDER_SIZES;
    return {
        dots: false,
        slidesToShow: desktopSliderImages,
        slidesToScroll: 3,
        swipeToSlide: true,
        swipe: true,
        arrows: true,
        infinite: false,
        centerMode: false,
        centerPadding: "0px",
        focusOnSelect: true,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToScroll: 1,
                    slidesToShow: 4.95,
                    focusOnSelect: false
                }
            }
        ]
    };
};

;// CONCATENATED MODULE: ./components/ImageGallery/v2/analytics/index.js
const addAnalyticsClickPdpImageVideo = (data)=>{
    const { index =0 , mediaType ="" , imageVideoName ="" , totalImages =0 , pdpType ="" , assetId =""  } = data;
    const { adobeDataLayer: {} = {}  } = window;
    const imageVideoIdKey = mediaType === "image reel" ? "imageId" : "videoId";
    const imageVideoNameKey = mediaType === "image reel" ? "imageName" : "videoName";
    const eventInfo = {
        eventAction: "pdp:product details:".concat(mediaType),
        eventName: "pdp:product details:".concat(mediaType),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: assetId,
        internalLinkPosition: "pdp".concat(pdpType === "bundle" ? ":bundle" : ""),
        internalLinkType: "pdp:".concat(mediaType),
        internalLinkZoneName: "pdp:product details",
        internalLinkURL: "n/a",
        clickInternalLinks: "true",
        imageSequence: "".concat(index, "_").concat(totalImages),
        [imageVideoIdKey]: assetId,
        [imageVideoNameKey]: imageVideoName
    };
    pushAnalyticsObjToDataLayer(eventInfo);
};
const addAnalyticsClickSliderImageVideo = (data)=>{
    const { index =0 , imageVideoId ="n/a" , totalImages =0 , pdpType ="" , zoomEntryPoint ="image reel" , imageName ="n/a" , imageClick =false  } = data;
    const { adobeDataLayer: {} = {}  } = window;
    const imageVideoIdKey = imageClick ? "imageId" : "videoId";
    const imageVideoNameKey = imageClick ? "imageName" : "videoName";
    const eventInfo = {
        eventAction: "pdp:product details:carousel image click",
        eventName: "pdp:product details:carousel image click",
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: imageVideoId,
        internalLinkPosition: "pdp".concat(pdpType === "bundle" ? ":bundle" : ""),
        internalLinkType: "pdp:".concat(zoomEntryPoint),
        internalLinkZoneName: "pdp:product details:view gallery",
        internalLinkURL: "n/a",
        clickInternalLinks: "true",
        imageSequence: "".concat(index, "_").concat(totalImages),
        [imageVideoIdKey]: imageVideoId,
        [imageVideoNameKey]: imageName ? imageName.toLowerCase() : "n/a"
    };
    pushAnalyticsObjToDataLayer(eventInfo);
};
const addAnalyticsClickCloseZoom = (data)=>{
    const { pdpType ="" , zoomEntryPoint ="image reel" , currentImageData ={} , totalImages =""  } = data;
    const { type: mediaType = "" , assetId: mediaAssetId = "" , url: mediaAssetURL = "" , label: mediaLabel = "n/a" , index: mediaIndex = ""  } = currentImageData;
    const assetId = mediaAssetId || mediaAssetURL;
    const { adobeDataLayer: {} = {}  } = window;
    const imageVideoIdKey = !mediaType ? "imageId" : "videoId";
    const imageVideoNameKey = !mediaType ? "imageName" : "videoName";
    const eventInfo = {
        eventAction: "pdp:product details:carousel image click:close button",
        eventName: "pdp:product details:carousel image click:close button",
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "close",
        internalLinkPosition: "pdp".concat(pdpType === "bundle" ? ":bundle" : ""),
        internalLinkType: "pdp:".concat(zoomEntryPoint),
        internalLinkZoneName: "pdp:product details:view gallery",
        internalLinkURL: "n/a",
        clickInternalLinks: "true",
        [imageVideoIdKey]: assetId,
        [imageVideoNameKey]: mediaLabel ? mediaLabel.toLowerCase() : "n/a",
        imageSequence: "".concat(mediaIndex + 1, "_").concat(totalImages)
    };
    pushAnalyticsObjToDataLayer(eventInfo);
};
const addAnalyticsClickZoomReset = (data)=>{
    const { pdpType ="" , zoomEntryPoint ="image reel" , currentImageData ={} , totalImages =""  } = data;
    const { type: mediaType = "" , assetId: mediaAssetId = "" , url: mediaAssetURL = "" , label: mediaLabel = "n/a" , index: mediaIndex = ""  } = currentImageData;
    const assetId = mediaAssetId || mediaAssetURL;
    const { adobeDataLayer: {} = {}  } = window;
    const imageVideoIdKey = !mediaType ? "imageId" : "videoId";
    const imageVideoNameKey = !mediaType ? "imageName" : "videoName";
    const eventInfo = {
        eventAction: "pdp:product details:carousel image click:zoom reset",
        eventName: "pdp:product details:carousel image click:zoom reset",
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "zoom reset:applied",
        internalLinkPosition: "pdp".concat(pdpType === "bundle" ? ":bundle" : ""),
        internalLinkType: "pdp:".concat(zoomEntryPoint),
        internalLinkZoneName: "pdp:product details:view gallery",
        internalLinkURL: "n/a",
        clickInternalLinks: "true",
        [imageVideoIdKey]: assetId,
        [imageVideoNameKey]: mediaLabel ? mediaLabel.toLowerCase() : "n/a",
        imageSequence: "".concat(mediaIndex + 1, "_").concat(totalImages)
    };
    pushAnalyticsObjToDataLayer(eventInfo);
};
const addAnalyticsZoomImageSliderArrow = (data)=>{
    const { pdpType ="" , zoomEntryPoint ="image reel" , arrowLable ="right"  } = data;
    const { adobeDataLayer: {} = {}  } = window;
    const eventInfo = {
        eventAction: "pdp:product details:carousel image click:".concat(arrowLable),
        eventName: "pdp:product details:carousel image click:".concat(arrowLable),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "".concat(arrowLable, " arrow"),
        internalLinkPosition: "pdp".concat(pdpType === "bundle" ? ":bundle" : ""),
        internalLinkType: "pdp:".concat(zoomEntryPoint),
        internalLinkZoneName: "pdp:product details:view gallery",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    pushAnalyticsObjToDataLayer(eventInfo);
};
const addAnalyticsClickZoomImage = (data)=>{
    const { pdpType ="" , zoomEntryPoint ="image reel" , zoomAction ="zoom in" , currentImageData ={} , totalImages =0 , counter  } = data;
    const { adobeDataLayer: {} = {}  } = window;
    const { assetId: mediaAssetId = "" , url: mediaAssetURL = "" , label: mediaLabel = "n/a" , index: mediaIndex = ""  } = currentImageData;
    const assetId = mediaAssetId || mediaAssetURL;
    const eventInfo = {
        eventAction: "pdp:product details:carousel image click:".concat(zoomAction),
        eventName: "pdp:product details:carousel image click:".concat(zoomAction),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "".concat(zoomAction, ":applied"),
        internalLinkPosition: "pdp".concat(pdpType === "bundle" ? ":bundle" : ""),
        internalLinkType: "pdp:".concat(zoomEntryPoint),
        internalLinkZoneName: "pdp:product details:view gallery",
        internalLinkURL: "n/a",
        clickInternalLinks: "true",
        imageId: assetId,
        imageName: mediaLabel ? mediaLabel.toLowerCase() : "n/a",
        imageSequence: "".concat(mediaIndex + 1, "_").concat(totalImages),
        zoomUsageDepth: "".concat(zoomAction, "_").concat(counter)
    };
    pushAnalyticsObjToDataLayer(eventInfo);
};
const addAnalyticsPdpSlider = (data)=>{
    const { pdpImageInfo ={} , totalImages =0 , pdpType ="" , arrowLabel ="right"  } = data;
    const { label: imageName = "n/a" , index: imageIndex = 0 , type: imageType = "" , assetId: imageAssetId = "" , url: imageUrl = ""  } = pdpImageInfo;
    const { adobeDataLayer: {} = {}  } = window;
    const imageVideoIdKey = imageType !== "video" ? "imageId" : "videoId";
    const imageVideoNameKey = imageType !== "video" ? "imageName" : "videoName";
    const eventInfo = {
        eventAction: "pdp:product details:slider image click:".concat(arrowLabel),
        eventName: "pdp:product details:slider image click:".concat(arrowLabel),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "".concat(arrowLabel, " arrow"),
        internalLinkPosition: "pdp".concat(pdpType === "bundle" ? ":bundle" : ""),
        internalLinkType: "pdp:image reel",
        internalLinkZoneName: "pdp:product details:image reel",
        internalLinkURL: "n/a",
        clickInternalLinks: "true",
        imageSequence: "".concat(imageIndex + 1, "_").concat(totalImages),
        [imageVideoIdKey]: imageType !== "video" ? imageAssetId : imageUrl,
        [imageVideoNameKey]: imageName.toLowerCase()
    };
    pushAnalyticsObjToDataLayer(eventInfo);
};
const pushAnalyticsObjToDataLayer = function() {
    let eventInfo = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const event = "cmp:click";
    const { productInfo  } = page;
    window.adobeDataLayer.push({
        event,
        eventInfo,
        page,
        productInfo
    });
};

;// CONCATENATED MODULE: ./components/ImageGallery/v2/ImageReel.jsx















const ImageReel = (props)=>{
    const { data =[] , isModel =false , swatchUrl ="" , staticTexts ={} , productInfo ={} , isHorizontal =false , galleryStackId ="" , assetAccountName ="" , imageClickCounter =0 , presetConfigObject ={} , productGalleryLabel ={} , initialImgAlt ="" , initialImgUrl ="" , pdpDesktopImage ="" , pdpMobileImage =""  } = props;
    const iframeContainer = (0,react.useRef)(null);
    const pdpInfo = JSON.parse(productInfo);
    const { productInfo: { pdpType: pdpType = []  }  } = pdpInfo;
    const [width] = (0,useWindowResize/* default */.Z)();
    const [activeIndex, setActiveIndex] = (0,react.useState)(0);
    const [activeImage, setactiveImage] = (0,react.useState)(null);
    const [zoomVideoId, setZoomVideoId] = (0,react.useState)(null);
    const [currentVideoId, setCurrentVideoId] = (0,react.useState)(null);
    const totalImages = isHorizontal ? data.length : 3;
    const imageScroll = (0,react.useRef)(null);
    const [imageIndex, setImageIndex] = (0,react.useState)(0);
    const [zoomEntryPoint, setZoomEntryPoint] = (0,react.useState)(null);
    const slickRef = (0,react.useRef)(null);
    const { largeIpadSize , imageReelTitle , mobileSize  } = constants.PDP_SLIDER_SIZES;
    const resourceCredits = productGalleryLabel && productGalleryLabel.resourceCredit_s && productGalleryLabel.resourceCredit_s.match("http") == null ? productGalleryLabel.resourceCredit_s : "";
    const imageSequence = imageClickCounter ? imageClickCounter + 1 : null;
    const getEventInfo = (type, id)=>{
        const viewGallery = type === "view gallery";
        let eventInfo = {
            eventAction: (viewGallery ? "pdp:product details:" : "pdp:product details:") + type,
            eventName: (viewGallery ? "pdp:product details:" : "pdp:product details:") + type,
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: viewGallery ? type : id || type,
            internalLinkPosition: "pdp".concat(pdpType === "bundle" ? ":bundle" : ""),
            internalLinkType: "pdp:".concat(viewGallery ? type : (id ? "image " : "") + "navigation"),
            internalLinkZoneName: "pdp:product details",
            internalLinkURL: "n/a",
            clickInternalLinks: "true"
        };
        if (!viewGallery) {
            eventInfo = {
                ...eventInfo,
                imageSequence
            };
        }
        return eventInfo;
    };
    const setIndex = (0,react.useCallback)(()=>{
        if (width < largeIpadSize && !isModel) {
            setActiveIndex(0);
        }
    });
    (0,react.useEffect)(()=>{
        setIndex();
    }, [
        data
    ]);
    const [kohlerScene, setKohlerScene] = (0,react.useState)(false);
    const pdpImages = data.reduce((acc, ini)=>{
        if (acc.filter((item)=>item.assetId === ini.assetId).length === 0 || ini.type === "video") {
            acc.push(ini);
        }
        return acc;
    }, []);
    const imageUrls = pdpImages.map((i)=>{
        return i === null || i === void 0 ? void 0 : i.url;
    });
    (0,react.useEffect)(()=>{
        const containtsKohlerSceneImage = imageUrls.some((url)=>url.includes("/PAWEB/"));
        if (containtsKohlerSceneImage) {
            setKohlerScene(true);
        }
    }, [
        imageUrls
    ]);
    const isOnePdpImage = initialImgUrl && pdpDesktopImage ? initialImgUrl : "";
    const firstImageForZoom = data && (pdpImages === null || pdpImages === void 0 ? void 0 : pdpImages.length) ? pdpImages[0].assetId : isOnePdpImage;
    const beforeChangeHandler = (0,react.useCallback)(function() {
        let current = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, next = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
        let arrowLabel = "right";
        if (current > next) {
            arrowLabel = "left";
        } else {
            arrowLabel = "right";
        }
        const pdpImageInfo = pdpImages === null || pdpImages === void 0 ? void 0 : pdpImages.map((item, index)=>({
                ...item,
                index
            })).find((item)=>{
            return (item === null || item === void 0 ? void 0 : item.index) === next;
        });
        addAnalyticsPdpSlider({
            pdpImageInfo,
            totalImages: pdpImages === null || pdpImages === void 0 ? void 0 : pdpImages.length,
            pdpType,
            arrowLabel
        });
    });
    const afterChangeHandler = (0,react.useCallback)((currentIndex)=>{
        setImageIndex(currentIndex);
    });
    const handleOpenModal = (0,react.useCallback)(()=>{
        openModal(window.s7viewers);
        window.addEventListener("keydown", handleKey);
    });
    (0,react.useEffect)(()=>{
        handleOpenModal();
    }, []);
    let isZoomClick = false;
    const slickGotoSlider = (sliderNumber)=>{
        slickRef.current.slickGoTo(sliderNumber);
    };
    const openImageZoom = (0,react.useCallback)(function() {
        let image = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, currentImageName = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
        setZoomEntryPoint(imageReelTitle);
        setZoomVideoId("");
        setactiveImage("");
        setactiveImage(image);
        openModalAction(image);
        if (width < mobileSize) {
            slickGotoSlider(i);
        }
        addAnalyticsClickPdpImageVideo({
            index: i + 1,
            mediaType: imageReelTitle,
            imageVideoName: currentImageName,
            totalImages: data === null || data === void 0 ? void 0 : data.length,
            pdpType,
            assetId: image
        });
    });
    const viewGalleryImageClick = (0,react.useCallback)(function() {
        let image = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
        setZoomEntryPoint("view gallery");
        setactiveImage(image);
        openModalAction(image);
    });
    const imageZoomClick = (0,react.useCallback)(function() {
        let image = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, imageName = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
        setZoomVideoId("");
        setactiveImage("");
        if (width < 1023) {
            setZoomEntryPoint(imageReelTitle);
        }
        initZoomviewer(image);
        setactiveImage(image);
        addAnalyticsClickSliderImageVideo({
            index: i + 1,
            imageVideoId: image,
            totalImages: data === null || data === void 0 ? void 0 : data.length,
            pdpType,
            zoomEntryPoint: zoomEntryPoint,
            imageName,
            imageClick: true
        });
        setTabIndexGallery();
    });
    const imageZoomVideoClick = (0,react.useCallback)(function() {
        let video = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
        if (width < 1023) {
            setZoomEntryPoint(imageReelTitle);
        }
        setactiveImage("");
        setactiveImage(video);
        setZoomVideoId(video);
        setCurrentVideoId(i + 1);
        zoomVideoImage();
        setTabIndexGallery();
    });
    const getVideoInfo = function() {
        let targetElement = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", index = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", videoId = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
        addAnalyticsClickSliderImageVideo({
            index,
            imageVideoId: videoId,
            totalImages: data === null || data === void 0 ? void 0 : data.length,
            pdpType,
            zoomEntryPoint: zoomEntryPoint,
            imageName: targetElement === null || targetElement === void 0 ? void 0 : targetElement.videoTitle,
            imageClick: false
        });
    };
    const imageZoomMobileVideoClick = (0,react.useCallback)(function() {
        let video = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
        if (width < 1023) {
            setZoomEntryPoint(imageReelTitle);
        }
        setCurrentVideoId(i + 1);
        setZoomVideoId(video);
        if (width < mobileSize) {
            slickGotoSlider(i);
        }
        openModalAction(video, true);
        setactiveImage(video);
    });
    const closeZoomImageClick = (0,react.useCallback)(()=>{
        counter = 0;
        zoomOutCounter = 0;
        setZoomVideoId(false);
        closeZoomImage();
        const currentImageData = pdpImages === null || pdpImages === void 0 ? void 0 : pdpImages.map((item, index)=>({
                ...item,
                index
            })).find((item)=>{
            return (item === null || item === void 0 ? void 0 : item.assetId) === activeImage || (item === null || item === void 0 ? void 0 : item.url) === activeImage;
        });
        addAnalyticsClickCloseZoom({
            pdpType,
            zoomEntryPoint,
            currentImageData,
            totalImages: pdpImages === null || pdpImages === void 0 ? void 0 : pdpImages.length
        });
    });
    const currentImageData = pdpImages === null || pdpImages === void 0 ? void 0 : pdpImages.map((item, index)=>({
            ...item,
            index
        })).find((item)=>{
        return (item === null || item === void 0 ? void 0 : item.assetId) === activeImage || (item === null || item === void 0 ? void 0 : item.url) === activeImage;
    });
    const s7viewerHandle = (0,react.useCallback)(()=>{
        let zoomImageClick = null;
        if ((iframeContainer === null || iframeContainer === void 0 ? void 0 : iframeContainer.current) && activeImage && zoomEntryPoint) {
            setTimeout(()=>{
                const zoomInButtonClick = iframeContainer === null || iframeContainer === void 0 ? void 0 : iframeContainer.current.querySelector(".s7button.s7zoominbutton");
                const zoomOutButtonClick = iframeContainer === null || iframeContainer === void 0 ? void 0 : iframeContainer.current.querySelector(".s7button.s7zoomoutbutton");
                const zoomResetButton = iframeContainer === null || iframeContainer === void 0 ? void 0 : iframeContainer.current.querySelector(".s7button.s7zoomresetbutton");
                zoomImageClick = iframeContainer === null || iframeContainer === void 0 ? void 0 : iframeContainer.current.querySelector(".s7zoomview");
                if (zoomImageClick) {
                    if (width <= largeIpadSize) {
                        zoomImageClick.addEventListener("touchstart", (ev)=>{
                            setTimeout(function() {
                                zoomImageIconAction();
                            }, 1000);
                        }, false);
                    }
                }
                if (zoomImageClick) {
                    const delta = 6;
                    let startX;
                    let startY;
                    zoomImageClick.addEventListener("mousedown", function(event) {
                        startX = event.pageX;
                        startY = event.pageY;
                        isZoomClick = true;
                    });
                    zoomImageClick.addEventListener("mouseup", function(event) {
                        const diffX = Math.abs(event.pageX - startX);
                        const diffY = Math.abs(event.pageY - startY);
                        isZoomClick = true;
                        if (diffX < delta && diffY < delta) {
                            isZoomClick = false;
                        }
                    });
                    zoomImageClick.addEventListener("click", zoomImageClickAction, false);
                }
                if (zoomInButtonClick) {
                    setTabIndexGallery();
                    zoomInButtonClick.addEventListener("click", zoomInButtonClickAction, false);
                }
                if (zoomOutButtonClick) {
                    zoomOutButtonClick.addEventListener("click", zoomOutButtonClickAction, false);
                }
                if (zoomResetButton) {
                    zoomResetButton.addEventListener("click", zoomResetButtonClickAction, false);
                }
            }, 500);
            const silckSliderNext = iframeContainer === null || iframeContainer === void 0 ? void 0 : iframeContainer.current.querySelector(".slick-next");
            if (silckSliderNext) {
                silckSliderNext.addEventListener("click", (e)=>{
                    e.preventDefault();
                    addAnalyticsZoomImageSliderArrow({
                        pdpType,
                        zoomEntryPoint,
                        arrowLable: "right"
                    });
                });
            }
            const silckSliderPrev = iframeContainer === null || iframeContainer === void 0 ? void 0 : iframeContainer.current.querySelector(".slick-prev");
            if (silckSliderPrev) {
                silckSliderPrev.addEventListener("click", (e)=>{
                    e.preventDefault();
                    addAnalyticsZoomImageSliderArrow({
                        pdpType,
                        zoomEntryPoint,
                        arrowLable: "left"
                    });
                });
            }
        }
        return ()=>{
            if (iframeContainer === null || iframeContainer === void 0 ? void 0 : iframeContainer.current) {
                const zoomImageClickBtn = iframeContainer === null || iframeContainer === void 0 ? void 0 : iframeContainer.current.querySelector(".s7zoomview");
                const zoomInButtonClick = iframeContainer === null || iframeContainer === void 0 ? void 0 : iframeContainer.current.querySelector(".s7button.s7zoominbutton");
                const zoomOutButtonClick = iframeContainer === null || iframeContainer === void 0 ? void 0 : iframeContainer.current.querySelector(".s7button.s7zoomoutbutton");
                const zoomResetButton = iframeContainer === null || iframeContainer === void 0 ? void 0 : iframeContainer.current.querySelector(".s7button.s7zoomresetbutton");
                if (zoomImageClickBtn) {
                    zoomImageClickBtn === null || zoomImageClickBtn === void 0 ? void 0 : zoomImageClickBtn.removeEventListener("click", zoomImageClickAction, false);
                }
                if (zoomInButtonClick) {
                    zoomInButtonClick === null || zoomInButtonClick === void 0 ? void 0 : zoomInButtonClick.removeEventListener("click", zoomInButtonClickAction, false);
                }
                if (zoomOutButtonClick) {
                    zoomOutButtonClick === null || zoomOutButtonClick === void 0 ? void 0 : zoomOutButtonClick.removeEventListener("click", zoomOutButtonClickAction, false);
                }
                if (zoomResetButton) {
                    zoomResetButton === null || zoomResetButton === void 0 ? void 0 : zoomResetButton.removeEventListener("click", zoomResetButtonClickAction, false);
                }
            }
        };
    });
    (0,react.useEffect)(()=>s7viewerHandle(), [
        iframeContainer,
        zoomEntryPoint,
        activeImage
    ]);
    let counter = 0;
    let zoomOutCounter = 0;
    const zoomImageClickAction = (0,react.useCallback)((e)=>{
        const zoomImageClick = iframeContainer === null || iframeContainer === void 0 ? void 0 : iframeContainer.current.querySelector(".s7zoomview");
        const cursortype = zoomImageClick === null || zoomImageClick === void 0 ? void 0 : zoomImageClick.getAttribute("cursortype");
        if (width <= largeIpadSize) {
            isZoomClick = false;
        }
        setTimeout(function() {
            setTabIndexGallery();
        }, 1000);
        if (!isZoomClick) {
            setTimeout(function() {
                setTabIndexGallery();
                if (cursortype !== "reset" || cursortype !== "drag") {
                    setTabIndexGallery();
                    if (cursortype === "zoomin") {
                        counter++;
                        addAnalyticsClickZoomImage({
                            pdpType,
                            zoomEntryPoint,
                            zoomAction: "zoom in",
                            currentImageData,
                            totalImages: pdpImages === null || pdpImages === void 0 ? void 0 : pdpImages.length,
                            counter
                        });
                    } else {
                        zoomOutCounter++;
                        addAnalyticsClickZoomImage({
                            pdpType,
                            zoomEntryPoint,
                            zoomAction: "zoom out",
                            currentImageData,
                            totalImages: pdpImages === null || pdpImages === void 0 ? void 0 : pdpImages.length,
                            counter: zoomOutCounter
                        });
                    }
                }
            }, 50);
        }
    });
    const zoomInButtonClickAction = (0,react.useCallback)((e)=>{
        if (width <= largeIpadSize) {
            setTimeout(function() {
                const zoomInImageClick = iframeContainer === null || iframeContainer === void 0 ? void 0 : iframeContainer.current.querySelector(".s7button.s7zoominbutton");
                const zoomImageOutClick = iframeContainer === null || iframeContainer === void 0 ? void 0 : iframeContainer.current.querySelector("#s7viewer_zoomOutButton");
                const zoomCursorType = zoomInImageClick.getAttribute("state");
                if (zoomCursorType === "disabled") {
                    zoomInImageClick.setAttribute("style", "display: none !important");
                    zoomImageOutClick.setAttribute("style", "display: block !important");
                } else {
                    zoomInImageClick.setAttribute("style", "display: block !important");
                    zoomImageOutClick.setAttribute("style", "display: none !important");
                }
            }, 1000);
        }
        counter++;
        addAnalyticsClickZoomImage({
            pdpType,
            zoomEntryPoint,
            zoomAction: "zoom in",
            currentImageData,
            totalImages: pdpImages === null || pdpImages === void 0 ? void 0 : pdpImages.length,
            counter
        });
    });
    const zoomOutButtonClickAction = (0,react.useCallback)((e)=>{
        zoomOutCounter++;
        addAnalyticsClickZoomImage({
            pdpType,
            zoomEntryPoint,
            zoomAction: "zoom out",
            currentImageData,
            totalImages: pdpImages === null || pdpImages === void 0 ? void 0 : pdpImages.length,
            counter: zoomOutCounter
        });
        if (width <= largeIpadSize) {
            setTimeout(function() {
                const zoomInImageClick = iframeContainer === null || iframeContainer === void 0 ? void 0 : iframeContainer.current.querySelector(".s7button.s7zoominbutton");
                const zoomImageOutClick = iframeContainer === null || iframeContainer === void 0 ? void 0 : iframeContainer.current.querySelector("#s7viewer_zoomOutButton");
                const zoomCursorType = zoomImageOutClick.getAttribute("state");
                if (zoomCursorType === "disabled") {
                    zoomInImageClick.setAttribute("style", "display: block !important");
                    zoomImageOutClick.setAttribute("style", "display: none !important");
                } else {
                    zoomInImageClick.setAttribute("style", "display: none !important");
                    zoomImageOutClick.setAttribute("style", "display: block !important");
                }
            }, 1000);
        }
    });
    const zoomResetButtonClickAction = (0,react.useCallback)((e)=>{
        counter = 0;
        zoomOutCounter = 0;
        addAnalyticsClickZoomReset({
            pdpType,
            zoomEntryPoint,
            currentImageData,
            totalImages: pdpImages === null || pdpImages === void 0 ? void 0 : pdpImages.length
        });
    });
    const lastTabIndex = 0;
    let currentIndex = 90;
    const handleKey = ()=>{
        window.addEventListener("focusin", function() {
            currentIndex = document.activeElement.tabIndex;
        }, true);
        let curIndex = currentIndex;
        if (curIndex == lastTabIndex) {
            curIndex = 90;
        }
        const tabbables = document.querySelectorAll(".image-overlay");
        for(let i = 0; i < tabbables.length; i++){
            if (tabbables[i].tabIndex == curIndex) {
                tabbables[i].focus();
                break;
            }
        }
    };
    const setTabIndexGallery = ()=>{
        const zoomInButtonClick = iframeContainer === null || iframeContainer === void 0 ? void 0 : iframeContainer.current.querySelector(".s7button.s7zoominbutton");
        const zoomOutButtonClick = iframeContainer === null || iframeContainer === void 0 ? void 0 : iframeContainer.current.querySelector(".s7button.s7zoomoutbutton");
        const zoomResetButton = iframeContainer === null || iframeContainer === void 0 ? void 0 : iframeContainer.current.querySelector(".s7button.s7zoomresetbutton");
        if (zoomInButtonClick) {
            zoomInButtonClick.setAttribute("tabindex", "96");
            zoomOutButtonClick.setAttribute("tabindex", "97");
            zoomResetButton.setAttribute("tabindex", "98");
        }
    };
    const zoomImageIconAction = ()=>{
        const zoomInImageClick = iframeContainer === null || iframeContainer === void 0 ? void 0 : iframeContainer.current.querySelector(".s7button.s7zoominbutton");
        const zoomImageOutClick = iframeContainer === null || iframeContainer === void 0 ? void 0 : iframeContainer.current.querySelector("#s7viewer_zoomOutButton");
        const zoomCursorType = zoomInImageClick.getAttribute("state");
        if (zoomCursorType === "disabled") {
            zoomOutCounter++;
            addAnalyticsClickZoomImage({
                pdpType,
                zoomEntryPoint,
                zoomAction: "zoom out",
                currentImageData,
                totalImages: pdpImages === null || pdpImages === void 0 ? void 0 : pdpImages.length,
                counter: zoomOutCounter
            });
            zoomInImageClick.setAttribute("style", "display: none !important");
            zoomImageOutClick.setAttribute("style", "display: block !important");
        } else {
            counter++;
            addAnalyticsClickZoomImage({
                pdpType,
                zoomEntryPoint,
                zoomAction: "zoom in",
                currentImageData,
                totalImages: pdpImages === null || pdpImages === void 0 ? void 0 : pdpImages.length,
                counter
            });
            zoomInImageClick.setAttribute("style", "display: block !important");
            zoomImageOutClick.setAttribute("style", "display: none !important");
        }
    };
    const renderTotalImages = ()=>{
        var ref;
        return data && totalImages && ((ref = data.slice(0, totalImages)) === null || ref === void 0 ? void 0 : ref.length) ? pdpImages.slice(0, totalImages).map((element, i)=>{
            const isVideo = element.type === "video";
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                elementid: element.assetId,
                id: i,
                className: "pdp-image-reel__image-list ".concat(isModel ? "pdp-image-reel__modal-image" : "", " ").concat(activeIndex === i && width < largeIpadSize ? "pdp-image-reel__active-image" : ""),
                role: "listitem",
                "aria-label": element.label,
                onClick: ()=>{
                    if (kohlerScene) {
                        !isVideo ? openImageZoom(element.assetId, i, element === null || element === void 0 ? void 0 : element.label) : imageZoomMobileVideoClick(element.url, i);
                    } else {
                        console.error("zoom disabled");
                    }
                },
                children: !element.type ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "".concat(kohlerScene ? "pdp-image-reel__image-display" : ""),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            role: "button",
                            onError: (e)=>{
                                return e.target.src = image_missing/* default */.Z === null || image_missing/* default */.Z === void 0 ? void 0 : image_missing/* default.src */.Z.src;
                            },
                            src: (0,helper.appendPresetToUrl)(assetAccountName, swatchUrl, element.assetId, width, presetConfigObject, true, element.url),
                            alt: element.label,
                            tabIndex: 0,
                            className: "".concat(i === 0 ? "print" : "no-print", " ").concat(!element.url.includes("/PAWEB/") ? "no-preset" : "")
                        }),
                        kohlerScene ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            role: "button",
                            src: tap_image_zoom === null || tap_image_zoom === void 0 ? void 0 : tap_image_zoom.src,
                            alt: element.label,
                            tabIndex: 0,
                            className: "tap-image-zoom"
                        }) : ""
                    ]
                }, "gallery-zoom-image-".concat(i)) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "pdp-video-wrapper",
                    children: width < 971 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoWrapper/* default */.Z, {
                        thumb: true,
                        alt: element.label,
                        videoId: element.url,
                        imageSequence: imageSequence,
                        playThumb: width < largeIpadSize && !isModel,
                        width: "100%",
                        height: "350",
                        getVideoInfo: getVideoInfo
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoWrapper/* default */.Z, {
                        videoId: element.url,
                        width: "100%",
                        height: "550"
                    })
                }, "gallery-zoom-image-".concat(i))
            }, "gallery-zoom-image-".concat(i));
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
            className: "pdp-image-reel__image-list",
            onClick: ()=>openImageZoom(initialImgUrl),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat(kohlerScene ? "pdp-image-reel__image-display" : ""),
                children: initialImgUrl && pdpDesktopImage ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("picture", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                            srcSet: pdpMobileImage.replace("/}", "/".concat(initialImgUrl, "}")).replace("&fmt=webp", ""),
                            media: "(max-width: 768px)"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                            srcSet: pdpDesktopImage.replace("/}", "/".concat(initialImgUrl, "}")).replace("&fmt=webp", ""),
                            media: "(min-width: 769px)"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            role: "button",
                            src: pdpMobileImage.replace("/}", "/".concat(initialImgUrl, "}")).replace("&fmt=webp", ""),
                            alt: initialImgAlt,
                            tabIndex: "0",
                            className: "print",
                            fetchpriority: "high"
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "shimmer-loading__para shimmer height-400"
                })
            })
        });
    };
    const images = pdpImages.map((i)=>i.assetId);
    const [currentImageIndex, setCurrentImageIndex] = (0,react.useState)(0);
    const touchStartX = (0,react.useRef)(0);
    const touchEndX = (0,react.useRef)(0);
    const multiTouchRef = (0,react.useRef)(0);
    const handleSwipe = (0,react.useCallback)(()=>{
        const swipeDistance = touchStartX.current - touchEndX.current;
        const swipeThreshold = 50;
        if (swipeDistance > swipeThreshold) {
            showNextImage();
        } else if (swipeDistance < -swipeThreshold) {
            showPreviousImage();
        }
    });
    const showNextImage = (0,react.useCallback)(()=>{
        setCurrentImageIndex((prevIndex)=>{
            const nextIndex = (prevIndex + 1) % images.length;
            initZoomviewer(images[nextIndex]);
            setactiveImage(images[nextIndex]);
            return nextIndex;
        });
    });
    const showPreviousImage = (0,react.useCallback)(()=>{
        setCurrentImageIndex((prevIndex)=>{
            const prevAdjustedIndex = (prevIndex - 1 + images.length) % images.length;
            initZoomviewer(images[prevAdjustedIndex]);
            setactiveImage(images[prevAdjustedIndex]);
            return prevAdjustedIndex;
        });
    });
    const touchTimeoutRef = (0,react.useRef)(null);
    const handleTouchStart = (e)=>{
        touchStartX.current = e.changedTouches[0].screenX;
        if (touchTimeoutRef.current) {
            clearTimeout(touchTimeoutRef.current);
        }
        touchTimeoutRef.current = setTimeout(()=>{
            if (e.touches.length > 1) {
                multiTouchRef.current = 2;
            }
        }, 100);
    };
    const handleTouchEnd = (e)=>{
        touchEndX.current = e.changedTouches[0].screenX;
        if (multiTouchRef.current < 2) {
            handleSwipe();
        }
        if (touchTimeoutRef.current) {
            clearTimeout(touchTimeoutRef.current);
            touchTimeoutRef.current = null;
        }
    };
    const mobileImageSlide = (0,react.useCallback)(()=>{
        const ZoomViewerElement = document.getElementById("s7viewer");
        ZoomViewerElement.addEventListener("touchstart", handleTouchStart);
        ZoomViewerElement.addEventListener("touchend", handleTouchEnd);
        return ()=>{
            ZoomViewerElement.removeEventListener("touchstart", handleTouchStart);
            ZoomViewerElement.removeEventListener("touchend", handleTouchEnd);
        };
    });
    (0,react.useEffect)(()=>{
        mobileImageSlide();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "image-overlay ".concat(zoomVideoId ? "video-open" : ""),
                id: "imageoverlay",
                tabIndex: 90,
                role: "dialog",
                "aria-labelledby": "gallery-test",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "close-zoom-image",
                        onClick: closeZoomImageClick,
                        tabIndex: 91,
                        role: "dialog",
                        "aria-labelledby": "myLargeModalLabel1",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: zoom_close_icon === null || zoom_close_icon === void 0 ? void 0 : zoom_close_icon.src,
                            role: "button",
                            alt: "close",
                            tabIndex: 152
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "popup-content",
                        tabIndex: 93,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "iframe-container",
                            ref: iframeContainer,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    id: "s7viewer",
                                    tabIndex: 99
                                }),
                                zoomVideoId ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "zoom-video",
                                    id: "zoomVideo",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoWrapper/* default */.Z, {
                                        videoId: zoomVideoId,
                                        width: "100%",
                                        playVideoClick: true,
                                        index: currentVideoId,
                                        totalPdpImages: data === null || data === void 0 ? void 0 : data.length,
                                        zoomEntryPoint: zoomEntryPoint,
                                        getVideoInfo: getVideoInfo
                                    })
                                }) : null,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "gallery",
                                    id: "gallery-test",
                                    tabIndex: 150,
                                    role: "dialog",
                                    "aria-labelledby": "myLargeModalLabel3",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_slick_lib/* default */.Z, {
                                        ...getSlickSettings(width),
                                        ref: (ref)=>slickRef.current = ref,
                                        tabIndex: 151,
                                        children: data && (pdpImages === null || pdpImages === void 0 ? void 0 : pdpImages.length) ? pdpImages.map((element, i)=>{
                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                children: !element.type ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "image-wrapper ".concat(element.assetId === activeImage ? "imageActive" : ""),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        role: "button",
                                                        onError: (e)=>{
                                                            return e.target.src = image_missing/* default */.Z === null || image_missing/* default */.Z === void 0 ? void 0 : image_missing/* default.src */.Z.src;
                                                        },
                                                        src: (0,helper.appendPresetToUrl)(assetAccountName, swatchUrl, element.assetId, width, presetConfigObject, true),
                                                        alt: element.label,
                                                        tabIndex: "10".concat(+i),
                                                        onClick: ()=>{
                                                            return imageZoomClick(element.assetId, i, element === null || element === void 0 ? void 0 : element.label);
                                                        }
                                                    })
                                                }, "zoom-image-".concat(i)) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    onClick: ()=>imageZoomVideoClick(element.url, i),
                                                    className: "image-wrapper zoom-video-section ".concat(element.url === activeImage ? "imageActive" : ""),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoWrapper/* default */.Z, {
                                                            thumb: true,
                                                            videoId: element.url,
                                                            getVideoInfo: getVideoInfo,
                                                            index: i,
                                                            totalPdpImages: data === null || data === void 0 ? void 0 : data.length,
                                                            zoomEntryPoint: zoomEntryPoint
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "zoom-video-icon",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                src: zoom_video_icon === null || zoom_video_icon === void 0 ? void 0 : zoom_video_icon.src,
                                                                alt: "zoom video",
                                                                tabIndex: 110 + i
                                                            })
                                                        })
                                                    ]
                                                }, "zoom-video-".concat(i))
                                            });
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "image-wrapper imageActive",
                                            children: initialImgUrl && pdpDesktopImage ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("picture", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                                        srcSet: pdpMobileImage.replace("/}", "/".concat(initialImgUrl, "}")).replace("&fmt=webp", ""),
                                                        media: "(max-width: 768px)"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                                        srcSet: pdpDesktopImage.replace("/}", "/".concat(initialImgUrl, "}")).replace("&fmt=webp", ""),
                                                        media: "(min-width: 769px)"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        role: "button",
                                                        src: pdpMobileImage.replace("/}", "/".concat(initialImgUrl, "}")).replace("&fmt=webp", ""),
                                                        alt: initialImgAlt,
                                                        tabIndex: "105",
                                                        className: "print",
                                                        fetchpriority: "high",
                                                        onClick: ()=>imageZoomClick(initialImgUrl, 0, initialImgAlt)
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "shimmer-loading__para shimmer height-400"
                                            })
                                        })
                                    }, "slider-zoom-gallery")
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "pdp-image-reel",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "".concat(isHorizontal ? "pdp-image-reel__horizontal-gallery" : ""),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        ref: imageScroll,
                        className: "pdp-image-reel__image-stack-view ".concat(width < largeIpadSize && !isModel ? "pdp-image-reel__slider-container" : ""),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                className: "pl-0 list-inline pdp-image-reel__image-stack-list",
                                role: "list",
                                id: galleryStackId,
                                onClick: (e)=>e.stopPropagation,
                                children: [
                                    width < largeIpadSize ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react_slick_lib/* default */.Z, {
                                        ...PDP_GALLERY_SLIDER_CONFIG,
                                        afterChange: afterChangeHandler,
                                        beforeChange: beforeChangeHandler,
                                        children: renderTotalImages()
                                    }, "pdpSliderKey") : renderTotalImages(),
                                    !isHorizontal && data && data.length > 3 && width >= largeIpadSize && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        id: "4",
                                        role: "listitem",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "pdp-image-reel__image-view",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                className: "pdp-image-reel__link-more gbh-data-layer",
                                                "data-gbh-data-layer": JSON.stringify(getEventInfo("view gallery")),
                                                "data-gbh-data-layer-custom": productInfo || null,
                                                onClick: ()=>viewGalleryImageClick(firstImageForZoom),
                                                children: staticTexts.viewGallery
                                            })
                                        })
                                    })
                                ]
                            }),
                            width < largeIpadSize && !isModel && totalImages > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "pdp-image-reel__slider-count",
                                children: [
                                    imageIndex + 1,
                                    " of ",
                                    pdpImages === null || pdpImages === void 0 ? void 0 : pdpImages.length
                                ]
                            })
                        ]
                    })
                })
            }),
            resourceCredits && isModel && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "pdp-image-reel__photo-credit",
                children: resourceCredits
            })
        ]
    });
};
ImageReel.propTypes = {
    data: prop_types_default().arrayOf((prop_types_default()).any).isRequired,
    staticTexts: (prop_types_default()).object,
    productInfo: (prop_types_default()).string,
    updateImageClickCounter: (prop_types_default()).func,
    imageClickCounter: (prop_types_default()).number
};
/* harmony default export */ var v2_ImageReel = (/*#__PURE__*/react.memo(ImageReel));

;// CONCATENATED MODULE: ./components/ImageGallery/v2/ImageGallery.jsx





const ImageGallery = (props)=>{
    const [showModal, setShowModal] = (0,react.useState)(null);
    const viewBtnRef = (0,react.useRef)();
    const { page ="" , productInfo ={} , initialImgAlt ="" , initialImgUrl ="" , pdpDesktopImage =""  } = props;
    const show = (0,react.useCallback)(()=>{
        (0,helper.preventBodyScroll)(showModal);
        if (showModal) document.body.classList.add("image-gallery-modal-opened");
        else if (showModal === false) {
            document.body.classList.remove("scroll-lock", "image-gallery-modal-opened");
            viewBtnRef.current.focus();
        }
    });
    (0,react.useEffect)(()=>{
        show();
    }, [
        showModal
    ]);
    const handleModalPopup = (0,react.useCallback)(()=>{
        setShowModal(true);
    });
    const onModalClose = (0,react.useCallback)(()=>{
        setShowModal(false);
    });
    const isHorizontalView = window.innerWidth < 1024;
    const eventInfo = JSON.stringify({
        eventAction: page + ":modal:gallery:close",
        eventName: page + "modal:gallery:close",
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "close",
        internalLinkPosition: page,
        internalLinkType: page + ":close",
        internalLinkZoneName: page + ":modal:gallery",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(v2_ImageReel, {
                viewBtnRef: viewBtnRef,
                isHorizontal: isHorizontalView,
                ...props,
                initialImgAlt: initialImgAlt,
                initialImgUrl: initialImgUrl,
                pdpDesktopImage: pdpDesktopImage,
                handlePopup: handleModalPopup,
                galleryStackId: "image-gallery__image-stack-gallery"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
                onModalClose: onModalClose,
                showModal: showModal,
                closeButtonAnalytics: eventInfo,
                analyticsCustomData: productInfo || null,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "pdp-image-gallery-container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v2_ImageReel, {
                        viewBtnRef: viewBtnRef,
                        isPopup: true,
                        isHorizontal: true,
                        isModel: true,
                        ...props,
                        handlePopup: handleModalPopup,
                        galleryStackId: "image-gallery__image-stack-kohler"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var v2_ImageGallery = (/*#__PURE__*/react.memo(ImageGallery));

// EXTERNAL MODULE: ./node_modules/lodash/isEqual.js
var isEqual = __webpack_require__(18446);
var isEqual_default = /*#__PURE__*/__webpack_require__.n(isEqual);
// EXTERNAL MODULE: ./node_modules/react-number-format/dist/react-number-format.es.js
var react_number_format_es = __webpack_require__(57333);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/ProductDetail/v3/analytics.js
var analytics = __webpack_require__(3155);
// EXTERNAL MODULE: ./components/core/Accordion/Accordion.jsx
var Accordion = __webpack_require__(92173);
// EXTERNAL MODULE: ./public/images/swatch-missing.jpeg
var swatch_missing = __webpack_require__(36562);
;// CONCATENATED MODULE: ./src/components/core/ColorSwatch/ColorSwatch.jsx








const ColorSwatch = (props)=>{
    const { type ="" , id ="" , label ="" , name ="" , value ="" , checked =false , color ="" , colorUrl =""  } = props;
    const [config, setConfig] = (0,react.useState)({});
    const [swatchUrl, setSwatchUrl] = (0,react.useState)("");
    (0,react.useEffect)(()=>{
        (0,constants_config/* getConfig */.i)().then((config)=>setConfig(config));
    }, []);
    (0,react.useEffect)(()=>{
        if (!isEmpty_default()(config)) {
            const assetAccountName = get_default()(config, "general.scene7AccountName", "PAWEB");
            let swatchUrl = colorUrl ? colorUrl + "?$PDPSwatch_Desk$" : swatch_missing/* default */.Z;
            swatchUrl = swatchUrl.replace("PAWEB", assetAccountName);
            setSwatchUrl(swatchUrl);
        }
    }, [
        config
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "color-swatch",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                type: type === "selector" ? "radio" : "checkbox",
                id: id,
                name: name,
                value: value,
                checked: checked,
                style: {
                    backgroundColor: color
                },
                onClick: (e)=>props.onClick(e.target.value),
                onChange: (e)=>props.onChange(e),
                "data-testid": "color-swatch-".concat(id !== null && id !== void 0 ? id : "0")
            }),
            type !== "selector" && /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                htmlFor: id,
                children: label
            }),
            type === "selector" && /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                className: "".concat(!colorUrl || colorUrl.includes(constants.SWATCH_NA) ? "--no-swatch" : ""),
                htmlFor: id,
                children: swatchUrl ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    role: "presentation",
                    src: swatchUrl,
                    alt: "NA"
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    role: "presentation",
                    src: constants.EMPTY_PIXEL,
                    alt: "EMPTY_PIXEL"
                })
            })
        ]
    });
};
ColorSwatch.defaultProps = {
    type: "",
    label: "",
    id: "",
    name: "",
    value: undefined,
    color: "",
    colorUrl: "",
    checked: undefined,
    defaultChecked: false,
    onClick: ()=>{},
    onChange: ()=>{}
};
ColorSwatch.propTypes = {
    type: (prop_types_default()).string,
    label: (prop_types_default()).string,
    id: (prop_types_default()).string,
    name: (prop_types_default()).string,
    value: (prop_types_default()).string || (prop_types_default()).number,
    color: (prop_types_default()).string,
    colorUrl: (prop_types_default()).string,
    checked: (prop_types_default()).bool,
    defaultChecked: (prop_types_default()).bool,
    onClick: (prop_types_default()).func,
    onChange: (prop_types_default()).func
};
/* harmony default export */ var ColorSwatch_ColorSwatch = (ColorSwatch);

;// CONCATENATED MODULE: ./components/ProductDetail/v3/ProductDetailView/SwatchList.jsx





const SwatchList = (props)=>{
    const { colorsData =[] , isDiscontinued =false , sku ="" , staticTexts: { discontinuedColorFinish ="" , colorOrFinish =""  } = {} , setSkuVariant =()=>{} , productData  } = props;
    const handleKeyDown = (i, e)=>{
        const { KEYCODE  } = constants["default"];
        const ele = e.target.parentNode.childNodes;
        switch(e.keyCode){
            case KEYCODE.UP:
                e.preventDefault();
                if (i > 0) ele[i - 1].focus();
                break;
            case KEYCODE.DOWN:
                e.preventDefault();
                if (i < ele.length - 1) ele[i + 1].focus();
                break;
            case KEYCODE.SPACE:
            case KEYCODE.ENTER:
                e.preventDefault();
                ele[i].querySelector("input").click();
                break;
            default:
                break;
        }
    };
    const handleColorSwatchClick = (sku)=>{
        if (productData.bundleNameSlugDetails_ss) {
            console.log("called bundle");
            (0,helper.getPDPUrlForProductTile)(productData, sku).then((ret)=>{
                setSkuVariant(sku);
                window.location.href = "".concat(ret, "?skuId=").concat(sku);
            });
        } else setSkuVariant(sku);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            colorsData.filter((c)=>!c.notApplicable).length > 0 ? isDiscontinued ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "row no-gutters product-detail-page__finish-sample",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "product-detail-page__discontinued",
                    tabIndex: "0",
                    "aria-roledescription": "Finish Type ".concat(get_default()(colorsData.find((item)=>item.id === sku), "label", ""), " selected"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "discontinued-text",
                            children: discontinuedColorFinish
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "discontinued-color-value",
                            children: get_default()(colorsData.find((item)=>item.id === sku), "label", "")
                        })
                    ]
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "row no-gutters product-detail-page__finish-sample",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "product-detail-page__finish",
                    tabIndex: "0",
                    "aria-roledescription": "Finish Type ".concat(get_default()(colorsData.find((item)=>item.id === sku), "label", ""), " selected"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "product-detail-page__finish_text",
                            children: colorOrFinish
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "product-detail-page__finish_value",
                            children: get_default()(colorsData.find((item)=>item.id === sku), "label", "")
                        })
                    ]
                })
            }) : null,
            colorsData.filter((c)=>!c.notApplicable).length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "row no-gutters product-detail-page__color-swatch-main",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    id: "finish-type-list",
                    className: "product-detail-page__color-swatch",
                    role: "listbox",
                    children: colorsData.filter((c)=>!c.notApplicable).map((item, i)=>{
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            role: "radio",
                            tabIndex: 0,
                            "aria-label": item.label,
                            "aria-checked": item.id === sku ? true : false,
                            onKeyDown: (e)=>handleKeyDown(i, e),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ColorSwatch_ColorSwatch, {
                                type: "selector",
                                id: item.id,
                                name: item.name,
                                value: item.value,
                                label: item.label,
                                colorUrl: item.colorUrl,
                                checked: item.id === sku,
                                onClick: (sku)=>{
                                    handleColorSwatchClick(sku);
                                }
                            }, i)
                        }, "".concat(item === null || item === void 0 ? void 0 : item.id, "-").concat(i));
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var ProductDetailView_SwatchList = (SwatchList);

// EXTERNAL MODULE: ./src/components/core/ToolTip/ToolTip.jsx
var ToolTip = __webpack_require__(45138);
// EXTERNAL MODULE: ./components/core/SelectDropdown/SelectDropdown.jsx
var SelectDropdown = __webpack_require__(77860);
;// CONCATENATED MODULE: ./public/icons/tooltip.svg
/* harmony default export */ var tooltip = ({"src":"/_next/static/media/tooltip.396c7bfc.svg","height":30,"width":30});
// EXTERNAL MODULE: ./src/components/ProductDetail/v3/OptionsSelector/index.module.scss
var index_module = __webpack_require__(49262);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
;// CONCATENATED MODULE: ./src/components/ProductDetail/v3/OptionsSelector/index.jsx








const OptionsSelector = (props)=>{
    const [selected, setSelected] = (0,react.useState)({});
    const [isActive, setIsActive] = (0,react.useState)("");
    const [expanded, setExpanded] = (0,react.useState)(false);
    const { i18n ={} , data ={} , tooltipdata ={} , curroptions =[] , selectoption , className =""  } = props;
    (0,react.useEffect)(()=>setSelected(curroptions), [
        curroptions
    ]);
    const formatFacetName = function() {
        let name = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
        if (props.facetLabels && props.facetLabels[name]) {
            return props.facetLabels[name];
        }
        return name.replace(/\./g, "/").replace(/_/g, " ");
    };
    const handleChange = (value, facet, dropdownName)=>{
        if (value !== selected[facet]) {
            const options = {};
            options[facet] = value;
            setSelected({
                ...selected,
                ...options
            });
            selectoption(value, facet, dropdownName);
        }
    };
    const styleClass = classnames_default()("options-selector", className);
    const handleTooltipMouseOver = (e, title, tooltipContent)=>{
        const { target: { className  }  } = e;
        if (className) setIsActive(e.target.className);
        const mouseoverTitle = (title + " mouseover").toLowerCase();
        props.selectMoreTooltipHandler(mouseoverTitle, false, tooltipContent);
    };
    const handleOptionExapandState = (isExpanded, title)=>{
        setExpanded(isExpanded);
        const accordianState = isExpanded ? "accordian expand" : "accordian collapse";
        props.configurationAccordianDataLayer("".concat(title === null || title === void 0 ? void 0 : title.toLowerCase()), accordianState);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (index_module_default()).optionsSelectorWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: styleClass,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* default */.Z, {
                id: "PDP-select-more",
                isOpen: expanded,
                contentOverflow: "visible",
                handleOpen: ()=>{
                    return handleOptionExapandState(true, "".concat(i18n === null || i18n === void 0 ? void 0 : i18n.productOptions));
                },
                handleClose: ()=>{
                    return handleOptionExapandState(false, "".concat(i18n === null || i18n === void 0 ? void 0 : i18n.productOptions));
                },
                title: "".concat(i18n === null || i18n === void 0 ? void 0 : i18n.productOptions, " (").concat(Object.keys(selected).length, ")"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "row",
                    children: Object.entries(data).map((facet, i)=>{
                        const values = [];
                        for(let j = 0; j < facet[1].length; j += 2){
                            values.push(facet[1][j]);
                        }
                        if (curroptions[facet[0]]) {
                            var ref;
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "options-selector__dropdown col-12 col-sm-6",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "options-selector__heading",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: formatFacetName(facet[0])
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                tabIndex: expanded ? 0 : -1,
                                                src: tooltip === null || tooltip === void 0 ? void 0 : tooltip.src,
                                                alt: i18n.toolTip,
                                                className: facet[0],
                                                onMouseLeave: (e)=>e.target.className ? setIsActive("") : "",
                                                onMouseOver: (e)=>handleTooltipMouseOver(e, formatFacetName(facet[0]), tooltipdata[facet[0]]),
                                                onFocus: (e)=>e.target.className ? setIsActive(e.target.className) : "",
                                                onBlur: (e)=>e.target.className ? setIsActive("") : ""
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectDropdown/* default */.Z, {
                                        id: facet[0],
                                        ariaLabel: formatFacetName(facet[0]),
                                        data: values,
                                        value: (ref = selected[facet[0]]) === null || ref === void 0 ? void 0 : ref.toString(),
                                        onChange: (val)=>handleChange(val, facet[0], formatFacetName(facet[0])),
                                        tabIndex: expanded ? 0 : -1
                                    }, facet[0]),
                                    isActive === facet[0] && Object.prototype.hasOwnProperty.call(tooltipdata, facet[0]) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ToolTip/* default */.Z, {
                                        message: tooltipdata[facet[0]]
                                    }) : ""
                                ]
                            }, i);
                        }
                    })
                })
            })
        })
    });
};
/* harmony default export */ var v3_OptionsSelector = (OptionsSelector);

// EXTERNAL MODULE: ./src/components/core/Button/Button.jsx
var Button = __webpack_require__(82476);
// EXTERNAL MODULE: ./utils/index.js
var utils_0 = __webpack_require__(20558);
// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var dist_lib = __webpack_require__(85518);
;// CONCATENATED MODULE: ./components/ProductDetail/v3/PDPRequiredItemModal/PDPRequiredItemModalAnalytics.js
const getEventInfo = function(type) {
    let needJSON = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var ref;
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const pagetitle = page === null || page === void 0 ? void 0 : (ref = page.category) === null || ref === void 0 ? void 0 : ref.pageType;
    const eventInfo = {
        eventAction: "".concat(pagetitle, ":select a product required for installation:").concat(type),
        eventName: "".concat(pagetitle, ":select a product required for installation:").concat(type),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: type,
        internalLinkPosition: "items required for install",
        internalLinkType: "".concat(pagetitle, ":select a product required for installation:").concat(type),
        internalLinkZoneName: "".concat(pagetitle, ":select a product required for installation"),
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    if (needJSON) {
        return eventInfo;
    }
    return JSON.stringify(eventInfo);
};
const pushAnalyticsData = (title, productInfo)=>{
    var ref;
    const eventInfo = getEventInfo(title, true);
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const productInfoObj = productInfo ? (ref = JSON.parse(productInfo)) === null || ref === void 0 ? void 0 : ref.productInfo : null;
    window.adobeDataLayer.push({
        event: "cmp:click",
        page,
        eventInfo,
        productInfoObj
    });
};

// EXTERNAL MODULE: ./src/components/core/Checkbox/Checkbox.jsx + 1 modules
var Checkbox = __webpack_require__(34846);
;// CONCATENATED MODULE: ./components/ProductDetail/v3/PDPRequiredItem/index.jsx











const PDPRequiredItem = (props)=>{
    var ref;
    const { item ={} , addItemsData =[] , productInfo ={} , staticTexts ={} , colorId ="" , cart ={} , locale ="" , currencyCode ="" , backorder ="" , currencySign ="" , updateItems =()=>{} , lwProdData ={}  } = props;
    const [pdpUrl, setPdpUrl] = (0,react.useState)("");
    const [isChecked, setIsChecked] = (0,react.useState)(false);
    const [selectedSkuItem, setSelectedSkuItem] = (0,react.useState)(item === null || item === void 0 ? void 0 : (ref = item.masterVariant) === null || ref === void 0 ? void 0 : ref.sku);
    const persona = (0,helper.getUserPersona)();
    const isMobile = window.innerWidth <= 480;
    const requiredProductsData = [];
    let colorsDataMaster = [];
    const colorsDataVariants = [];
    let imagesDataMaster = [];
    const imagesDataVariants = [];
    let priceOfMaster = [];
    const priceOfVariants = [];
    let category = "";
    let slug = "";
    let customerFacingSKUMaster = [];
    const customerFacingSKUVariant = [];
    if (item) {
        var ref1, ref2, ref3, ref4, ref5;
        let product = {};
        const masterVariant = get_default()(item, "masterVariant", []);
        const variants = get_default()(item, "variants", []);
        const masterVariantSku = get_default()(masterVariant, "sku", "");
        slug = get_default()(item, 'slug["en-IN"]', "");
        var ref6;
        const Color_SKU_Details_s = (ref6 = (ref2 = (ref1 = lwProdData["Color.SKU.Details_ss"]) === null || ref1 === void 0 ? void 0 : ref1.find((item)=>item.includes(masterVariantSku))) === null || ref2 === void 0 ? void 0 : ref2.split("|")) !== null && ref6 !== void 0 ? ref6 : {};
        var ref7;
        const productImage_labelWithUrl_s = (ref7 = (ref4 = (ref3 = lwProdData["productImage.labelWithUrl_ss"]) === null || ref3 === void 0 ? void 0 : ref3.find((item)=>item.includes(masterVariantSku))) === null || ref4 === void 0 ? void 0 : ref4.split("|")) !== null && ref7 !== void 0 ? ref7 : {};
        const productImage = productImage_labelWithUrl_s ? productImage_labelWithUrl_s[(productImage_labelWithUrl_s === null || productImage_labelWithUrl_s === void 0 ? void 0 : productImage_labelWithUrl_s.length) - 1] : "";
        const SKUColorFinishName = Color_SKU_Details_s === null || Color_SKU_Details_s === void 0 ? void 0 : Color_SKU_Details_s[0];
        const SKUColorSwatchFilename = Color_SKU_Details_s === null || Color_SKU_Details_s === void 0 ? void 0 : Color_SKU_Details_s[1];
        const CustomerFacingSKU = Color_SKU_Details_s === null || Color_SKU_Details_s === void 0 ? void 0 : Color_SKU_Details_s[(Color_SKU_Details_s === null || Color_SKU_Details_s === void 0 ? void 0 : Color_SKU_Details_s.length) - 1];
        product.skuid = selectedSkuItem;
        product.masterVariantSku = masterVariantSku;
        let masterAttributes = get_default()(masterVariant, "attributes", []);
        customerFacingSKUMaster = [
            {
                id: masterVariantSku,
                CustomerFacingSKU
            }
        ];
        const masterColorName = SKUColorFinishName !== null && SKUColorFinishName !== void 0 ? SKUColorFinishName : "";
        const masterColorFiles = SKUColorSwatchFilename !== null && SKUColorSwatchFilename !== void 0 ? SKUColorSwatchFilename : "";
        product.brandName = lwProdData === null || lwProdData === void 0 ? void 0 : lwProdData.ProductBrandNameDisplay_s;
        product.productName = lwProdData === null || lwProdData === void 0 ? void 0 : lwProdData.productName_s;
        product.productDescription = get_default()(masterVariant.attributes.find((attr)=>attr.name === "ProductDescriptionProductShort"), "value", "");
        imagesDataMaster = [
            {
                id: masterVariantSku,
                image: productImage ? productImage : image_missing/* default */.Z
            }
        ];
        category = (0,helper.getAttributeValue)(masterAttributes, "ProductLocalCategory");
        priceOfMaster = [
            {
                id: masterVariantSku,
                price: (Number(get_default()(masterVariant.prices.find((item)=>{
                    var ref, ref1, ref2;
                    return (item === null || item === void 0 ? void 0 : (ref = item.value) === null || ref === void 0 ? void 0 : ref.currencyCode) === currencyCode && (item === null || item === void 0 ? void 0 : (ref1 = item.customerGroup) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.obj) === null || ref2 === void 0 ? void 0 : ref2.key) === persona;
                }), "value.centAmount", 0)) / 100).toFixed(2),
                discountedPrice: (Number(get_default()(masterVariant.prices.find((item)=>{
                    var ref, ref1, ref2;
                    return (item === null || item === void 0 ? void 0 : (ref = item.value) === null || ref === void 0 ? void 0 : ref.currencyCode) === currencyCode && (item === null || item === void 0 ? void 0 : (ref1 = item.customerGroup) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.obj) === null || ref2 === void 0 ? void 0 : ref2.key) === persona;
                }), "discounted.value.centAmount", 0)) / 100).toFixed(2),
                discountPercent: Number(get_default()(masterVariant.prices.find((item)=>{
                    var ref;
                    return (item === null || item === void 0 ? void 0 : (ref = item.value) === null || ref === void 0 ? void 0 : ref.currencyCode) === currencyCode;
                }), "discounted.discount.obj.value.permyriad", 0)) / 100,
                discountType: get_default()(masterVariant.prices.find((item)=>{
                    var ref;
                    return (item === null || item === void 0 ? void 0 : (ref = item.value) === null || ref === void 0 ? void 0 : ref.currencyCode) === currencyCode;
                }), "discounted.discount.obj.value.type", "")
            }
        ];
        if (!masterVariant.prices.find((item)=>{
            var ref, ref1, ref2;
            return (item === null || item === void 0 ? void 0 : (ref = item.value) === null || ref === void 0 ? void 0 : ref.currencyCode) === currencyCode && (item === null || item === void 0 ? void 0 : (ref1 = item.customerGroup) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.obj) === null || ref2 === void 0 ? void 0 : ref2.key) === persona;
        })) {
            priceOfMaster[0].price = (Number(get_default()(masterVariant.prices.find((item)=>{
                var ref;
                return (item === null || item === void 0 ? void 0 : (ref = item.value) === null || ref === void 0 ? void 0 : ref.currencyCode) === currencyCode;
            }), "value.centAmount", 0)) / 100).toFixed(2);
        }
        var ref8;
        const cartMasterVar = (ref8 = cart === null || cart === void 0 ? void 0 : (ref5 = cart.lineItems) === null || ref5 === void 0 ? void 0 : ref5.find((item)=>{
            return (item === null || item === void 0 ? void 0 : item.variant.sku) === masterVariantSku;
        })) !== null && ref8 !== void 0 ? ref8 : {};
        if (cartMasterVar === null || cartMasterVar === void 0 ? void 0 : cartMasterVar.discountedPrice) {
            priceOfMaster[0].discountedPrice = (Number(get_default()(cartMasterVar.discountedPrice, "value.centAmount", 0)) / 100).toFixed(2);
            priceOfMaster[0].discountType = get_default()(cartMasterVar.discountedPrice, "includedDiscounts[0].discount.obj.value.type", "");
            priceOfMaster[0].discountPercent = priceOfMaster[0].discountType === "absolute" ? Number(get_default()(cartMasterVar.discountedPrice, "includedDiscounts[0].discount.obj.value.money[0].centAmount", 0)) / 100 : Number(get_default()(cartMasterVar.discountedPrice, "includedDiscounts[0].discount.obj.value.permyriad", 0)) / 100;
        }
        let OutOfStockMaster = false;
        // const channels = Object.values(
        //   _get(masterVariant.availability, "channels", {})
        // )
        // if (channels.length > 0) {
        //   const availableQtyMaster = _get(channels[0], "availableQuantity", 0)
        //   OutOfStockMaster = availableQtyMaster > 0 ? false : true
        // } else {
        //   OutOfStockMaster = true
        // }
        const getDiscontinuedValue = get_default()(masterAttributes.find((attr)=>attr.name === "RegionDiscontinuedDate"), "value", "");
        const discontinuedMasterVariant = Date.parse(getDiscontinuedValue) < Date.now();
        colorsDataMaster = [
            {
                id: masterVariantSku,
                name: "product-color-".concat(colorId),
                value: masterVariantSku,
                label: masterColorName,
                colorUrl: constants["default"].COLOR_FILE_URL + masterColorFiles,
                checked: masterVariantSku === selectedSkuItem ? true : false,
                isOutOfStock: OutOfStockMaster,
                isDiscontinued: discontinuedMasterVariant,
                notApplicable: masterColorFiles.toLowerCase() === constants.SWATCH_NA.toLowerCase()
            }
        ];
        variants.forEach((variant, i)=>{
            var ref, ref1, ref2, ref3, ref4;
            const variantAttributes = get_default()(variant, "attributes", []);
            const variantSku = get_default()(variant, "sku", "");
            var ref5;
            const Color_SKU_Details_s = (ref5 = (ref1 = (ref = lwProdData["Color.SKU.Details_ss"]) === null || ref === void 0 ? void 0 : ref.find((item)=>item.includes(variantSku))) === null || ref1 === void 0 ? void 0 : ref1.split("|")) !== null && ref5 !== void 0 ? ref5 : [];
            var ref6;
            const productImage = (ref6 = (ref3 = (ref2 = lwProdData["Color.ANY.Details_ss"]) === null || ref2 === void 0 ? void 0 : ref2.find((item)=>item.includes(variantSku))) === null || ref3 === void 0 ? void 0 : ref3.split("|")) !== null && ref6 !== void 0 ? ref6 : [];
            var ref7;
            const colorName = (ref7 = Color_SKU_Details_s[0]) !== null && ref7 !== void 0 ? ref7 : "";
            var ref8;
            const colorFiles = (ref8 = Color_SKU_Details_s[1]) !== null && ref8 !== void 0 ? ref8 : "";
            const getDiscontinuedValue = get_default()(variantAttributes.find((attr)=>attr.name === "RegionDiscontinuedDate"), "value", "");
            const isDiscontinuedVariant = Date.parse(getDiscontinuedValue) < Date.now();
            let OutOfStockVariant = false;
            // const channels = Object.values(_get(variant, "availability.channels", {}))
            // if (channels.length > 0) {
            //   const availableQtyvariants = _get(channels[0], "availableQuantity", 0)
            //   OutOfStockVariant = availableQtyvariants > 0 ? false : true
            // }
            const isImgVariant = variantSku.startsWith("IMGV");
            customerFacingSKUVariant[i] = {
                id: variantSku,
                CustomerFacingSKU: get_default()(variantAttributes.find((attr)=>attr.name === "CustomerFacingSKU"), "value", "")
            };
            colorsDataVariants[i] = {
                id: variantSku,
                name: "product-color-".concat(colorId),
                value: variantSku,
                label: colorName,
                colorUrl: constants["default"].COLOR_FILE_URL + colorFiles,
                checked: variantSku === selectedSkuItem ? true : false,
                isOutOfStock: OutOfStockVariant,
                isDiscontinued: isDiscontinuedVariant || isImgVariant,
                notApplicable: false
            };
            imagesDataVariants[i] = {
                id: variantSku,
                image: productImage.length ? productImage.pop() : image_missing/* default */.Z
            };
            priceOfVariants[i] = {
                id: variantSku,
                price: (Number(get_default()(variant.prices.find((item)=>{
                    var ref, ref1, ref2;
                    return (item === null || item === void 0 ? void 0 : (ref = item.value) === null || ref === void 0 ? void 0 : ref.currencyCode) === currencyCode && (item === null || item === void 0 ? void 0 : (ref1 = item.customerGroup) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.obj) === null || ref2 === void 0 ? void 0 : ref2.key) === persona;
                }), "value.centAmount", 0)) / 100).toFixed(2),
                discountedPrice: (Number(get_default()(variant.prices.find((item)=>{
                    var ref, ref1, ref2;
                    return (item === null || item === void 0 ? void 0 : (ref = item.value) === null || ref === void 0 ? void 0 : ref.currencyCode) === currencyCode && (item === null || item === void 0 ? void 0 : (ref1 = item.customerGroup) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.obj) === null || ref2 === void 0 ? void 0 : ref2.key) === persona;
                }), "discounted.value.centAmount", 0)) / 100).toFixed(2),
                discountPercent: Number(get_default()(variant.prices.find((item)=>{
                    var ref;
                    return (item === null || item === void 0 ? void 0 : (ref = item.value) === null || ref === void 0 ? void 0 : ref.currencyCode) === currencyCode;
                }), "discounted.discount.obj.value.permyriad", 0)) / 100,
                discountType: get_default()(variant.prices.find((item)=>{
                    var ref;
                    return (item === null || item === void 0 ? void 0 : (ref = item.value) === null || ref === void 0 ? void 0 : ref.currencyCode) === currencyCode;
                }), "discounted.discount.obj.value.type", "")
            };
            if (!variant.prices.find((item)=>{
                var ref, ref1, ref2;
                return (item === null || item === void 0 ? void 0 : (ref = item.value) === null || ref === void 0 ? void 0 : ref.currencyCode) === currencyCode && (item === null || item === void 0 ? void 0 : (ref1 = item.customerGroup) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.obj) === null || ref2 === void 0 ? void 0 : ref2.key) === persona;
            })) {
                priceOfVariants[i].price = (Number(get_default()(variant.prices.find((item)=>{
                    var ref;
                    return (item === null || item === void 0 ? void 0 : (ref = item.value) === null || ref === void 0 ? void 0 : ref.currencyCode) === currencyCode;
                }), "value.centAmount", 0)) / 100).toFixed(2);
            }
            var ref9;
            const cartItem = (ref9 = cart === null || cart === void 0 ? void 0 : (ref4 = cart.lineItems) === null || ref4 === void 0 ? void 0 : ref4.find((item)=>{
                var ref;
                return (item === null || item === void 0 ? void 0 : (ref = item.variant) === null || ref === void 0 ? void 0 : ref.sku) === variantSku;
            })) !== null && ref9 !== void 0 ? ref9 : {};
            if (cartItem === null || cartItem === void 0 ? void 0 : cartItem.discountedPrice) {
                priceOfVariants[i].discountedPrice = (Number(get_default()(cartItem.discountedPrice, "value.centAmount", 0)) / 100).toFixed(2);
                priceOfVariants[i].discountType = get_default()(cartItem.discountedPrice, "includedDiscounts[0].discount.obj.value.type", "");
                priceOfVariants[i].discountPercent = priceOfVariants[i].discountType === "absolute" ? Number(get_default()(cartItem.discountedPrice, "includedDiscounts[0].discount.obj.value.money[0].centAmount", 0)) / 100 : Number(get_default()(cartItem.discountedPrice, "includedDiscounts[0].discount.obj.value.permyriad", 0)) / 100;
            }
        });
        product.customerFacingSKU = [
            ...customerFacingSKUMaster,
            ...customerFacingSKUVariant
        ];
        product.priceData = [
            ...priceOfMaster,
            ...priceOfVariants
        ];
        product.imagesData = [
            ...imagesDataMaster,
            ...imagesDataVariants
        ];
        product.colorsData = [
            ...colorsDataMaster,
            ...colorsDataVariants
        ];
        product.backorder = backorder;
        product.inRiverId = lwProdData === null || lwProdData === void 0 ? void 0 : lwProdData.productInRiverId_s;
        requiredProductsData.push(product);
    }
    (0,react.useEffect)(()=>{
        var ref, ref1;
        const selectedVariant = addItemsData && addItemsData.filter((list)=>{
            var ref;
            return (list === null || list === void 0 ? void 0 : list.masterVariantSku) === (item === null || item === void 0 ? void 0 : (ref = item.masterVariant) === null || ref === void 0 ? void 0 : ref.sku);
        });
        var ref2;
        const selectedSku = (ref2 = selectedVariant && ((ref = selectedVariant[0]) === null || ref === void 0 ? void 0 : ref.skuid)) !== null && ref2 !== void 0 ? ref2 : item === null || item === void 0 ? void 0 : (ref1 = item.masterVariant) === null || ref1 === void 0 ? void 0 : ref1.sku;
        setSelectedSkuItem(selectedSku);
        setIsChecked(Boolean(addItemsData && addItemsData.find((list)=>{
            return (list === null || list === void 0 ? void 0 : list.skuid) === selectedSku;
        })));
    }, []);
    (0,react.useEffect)(()=>{
        setIsChecked(Boolean(addItemsData && addItemsData.find((list)=>list.skuid === selectedSkuItem)));
    }, [
        addItemsData
    ]);
    (0,react.useEffect)(()=>{
        if (category && slug) {
            (0,helper.getPDPUrl)(category, slug).then((url)=>{
                setPdpUrl(url);
            });
        }
    }, [
        category,
        slug
    ]);
    const getSelectedSku = (sku)=>{
        setSelectedSkuItem(sku);
        setIsChecked(Boolean(addItemsData && addItemsData.find((list)=>list.skuid === sku)));
    };
    const getPrice = (sku, type)=>{
        return get_default()(requiredProductsData[0].priceData.find((item)=>{
            return (item === null || item === void 0 ? void 0 : item.id) === sku;
        }), type, 0);
    };
    const isItemOutOfStock = backorder ? false : get_default()(requiredProductsData[0].colorsData.find((item)=>{
        return (item === null || item === void 0 ? void 0 : item.id) === selectedSkuItem;
    }), "isOutOfStock", "");
    const getEventInfo = function(type) {
        let needJSON = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, link = arguments.length > 2 ? arguments[2] : void 0;
        var ref;
        const { adobeDataLayer: { getState  } = {}  } = window;
        const page = getState && getState("page") || {};
        const pagetitle = page === null || page === void 0 ? void 0 : (ref = page.category) === null || ref === void 0 ? void 0 : ref.pageType;
        const eventInfo = {
            eventAction: "".concat(pagetitle, ":select a product required for installation:").concat(type),
            eventName: "".concat(pagetitle, ":select a product required for installation:").concat(type),
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: type,
            internalLinkPosition: "items required for install",
            internalLinkType: "".concat(pagetitle, ":select a product required for installation:").concat(type),
            internalLinkZoneName: "".concat(pagetitle, ":select a product required for installation"),
            internalLinkURL: link ? (link.indexOf("http") === -1 ? window.location.origin : "") + link : "n/a",
            clickInternalLinks: "true"
        };
        if (needJSON) {
            return eventInfo;
        }
        return JSON.stringify(eventInfo);
    };
    const colorswatchClickHandler = (id)=>{
        getSelectedSku(id);
        pushAnalyticsData("color selection", productInfo);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "line-item",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "line-item__image",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "product-tile__image",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            alt: "",
                            src: get_default()(requiredProductsData[0].imagesData.find((item)=>{
                                return (item === null || item === void 0 ? void 0 : item.id) === selectedSkuItem;
                            }), "image", ""),
                            width: "120px",
                            height: "120px"
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "line-item__header",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "title-and-description",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "must-have",
                                children: props.staticTexts.mustItemCTA
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "brand-name",
                                children: requiredProductsData[0].productName
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "item-description",
                                children: requiredProductsData[0].productDescription
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "line-item__sku",
                        children: [
                            !isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "sku-id",
                                children: "K-".concat(selectedSkuItem)
                            }) : "",
                            isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "line-item__include--mobile",
                                children: !isItemOutOfStock && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                        className: "include-text",
                                        value: "",
                                        checked: isChecked,
                                        onChange: (e)=>updateItems(e.target.checked, requiredProductsData[0])
                                    })
                                })
                            }) : ""
                        ]
                    }),
                    !isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "line-item__price--desktop",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "price",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "list-item__price",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                            value: getPrice(selectedSkuItem, "discountedPrice") > 0 ? getPrice(selectedSkuItem, "discountedPrice") : getPrice(selectedSkuItem, "price"),
                                            displayType: "text",
                                            thousandSeparator: true,
                                            prefix: currencySign,
                                            decimalScale: 2,
                                            fixedDecimalScale: true
                                        })
                                    }),
                                    getPrice(selectedSkuItem, "discountedPrice") > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "list-item__discounted",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "list-item__percent-off",
                                                children: getPrice(selectedSkuItem, "discountType") === "absolute" ? "".concat(currencySign, "  ").concat(getPrice(selectedSkuItem, "discountPercent")) : "".concat(getPrice(selectedSkuItem, "discountPercent"), "% ").concat(staticTexts.percentOff)
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                                value: getPrice(selectedSkuItem, "price"),
                                                displayType: "text",
                                                thousandSeparator: true,
                                                prefix: currencySign,
                                                decimalScale: 2,
                                                fixedDecimalScale: true
                                            })
                                        ]
                                    })
                                ]
                            }),
                            !isItemOutOfStock && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                    checked: isChecked,
                                    onChange: (e)=>updateItems(e.target.checked, requiredProductsData[0])
                                })
                            })
                        ]
                    }) : ""
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "line-item__info",
                children: [
                    isMobile && !dist_lib/* isTablet */.Em ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "sku-id",
                        children: get_default()(requiredProductsData[0].customerFacingSKU.find((item)=>{
                            return (item === null || item === void 0 ? void 0 : item.id) === selectedSkuItem;
                        }), "id", "")
                    }) : "",
                    isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "line-item__price--mobile",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "price",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "price_item",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                        value: getPrice(selectedSkuItem, "discountedPrice") > 0 ? getPrice(selectedSkuItem, "discountedPrice") : getPrice(selectedSkuItem, "price"),
                                        displayType: "text",
                                        thousandSeparator: true,
                                        prefix: currencySign,
                                        decimalScale: 2,
                                        fixedDecimalScale: true
                                    })
                                }),
                                getPrice(selectedSkuItem, "discountedPrice") > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "discount-price",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                            value: getPrice(selectedSkuItem, "price"),
                                            displayType: "text",
                                            thousandSeparator: true,
                                            prefix: currencySign,
                                            decimalScale: 2,
                                            fixedDecimalScale: true
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            className: "discount-percent-off",
                                            children: [
                                                getPrice(selectedSkuItem, "discountType") === "absolute" ? currencySign + getPrice(selectedSkuItem, "discountPercent") : getPrice(selectedSkuItem, "discountPercent") + "%",
                                                " ",
                                                staticTexts.percentOff
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }) : "",
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "item-color",
                        children: [
                            requiredProductsData[0].colorsData && requiredProductsData[0].colorsData.filter((col)=>!col.notApplicable && !col.isDiscontinued).length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "color-section",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "color-finish",
                                        children: staticTexts.colorOrFinish
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "color-value",
                                        children: get_default()(requiredProductsData[0].colorsData.find((item)=>{
                                            return (item === null || item === void 0 ? void 0 : item.id) === selectedSkuItem;
                                        }), "label", "")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "item-color-swatches",
                                children: requiredProductsData[0].colorsData && requiredProductsData[0].colorsData.filter((col)=>!col.notApplicable && !col.isDiscontinued).map((color, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(ColorSwatch_ColorSwatch, {
                                        type: "selector",
                                        id: color.id,
                                        name: color.name,
                                        value: color.value,
                                        label: color.label,
                                        colorUrl: color.colorUrl,
                                        checked: color.checked ? true : false,
                                        onClick: (id)=>colorswatchClickHandler(id)
                                    }, i))
                            }),
                            isItemOutOfStock && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "out-of-stock-section --desktop",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "out-of-stock-msg",
                                        children: staticTexts.outOfStockErr
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "back-in-stock",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: "gbh-data-layer",
                                            "data-gbh-data-layer": getEventInfo(staticTexts.backInStock.toLowerCase(), false, pdpUrl === null || pdpUrl === void 0 ? void 0 : pdpUrl.trim().toLowerCase()),
                                            "data-gbh-data-layer-custom": productInfo,
                                            href: pdpUrl,
                                            children: staticTexts.backInStock
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            !isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "line-item__include--mobile",
                children: !isItemOutOfStock && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                        className: "include-text",
                        value: staticTexts.includeTextCTA,
                        checked: isChecked,
                        onChange: (e)=>updateItems(e.target.checked, requiredProductsData[0])
                    })
                })
            }) : "",
            !isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "line-item__price--mobile",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "price",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "price_item",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                value: getPrice(selectedSkuItem, "discountedPrice") > 0 ? getPrice(selectedSkuItem, "discountedPrice") : getPrice(selectedSkuItem, "price"),
                                displayType: "text",
                                thousandSeparator: true,
                                prefix: currencySign,
                                decimalScale: 2,
                                fixedDecimalScale: true
                            })
                        }),
                        getPrice(selectedSkuItem, "discountedPrice") > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "discount-price",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                    value: getPrice(selectedSkuItem, "price"),
                                    displayType: "text",
                                    thousandSeparator: true,
                                    prefix: currencySign,
                                    decimalScale: 2,
                                    fixedDecimalScale: true
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "discount-percent-off",
                                    children: [
                                        getPrice(selectedSkuItem, "discountType") === "absolute" ? currencySign + getPrice(selectedSkuItem, "discountPercent") : getPrice(selectedSkuItem, "discountPercent") + "%",
                                        " ",
                                        staticTexts.percentOff
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }) : "",
            isItemOutOfStock && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "out-of-stock-section --mobile",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "out-of-stock-msg",
                        children: staticTexts.outOfStockErr
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "back-in-stock",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: "gbh-data-layer",
                            "data-gbh-data-layer": getEventInfo(staticTexts.backInStock.toLowerCase(), false, pdpUrl === null || pdpUrl === void 0 ? void 0 : pdpUrl.trim().toLowerCase()),
                            "data-gbh-data-layer-custom": productInfo,
                            href: pdpUrl,
                            children: staticTexts.backInStock
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var v3_PDPRequiredItem = (PDPRequiredItem);

// EXTERNAL MODULE: ./components/ProductDetail/v3/PDPRequiredItemModal/index.module.scss
var PDPRequiredItemModal_index_module = __webpack_require__(61184);
var PDPRequiredItemModal_index_module_default = /*#__PURE__*/__webpack_require__.n(PDPRequiredItemModal_index_module);
;// CONCATENATED MODULE: ./components/ProductDetail/v3/PDPRequiredItemModal/index.jsx
/* eslint-disable new-cap */ 












const PDPRequiredItemModal = (props)=>{
    const { name ="" , desc ="" , customerFacingSKU ="" , sku ="" , staticTexts ={} , imagesData =[] , installReq =[] , colorsData =[] , price =0 , discountedPrice =0 , currencySign ="" , reqItemLwData =[] , currencyCode ="" , locale ="" , productInfo ={} , discountPercent =0 , isType ="" , getRequireItemsData =()=>{} , onModalClose =()=>{} , showModal =false , installRequiredItemsData =[]  } = props;
    const [addItems, setAddItems] = (0,react.useState)([]);
    const [enableInclude, setEnableInclude] = (0,react.useState)(false);
    const [config, setConfig] = (0,react.useState)("");
    const [imageUrl, setImageUrl] = (0,react.useState)("");
    const modalWindow = (0,react.useRef)(null);
    const itemScroll = (0,react.useRef)(null);
    const [width] = (0,useWindowResize/* default */.Z)();
    window.addEventListener("click", function(e) {
        var ref;
        if (e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.contains(modalWindow === null || modalWindow === void 0 ? void 0 : modalWindow.current)) {
            onModalClose();
        }
    });
    (0,react.useEffect)(()=>{
        (0,constants_config/* getConfig */.i)().then((config)=>setConfig(config));
    }, []);
    (0,react.useEffect)(()=>{
        if (!isEmpty_default()(config)) {
            const { general: { swatchUrl =""  } = {}  } = config;
            var ref;
            const { assetId ="" , url =""  } = (ref = imagesData[0]) !== null && ref !== void 0 ? ref : {};
            const imageUrl = !url.includes("/PAWEB/") ? url : swatchUrl + assetId;
            setImageUrl(imageUrl);
        }
    }, [
        config,
        imagesData
    ]);
    (0,react.useEffect)(()=>{
        setAddItems(installReq);
    }, [
        installReq
    ]);
    (0,react.useEffect)(()=>{
        if (addItems.length !== 0) {
            setEnableInclude(true);
        } else {
            setEnableInclude(false);
        }
    }, [
        addItems
    ]);
    const updateItems = (checked, item)=>{
        let installRequireItems = addItems;
        if (checked) {
            installRequireItems = installRequireItems.filter((requiredProduct)=>requiredProduct.masterVariantSku !== item.masterVariantSku);
            installRequireItems.push(item);
        } else {
            installRequireItems = installRequireItems.filter((requiredProduct)=>requiredProduct.skuid !== item.skuid);
        }
        setAddItems([
            ...installRequireItems
        ]);
    };
    const includeOnClick = ()=>{
        getRequireItemsData(addItems);
        onModalClose();
    };
    (0,react.useEffect)(()=>{
        if (width > 991 && showModal && itemScroll.current && (installRequiredItemsData === null || installRequiredItemsData === void 0 ? void 0 : installRequiredItemsData.length) > 0) {
            window.OverlayScrollbars ? window.OverlayScrollbars(itemScroll === null || itemScroll === void 0 ? void 0 : itemScroll.current, {
                className: "os-theme-dark",
                resize: "none",
                sizeAutoCapable: true,
                clipAlways: true,
                normalizeRTL: true,
                paddingAbsolute: false,
                autoUpdate: null,
                autoUpdateInterval: 33,
                nativeScrollbarsOverlaid: {
                    showNativeScrollbars: false,
                    initialize: true
                },
                overflow: {
                    x: "hidden"
                },
                scrollbars: {
                    visibility: "auto",
                    autoHide: "never",
                    autoHideDelay: 800,
                    dragScrolling: true,
                    clickScrolling: true,
                    touchSupport: true,
                    snapHandle: true
                }
            }) : null;
        }
    }, [
        showModal,
        itemScroll === null || itemScroll === void 0 ? void 0 : itemScroll.current,
        installRequiredItemsData,
        width
    ]);
    const includeButtonClickHandler = ()=>{
        var ref;
        includeOnClick();
        pushAnalyticsData(staticTexts === null || staticTexts === void 0 ? void 0 : (ref = staticTexts.includeTextCTA) === null || ref === void 0 ? void 0 : ref.toLowerCase(), productInfo);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (PDPRequiredItemModal_index_module_default()).pdpRequiredItemModalWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "product-detail-page__install-items-modal",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
                showModal: showModal,
                onModalClose: onModalClose,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "required-item",
                    ref: modalWindow,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "required-item__container",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "required-item__left-section",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "product-title",
                                        children: staticTexts.title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "item-details",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "item-details__image",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "product-image",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        className: "product-image-container",
                                                        src: imageUrl,
                                                        alt: name,
                                                        onError: (e)=>(0,utils_0/* onImageError */.Ac)(e, imageUrl),
                                                        width: "250px",
                                                        height: "250px"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "item-details__info",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "product-family-name",
                                                        children: name
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "product-description",
                                                        children: desc
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "sku-id",
                                                        children: customerFacingSKU || sku
                                                    }),
                                                    colorsData.filter((c)=>!c.notApplicable).length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "color-finish",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                children: "Color/Finish"
                                                            }),
                                                            " :",
                                                            " ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                children: get_default()(colorsData.find((item)=>item.id === sku), "label", "")
                                                            })
                                                        ]
                                                    }),
                                                    price > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "price",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "price-amount",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                                                value: discountedPrice > 0 && discountedPrice < price ? discountedPrice : price,
                                                                displayType: "text",
                                                                thousandSeparator: true,
                                                                prefix: currencySign,
                                                                decimalScale: 2,
                                                                fixedDecimalScale: true
                                                            })
                                                        })
                                                    }),
                                                    discountedPrice > 0 && discountedPrice < price && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "required-item__display-discount --mobile",
                                                        children: [
                                                            discountPercent > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                className: "required-item__percent-off",
                                                                children: [
                                                                    isType === "absolute" ? currencySign + discountPercent : discountPercent + "%",
                                                                    " ",
                                                                    staticTexts.percentOff
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "required-item__discount-price --mobile",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                                                    value: price,
                                                                    displayType: "text",
                                                                    thousandSeparator: true,
                                                                    prefix: currencySign,
                                                                    decimalScale: 2,
                                                                    fixedDecimalScale: true
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "required-item__right-section",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        className: "required-product-title",
                                        children: staticTexts.requiredProductTitle
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "required-product-description",
                                        children: staticTexts.requiredProductDescription
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "required-product-header",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: staticTexts.productText
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: staticTexts.includeTextCTA
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        ref: itemScroll,
                                        className: "product-line-items",
                                        children: installRequiredItemsData.length > 0 && installRequiredItemsData.map((product, i)=>{
                                            var ref;
                                            const lwProdData = (ref = reqItemLwData === null || reqItemLwData === void 0 ? void 0 : reqItemLwData.find((i)=>product.id === i.ctId_s)) !== null && ref !== void 0 ? ref : {};
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(v3_PDPRequiredItem, {
                                                staticTexts: staticTexts,
                                                addItemsData: addItems,
                                                item: product,
                                                updateItems: (checked, item)=>updateItems(checked, item),
                                                currencyCode: currencyCode,
                                                currencySign: currencySign,
                                                locale: locale,
                                                colorId: i,
                                                backorder: lwProdData["RegionOnBackOrder_s"] === "Yes",
                                                lwProdData: lwProdData,
                                                productInfo: productInfo,
                                                ...props
                                            }, i);
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "include-button",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            useDefaultClass: true,
                                            role: "button",
                                            label: staticTexts.includeTextCTA,
                                            size: "medium",
                                            type: "primary",
                                            onClick: ()=>{
                                                includeButtonClickHandler();
                                            },
                                            disabled: !enableInclude
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        })
    });
};
/* harmony default export */ var v3_PDPRequiredItemModal = (PDPRequiredItemModal);

;// CONCATENATED MODULE: ./components/ProductDetail/v3/ProductDetailView/InstallReqItems.jsx







const InstallReqItems = (props)=>{
    const { isDiscontinued =false , staticTexts ={} , price =0 , discountedPrice =0 , currencySign ="" , installReq =[] , productAnalyticsData ={} , onInstallCTA =()=>{} , toolTipIcon ="" , handleInfoToolTipHover =()=>{} , setShowTooltip =()=>{} , showTooltip =false , isMobileOnly =false , handleRemove =()=>{} , priceList =[] , subTotal =0 , requiredItems =[] , getRequireItems =()=>{} , installReqData =[] , reqItemLwData =[] , onModalClose =()=>{} , showPDPInstallModal =false , locale ="" , currencyCode ="" , reqItemsError ={}  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: !isDiscontinued && (requiredItems === null || requiredItems === void 0 ? void 0 : requiredItems.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "row no-gutters product-detail-page__install-item",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "product-detail-page__install-item-btn",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                role: "button",
                                className: "gbh-data-layer",
                                "data-gbh-data-layer": (0,analytics/* getEventInfo */.wQ)((installReq.length === 0 ? staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.itemReqCTA : staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.editItemReqCTA).toLowerCase()),
                                "data-gbh-data-layer-custom": productAnalyticsData.stringProductInfo,
                                label: installReq.length === 0 ? staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.itemReqCTA : staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.editItemReqCTA,
                                size: "small",
                                type: "ghost",
                                onClick: onInstallCTA
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "product-detail-page__tooltip-icon",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: toolTipIcon.src,
                                        alt: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.toolTip,
                                        onMouseOver: (e)=>handleInfoToolTipHover(e),
                                        onMouseLeave: ()=>setShowTooltip(false),
                                        width: "16px",
                                        height: "16px",
                                        "data-testid": "img-tooltip-installRqitm"
                                    }),
                                    showTooltip && /*#__PURE__*/ (0,jsx_runtime.jsx)(ToolTip/* default */.Z, {
                                        message: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.tooltipMsg
                                    })
                                ]
                            })
                        ]
                    })
                }),
                installReq.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "no-gutters product-detail-page__install-items-container",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "product-detail-page__required-product-header",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.requiredItemsProduct
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.requiredItemsPrice
                                })
                            ]
                        }),
                        installReq && installReq.map((item, i)=>{
                            var ref;
                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                className: "col-12 product-detail-page__install-item-details",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "row",
                                        children: [
                                            !isMobileOnly ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "col-2",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        alt: "",
                                                        src: get_default()(item.imagesData.find((list)=>list.id === item.skuid), "image", ""),
                                                        width: "80px",
                                                        height: "80px"
                                                    })
                                                })
                                            }) : "",
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: isMobileOnly ? "col-8" : "col-6",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "item-details",
                                                        children: item.productName
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "item-description",
                                                        children: item.productDescription
                                                    }),
                                                    !get_default()(item.colorsData.find((list)=>list.id === item.skuid), "notApplicable", false) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                            className: "item-color-details",
                                                            children: [
                                                                staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.colorOrFinish,
                                                                " :",
                                                                " ",
                                                                get_default()(item.colorsData.find((list)=>list.id === item.skuid), "label", "")
                                                            ]
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "col-4",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                        className: "item-price",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                                            value: get_default()(item.priceData.find((list)=>list.id === item.skuid), "discountedPrice", 0) > 0 ? get_default()(item.priceData.find((list)=>list.id === item.skuid), "discountedPrice", 0) : get_default()(item.priceData.find((list)=>list.id === item.skuid), "price", 0),
                                                            displayType: "text",
                                                            thousandSeparator: true,
                                                            prefix: currencySign,
                                                            decimalScale: 2,
                                                            fixedDecimalScale: true
                                                        })
                                                    }),
                                                    get_default()(item.priceData.find((list)=>list.id === item.skuid), "discountedPrice", 0) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "discount-price-item",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "discount-price",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                                                        value: get_default()(item.priceData.find((list)=>list.id === item.skuid), "price", 0),
                                                                        displayType: "text",
                                                                        thousandSeparator: true,
                                                                        prefix: currencySign,
                                                                        decimalScale: 2,
                                                                        fixedDecimalScale: true
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "discount-percent",
                                                                    children: [
                                                                        get_default()(item.priceData.find((list)=>list.id === item.skuid), "discountType", "") === "absolute" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                                                            value: get_default()(item.priceData.find((list)=>list.id === item.skuid), "discountPercent", 0),
                                                                            displayType: "text",
                                                                            thousandSeparator: true,
                                                                            prefix: currencySign,
                                                                            decimalScale: 2,
                                                                            fixedDecimalScale: true
                                                                        }) : get_default()(item.priceData.find((list)=>list.id === item.skuid), "discountPercent", 0) + "%",
                                                                        " ",
                                                                        staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.percentOff
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "remove",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            className: "remove-link gbh-data-layer",
                                                            onClick: ()=>handleRemove(item),
                                                            "data-gbh-data-layer": (0,analytics/* getEventInfo */.wQ)(staticTexts === null || staticTexts === void 0 ? void 0 : (ref = staticTexts.remove) === null || ref === void 0 ? void 0 : ref.toLowerCase()),
                                                            "data-gbh-data-layer-custom": productAnalyticsData.stringProductInfo,
                                                            children: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.remove
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "row",
                                        children: reqItemsError[item.skuid] && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            class: "pincode-error col-12",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                class: "error-msg",
                                                children: reqItemsError[item.skuid]
                                            })
                                        })
                                    })
                                ]
                            }, i);
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-12 product-detail-page__install-item-details",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "row",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "col-8",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "base-product",
                                                children: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.baseProduct
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "base-product",
                                                children: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.requiredItems
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "total",
                                                children: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.subTotal
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "col-4",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "item-price",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                                    value: discountedPrice > 0 ? discountedPrice : price,
                                                    displayType: "text",
                                                    thousandSeparator: true,
                                                    prefix: currencySign,
                                                    decimalScale: 2,
                                                    fixedDecimalScale: true
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                    className: "item-price",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                                        value: priceList,
                                                        displayType: "text",
                                                        thousandSeparator: true,
                                                        prefix: currencySign,
                                                        decimalScale: 2,
                                                        fixedDecimalScale: true
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "sub-total",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                                    value: subTotal.toFixed(2),
                                                    displayType: "text",
                                                    thousandSeparator: true,
                                                    prefix: currencySign,
                                                    decimalScale: 2,
                                                    fixedDecimalScale: true
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(v3_PDPRequiredItemModal, {
                    ...props,
                    staticTexts: staticTexts,
                    getRequireItemsData: (addItems)=>getRequireItems(addItems),
                    installRequiredItemsData: installReqData,
                    reqItemLwData: reqItemLwData,
                    onModalClose: onModalClose,
                    showModal: showPDPInstallModal,
                    locale: locale,
                    currencyCode: currencyCode,
                    installReq: installReq,
                    currencySign: currencySign,
                    productInfo: productAnalyticsData.stringProductInfo
                })
            ]
        })
    });
};
/* harmony default export */ var ProductDetailView_InstallReqItems = (InstallReqItems);

// EXTERNAL MODULE: ./node_modules/lodash/debounce.js
var debounce = __webpack_require__(23279);
// EXTERNAL MODULE: ./components/core/Input/Input.jsx
var Input = __webpack_require__(3372);
// EXTERNAL MODULE: ./js/helperV2.js + 1 modules
var helperV2 = __webpack_require__(83699);
// EXTERNAL MODULE: ./components/ProductDetail/v3/AddToCart/analytics.js
var AddToCart_analytics = __webpack_require__(30525);
// EXTERNAL MODULE: ./utils/validate.js
var validate = __webpack_require__(45648);
;// CONCATENATED MODULE: ./components/ProductDetail/v3/ProductDetailView/NotifyComponent.jsx










const NotifyComponent = (props)=>{
    const { staticTexts , setNotifySuccess , productAnalyticsData , productInRiverId_s , sku , fromAddToCart =false , notifyContainer , notifyClicked =false , productCategory ="" , imagesData  } = props;
    const getCookieValue = (name)=>{
        var ref;
        return ((ref = document.cookie.match("(^|;)\\s*" + name + "\\s*=\\s*([^;]+)")) === null || ref === void 0 ? void 0 : ref.pop()) || "";
    };
    const initState = {
        email: "",
        pincode: getCookieValue("pincode")
    };
    const [notifyMeFormData, setNotifyFormData] = (0,react.useState)(initState);
    const [notifyMeErrors, setNotifyFormErrors] = (0,react.useState)({});
    const { isAuth , user  } = (0,es/* useSelector */.v9)(authSlice/* selectAuthState */._9);
    const handleFieldChange = function() {
        let val = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", fieldName = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", data = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, setData = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : ()=>{};
        const inputValue = val.trimStart();
        if (inputValue === "") {
            setData({
                ...data,
                [fieldName]: inputValue
            });
        } else if (fieldName === "email") {
            setData({
                ...data,
                [fieldName]: inputValue.trim()
            });
        } else if (fieldName === "pincode") {
            if ((0,validate/* validNumber */.BP)(inputValue) && inputValue.length <= 6) {
                setData({
                    ...data,
                    [fieldName]: inputValue
                });
            }
        }
    };
    (0,react.useEffect)(()=>{
        if (notifyClicked) handleNotification();
    }, [
        notifyClicked
    ]);
    const handleFieldBlur = function() {
        let val = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", fieldName = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", errors = arguments.length > 2 ? arguments[2] : void 0, setError = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : ()=>{};
        const inputValue = val.trimStart();
        const { validEmail , validPincode  } = staticTexts;
        if (fieldName === "email") {
            if (!(0,helperV2/* validateEmail */.oH)(inputValue)) {
                setError({
                    ...errors,
                    [fieldName]: validEmail
                });
            }
        } else if (fieldName === "pincode") {
            if (inputValue.length < 6) {
                setError({
                    ...errors,
                    [fieldName]: validPincode
                });
            }
        }
    };
    const onFieldChange = (e)=>{
        const { name ="" , value =""  } = e.target;
        handleFieldChange(value, name, notifyMeFormData, setNotifyFormData);
        setNotifyFormErrors({
            ...notifyMeErrors,
            [name]: ""
        });
    };
    const onFieldBlur = (e)=>{
        const { name ="" , value =""  } = e.target;
        handleFieldBlur(value, name, notifyMeErrors, setNotifyFormErrors);
    };
    const handleNotification = ()=>{
        var ref;
        const { email , pincode  } = notifyMeFormData;
        let { price , name: skuName , desc: skuDescription  } = props;
        let isValid = (ref = Object === null || Object === void 0 ? void 0 : Object.values(notifyMeErrors)) === null || ref === void 0 ? void 0 : ref.every((el)=>el === null || el === "" || el === undefined);
        let error = {};
        if (email === "") {
            error = {
                ...error,
                email: "Please enter a valid email address."
            };
            isValid = false;
        }
        if (pincode === "") {
            error = {
                ...error,
                pincode: "Please enter a valid Pin code."
            };
            isValid = false;
        }
        setNotifyFormErrors(error);
        if (!skuName || !skuDescription) {
            const { productAnalyticsData  } = props;
            skuName = productAnalyticsData.name;
            skuDescription = productAnalyticsData.desc;
        }
        if (isValid) {
            const assetId = imagesData[0].assetId;
            const isMissingImage = assetId.includes("image-missing");
            const body = {
                mastervariantkey: productInRiverId_s,
                sku: sku,
                skuName: skuName,
                skuDescription: skuDescription,
                skuPrice: "".concat(price),
                customer: {
                    email: email,
                    ...isAuth && {
                        phone: user.login
                    }
                },
                pincode: pincode,
                qty: "1",
                pdpUrl: window.location.href,
                category: productCategory,
                skuImageUrl: !isMissingImage ? imagesData[0].url : ""
            };
            api/* apim.post */.TH.post("catalog/product/oos/notify", body).then((res)=>{
                if (res) {
                    setNotifySuccess(true);
                }
            }).catch((error)=>{});
        }
    };
    const checkDisabled = (data)=>{
        const { email , pincode  } = data;
        return !((0,helperV2/* validateEmail */.oH)(email) && (0,validate/* validPincode */.cE)(pincode));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !fromAddToCart ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "notify-text",
                children: staticTexts.notifyEmailOosTxt
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "notify-email notify-email__out-of-stock",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "notify-email__input",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                            id: "email",
                            name: "email",
                            ariaRequried: true,
                            type: "text",
                            maxLength: 60,
                            value: notifyMeFormData === null || notifyMeFormData === void 0 ? void 0 : notifyMeFormData.email,
                            label: "".concat(staticTexts.emailAddress, "*"),
                            onChange: onFieldChange,
                            showError: notifyMeErrors === null || notifyMeErrors === void 0 ? void 0 : notifyMeErrors.email,
                            onBlur: onFieldBlur,
                            errorMessage: notifyMeErrors === null || notifyMeErrors === void 0 ? void 0 : notifyMeErrors.email
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "notify-email__input",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                            id: "pincode",
                            name: "pincode",
                            ariaRequried: true,
                            type: "text",
                            maxLength: 60,
                            value: notifyMeFormData === null || notifyMeFormData === void 0 ? void 0 : notifyMeFormData.pincode,
                            label: staticTexts.pincode,
                            onChange: onFieldChange,
                            showError: notifyMeErrors === null || notifyMeErrors === void 0 ? void 0 : notifyMeErrors.pincode,
                            onBlur: onFieldBlur,
                            errorMessage: notifyMeErrors === null || notifyMeErrors === void 0 ? void 0 : notifyMeErrors.pincode
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "notify-btn",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            className: "gbh-data-layer",
                            "data-gbh-data-layer": (0,AddToCart_analytics/* getAnalyticsData */.Eb)(staticTexts.notifyMailCTA),
                            "data-gbh-data-layer-custom": productAnalyticsData.stringProductInfo,
                            label: staticTexts.notifyMailCTA,
                            onClick: handleNotification,
                            size: "large",
                            type: "primary",
                            role: "button",
                            flexible: true,
                            disabled: false,
                            ref: notifyContainer
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var ProductDetailView_NotifyComponent = (NotifyComponent);

;// CONCATENATED MODULE: ./components/ProductDetail/v3/ProductDetailView/NotifySuccess.jsx


const NotifySuccess = (props)=>{
    const { staticTexts  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "success-message",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "thank-title",
                children: staticTexts.thanksMessage
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "thank-title",
                children: (0,helper.sanitizeAndDecodeHtml)(staticTexts.successMsg)
            })
        ]
    });
};
/* harmony default export */ var ProductDetailView_NotifySuccess = (NotifySuccess);

// EXTERNAL MODULE: ./components/cart/QuantitySelector.jsx
var QuantitySelector = __webpack_require__(75653);
// EXTERNAL MODULE: ./public/icons/wish.svg
var wish = __webpack_require__(29875);
// EXTERNAL MODULE: ./public/icons/wishlist-gray-filled.svg
var wishlist_gray_filled = __webpack_require__(62084);
// EXTERNAL MODULE: ./public/icons/warning.svg
var warning = __webpack_require__(10502);
// EXTERNAL MODULE: ./components/ProductDetail/v3/AddToCart/index.module.scss
var AddToCart_index_module = __webpack_require__(98185);
var AddToCart_index_module_default = /*#__PURE__*/__webpack_require__.n(AddToCart_index_module);
;// CONCATENATED MODULE: ./components/ProductDetail/v3/AddToCart/index.jsx
/* eslint-disable camelcase */ 




























const AddToCart = /*#__PURE__*/ (0,react.forwardRef)((props, ref)=>{
    const { isDiscontinued =false , isColorDiscontinued =false , productOnStock =1 , compareData ={} , sku ="" , ProductPriceSpiderIncluded_s ="" , price =0 , backOrder =false , isParts =false , onQtyChange =()=>{} , staticTexts ={} , onRemove =()=>{} , onAdd =()=>{} , onAddToCart =()=>{} , isComboSku =false , customerBrandName ="" , ctData ="" , productData ={} , productData: {} = {} , replaceAddToCartCtaLabel ="" , replaceAddToCartCtaLink ="" , onAvailableColor =()=>{} , disableEcommerce =false , specialOrder ="" , isRegionSoldOnline =true , replaceAddToCart =false , linkNewTab =false , isEnable =true , isFavorite =false , disableRatings =false , handleNavChange =()=>{} , productCategory ="" , favItem =[] , isPdpPropsLoaded =true , installError =false , masterSku ="" , availableQty =0 , installationData ={} , isInstallationAdded =false , isFragile =false , warehouses , isBundle , productInfo ={} , installProductInfo ={} , setPinCodeError , pinCodeError , installationError , setInstallationError , error , setError , loading: installLoading , setLoading: setInstallLoading , reqItemsError , quantity , setQuantity , handleBuyNow =()=>{} , setPincode: setPincodeValue , name , desc , productInRiverId_s , setNotifySuccess , notifySuccess , notifyContainer , isOutOfStock , notifyClicked =false , imagesData =imagesData  } = props;
    const { t  } = (0,esm/* useTranslation */.$G)("pdp");
    const initState = {
        phoneNumber: "",
        name: "",
        email: "",
        zipcode: ""
    };
    const { isAuth , user: { persona =[]  } = {}  } = (0,es/* useSelector */.v9)(authSlice/* selectAuthState */._9);
    const { toaster  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const { cart  } = (0,es/* useSelector */.v9)(cartSlice/* selectCartState */.xw);
    const [loading, setLoading] = (0,react.useState)(false);
    const [buyNowLoading, setBuyNowLoading] = (0,react.useState)(false);
    const [isChecked, setIsChecked] = (0,react.useState)(false);
    const [errorMessage, setErrorMessage] = (0,react.useState)("");
    const [notifyMeFormData, setNotifyFormData] = (0,react.useState)(initState);
    const [notifyMeErrors, setNotifyFormErrors] = (0,react.useState)({});
    const [leadFormData, setLeadFormData] = (0,react.useState)(initState);
    const [leadFormErrors, setLeadFormErrors] = (0,react.useState)({});
    const [showWelcome, setShowWelcome] = (0,react.useState)(false);
    const [leadGenFlag, setLeadGenFlag] = (0,react.useState)(false);
    const dispatch = (0,es/* useDispatch */.I0)();
    const [productStock, setProductStock] = (0,react.useState)(1);
    const enableFav = isDiscontinued || isColorDiscontinued ? true : false;
    const [showBuyBoxArea, setShowBuyBoxArea] = (0,react.useState)(true);
    const [stockAlert, setStockAlert] = (0,react.useState)({
        show: false,
        mssg: ""
    });
    const [loginFavouriteCallback, setLoginFavouriteCallback] = (0,react.useState)(null);
    const addToCartButton = (0,react.useRef)(null);
    const localStoreOrShowroomRef = (0,react.useRef)(null);
    const [outOfStockMsg, setOutOfStockMsg] = (0,react.useState)("");
    const [pincode, setPincode] = (0,react.useState)("");
    const [toasterContent, setToasterContent] = (0,react.useState)({
        successMessage: "",
        unfavoriteSuccessMessage: ""
    });
    const isIscUser = persona === null || persona === void 0 ? void 0 : persona.includes("IN_Kohler_ISC");
    const router = (0,next_router.useRouter)();
    (0,react.useEffect)(()=>{
        if (staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.outOfStockMsg) {
            (0,helper.getShortenedUrl)(staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.outOfStockMsg).then((res)=>{
                return setOutOfStockMsg(res !== null && res !== void 0 ? res : staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.outOfStockMsg);
            });
        }
    }, [
        staticTexts.outOfStockMsg
    ]);
    (0,react.useEffect)(()=>{
        setToasterMessage();
        document.addEventListener("stop-loading-atc", ()=>{
            setLoading(false);
        });
        document.addEventListener("set-stock-alert", ()=>{
            setStockAlert({
                show: true,
                mssg: t("kf.pdp.label.noItemsToShip")
            });
        });
        return ()=>{
            document.removeEventListener("stop-loading-atc");
            document.removeEventListener("set-stock-alert");
        };
    }, []);
    const element = document.getElementById("product-recs-AT-Similar-items");
    let showSimilarItems = false;
    if (element) {
        showSimilarItems = true;
    }
    (0,react.useEffect)(()=>{
        if (loginFavouriteCallback && isAuth) {
            handleFavorite(loginFavouriteCallback);
        }
    }, [
        loginFavouriteCallback,
        isAuth
    ]);
    (0,react.useEffect)(()=>{
        setProductStock(productOnStock);
    }, [
        productOnStock
    ]);
    (0,react.useEffect)(()=>{
        if (installError) {
            setStockAlert({
                show: false,
                mssg: ""
            });
        }
    }, [
        installError
    ]);
    (0,react.useEffect)(()=>{
        var ref;
        if (compareData === null || compareData === void 0 ? void 0 : (ref = compareData.comparedProducts) === null || ref === void 0 ? void 0 : ref.find((prod)=>{
            return (prod === null || prod === void 0 ? void 0 : prod.compareSku) === sku;
        })) setIsChecked(true);
        else setIsChecked(false);
    }, [
        compareData === null || compareData === void 0 ? void 0 : compareData.comparedProducts,
        sku
    ]);
    (0,react.useEffect)(()=>{
        setShowBuyBoxArea(!ProductPriceSpiderIncluded_s);
    }, [
        ProductPriceSpiderIncluded_s,
        price
    ]);
    const getCookieValue = (name)=>{
        var ref;
        return ((ref = document.cookie.match("(^|;)\\s*" + name + "\\s*=\\s*([^;]+)")) === null || ref === void 0 ? void 0 : ref.pop()) || "";
    };
    const availablePincode = getCookieValue("pincode");
    (0,react.useEffect)(()=>{
        setPincode(availablePincode !== null && availablePincode !== void 0 ? availablePincode : "");
        setPincodeValue(availablePincode);
    }, [
        availablePincode
    ]);
    const setToasterMessage = async ()=>{
        if (!isEmpty_default()(toaster === null || toaster === void 0 ? void 0 : toaster.content)) {
            const { successMessage , unfavoriteSuccessMessage  } = toaster.content;
            setToasterContent({
                successMessage: await (0,helper.getShortenedUrl)(successMessage),
                unfavoriteSuccessMessage: await (0,helper.getShortenedUrl)(unfavoriteSuccessMessage)
            });
        }
    };
    const handleChange = async (qty)=>{
        var ref;
        setStockAlert({
            show: false,
            mssg: ""
        });
        if (backOrder === "Yes" || isParts) {
            setQuantity(qty);
            setLoading(false);
            return;
        }
        setLoading(true);
        var ref1;
        const cartItem = (ref1 = (ref = cart.lineItems) === null || ref === void 0 ? void 0 : ref.find((item)=>item.variant.sku === sku)) !== null && ref1 !== void 0 ? ref1 : {};
        var _quantity;
        const cartQuantity = (_quantity = cartItem.quantity) !== null && _quantity !== void 0 ? _quantity : 0;
        if (qty && qty > 0) {
            setQuantity(qty);
            try {
                const stock = isFragile && availableQty > 0 ? availableQty : await (0,utils_cart/* getStockCached */.fd)(sku);
                if (cartQuantity > 0 && stock <= cartQuantity) {
                    setStockAlert({
                        show: true,
                        mssg: t("kf.pdp.label.noItemsToShip")
                    });
                } else if (stock >= qty + cartQuantity) {
                    onQtyChange(qty);
                } else {
                    setProductStock(stock);
                    if (stock > 0) {
                        setQuantity(stock - cartQuantity);
                        onQtyChange(stock - cartQuantity);
                        setStockAlert({
                            show: true,
                            mssg: t("kf.pdp.label.availableToShip", {
                                qty: stock
                            })
                        });
                        (0,AddToCart_analytics/* quantityOutOfStockAnalytics */.vQ)(productInfo, pincode);
                    }
                }
                setLoading(false);
            } catch (err) {
                setLoading(false);
            }
        }
    };
    const navigateToSimilarItems = ()=>{
        const element = document.getElementById("product-recs-AT-Similar-items");
        if (element) {
            element.scrollIntoView({
                behavior: "smooth",
                block: "center",
                inline: "nearest"
            });
        }
    };
    const handleCompare = (e)=>{
        var ref;
        let isCompareChecked = !isChecked;
        if (e.target.checked) {
            var ref1;
            if ((compareData === null || compareData === void 0 ? void 0 : (ref1 = compareData.comparedProducts) === null || ref1 === void 0 ? void 0 : ref1.length) < 4) {
                if ((compareData === null || compareData === void 0 ? void 0 : compareData.category) !== "" && (compareData === null || compareData === void 0 ? void 0 : compareData.category) !== productCategory) {
                    setErrorMessage(staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.sameCategory);
                    setTimeout(()=>{
                        setErrorMessage("");
                    }, 2000);
                    isCompareChecked = false;
                    onRemove(sku);
                } else {
                    onAdd(sku);
                }
            } else {
                setErrorMessage(staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.maxProduct);
                setTimeout(()=>{
                    setErrorMessage("");
                }, 2000);
                isCompareChecked = false;
                onRemove(sku);
            }
        } else {
            onRemove(sku);
        }
        setIsChecked(isCompareChecked);
        const page = window.adobeDataLayer.getState("page");
        (ref = window.adobeDataLayer) === null || ref === void 0 ? void 0 : ref.push({
            event: "cmp:click",
            eventInfo: JSON.parse((0,AddToCart_analytics/* addToCompareAnalytics */.mw)(!isCompareChecked)),
            productInfo,
            page
        });
    };
    const handleATCKeydown = (e)=>{
        if (e.keyCode === 13 || e.keyCode === 32) {
            window.previewCartKeySource = true;
        } else {
            window.previewCartKeySource = false;
        }
    };
    const addToCartWrapper = function(actions) {
        let isBuyNow = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        isBuyNow ? handleBuyNow(actions) : onAddToCart(actions);
    };
    const handleAddToCart = function() {
        let isBuyNow = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        var ref, ref1;
        isBuyNow ? setBuyNowLoading(true) : setLoading(true);
        if (!pincode) {
            setPinCodeError(true);
            setLoading(false);
            setBuyNowLoading(false);
            return;
        }
        if (pinCodeError) {
            setLoading(false);
            setBuyNowLoading(false);
            return;
        }
        if (error || installationError) {
            setLoading(false);
            setBuyNowLoading(false);
            return;
        }
        if (installLoading) {
            setLoading(false);
            setBuyNowLoading(false);
            return;
        }
        setStockAlert({
            show: false,
            mssg: ""
        });
        if (backOrder === "Yes" || isParts) {
            addToCartWrapper([
                {
                    sku: sku,
                    quantity: quantity,
                    isBundle: isComboSku,
                    backorder: true,
                    brand: customerBrandName === null || customerBrandName === void 0 ? void 0 : customerBrandName.toLowerCase(),
                    warehouses: warehouses
                }
            ], isBuyNow);
            return;
        }
        if (addToCartButton.current) window.cartButtonElement = addToCartButton.current.firstElementChild;
        var ref2;
        const cartItem = (ref2 = (ref = cart.lineItems) === null || ref === void 0 ? void 0 : ref.find((item)=>item.variant.sku === sku)) !== null && ref2 !== void 0 ? ref2 : {};
        var _quantity;
        const cartQuantity = (_quantity = cartItem.quantity) !== null && _quantity !== void 0 ? _quantity : 0;
        var ref3;
        let custom = (ref3 = cartItem === null || cartItem === void 0 ? void 0 : cartItem.custom) !== null && ref3 !== void 0 ? ref3 : {};
        (0,utils_cart/* getStock */.K5)(sku).then((stock)=>{
            setProductStock(stock);
            if (cartQuantity + quantity > stock) {
                if (stock > cartQuantity) {
                    addToCartWrapper([
                        {
                            sku: sku,
                            quantity: stock - cartQuantity,
                            brand: customerBrandName === null || customerBrandName === void 0 ? void 0 : customerBrandName.toLowerCase(),
                            warehouses: warehouses,
                            custom
                        }
                    ], isBuyNow);
                    setStockAlert({
                        show: true,
                        mssg: t("kf.pdp.label.availableToShip", {
                            qty: stock
                        })
                    });
                } else {
                    setStockAlert({
                        show: true,
                        mssg: t("kf.pdp.label.noItemsToShip")
                    });
                }
                (0,AddToCart_analytics/* quantityOutOfStockAnalytics */.vQ)(productInfo, pincode);
                setLoading(false);
                setBuyNowLoading(false);
            } else {
                if ((installationData === null || installationData === void 0 ? void 0 : installationData.isInstallation) && isInstallationAdded) {
                    const payload = [
                        {
                            sku: sku,
                            quantity: quantity,
                            isBundle: isBundle,
                            brand: customerBrandName === null || customerBrandName === void 0 ? void 0 : customerBrandName.toLowerCase(),
                            isInstallService: true,
                            installServiceName: installationData === null || installationData === void 0 ? void 0 : installationData.sku,
                            installServiceQty: quantity,
                            warehouses: warehouses,
                            custom
                        }
                    ];
                    if (!isBundle) {
                        if (Object.keys(cartItem).length === 0) {
                            custom = {
                                fields: {
                                    associatedProduct: sku,
                                    warehouses: warehouses
                                }
                            };
                        } else {
                            custom = {
                                fields: {
                                    associatedProduct: sku
                                }
                            };
                        }
                        payload.push({
                            sku: installationData === null || installationData === void 0 ? void 0 : installationData.sku,
                            quantity: quantity,
                            isBundle: false,
                            brand: customerBrandName === null || customerBrandName === void 0 ? void 0 : customerBrandName.toLowerCase(),
                            warehouses: warehouses,
                            custom
                        });
                    }
                    addToCartWrapper(payload, isBuyNow);
                } else {
                    addToCartWrapper([
                        {
                            sku: sku,
                            quantity: quantity,
                            isBundle: isBundle,
                            brand: customerBrandName === null || customerBrandName === void 0 ? void 0 : customerBrandName.toLowerCase(),
                            warehouses: warehouses,
                            custom
                        }
                    ], isBuyNow);
                }
            }
        });
        const page = window.adobeDataLayer.getState("page");
        const eventInfo = (0,AddToCart_analytics/* getAnalyticsData */.Eb)(isBuyNow ? "buy now" : staticTexts.addToCart, "", true);
        const productArray = [
            productInfo
        ];
        if (isInstallationAdded && !isEmpty_default()(installProductInfo)) {
            productArray.push(installProductInfo);
        }
        const { ...rest } = router.query;
        const utmPayload = {};
        const utmParams = [
            "utm_source",
            "utm_medium"
        ];
        utmParams === null || utmParams === void 0 ? void 0 : utmParams.forEach((param)=>{
            if (rest === null || rest === void 0 ? void 0 : rest[param]) {
                utmPayload[param] = decodeURIComponent(rest[param]);
            } else {
                utmPayload[param] = "";
            }
        });
        (0,AddToCart_analytics/* gtmAddToCartEvent */._D)({
            productInfo,
            utmPayload
        });
        (ref1 = window.adobeDataLayer) === null || ref1 === void 0 ? void 0 : ref1.push({
            event: "cmp:click",
            eventInfo,
            page,
            productArray
        });
    };
    const handleNotification = ()=>{
        var ref;
        const { name , email , phoneNumber , zipcode  } = notifyMeFormData;
        const { price , productData: { name: skuName , desc: skuDescription  }  } = props;
        const isValid = (ref = Object === null || Object === void 0 ? void 0 : Object.values(notifyMeErrors)) === null || ref === void 0 ? void 0 : ref.every((el)=>el === null || el === "");
        if (isValid) {
            const body = {
                mastervariantkey: masterSku,
                sku: sku,
                skuName: skuName,
                skuDescription: skuDescription,
                skuPrice: "".concat(price),
                customer: {
                    name: name,
                    email: email,
                    phone: phoneNumber
                },
                pincode: zipcode,
                qty: "1",
                pdpUrl: window.location.href
            };
            api/* apim.post */.TH.post("catalog/product/oos/notify", body).then((res)=>{
                if (res) {
                    setShowWelcome(true);
                }
            }).catch((error)=>{
                var ref, ref1, ref2;
                setNotifyFormErrors({
                    ...notifyMeErrors,
                    zipcode: error === null || error === void 0 ? void 0 : (ref = error.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.result) === null || ref2 === void 0 ? void 0 : ref2.error
                });
            });
        }
    };
    const handleCreateLead = ()=>{
        var ref;
        const { name , email , phoneNumber , zipcode  } = leadFormData;
        const isValid = (ref = Object === null || Object === void 0 ? void 0 : Object.values(leadFormErrors)) === null || ref === void 0 ? void 0 : ref.every((el)=>el === null || el === "");
        if (isValid) {
            let body = {
                email: email,
                contactNumber: phoneNumber,
                name: name,
                pincode: zipcode,
                consent: true,
                sku: sku,
                inRiver: masterSku,
                productName: productData.name
            };
            api/* apim.post */.TH.post("support/lead/create", body).then((res)=>{
                if (res) {
                    setLeadGenFlag(true);
                }
            }).catch((error)=>{
                var ref;
                setLeadFormErrors({
                    ...leadFormErrors,
                    zipcode: error === null || error === void 0 ? void 0 : (ref = error.result) === null || ref === void 0 ? void 0 : ref.error
                });
            });
        }
    };
    const checkDisabled = (data)=>{
        const { name , email , zipcode  } = data;
        return !(name && email && zipcode);
    };
    const onFieldChange = (e)=>{
        const { name ="" , value =""  } = e.target;
        handleFieldChange(value, name, notifyMeFormData, setNotifyFormData);
        setNotifyFormErrors({
            ...notifyMeErrors,
            [name]: ""
        });
    };
    const onLeadFieldChange = (e)=>{
        const { name ="" , value =""  } = e.target;
        handleFieldChange(value, name, leadFormData, setLeadFormData);
        setLeadFormErrors({
            ...leadFormErrors,
            [name]: ""
        });
    };
    const handleFieldChange = function() {
        let val = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", fieldName = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", data = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, setData = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : ()=>{};
        const inputValue = val.trimStart();
        if (inputValue === "") {
            setData({
                ...data,
                [fieldName]: inputValue
            });
        } else if (fieldName === "phoneNumber") {
            if ((0,validate/* validNumber */.BP)(inputValue) && inputValue.length <= 10) {
                setData({
                    ...data,
                    [fieldName]: inputValue
                });
            }
        } else if (fieldName === "name") {
            if ((0,validate/* validText */.WQ)(inputValue)) {
                setData({
                    ...data,
                    [fieldName]: inputValue
                });
            }
        } else if (fieldName === "zipcode") {
            if ((0,validate/* validNumber */.BP)(inputValue) && inputValue.length <= 6) {
                setData({
                    ...data,
                    [fieldName]: inputValue
                });
            }
        } else if (fieldName === "email") {
            setData({
                ...data,
                [fieldName]: inputValue.trim()
            });
        }
    };
    const onFieldBlur = (e)=>{
        const { name ="" , value =""  } = e.target;
        handleFieldBlur(value, name, notifyMeErrors, setNotifyFormErrors);
    };
    const onLeadFieldBlur = (e)=>{
        const { name ="" , value =""  } = e.target;
        handleFieldBlur(value, name, leadFormErrors, setLeadFormErrors);
    };
    const handleFieldBlur = function() {
        let val = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", fieldName = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", errors = arguments.length > 2 ? arguments[2] : void 0, setError = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : ()=>{};
        const inputValue = val.trimStart();
        const { validEmail , validPincode , validName , validPhoneNumber  } = staticTexts;
        if (fieldName === "phoneNumber") {
            if (inputValue && !(0,validate/* validPhone */.er)(inputValue)) {
                setError({
                    ...errors,
                    [fieldName]: validPhoneNumber
                });
            }
        } else if (fieldName === "name") {
            if (!inputValue) {
                setError({
                    ...errors,
                    [fieldName]: validName
                });
            }
        } else if (fieldName === "zipcode") {
            if (inputValue.length < 6) {
                setError({
                    ...errors,
                    [fieldName]: validPincode
                });
            }
        } else if (fieldName === "email") {
            if (!(0,validate/* validateEmail */.oH)(inputValue)) {
                setError({
                    ...errors,
                    [fieldName]: validEmail
                });
            }
        }
    };
    const handleLogin = function(e) {
        let isBuyNow = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        e.preventDefault();
        e.stopPropagation();
        if (isBuyNow) {
            dispatch((0,authSlice/* setBuyNowLogin */.LL)());
            window.loginCallback = ()=>{
                handleAddToCart(true);
            };
        } else {
            window.loginFavouriteCallback = ()=>{
                setLoginFavouriteCallback(e);
            };
            dispatch((0,authSlice/* setFavoritesLogin */.Up)());
        }
        dispatch((0,authSlice/* setAuthModalVisibility */.LY)({
            show: true
        }));
    };
    const handleFavorite = (e)=>{
        e.preventDefault();
        addFavoriteAnalytics(isFavorite);
        if (isFavorite === true) {
            favItem === null || favItem === void 0 ? void 0 : favItem.map((fav)=>{
                if (fav.productId === ctData && isAuth) {
                    dispatch((0,favoritesSlice/* removeItems */.Er)([
                        fav.id
                    ])).unwrap().then(()=>{
                        dispatch((0,genericSlice/* showToast */.CF)({
                            message: toasterContent.unfavoriteSuccessMessage || staticTexts.removeItem,
                            isVisible: true
                        }));
                    }).catch((err)=>{
                        dispatch((0,genericSlice/* showToast */.CF)({
                            message: staticTexts.removeItemError,
                            isVisible: true
                        }));
                    });
                }
            });
        } else {
            dispatch((0,favoritesSlice/* addProduct */.gK)(sku)).unwrap().then(()=>{
                dispatch((0,genericSlice/* showToast */.CF)({
                    message: toasterContent.successMessage || staticTexts.favSuccessMsg,
                    isVisible: true
                }));
            }).catch((err)=>{
                dispatch((0,genericSlice/* showToast */.CF)({
                    message: staticTexts.favErrorMsg,
                    isVisible: true
                }));
            });
        }
        window.keyFocusCallBack = e.target.id;
    };
    const addFavoriteAnalytics = (checked)=>{
        var ref;
        const eventInfo = {
            eventAction: "pdp:product details:".concat(checked ? "remove" : "add", " favorites"),
            eventName: "pdp:product details:".concat(checked ? "remove" : "add", " favorites"),
            eventType: "navigation",
            internalLinkName: "".concat(checked ? "remove" : "add", " favorites"),
            internalLinkPosition: "pdp",
            internalLinkType: "pdp:favorites",
            internalLinkZoneName: "pdp:product details",
            internalLinkURL: "n/a",
            clickInternalLinks: "true"
        };
        const page = window.adobeDataLayer.getState("page");
        (ref = window.adobeDataLayer) === null || ref === void 0 ? void 0 : ref.push({
            event: "cmp:click",
            eventInfo,
            productInfo,
            page
        });
    };
    const productAnalyticsData = productData || {};
    (0,react.useEffect)(()=>{
        setTimeout(()=>{
            addDatalayerForLocalStoreOrShowroom();
        }, 500);
    }, []);
    const addDatalayerForLocalStoreOrShowroom = ()=>{
        if (localStoreOrShowroomRef.current) {
            const localStoreOrShowroomAnchorLink = localStoreOrShowroomRef.current.querySelector("a");
            if (localStoreOrShowroomAnchorLink) {
                localStoreOrShowroomAnchorLink.classList.add("gbh-data-layer");
                localStoreOrShowroomAnchorLink.setAttribute("data-gbh-data-layer", (0,AddToCart_analytics/* getAnalyticsData */.Eb)("local store or showroom", localStoreOrShowroomAnchorLink.getAttribute("href")));
                localStoreOrShowroomAnchorLink.setAttribute("data-gbh-data-layer-custom", productAnalyticsData.stringProductInfo);
            }
        }
    };
    const AddToCartActionsMarkup = ()=>{
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "add-cart-container",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "quantity-selector-container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(QuantitySelector/* default */.Z, {
                        productData: productAnalyticsData,
                        value: quantity,
                        onChange: handleChange,
                        loading: loading || installError,
                        isPDPQuantitySelector: true,
                        doNotRequiredAnalyticsData: true,
                        isAddToCart: true,
                        onLoading: setLoading,
                        isError: installError,
                        setQuantity: setQuantity
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "add-to-cart-container",
                    ref: addToCartButton,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        role: "button",
                        ariaLabel: staticTexts.ariaLabel.addProductToCart,
                        label: staticTexts.addToCart,
                        onClick: handleAddToCart,
                        onKeyDown: handleATCKeydown,
                        size: "large",
                        type: "primary",
                        flexible: true,
                        disabled: loading || !quantity || parseInt(quantity) < 1 || !price || reqItemsError,
                        loading: loading
                    })
                })
            ]
        });
    };
    const divRef = !isOutOfStock ? {
        ref: ref
    } : {};
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (AddToCart_index_module_default()).addToCartWrapper,
        ...divRef,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "row no-gutters buy-area",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "add-to-cart col-12 ".concat(isDiscontinued ? "add-to-cart__discontinued" : ""),
                children: [
                    showBuyBoxArea ? !isDiscontinued && (!(productStock > 0) && !disableEcommerce ? specialOrder === "Yes" || backOrder === "Yes" || isParts ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            stockAlert.show && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "product-detail-page__stock-alert",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        alt: "",
                                        src: warning/* default.src */.Z.src
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: stockAlert.mssg
                                    })
                                ]
                            }),
                            isRegionSoldOnline && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "add-cart-container",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "quantity-selector-container",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(QuantitySelector/* default */.Z, {
                                                    productData: productAnalyticsData,
                                                    value: quantity,
                                                    onChange: handleChange,
                                                    loading: loading,
                                                    isPDPQuantitySelector: true,
                                                    doNotRequiredAnalyticsData: true,
                                                    isAddToCart: true,
                                                    onLoading: setLoading,
                                                    isError: installError,
                                                    setQuantity: setQuantity
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "add-to-cart-container",
                                                ref: addToCartButton,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                    role: "button",
                                                    ariaLabel: staticTexts.ariaLabel.addProductToCart,
                                                    label: staticTexts.addToCart,
                                                    onClick: handleAddToCart,
                                                    onKeyDown: handleATCKeydown,
                                                    size: "large",
                                                    type: "primary",
                                                    flexible: true,
                                                    disabled: loading || !quantity || parseInt(quantity) < 1 || !price || reqItemsError,
                                                    loading: loading
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }) : isPdpPropsLoaded && isRegionSoldOnline ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "out-of-stock-container",
                        children: !showWelcome ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "".concat(showSimilarItems ? "out-of-stock-div" : ""),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "out-of-stock ".concat(showSimilarItems ? "out-of-stock__similar-items" : ""),
                                            children: staticTexts.outOfStock
                                        }),
                                        showSimilarItems ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "view-similar",
                                            onClick: navigateToSimilarItems,
                                            children: "View Similar Items"
                                        }) : null
                                    ]
                                }),
                                outOfStockMsg ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "out-of-stock-description",
                                    ref: localStoreOrShowroomRef,
                                    children: (0,helper.sanitizeAndDecodeHtml)(outOfStockMsg)
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "out-of-stock-description",
                                    children: staticTexts.notifyEmailOosTxt
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDetailView_NotifyComponent, {
                                    staticTexts: staticTexts,
                                    productAnalyticsData: productAnalyticsData,
                                    productInRiverId_s: masterSku,
                                    name: props === null || props === void 0 ? void 0 : props.skuName,
                                    desc: props === null || props === void 0 ? void 0 : props.skuDescription,
                                    sku: sku,
                                    price: price,
                                    setNotifySuccess: setShowWelcome,
                                    fromAddToCart: true,
                                    notifyContainer: notifyContainer,
                                    notifyClicked: notifyClicked,
                                    productCategory: productCategory,
                                    imagesData: imagesData
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDetailView_NotifySuccess, {
                            staticTexts: staticTexts
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "out-of-stock-container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: isRegionSoldOnline === false ? showWelcome === false ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "".concat(showSimilarItems ? "out-of-stock-div" : ""),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "out-of-stock ".concat(showSimilarItems ? "out-of-stock__similar-items" : ""),
                                                children: staticTexts.outOfStock
                                            }),
                                            showSimilarItems ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "view-similar",
                                                onClick: navigateToSimilarItems,
                                                children: "View Similar Items"
                                            }) : null
                                        ]
                                    }),
                                    outOfStockMsg ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "out-of-stock-description",
                                        ref: localStoreOrShowroomRef,
                                        children: (0,helper.sanitizeAndDecodeHtml)(outOfStockMsg)
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "out-of-stock-description",
                                        children: staticTexts.notifyEmailOosTxt
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDetailView_NotifyComponent, {
                                        staticTexts: staticTexts,
                                        productAnalyticsData: productAnalyticsData,
                                        productInRiverId_s: masterSku,
                                        name: props === null || props === void 0 ? void 0 : props.skuName,
                                        desc: props === null || props === void 0 ? void 0 : props.skuDescription,
                                        sku: sku,
                                        price: price,
                                        setNotifySuccess: setShowWelcome,
                                        notifyContainer: notifyContainer,
                                        notifyClicked: notifyClicked,
                                        fromAddToCart: true,
                                        productCategory: productCategory,
                                        imagesData: imagesData
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDetailView_NotifySuccess, {
                                staticTexts: staticTexts
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: leadGenFlag ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "out-of-stock__success-message lead_success_message",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "out-of-stock__thank-title",
                                            children: staticTexts.leadSuccessTxt
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "out-of-stock__thank-description",
                                            children: (0,helper.sanitizeAndDecodeHtml)(staticTexts.leadSuccessMsg)
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "out-of-stock",
                                            children: staticTexts.nonSellable
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "out-of-stock-description",
                                            children: (0,helper.sanitizeAndDecodeHtml)(staticTexts.notifyEmailOosTxt)
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDetailView_NotifyComponent, {
                                            staticTexts: staticTexts,
                                            productAnalyticsData: productAnalyticsData,
                                            productInRiverId_s: masterSku,
                                            name: props === null || props === void 0 ? void 0 : props.skuName,
                                            desc: props === null || props === void 0 ? void 0 : props.skuDescription,
                                            sku: sku,
                                            price: price,
                                            setNotifySuccess: setShowWelcome,
                                            fromAddToCart: true,
                                            notifyContainer: notifyContainer,
                                            notifyClicked: notifyClicked,
                                            productCategory: productCategory,
                                            imagesData: imagesData
                                        })
                                    ]
                                })
                            })
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            stockAlert.show && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "product-detail-page__stock-alert",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        alt: "",
                                        src: warning/* default */.Z === null || warning/* default */.Z === void 0 ? void 0 : warning/* default.src */.Z.src
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: stockAlert.mssg
                                    })
                                ]
                            }),
                            isRegionSoldOnline !== false ? error !== "Currently, this product is out of stock for your location" && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "add-cart-container ".concat(isIscUser ? "two-elem" : "three-elem"),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "quantity-selector-container",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(QuantitySelector/* default */.Z, {
                                                productData: productAnalyticsData,
                                                value: quantity,
                                                onChange: handleChange,
                                                loading: loading,
                                                isPDPQuantitySelector: true,
                                                doNotRequiredAnalyticsData: true,
                                                isAddToCart: true,
                                                onLoading: setLoading,
                                                isError: installError,
                                                setQuantity: setQuantity
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "add-to-cart-container",
                                            ref: addToCartButton,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                role: "button",
                                                ariaLabel: staticTexts.ariaLabel.addProductToCart,
                                                label: staticTexts.addToCart,
                                                onClick: ()=>handleAddToCart(false),
                                                onKeyDown: handleATCKeydown,
                                                size: "large",
                                                type: "primary",
                                                flexible: true,
                                                disabled: loading || !quantity || parseInt(quantity) < 1 || !price || reqItemsError,
                                                loading: loading
                                            })
                                        }),
                                        !isIscUser ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "buy-now-container",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                role: "button",
                                                ariaLabel: "buy now",
                                                label: "Buy Now",
                                                onClick: (e)=>{
                                                    if (isAuth) {
                                                        handleAddToCart(true);
                                                    } else {
                                                        if (!pincode) {
                                                            setPinCodeError(true);
                                                            setLoading(false);
                                                            setBuyNowLoading(false);
                                                            return;
                                                        } else {
                                                            handleLogin(e, true);
                                                        }
                                                    }
                                                },
                                                size: "large",
                                                type: "ghost",
                                                flexible: true,
                                                disabled: loading || !quantity || parseInt(quantity) < 1 || !price || reqItemsError
                                            })
                                        }) : null
                                    ]
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: leadGenFlag ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "out-of-stock__success-message lead_success_message",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "out-of-stock__thank-title",
                                            children: staticTexts.leadSuccessTxt
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "out-of-stock__thank-description",
                                            children: (0,helper.sanitizeAndDecodeHtml)(staticTexts.leadSuccessMsg)
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "out-of-stock",
                                            children: staticTexts.nonSellable
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "out-of-stock-description",
                                            children: (0,helper.sanitizeAndDecodeHtml)(staticTexts.notifyEmailOosTxt)
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDetailView_NotifyComponent, {
                                            staticTexts: staticTexts,
                                            productAnalyticsData: productAnalyticsData,
                                            productInRiverId_s: masterSku,
                                            name: props === null || props === void 0 ? void 0 : props.skuName,
                                            desc: props === null || props === void 0 ? void 0 : props.skuDescription,
                                            sku: sku,
                                            price: price,
                                            setNotifySuccess: setShowWelcome,
                                            fromAddToCart: true,
                                            notifyContainer: notifyContainer,
                                            notifyClicked: notifyClicked,
                                            productCategory: productCategory,
                                            imagesData: imagesData
                                        })
                                    ]
                                })
                            }),
                            error === "Currently, this product is out of stock for your location" && !notifySuccess ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDetailView_NotifyComponent, {
                                staticTexts: staticTexts,
                                setNotifySuccess: setNotifySuccess,
                                productAnalyticsData: productAnalyticsData,
                                productInRiverId_s: productInRiverId_s,
                                name: name,
                                desc: desc,
                                sku: sku,
                                price: price,
                                notifyContainer: notifyContainer,
                                notifyClicked: notifyClicked,
                                productCategory: productCategory,
                                imagesData: imagesData
                            }) : null,
                            error === "Currently, this product is out of stock for your location" && notifySuccess ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDetailView_NotifySuccess, {
                                staticTexts: staticTexts
                            }) : null
                        ]
                    })) : null,
                    replaceAddToCart && !isDiscontinued ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "replace-add-to-cart-container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            onClick: ()=>(0,AddToCart_analytics/* replaceAddToCartDatalayerPush */.ME)(replaceAddToCartCtaLabel, replaceAddToCartCtaLink),
                            role: "button",
                            ariaLabel: replaceAddToCartCtaLabel,
                            label: replaceAddToCartCtaLabel,
                            size: "large",
                            type: "primary",
                            flexible: true,
                            to: replaceAddToCartCtaLink,
                            target: linkNewTab ? "_blank" : "_self"
                        })
                    }) : null,
                    !isDiscontinued && isRegionSoldOnline ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "bottom-section",
                        children: [
                            !isBundle && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: classnames_default()({
                                    favorites: true,
                                    "favorites--discontinued": enableFav
                                }),
                                id: "kf-pdp-favorites",
                                onClick: isAuth ? handleFavorite : handleLogin,
                                role: "button",
                                tabIndex: "0",
                                "aria-label": staticTexts.favTxt,
                                "data-gbh-clickable": "true",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: isFavorite ? wishlist_gray_filled/* default.src */.Z.src : wish/* default.src */.Z.src,
                                        alt: staticTexts.favTxt
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "text",
                                        children: [
                                            staticTexts.favTxt,
                                            " "
                                        ]
                                    })
                                ]
                            }),
                            !isDiscontinued && !disableRatings ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                "data-bv-show": "rating_summary",
                                "data-bv-product-id": sku,
                                className: "product-detail-page__inline-rating",
                                onClick: ()=>handleNavChange(4, true)
                            }) : null
                        ]
                    }) : null
                ]
            })
        })
    });
});
AddToCart.propTypes = {
    staticTexts: (prop_types_default()).object
};
AddToCart.displayName = "AddToCart";
/* harmony default export */ var v3_AddToCart = (AddToCart);

// EXTERNAL MODULE: ./components/sharedCart/shareCartHelper.js
var shareCartHelper = __webpack_require__(4364);
// EXTERNAL MODULE: ./src/components/ProductDetail/v3/MoreFromCollection/index.module.scss
var MoreFromCollection_index_module = __webpack_require__(41415);
var MoreFromCollection_index_module_default = /*#__PURE__*/__webpack_require__.n(MoreFromCollection_index_module);
;// CONCATENATED MODULE: ./src/components/ProductDetail/v3/MoreFromCollection/index.jsx









const MoreFromCollection = (props)=>{
    const { sku ="" , pdpJson ={} , presetConfigObject ={} , productType ="" , partReplacementSuggestions ="" , i18n: { partNumber ="" , partName =""  } = {}  } = props;
    const [data, setData] = (0,react.useState)([]);
    const [recommendations, setRecommendations] = (0,react.useState)([]);
    const [title, setTitle] = (0,react.useState)("");
    const [config, setConfig] = (0,react.useState)({});
    const [general, setGeneral] = (0,react.useState)(null);
    const [plpServletPath, setPlpServletPath] = (0,react.useState)(null);
    if (!pdpJson.ctRecommendations) {
        pdpJson.ctRecommendations = [];
    }
    var ref;
    const { title: replacementTitle , producttype  } = (ref = 0 in pdpJson.ctRecommendations && pdpJson.ctRecommendations[0]) !== null && ref !== void 0 ? ref : {};
    (0,react.useEffect)(()=>{
        (0,constants_config/* getConfig */.i)().then((config)=>{
            setConfig(config);
            setGeneral(config.general);
            setPlpServletPath(config.plpServletPath);
        });
    }, []);
    (0,react.useEffect)(()=>{
        if (productType === producttype) {
            if (partReplacementSuggestions) {
                setTitle(replacementTitle);
                setRecommendations(partReplacementSuggestions.split(",").map((product)=>({
                        sku: product
                    })));
            } else {
                setTitle("");
                setRecommendations([]);
            }
        }
    }, [
        sku,
        partReplacementSuggestions
    ]);
    /**
   * Selects Appropriate preset for more collections and appends it to the image url based on screen size
   * as container size cannot be considered in this scenario
   *
   * @param {string} uUrl     the formatted url which contains swatch url and id
   * @return {string} final url with correct preset appended
   */ const appendPreset = (uUrl)=>{
        let sPreset = "";
        if (window.innerWidth < 660) {
            var _MoreCollectionMobilePotrait;
            sPreset = (_MoreCollectionMobilePotrait = presetConfigObject.MoreCollectionMobilePotrait) !== null && _MoreCollectionMobilePotrait !== void 0 ? _MoreCollectionMobilePotrait : "";
        } else if (dist_lib/* isMobile */.tq) {
            var _MoreCollectionMobileLandscape;
            sPreset = (_MoreCollectionMobileLandscape = presetConfigObject.MoreCollectionMobileLandscape) !== null && _MoreCollectionMobileLandscape !== void 0 ? _MoreCollectionMobileLandscape : "";
        } else {
            var _MoreCollectionDesktop;
            sPreset = (_MoreCollectionDesktop = presetConfigObject.MoreCollectionDesktop) !== null && _MoreCollectionDesktop !== void 0 ? _MoreCollectionDesktop : "";
        }
        return "".concat(uUrl, "?").concat(sPreset);
    };
    /**
   * Formats the base url using the logic of swatch url + id + preset, that way it can be
   * used to render the final image to the DOM
   *
   * @param {string} uUrl   the base url which will come from the api response
   * @return {string}
   */ const formatUrl = (uUrl)=>{
        var ref;
        const sUrlPath = (ref = uUrl.split("?")[0]) === null || ref === void 0 ? void 0 : ref.split("/");
        const sUrlId = sUrlPath[sUrlPath.length - 1];
        const swatchUrl = pdpJson.swatchUrl;
        const uFinalUrl = appendPreset("".concat(swatchUrl).concat(sUrlId));
        return uFinalUrl;
    };
    (0,react.useEffect)(()=>{
        const getProducts = async ()=>{
            var ref;
            const skus = (ref = recommendations.map((product)=>{
                if (product.sku) {
                    return product.sku.replace("K-", "");
                }
            })) !== null && ref !== void 0 ? ref : [];
            if (skus.length) {
                try {
                    const d = await (0,shareCartHelper/* getProductsBySku */.uX)(skus);
                    const productData = skus.map((sku)=>{
                        var ref, ref1, ref2, ref3, ref4;
                        const item = d.find((p)=>p.masterVariant.sku === sku || p.variants.find((v)=>v.sku === sku));
                        const variant = item.masterVariant.sku === sku ? item.masterVariant : item.variants.find((v)=>v.sku === sku);
                        var ref5;
                        const channels = (ref5 = variant === null || variant === void 0 ? void 0 : (ref = variant.availability) === null || ref === void 0 ? void 0 : ref.channels) !== null && ref5 !== void 0 ? ref5 : {};
                        var ref6;
                        const inStock = (ref6 = (ref1 = channels[0]) === null || ref1 === void 0 ? void 0 : ref1.availableQuantity) !== null && ref6 !== void 0 ? ref6 : 0;
                        const image = (variant === null || variant === void 0 ? void 0 : (ref2 = variant.images) === null || ref2 === void 0 ? void 0 : ref2.length) > 0 ? formatUrl(variant.images[0].url) : image_missing/* default */.Z;
                        const category = variant.attributes.filter((attr)=>attr.name === "ProductLocalCategory")[0];
                        const skuID = get_default()(variant.attributes.find((attr)=>attr.name === "CustomerFacingSKU"), "value", "");
                        return {
                            name: item.name[(ref3 = config.internationalization) === null || ref3 === void 0 ? void 0 : ref3.locale],
                            slug: item.slug[(ref4 = config.internationalization) === null || ref4 === void 0 ? void 0 : ref4.locale],
                            inStock,
                            image,
                            category: category === null || category === void 0 ? void 0 : category.value,
                            sku: variant === null || variant === void 0 ? void 0 : variant.sku,
                            skuID: skuID
                        };
                    });
                    setData(productData);
                } catch (e) {
                    setData([]);
                }
            } else {
                setData([]);
            }
        };
        getProducts();
    }, [
        recommendations,
        config
    ]);
    return data && data.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (MoreFromCollection_index_module_default()).moreFromCollectionWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "pdp-more-from-collection ".concat(productType === producttype ? "parts" : ""),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "pdp-more-from-collection__title",
                    children: title
                }),
                productType === producttype ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                    className: "pdp-more-from-collection__parts",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: partNumber
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: partName
                                })
                            ]
                        }),
                        data.map((item, i)=>{
                            const url = (0,helper.getPDPUrlWithConfig)(item.category, item.slug, plpServletPath, general);
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: "gbh-data-layer",
                                            "data-gbh-data-layer": '{"eventAction":"pdp:more from collection:carousel image","eventName":"pdp:more from collection:carousel image","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"'.concat(item.name, '","internalLinkPosition":"pdp","internalLinkType":"pdp:navigation","internalLinkZoneName":"pdp:cross-sell:more from collection","internalLinkURL":"n/a","clickInternalLinks":"true"}'),
                                            href: "".concat(url).concat((url === null || url === void 0 ? void 0 : url.includes("?type=part")) ? "&" : "?", "skuId=").concat(item.sku),
                                            alt: item.name,
                                            children: item.skuID
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "pdp-more-from-collection__part-name",
                                        children: item.name
                                    })
                                ]
                            }, i);
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "pdp-more-from-collection__track",
                    children: data.map((item, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "pdp-more-from-collection__product",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: "gbh-data-layer",
                                "data-gbh-data-layer": '{"eventAction":"pdp:more from collection:carousel image","eventName":"pdp:more from collection:carousel image","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"'.concat(item.name, '","internalLinkPosition":"pdp","internalLinkType":"pdp:navigation","internalLinkZoneName":"pdp:cross-sell:more from collection","internalLinkURL":"n/a","clickInternalLinks":"true"}'),
                                href: (0,helper.getPDPUrlWithConfig)(item.category, item.slug, plpServletPath, general),
                                alt: item.name,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: item.image,
                                    onError: (e)=>e.target.src = image_missing/* default */.Z,
                                    className: "pdp-more-from-collection__image",
                                    alt: item.name
                                })
                            })
                        }, i))
                })
            ]
        })
    });
};
/* harmony default export */ var v3_MoreFromCollection = (MoreFromCollection);

// EXTERNAL MODULE: ./components/ProductDetail/v3/ProductAccordionList/index.jsx + 13 modules
var ProductAccordionList = __webpack_require__(57114);
// EXTERNAL MODULE: ./store/index.js + 1 modules
var store = __webpack_require__(45094);
// EXTERNAL MODULE: ./components/ProductDetail/v3/CatalogCTA/index.module.scss
var CatalogCTA_index_module = __webpack_require__(24064);
var CatalogCTA_index_module_default = /*#__PURE__*/__webpack_require__.n(CatalogCTA_index_module);
;// CONCATENATED MODULE: ./public/icons/tooltip-red.svg
/* harmony default export */ var tooltip_red = ({"src":"/_next/static/media/tooltip-red.3be5ed6c.svg","height":30,"width":30});
;// CONCATENATED MODULE: ./components/ProductDetail/v3/CatalogCTA/index.jsx








const CatalogCTA = (param)=>{
    let { sku ="" , config ={} , isSoldOnline , isDiscontinued , productName ="" , staticTexts: label , redirectUrl ="" , inriverId =""  } = param;
    const { general: { findStorePagePath ="/" , productEnquiryPath ="/"  } = {}  } = config;
    (0,react.useEffect)(()=>{
        store/* store.dispatch */.h.dispatch((0,genericSlice/* toggleSiteWideWarning */.jy)());
    }, []);
    const handleAnalytics = function(ctaName, ctaLink) {
        let internalLink = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
        const link = ctaLink ? (ctaLink.indexOf("http") === -1 ? window.location.origin : "") + ctaLink : "n/a";
        const eventInfo = {
            clickInternalLinks: internalLink ? "true" : "false",
            eventAction: "pdp:product details:".concat(ctaName),
            eventName: "pdp:product details:".concat(ctaName),
            eventType: "navigation",
            internalLinkName: ctaName,
            internalLinkPosition: "pdp",
            internalLinkType: "pdp:navigation",
            internalLinkZoneName: "pdp:product details",
            internalLinkURL: link
        };
        (0,helper.pushAnalyticsObjToDataLayer)(eventInfo);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (CatalogCTA_index_module_default()).catalogCtaWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "catalog-ctas",
            children: isDiscontinued ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "catalog-discontinued",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: tooltip_red.src,
                        alt: ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: label.brandsDiscontinuedMsg
                    })
                ]
            }) : redirectUrl ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                to: redirectUrl,
                role: "link",
                ariaLabel: label.shopKohler,
                label: label.shopKohler,
                size: "large",
                type: "primary",
                flexible: true,
                className: "catalog-btn",
                onClick: ()=>handleAnalytics("shop kohler", redirectUrl, false)
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "catalog-enquiry-ctas",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "cta",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            role: "link",
                            label: label.productEnquiry,
                            size: "large",
                            type: "black",
                            to: "".concat(productEnquiryPath, "?sku=").concat(sku, "&pname=").concat(productName, "&id=").concat(inriverId),
                            target: "_blank",
                            className: "catalog-btn",
                            flexible: true,
                            onClick: ()=>handleAnalytics("product enquiry", "".concat(productEnquiryPath, "?sku=").concat(sku, "&pname=").concat(productName, "&id=").concat(inriverId))
                        })
                    }),
                    isSoldOnline !== false && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "cta",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            role: "link",
                            label: label.findStore,
                            size: "large",
                            type: "ghost",
                            to: findStorePagePath,
                            target: "_blank",
                            className: "catalog-btn",
                            flexible: true,
                            onClick: ()=>handleAnalytics("find a store", findStorePagePath)
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var v3_CatalogCTA = (CatalogCTA);

// EXTERNAL MODULE: ./components/ProductDetail/v3/InstallService/index.module.scss
var InstallService_index_module = __webpack_require__(47848);
var InstallService_index_module_default = /*#__PURE__*/__webpack_require__.n(InstallService_index_module);
;// CONCATENATED MODULE: ./components/ProductDetail/v3/InstallService/index.jsx
















const InstallService = (param)=>{
    let { sku ="" , qty ="" , i18n ={} , masterSku ="" , disableCart , setWareHouses , setAvailableQty , installServiceData , setInstallationData , isInstallationAvailable , isBundle =false , productInfo ={} , setInstallProductInfo =()=>{} , installErrorCallback , setPinCodeError , pinCodeError , installationError , setInstallationError , error , setError , loading , setLoading , installReq =[] , setReqItemsError , setPincodeValue =()=>{} , setNotifySuccess =()=>{} , setIsOutOfStock =()=>{} , setIsEtaLoading =()=>{}  } = param;
    const [pincode, setPincode] = (0,react.useState)("");
    const [isAvailable, setAvailability] = (0,react.useState)(false);
    const [eta, setEta] = (0,react.useState)({
        minDay: "",
        maxDay: ""
    });
    const [installationMsg, setInstallationMsg] = (0,react.useState)("");
    const [installationWarning, setInstallationWarning] = (0,react.useState)("");
    const [installationAvailable, setInstallationAvailable] = (0,react.useState)(false);
    const [hideSimilarItems, setHideSimilarItems] = (0,react.useState)(false);
    const dispatch = (0,es/* useDispatch */.I0)();
    const { isAuth , user: { persona =[
        "IN_KOHLER_GST"
    ]  }  } = (0,es/* useSelector */.v9)(authSlice/* selectAuthState */._9);
    const stopATCLoading = new Event("stop-loading-atc");
    (0,react.useEffect)(()=>{
        if (installationError !== "" || installationWarning !== "") {
            installErrorCallback(true);
        } else {
            installErrorCallback(loading);
        }
    }, [
        installationError,
        installationWarning,
        loading
    ]);
    const element = document.getElementById("product-recs-AT-Similar-items");
    let showSimilarItems = false;
    if (element) {
        showSimilarItems = true;
    }
    const getUserPincode = ()=>{
        dispatch((0,genericSlice/* getUserProfile */.et)()).unwrap().then((res)=>{
            let userPincode = "";
            var _addresses;
            const addresses = (_addresses = res.addresses) !== null && _addresses !== void 0 ? _addresses : [];
            const { defaultShippingAddressId  } = res !== null && res !== void 0 ? res : "";
            if (addresses.length) {
                var ref;
                userPincode = (ref = addresses.find((add)=>add.id === defaultShippingAddressId)) === null || ref === void 0 ? void 0 : ref.postalCode;
            }
            setPincode(userPincode);
        });
    };
    const setCookie = ()=>{
        if (pincode) {
            document.cookie = "pincode=".concat(pincode, "; path=/");
        }
    };
    const getCookieValue = (name)=>{
        var ref;
        return ((ref = document.cookie.match("(^|;)\\s*" + name + "\\s*=\\s*([^;]+)")) === null || ref === void 0 ? void 0 : ref.pop()) || "";
    };
    const deleteCookieValue = (name)=>{
        setAvailableQty(0);
        document.cookie = name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
    };
    (0,react.useEffect)(()=>{
        const availablePincode = getCookieValue("pincode");
        if (availablePincode) {
            setPincode(availablePincode);
        } else if (isAuth) {
            getUserPincode();
        }
    }, [
        isAuth
    ]);
    (0,react.useEffect)(()=>{
        if (isAvailable || error) {
            setError("");
            handleSearch(true);
        } else {
            document.dispatchEvent(stopATCLoading);
        }
    }, [
        qty,
        installReq
    ]);
    (0,react.useEffect)(()=>{
        if ((0,validate/* validNumber */.BP)(pincode) && pincode.length <= 6) {
            setPincodeValue(pincode);
        }
    }, [
        pincode
    ]);
    (0,react.useEffect)(()=>{
        disableCart(true);
        setError("");
        setInstallationWarning("");
        setInstallationError(false);
        if ((0,helper.isValidPincode)(pincode) && (isBundle || masterSku)) {
            handleSearch();
        }
    }, [
        pincode,
        masterSku,
        isBundle,
        sku
    ]);
    const getInstallProductInfo = function() {
        let serviceData = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        var ref, ref1, ref2, ref3, ref4, ref5, ref6;
        const servicename = (serviceData === null || serviceData === void 0 ? void 0 : (ref = serviceData.name) === null || ref === void 0 ? void 0 : ref["en-IN"]) || "n/a";
        const userPersona = persona[0];
        const personaprice = (ref2 = serviceData === null || serviceData === void 0 ? void 0 : (ref1 = serviceData.masterVariant) === null || ref1 === void 0 ? void 0 : ref1.prices.filter((p)=>{
            var ref, ref1;
            return userPersona.includes(p === null || p === void 0 ? void 0 : (ref = p.customerGroup) === null || ref === void 0 ? void 0 : (ref1 = ref.obj) === null || ref1 === void 0 ? void 0 : ref1.key);
        })) === null || ref2 === void 0 ? void 0 : ref2[0];
        const unitPrice = personaprice === null || personaprice === void 0 ? void 0 : (ref3 = personaprice.value) === null || ref3 === void 0 ? void 0 : ref3.centAmount;
        const discountPrice = personaprice === null || personaprice === void 0 ? void 0 : (ref4 = personaprice.discounted) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.value) === null || ref5 === void 0 ? void 0 : ref5.centAmount;
        return {
            description: servicename === null || servicename === void 0 ? void 0 : servicename.toLowerCase(),
            frequency: "n/a",
            globalPromotionPrice: Number(discountPrice || unitPrice) / 100,
            isRecommended: "n/a",
            isSendNow: "n/a",
            isSubscription: "n/a",
            priceState: "regular price",
            productBasePrice: unitPrice ? Number(unitPrice) / 100 : "n/a",
            productCategory: "install services",
            productColor: "n/a",
            productCoupondiscount: 0,
            productCouponCode: "n/a",
            productID: (serviceData === null || serviceData === void 0 ? void 0 : (ref6 = serviceData.masterVariant) === null || ref6 === void 0 ? void 0 : ref6.sku) || "n/a",
            productName: servicename === null || servicename === void 0 ? void 0 : servicename.toLowerCase(),
            productPartnerBuyNow: false,
            productRoom: "n/a",
            productSalePrice: Number(discountPrice || unitPrice) / 100,
            productSaleable: true,
            productStatus: "in stock",
            productSuperSku: false,
            productTileName: servicename === null || servicename === void 0 ? void 0 : servicename.toLowerCase(),
            quantity: 1,
            defaultImageName: "n/a",
            ratings: "n/a",
            numberOfReviews: "n/a",
            pdpType: "service",
            productFindingMethod: "n/a",
            productCollectionsName: "install services",
            productBrand: "kohler-india",
            globalOffer: "n/a",
            globalDiscount: 0,
            itemType: "service",
            category: "install services",
            waterSenseProduct: "n/a"
        };
    };
    const handleSearch = async (isQtyAction)=>{
        if ((0,helper.isValidPincode)(pincode)) {
            if (!isQtyAction) {
                setCookie();
                setPinCodeError(false);
                setAvailability(false);
                setInstallationAvailable(false);
            }
            setReqItemsError({});
            setLoading(true);
            setIsEtaLoading(true);
            const payload = {
                pincode,
                qty
            };
            if (isBundle) {
                if ((installReq === null || installReq === void 0 ? void 0 : installReq.length) > 0) {
                    let getProducts = installReq === null || installReq === void 0 ? void 0 : installReq.map((item)=>{
                        return {
                            sku: item === null || item === void 0 ? void 0 : item.skuid,
                            mastervariantkey: item === null || item === void 0 ? void 0 : item.inRiverId
                        };
                    });
                    payload.action = "must-order", payload.products = [
                        {
                            sku: sku,
                            mastervariantkey: sku
                        },
                        ...getProducts
                    ];
                } else {
                    payload.mastervariantkey = sku;
                    payload.sku = sku;
                    payload.type = "Sales";
                }
            } else {
                if ((installReq === null || installReq === void 0 ? void 0 : installReq.length) > 0) {
                    let getProducts1 = installReq === null || installReq === void 0 ? void 0 : installReq.map((item)=>{
                        return {
                            sku: item === null || item === void 0 ? void 0 : item.skuid,
                            mastervariantkey: (item === null || item === void 0 ? void 0 : item.inRiverId) !== "" ? item === null || item === void 0 ? void 0 : item.inRiverId : item === null || item === void 0 ? void 0 : item.skuid
                        };
                    });
                    payload.action = "must-order", payload.products = [
                        {
                            sku: sku,
                            mastervariantkey: masterSku
                        },
                        ...getProducts1
                    ];
                } else {
                    payload.mastervariantkey = masterSku;
                    payload.sku = sku;
                    payload.type = "Sales";
                }
            }
            try {
                var ref, ref1, ref2, ref3, ref4, ref5, ref6;
                const isMustOrder = (installReq === null || installReq === void 0 ? void 0 : installReq.length) > 0;
                const data = await (0,utils_cart/* getETACached */.X3)(isBundle, payload, isMustOrder);
                if ((data === null || data === void 0 ? void 0 : (ref = data.data) === null || ref === void 0 ? void 0 : ref.status) === "fail" && (data === null || data === void 0 ? void 0 : (ref1 = data.data) === null || ref1 === void 0 ? void 0 : ref1.statusCode) === 404) {
                    var ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16;
                    setError((data === null || data === void 0 ? void 0 : (ref7 = data.data) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.result) === null || ref8 === void 0 ? void 0 : ref8.error) || (data === null || data === void 0 ? void 0 : (ref9 = data.data) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.result) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.data) === null || ref11 === void 0 ? void 0 : ref11.error));
                    setIsOutOfStock((data === null || data === void 0 ? void 0 : (ref12 = data.data) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.result) === null || ref13 === void 0 ? void 0 : ref13.error) || (data === null || data === void 0 ? void 0 : (ref14 = data.data) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.result) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.data) === null || ref16 === void 0 ? void 0 : ref16.error));
                    disableCart(true);
                    setAvailability(false);
                    setInstallationData({
                        isInstallation: false,
                        name: "",
                        price: ""
                    });
                    setInstallationWarning(i18n.installServiceNotAvailableMsg);
                    setInstallationAvailable(false);
                    setLoading(false);
                    setIsEtaLoading(false);
                    setHideSimilarItems(true);
                    showSimilarItems = false;
                    return;
                }
                setHideSimilarItems(false);
                if (isBundle) {
                    var ref17, ref18, ref19;
                    setWareHouses((ref17 = data.result) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.data) === null || ref18 === void 0 ? void 0 : ref18.items);
                    data.result.data = (ref19 = data.result) === null || ref19 === void 0 ? void 0 : ref19.data;
                }
                if (isMustOrder) {
                    var ref20, ref21, ref22;
                    const errorData = {};
                    (ref20 = data.result) === null || ref20 === void 0 ? void 0 : ref20.data.forEach((item)=>{
                        var ref;
                        if ((ref = item.result) === null || ref === void 0 ? void 0 : ref.error) {
                            errorData[item.sku] = item.result.error;
                        }
                    });
                    setReqItemsError(errorData);
                    data.result = (ref22 = (ref21 = data.result) === null || ref21 === void 0 ? void 0 : ref21.data[0]) === null || ref22 === void 0 ? void 0 : ref22.result;
                }
                const responseData = isBundle ? data === null || data === void 0 ? void 0 : (ref2 = data.result) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.data) === null || ref3 === void 0 ? void 0 : ref3.bundle : data === null || data === void 0 ? void 0 : (ref4 = data.result) === null || ref4 === void 0 ? void 0 : ref4.data;
                const { eta ={} , warehouse =[] , installationService ={}  } = responseData || {};
                const error = (data === null || data === void 0 ? void 0 : (ref5 = data.result) === null || ref5 === void 0 ? void 0 : ref5.error) || "";
                if (((ref6 = Object.keys(eta)) === null || ref6 === void 0 ? void 0 : ref6.length) > 0) {
                    var ref23;
                    if (warehouse === null || warehouse === void 0 ? void 0 : warehouse.length) {
                        const _availableQty = warehouse === null || warehouse === void 0 ? void 0 : warehouse.reduce((acc, cur)=>acc + cur.availableQty, 0);
                        setAvailableQty(_availableQty);
                        setWareHouses(warehouse);
                    }
                    if (!isQtyAction || isQtyAction && (installationService === null || installationService === void 0 ? void 0 : installationService.isInstallation) && !(installServiceData === null || installServiceData === void 0 ? void 0 : installServiceData.isInstallation)) {
                        if (Object.keys(installationService).length > 0) {
                            if (installationService === null || installationService === void 0 ? void 0 : installationService.isInstallation) {
                                var ref24, ref25, ref26, ref27, ref28, ref29, ref30, ref31;
                                const response = await (0,product/* getProductBySku */.YB)(installationService === null || installationService === void 0 ? void 0 : installationService.name);
                                const mrpPrice = (ref25 = response === null || response === void 0 ? void 0 : (ref24 = response.masterVariant) === null || ref24 === void 0 ? void 0 : ref24.prices.filter((p)=>{
                                    return !(p === null || p === void 0 ? void 0 : p.customerGroup);
                                })) === null || ref25 === void 0 ? void 0 : ref25[0];
                                const userPersona = (0,helper.getUserPersona)() || "IN_Kohler_ISC";
                                const personaprice = (ref27 = response === null || response === void 0 ? void 0 : (ref26 = response.masterVariant) === null || ref26 === void 0 ? void 0 : ref26.prices.filter((p)=>{
                                    var ref, ref1;
                                    return userPersona.includes(p === null || p === void 0 ? void 0 : (ref = p.customerGroup) === null || ref === void 0 ? void 0 : (ref1 = ref.obj) === null || ref1 === void 0 ? void 0 : ref1.key);
                                })) === null || ref27 === void 0 ? void 0 : ref27[0];
                                setInstallationData({
                                    isInstallation: installationService === null || installationService === void 0 ? void 0 : installationService.isInstallation,
                                    name: response === null || response === void 0 ? void 0 : response.name["en-IN"],
                                    installServiceSKU: installationService.name,
                                    sku: installationService.name,
                                    mrpPrice: mrpPrice === null || mrpPrice === void 0 ? void 0 : (ref28 = mrpPrice.value) === null || ref28 === void 0 ? void 0 : ref28.centAmount,
                                    price: (personaprice === null || personaprice === void 0 ? void 0 : (ref29 = personaprice.discounted) === null || ref29 === void 0 ? void 0 : (ref30 = ref29.value) === null || ref30 === void 0 ? void 0 : ref30.centAmount) || (personaprice === null || personaprice === void 0 ? void 0 : (ref31 = personaprice.value) === null || ref31 === void 0 ? void 0 : ref31.centAmount)
                                });
                                setInstallationMsg(i18n.installServiceAvailableMsg);
                                setInstallationAvailable(true);
                                const installProductInfo = getInstallProductInfo(response);
                                setInstallProductInfo(installProductInfo);
                            } else {
                                setInstallationData({
                                    isInstallation: installationService === null || installationService === void 0 ? void 0 : installationService.isInstallation,
                                    name: "",
                                    price: ""
                                });
                                setInstallationMsg("");
                                setInstallationWarning(i18n.installServiceNotAvailableMsg);
                                setInstallationError("");
                                setInstallationAvailable(false);
                            }
                        } else {
                            setInstallationData({
                                isInstallation: installationService === null || installationService === void 0 ? void 0 : installationService.isInstallation,
                                name: "",
                                price: ""
                            });
                            setInstallationWarning(i18n.installServiceNotAvailableforProductMsg);
                            setInstallationAvailable(false);
                        }
                    }
                    setEta(eta);
                    setAvailability(true);
                    setPinCodeError(false);
                    disableCart(false);
                    const eventInfo = {
                        clickInternalLinks: "true",
                        eventAction: "pdp:product details:check availability",
                        eventName: "pdp:product details:check availability",
                        eventType: "navigation",
                        internalLinkName: "check availability",
                        internalLinkPosition: "pdp",
                        internalLinkType: "pdp:".concat(pincode),
                        internalLinkZoneName: "pdp:product details",
                        internalLinkURL: "n/a",
                        pincode: pincode
                    };
                    productInfo.pincode = pincode;
                    const page = window === null || window === void 0 ? void 0 : (ref23 = window.adobeDataLayer) === null || ref23 === void 0 ? void 0 : ref23.getState("page");
                    page.productInfo.pincode = pincode;
                    const customDataLayer = {
                        productInfo,
                        page
                    };
                    (0,helper.pushAnalyticsObjToDataLayer)(eventInfo, "cmp:click", {}, customDataLayer);
                } else if (error) {
                    setError(error);
                    disableCart(true);
                    setAvailability(false);
                    setInstallationData({
                        isInstallation: false,
                        name: "",
                        price: ""
                    });
                    setIsOutOfStock(error);
                    setInstallationWarning(i18n.installServiceNotAvailableMsg);
                    setInstallationAvailable(false);
                }
                setLoading(false);
                setIsEtaLoading(false);
                document.dispatchEvent(stopATCLoading);
            } catch (err) {
                var ref32;
                const { response: { data: errData = {}  } = {}  } = err;
                var ref33;
                setError(errData.statusCode === 404 && errData.status === "fail" ? isBundle ? i18n.notDeliverBundleMsg : i18n.notDeliverErrorMsg : (ref33 = (ref32 = errData.result) === null || ref32 === void 0 ? void 0 : ref32.error) !== null && ref33 !== void 0 ? ref33 : i18n.pincodeApiFailMsg);
                setInstallationWarning("");
                disableCart(true);
                setInstallationData({
                    isInstallation: false,
                    name: "",
                    price: ""
                });
                setLoading(false);
                setIsEtaLoading(false);
                document.dispatchEvent(stopATCLoading);
                console.error(err);
            }
        } else {
            setError(i18n.validPincode);
            setLoading(false);
            setIsEtaLoading(false);
            document.dispatchEvent(stopATCLoading);
            setInstallationWarning("");
        }
    };
    const navigateToSimilarItems = ()=>{
        const element = document.getElementById("product-recs-AT-Similar-items");
        if (element) {
            element.scrollIntoView({
                behavior: "smooth",
                block: "center",
                inline: "nearest"
            });
        }
    };
    const handleKeyDown = (e)=>{
        const { KEYCODE  } = constants["default"];
        if (e.keyCode === KEYCODE.ENTER) {
            handleSearch();
        }
    };
    const handleChange = (param)=>{
        let { target: { value =""  } = {}  } = param;
        setNotifySuccess(false);
        setIsOutOfStock("");
        if ((0,validate/* validNumber */.BP)(value) && value.length <= 6) {
            setPincode(value);
            setAvailability(false);
            deleteCookieValue("pincode");
        }
    };
    const addChangeAnalytics = ()=>{
        const eventInfo = {
            clickInternalLinks: "true",
            eventAction: "pdp:product details:pincode change",
            eventName: "pdp:product details:pincode change",
            eventType: "navigation",
            internalLinkName: "change",
            internalLinkPosition: "pdp",
            internalLinkType: "pdp:pincode change",
            internalLinkZoneName: "pdp:product details",
            internalLinkURL: "n/a"
        };
        const customDataLayer = {
            productInfo
        };
        (0,helper.pushAnalyticsObjToDataLayer)(eventInfo, "cmp:click", {}, customDataLayer);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (InstallService_index_module_default()).pdpInstallServiceWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "pdp-install-service",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "title ".concat(!error && !installationError && !installationWarning ? "mt-5" : ""),
                    children: !installationAvailable || !isAvailable ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: installationWarning && !installationError || !error && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "title",
                            children: i18n.serviceTitle
                        })
                    }) : null
                }),
                isAvailable && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "eta",
                    children: eta ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                children: i18n.eta({
                                    min: eta.minDay,
                                    max: eta.maxDay,
                                    pincode: pincode
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: "change-btn",
                                onClick: ()=>{
                                    disableCart(true);
                                    setAvailability(false);
                                    setPinCodeError(true);
                                    setInstallationWarning("");
                                    setError("");
                                    setInstallationData({
                                        isInstallation: isInstallationAvailable === "Yes" ? true : false,
                                        name: ""
                                    });
                                    addChangeAnalytics();
                                },
                                children: "Change Pincode"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: i18n.etaMessage({
                                    message: installationMsg
                                })
                            })
                        ]
                    }) : null
                }),
                !installationAvailable || !isAvailable ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        installationWarning && !installationError || !error && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "".concat(pinCodeError ? "desc-red" : "desc"),
                            children: i18n.serviceDesc
                        }),
                        (error || installationError) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "pincode-error ".concat(!hideSimilarItems && showSimilarItems ? "out-of-stock-div" : ""),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "error-msg ".concat(!hideSimilarItems && showSimilarItems ? "pincode-error__similar-items" : ""),
                                    children: error ? error : installationError
                                }),
                                !hideSimilarItems && showSimilarItems ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "view-similar",
                                    onClick: navigateToSimilarItems,
                                    children: "View Similar Items"
                                }) : null
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "pincode-wrap",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "pincode-input",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                        id: "pdp-install-service-pincode",
                                        type: "text",
                                        value: pincode,
                                        label: i18n.pincodeLabel,
                                        placeholder: i18n.pincodeLabel,
                                        onChange: handleChange,
                                        onBlur: ()=>{},
                                        haspopup: false,
                                        onKeyDown: handleKeyDown
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "pincode-btn",
                                    children: pincode !== "" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        type: "ghost",
                                        size: "small",
                                        role: "button",
                                        loading: loading,
                                        onClick: handleSearch,
                                        label: i18n.search
                                    }) : null
                                })
                            ]
                        })
                    ]
                }) : null
            ]
        })
    });
};
/* harmony default export */ var v3_InstallService = (InstallService);

// EXTERNAL MODULE: ./components/ProductDetail/v3/ServiceAvailability/index.module.scss
var ServiceAvailability_index_module = __webpack_require__(27003);
var ServiceAvailability_index_module_default = /*#__PURE__*/__webpack_require__.n(ServiceAvailability_index_module);
;// CONCATENATED MODULE: ./public/icons/brand-installation.svg
/* harmony default export */ var brand_installation = ({"src":"/_next/static/media/brand-installation.da87f0ec.svg","height":46,"width":46});
;// CONCATENATED MODULE: ./components/ProductDetail/v3/ServiceAvailability/index.jsx






const ServiceAvailability = (param)=>{
    let { i18n ={} , config ={} , isChecked , currencySign ="₹" , setIsChecked , installationData ={}  } = param;
    var ref;
    const { legalPageData  } = config;
    const { name , price , mrpPrice  } = installationData;
    let exactPrice = (price / 100).toFixed(2);
    const exactMRPPrice = (mrpPrice / 100).toFixed(2);
    if (isNaN(exactPrice)) {
        exactPrice = exactMRPPrice;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (ServiceAvailability_index_module_default()).pdpServiceAvailabilityWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "pdp-service-available",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "avilable-icon",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: brand_installation.src,
                        alt: "Tools"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "available-content",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                            children: name
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "installtion-div",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: i18n.installServiceAvailableDesc({
                                        exactPrice
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: (ref = legalPageData.map) === null || ref === void 0 ? void 0 : ref.termsOfService,
                                    className: "tc",
                                    children: i18n.tc
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "terms --mobile",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "price",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                        value: exactPrice,
                                        displayType: "text",
                                        thousandSeparator: true,
                                        prefix: currencySign,
                                        decimalScale: 2,
                                        fixedDecimalScale: true,
                                        thousandsGroupStyle: "lakh"
                                    })
                                }),
                                exactMRPPrice !== exactPrice && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "installtion-service",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "mrp",
                                            children: i18n.mrp
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "price price-discounted",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                                value: exactMRPPrice,
                                                displayType: "text",
                                                thousandSeparator: true,
                                                prefix: currencySign,
                                                decimalScale: 2,
                                                fixedDecimalScale: true,
                                                thousandsGroupStyle: "lakh"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "available-price",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "terms",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "price",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                        value: exactPrice,
                                        displayType: "text",
                                        thousandSeparator: true,
                                        prefix: currencySign,
                                        decimalScale: 2,
                                        fixedDecimalScale: true,
                                        thousandsGroupStyle: "lakh"
                                    })
                                }),
                                exactMRPPrice !== exactPrice && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "installtion-service",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "mrp",
                                            children: i18n.mrp
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "price price-discounted",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                                value: exactMRPPrice,
                                                displayType: "text",
                                                thousandSeparator: true,
                                                prefix: currencySign,
                                                decimalScale: 2,
                                                fixedDecimalScale: true,
                                                thousandsGroupStyle: "lakh"
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                            checked: isChecked,
                            onChange: (e)=>setIsChecked(e.target.checked)
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var v3_ServiceAvailability = (ServiceAvailability);

;// CONCATENATED MODULE: ./public/icons/tooltip-info.svg
/* harmony default export */ var tooltip_info = ({"src":"/_next/static/media/tooltip-info.9bb375b5.svg","height":20,"width":20});
;// CONCATENATED MODULE: ./public/icons/assistance.svg
/* harmony default export */ var assistance = ({"src":"/_next/static/media/assistance.c9744748.svg","height":50,"width":50});
// EXTERNAL MODULE: ./node_modules/react-rating-stars-component/dist/react-stars.js
var react_stars = __webpack_require__(11312);
// EXTERNAL MODULE: ./public/icons/half-star.svg
var half_star = __webpack_require__(56878);
// EXTERNAL MODULE: ./public/icons/full-star.svg
var full_star = __webpack_require__(41165);
// EXTERNAL MODULE: ./public/icons/empty-star.svg
var empty_star = __webpack_require__(20822);
;// CONCATENATED MODULE: ./components/Shared/BundleList/BundleItem.jsx








const BundleItem = (param)=>{
    let { item , t  } = param;
    const [currency, setCurrencySign] = (0,react.useState)("");
    const [pdpUrl, setPdpUrl] = (0,react.useState)("");
    (0,react.useEffect)(()=>{
        (0,constants_config/* getConfig */.i)().then((config)=>{
            const currency = get_default()(config, "internationalization.currencySign", "");
            setCurrencySign(currency);
        });
        (0,helper.getPDPUrl)(item.category, item.slug).then((url)=>{
            let bundleUrl = "".concat(url, "?skuId=").concat(item.sku);
            setPdpUrl(bundleUrl);
        }).catch((err)=>console.log(err));
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "bundle-item",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bundle-image",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: item.img,
                    alt: ""
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bundle-details",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: pdpUrl,
                        target: "_blank",
                        className: "gbh-data-layer",
                        "data-gbh-data-layer": (0,analytics/* getEventInfo */.wQ)("included items", false, null, null, pdpUrl),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                            children: item.productName
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "bundle-details__color",
                        children: [
                            t("kf.pdp.label.colorOrFinish", "Color/Finish"),
                            ": ",
                            item.color
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "bundle-details__sku",
                        children: [
                            t("kf.cart.label.sku", "SKU"),
                            ": ",
                            item.sku
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "bundle-details__qty",
                        children: [
                            t("kf.pdp.qty", "Qty"),
                            ": ",
                            item.qty,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "bundle-price",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                            value: item.mrpprice,
                                            displayType: "text",
                                            thousandSeparator: true,
                                            prefix: currency,
                                            decimalScale: 2,
                                            fixedDecimalScale: true,
                                            thousandsGroupStyle: "lakh"
                                        })
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bundle-price",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                            value: item.mrpprice,
                            displayType: "text",
                            thousandSeparator: true,
                            prefix: currency,
                            decimalScale: 2,
                            fixedDecimalScale: true,
                            thousandsGroupStyle: "lakh"
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var BundleList_BundleItem = (BundleItem);
BundleItem.propTypes = {
    item: {
        img: prop_types.string,
        productName: prop_types.string,
        color: prop_types.string,
        sku: prop_types.string,
        qty: prop_types.number,
        price: prop_types.number,
        slug: prop_types.string,
        category: prop_types.string
    }
};
BundleItem.defaultProps = {
    item: {
        img: "",
        productName: "",
        color: "",
        sku: "",
        qty: 1,
        price: 0,
        slug: "",
        category: ""
    }
};

// EXTERNAL MODULE: ./components/Shared/BundleList/bundle-list.module.scss
var bundle_list_module = __webpack_require__(21901);
var bundle_list_module_default = /*#__PURE__*/__webpack_require__.n(bundle_list_module);
;// CONCATENATED MODULE: ./components/Shared/BundleList/BundleList.jsx







const BundleList = (param)=>{
    let { items =[] , title =""  } = param;
    const [count, setCount] = (0,react.useState)(5);
    const { t  } = (0,esm/* useTranslation */.$G)("pdp");
    const handleViewRemaining = ()=>{
        setCount(items.length);
    };
    return items && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (bundle_list_module_default()).bundleList,
        children: [
            title && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bundle-title",
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bundle-items",
                children: items.slice(0, count).map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "bundle-item__wrap",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BundleList_BundleItem, {
                            item: item,
                            t: t
                        })
                    }, item.sku))
            }),
            items.length > 5 && count === 5 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                label: "".concat(t("kf.pdp.viewRemaining", "View Remaining"), " (").concat(items.length - 5, ")"),
                onClick: handleViewRemaining,
                flexible: true,
                size: "small",
                type: "ghost",
                role: "button",
                customClass: "bundle-list__btn"
            })
        ]
    });
};
BundleList.propTypes = {
    title: prop_types.string,
    items: prop_types.array.isRequired
};
BundleList.defaultProps = {
    title: "",
    items: []
};

;// CONCATENATED MODULE: ./components/Shared/BundleList/index.js


// EXTERNAL MODULE: ./node_modules/html-react-parser/index.mjs
var html_react_parser = __webpack_require__(25935);
// EXTERNAL MODULE: ./utils/addTocart.js
var addTocart = __webpack_require__(27522);
// EXTERNAL MODULE: ./src/store/features/locationSlice.js
var locationSlice = __webpack_require__(13644);
// EXTERNAL MODULE: ./src/components/FindStore/v1/api.js
var v1_api = __webpack_require__(75058);
;// CONCATENATED MODULE: ./src/components/ProductDetail/v3/ProductDetailView/analytics/constant.js
const constant_PDP_DEATAIL = "product details";
const constant_PDP_VIEW = "view this product in your space";
const constant_PDP = "pdp";
const constant_NAVIGATION = "navigation";
const CROSS_SELL = "cross-sell";
const BASED_ON_LOCATION = "based on your current location";
const ADD_INSTALL = "add an install service";
const PURCHASE_DESIGN = "purchase a design plan";
const STORE_NEAR = "see product on display";
const FIND_PRO = "find a local pro";
const WAIT_TIME_FOR_DATALAYER = 5000;
const ADD_TO_CART = "add to cart";
const PRODUCT_DECS = "flat fee pricing. kohler trusted professionals.";
const PRODUCT_TYPE = "regular w/required Items";
const PRODUCT_INSATLL = "install service";

;// CONCATENATED MODULE: ./src/components/ProductDetail/v3/ProductDetailView/analytics/analytics.js


const addAnalyticsForViewNowClick = (productInfo)=>{
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(PDP, ":").concat(PDP_DEATAIL, ":view now"),
        eventName: "".concat(PDP, ":").concat(PDP_DEATAIL, ":view now"),
        eventType: NAVIGATION,
        internalLinkName: "view now",
        internalLinkPosition: PDP,
        internalLinkType: "".concat(PDP, ":").concat(PDP_VIEW),
        internalLinkZoneName: "".concat(PDP, ":").concat(PDP_DEATAIL),
        internalLinkURL: "n/a"
    };
    analytics_pushAnalyticsObjToDataLayer(eventInfo, productInfo);
};
const addAnalyticsForCloseClick = (productInfo)=>{
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(PDP, ":").concat(PDP_DEATAIL, ":modal:").concat(PDP_VIEW, ":close"),
        eventName: "".concat(PDP, ":").concat(PDP_DEATAIL, ":modal:").concat(PDP_VIEW, ":close"),
        eventType: NAVIGATION,
        internalLinkName: "close",
        internalLinkPosition: PDP,
        internalLinkType: "".concat(PDP, ":close"),
        internalLinkZoneName: "".concat(PDP, ":").concat(PDP_DEATAIL, ":modal:").concat(PDP_VIEW),
        internalLinkURL: "n/a"
    };
    analytics_pushAnalyticsObjToDataLayer(eventInfo, productInfo);
};
const addAnalyticsForChangeZipCode = function() {
    let titleName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", productInfo = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, zipval = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    const title = titleName.toLowerCase();
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(constant_PDP, ":").concat(CROSS_SELL, ":").concat(title),
        eventName: "".concat(constant_PDP, ":").concat(CROSS_SELL, ":").concat(title),
        eventMsg: "n/a",
        eventStatus: "n/a",
        eventType: constant_NAVIGATION,
        internalLinkName: title,
        internalLinkPosition: constant_PDP,
        internalLinkType: "".concat(constant_PDP, ":").concat(zipval),
        internalLinkZoneName: "".concat(constant_PDP, ":").concat(CROSS_SELL, ":").concat(BASED_ON_LOCATION),
        internalLinkURL: "n/a"
    };
    analytics_pushAnalyticsObjToDataLayer(eventInfo, productInfo);
};
const addAnalyticsForUpdate = function() {
    let titleName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", productInfo = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, zipval = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, showcard = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true;
    const title = titleName.toLowerCase();
    const eventStatusItem = showcard ? "success" : "failure";
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(constant_PDP, ":").concat(CROSS_SELL, ":").concat(title, " zip code"),
        eventName: "".concat(constant_PDP, ":").concat(CROSS_SELL, ":").concat(title, " zip code"),
        eventMsg: "n/a",
        eventStatus: "".concat(eventStatusItem),
        eventType: constant_NAVIGATION,
        internalLinkName: title,
        internalLinkPosition: constant_PDP,
        internalLinkType: "".concat(constant_PDP, ":").concat(zipval),
        internalLinkZoneName: "".concat(constant_PDP, ":").concat(CROSS_SELL, ":").concat(BASED_ON_LOCATION),
        internalLinkURL: "n/a"
    };
    analytics_pushAnalyticsObjToDataLayer(eventInfo, productInfo);
};
const addAnalyticsForBuymore = function() {
    let titleName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", url = arguments.length > 1 ? arguments[1] : void 0, productInfo = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    const title = titleName.toLowerCase();
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(constant_PDP, ":").concat(CROSS_SELL, ":").concat(title),
        eventName: "".concat(constant_PDP, ":").concat(CROSS_SELL, ":").concat(title),
        eventMsg: "n/a",
        eventStatus: "n/a",
        eventType: constant_NAVIGATION,
        internalLinkName: title,
        internalLinkPosition: constant_PDP,
        internalLinkType: "".concat(constant_PDP, ":").concat(ADD_INSTALL),
        internalLinkZoneName: "".concat(constant_PDP, ":").concat(CROSS_SELL, ":").concat(ADD_INSTALL),
        internalLinkURL: url ? url : "n/a"
    };
    analytics_pushAnalyticsObjToDataLayer(eventInfo, productInfo);
};
const addAnalyticsForAddService = function() {
    let titleName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", productitem = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, serviceName = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", servicePrice = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, productServices = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "";
    const title = titleName.toLowerCase();
    const service = (0,helper.getPureText)(serviceName).toLowerCase();
    const { productName ="" , quantity =1 , productBrand =""  } = productitem;
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(constant_PDP, ":").concat(CROSS_SELL, ":").concat(ADD_INSTALL, ":").concat(ADD_TO_CART),
        eventName: "".concat(constant_PDP, ":").concat(CROSS_SELL, ":").concat(ADD_INSTALL, ":").concat(ADD_TO_CART),
        eventMsg: "n/a",
        eventStatus: "n/a",
        eventType: constant_NAVIGATION,
        internalLinkName: title,
        internalLinkPosition: constant_PDP,
        internalLinkType: "".concat(constant_PDP, ":").concat(service),
        internalLinkZoneName: "".concat(constant_PDP, ":").concat(CROSS_SELL, ":").concat(ADD_INSTALL),
        internalLinkURL: "n/a"
    };
    const productInfo = {
        defaultImageName: "n/a",
        description: PRODUCT_DECS,
        frequency: "n/a",
        globalPromotionPrice: servicePrice,
        isRecommended: "n/a",
        isSendNow: "n/a",
        isSubscription: "n/a",
        numberOfReviews: "n/a",
        pdpType: PRODUCT_TYPE,
        priceState: "regular price",
        productBasePrice: servicePrice,
        productBrand: productBrand,
        productCategory: PRODUCT_INSATLL,
        productCollectionsName: PRODUCT_INSATLL,
        productColor: "n/a",
        productCouponCode: "n/a",
        productCoupondiscount: "n/a",
        productFindingMethod: "n/a",
        productID: productServices,
        productName: productName,
        productPartnerBuyNow: "n/a",
        productRoom: PRODUCT_INSATLL,
        productSalePrice: servicePrice,
        productSaleable: "true",
        productStatus: "in stock",
        productSuperSku: "false",
        productTileName: "installation services",
        quantity: quantity,
        ratings: "n/a"
    };
    analytics_pushAnalyticsObjToDataLayer(eventInfo, productInfo);
};
const addAnalyticsForBathroomDesign = function() {
    let titleName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", url = arguments.length > 1 ? arguments[1] : void 0, productInfo = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    const title = titleName.toLowerCase();
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(constant_PDP, ":").concat(CROSS_SELL, ":").concat(title),
        eventName: "".concat(constant_PDP, ":").concat(CROSS_SELL, ":").concat(title),
        eventMsg: "n/a",
        eventStatus: "n/a",
        eventType: constant_NAVIGATION,
        internalLinkName: title,
        internalLinkPosition: constant_PDP,
        internalLinkType: "".concat(constant_PDP, ":").concat(PURCHASE_DESIGN),
        internalLinkZoneName: "".concat(constant_PDP, ":").concat(CROSS_SELL, ":").concat(PURCHASE_DESIGN),
        internalLinkURL: url
    };
    analytics_pushAnalyticsObjToDataLayer(eventInfo, productInfo);
};
const addAnalyticsForStoreNearYou = function() {
    let titleName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", url = arguments.length > 1 ? arguments[1] : void 0, productInfo = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    const title = titleName.toLowerCase();
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(constant_PDP, ":").concat(CROSS_SELL, ":").concat(title),
        eventName: "".concat(constant_PDP, ":").concat(CROSS_SELL, ":").concat(title),
        eventMsg: "n/a",
        eventStatus: "n/a",
        eventType: constant_NAVIGATION,
        internalLinkName: title,
        internalLinkPosition: constant_PDP,
        internalLinkType: "".concat(constant_PDP, ":").concat(STORE_NEAR),
        internalLinkZoneName: "".concat(constant_PDP, ":").concat(CROSS_SELL, ":").concat(STORE_NEAR),
        internalLinkURL: url
    };
    analytics_pushAnalyticsObjToDataLayer(eventInfo, productInfo);
};
const addAnalyticsForGetProfessionalClick = function() {
    let titleName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", url = arguments.length > 1 ? arguments[1] : void 0, productInfo = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    const title = titleName.toLowerCase();
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(constant_PDP, ":").concat(CROSS_SELL, ":").concat(title),
        eventName: "".concat(constant_PDP, ":").concat(CROSS_SELL, ":").concat(title),
        eventMsg: "n/a",
        eventStatus: "n/a",
        eventType: constant_NAVIGATION,
        internalLinkName: title,
        internalLinkPosition: constant_PDP,
        internalLinkType: "".concat(constant_PDP, ":").concat(FIND_PRO),
        internalLinkZoneName: "".concat(constant_PDP, ":").concat(CROSS_SELL, ":").concat(FIND_PRO),
        internalLinkURL: url
    };
    analytics_pushAnalyticsObjToDataLayer(eventInfo, productInfo);
};
const analytics_pushAnalyticsObjToDataLayer = function() {
    let eventInfo = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, productInfo = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const event = "cmp:click";
    window.adobeDataLayer.push({
        event,
        eventInfo,
        page,
        productInfo
    });
};

// EXTERNAL MODULE: ./components/cart/cartHelper.js
var cartHelper = __webpack_require__(44753);
;// CONCATENATED MODULE: ./components/ProductDetail/v3/ProductDisplay.jsx



















const ProductOnDisplay = (param)=>{
    let { pdpJson ={} , productServices ={} , installationData ={} , currencyCode ="" , currencySign ="$" , brandName ="" , findStores ="" , colorsData =[] , shortendPagePath ="" , findStoreDetailsUrl ="" , productType ="" , productInfo ={} , getZipCode =()=>{}  } = param;
    var ref, ref1;
    const { locationTitles ="" , zipCodeToUpdate ="" , updateZipTitle ="" , productDisplayTitle ="" , sectionHeadingProductNotAvailable ="" , addInstallServiceTitle ="" , changeZipCode ="" , yourZipCode ="" , serviceUnavailableTitle ="" , serviceUnavailableSectionHeading ="" , descriptionProductNotAvailable ="" , errorMessage ="" , multiDesignServices =[] , installServices =[] , zipCodeTitle ="" , buyMoreTitle ="" , buyMoreToolTip ="" , addServiceToCart =""  } = pdpJson;
    const dispatch = (0,es/* useDispatch */.I0)();
    const { utilityLocation =""  } = (0,es/* useSelector */.v9)(locationSlice/* locationState */._n);
    const [tooltip, setTooltip] = (0,react.useState)({
        buyMoreSaveMore: false
    });
    const [serviceDetails, setServiceDetails] = (0,react.useState)({});
    const [servicePrice, setServicePrice] = (0,react.useState)("");
    const [zipCodeInputVal, setZipCodeInputVal] = (0,react.useState)(utilityLocation);
    const [showAddanInstallCard, setShowAddanInstallCard] = (0,react.useState)(false);
    const [toggleZipCodeSection, setToggleZipCodeSection] = (0,react.useState)(zipCodeInputVal ? true : false);
    const [storeInfo, setStoreInfo] = (0,react.useState)([]);
    const [findStoreUtilityDetails, setFindStoreUtilityDetails] = (0,react.useState)({});
    const learnMoreRef = (0,react.useRef)();
    const installSeriveRef = (0,react.useRef)();
    const isInitionalRender = (0,react.useRef)(true);
    const [zipcode, setZipcode] = (0,react.useState)();
    const installserviceClickHandler = (e, productInfo)=>{
        const { target: { href ="" , textContent =""  } = {}  } = e;
        addAnalyticsForBathroomDesign(textContent.toLowerCase(), href, productInfo);
        window.open(href);
    };
    const servicesClick = (e, productInfo)=>{
        const { target: { href ="" , textContent =""  } = {}  } = e;
        addAnalyticsForBuymore(textContent, href, productInfo);
        window.open(href);
    };
    const titleclickhandler = (e, productInfo)=>{
        const { target: { href ="" , textContent =""  } = {}  } = e;
        addAnalyticsForBuymore(textContent, href, productInfo);
        window.open(href);
    };
    (0,react.useEffect)(()=>{
        if (showAddanInstallCard > 0) {
            if (installSeriveRef === null || installSeriveRef === void 0 ? void 0 : installSeriveRef.current) {
                var ref;
                installSeriveRef === null || installSeriveRef === void 0 ? void 0 : (ref = installSeriveRef.current) === null || ref === void 0 ? void 0 : ref.querySelectorAll("a").forEach((item)=>{
                    if ((item === null || item === void 0 ? void 0 : item.getAttribute("listener")) !== "true") {
                        item === null || item === void 0 ? void 0 : item.addEventListener("click", (e)=>{
                            servicesClick(e, productInfo);
                        });
                    }
                });
            }
        }
        return ()=>{
            var ref;
            installSeriveRef === null || installSeriveRef === void 0 ? void 0 : (ref = installSeriveRef.current) === null || ref === void 0 ? void 0 : ref.querySelectorAll("a").forEach((item)=>{
                item === null || item === void 0 ? void 0 : item.removeEventListener("click", servicesClick);
            });
        };
    }, [
        showAddanInstallCard,
        servicePrice
    ]);
    const storeclickHandler = (e, productInfo)=>{
        const { target: { href ="" , textContent =""  } = {}  } = e;
        addAnalyticsForStoreNearYou(textContent, href, productInfo);
        window.open(href);
    };
    (0,react.useEffect)(()=>{
        if (utilityLocation) setZipCodeInputVal(utilityLocation);
    }, [
        utilityLocation
    ]);
    (0,react.useEffect)(()=>{
        isInitionalRender.current = true;
        if (!zipCodeInputVal) setZipCodeInputVal(localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem("currentZipCode"));
        // handleCheckAvailability(localStorage?.getItem("currentZipCode"), true)
        // fetchFindStoreUtilityDetails()
        if (learnMoreRef === null || learnMoreRef === void 0 ? void 0 : learnMoreRef.current) {
            var ref;
            learnMoreRef === null || learnMoreRef === void 0 ? void 0 : (ref = learnMoreRef.current) === null || ref === void 0 ? void 0 : ref.querySelectorAll("a").forEach((item)=>{
                item === null || item === void 0 ? void 0 : item.addEventListener("click", (e)=>{
                    installserviceClickHandler(e, productInfo);
                });
            });
        }
        return ()=>{
            var ref;
            learnMoreRef === null || learnMoreRef === void 0 ? void 0 : (ref = learnMoreRef.current) === null || ref === void 0 ? void 0 : ref.querySelectorAll("a").forEach((item)=>{
                item === null || item === void 0 ? void 0 : item.removeEventListener("click", (e)=>{
                    installserviceClickHandler(e, productInfo);
                });
            });
        };
    }, []);
    const fetchFindStoreUtilityDetails = ()=>{
        (0,api/* aemAxiosInstance */.Gb)({
            url: constants.GLOBAL_CONFIGURATION_ENDPOINT,
            params: {
                path: findStoreDetailsUrl
            }
        }).then((response)=>{
            const { data ={}  } = response;
            if (response && data) {
                setFindStoreUtilityDetails(data);
            // if (zipCodeInputVal && colorsData.length)
            // fetchProductsOnDisplayStores()
            }
        }).catch((err)=>{
            console.log("Failed to get compare attributes JSON file", err);
        });
    };
    const fetchProductsOnDisplayStores = async ()=>{
        var ref;
        const skus = (ref = colorsData === null || colorsData === void 0 ? void 0 : colorsData.map((item)=>item.id)) !== null && ref !== void 0 ? ref : [];
        const { data: { info =[]  } = {}  } = await (0,v1_api/* getFindAStoresResult */.R)(findStores, zipCodeInputVal, brandName, null, 1, "", null, skus.join(","));
        if (info.length) setStoreInfo(info);
        else setStoreInfo([]);
    };
    (0,react.useEffect)(()=>{
        if (productServices.length) {
            var ref;
            const qualifiedService = (ref = installServices.find((item)=>item.sku === productServices[0])) !== null && ref !== void 0 ? ref : {};
            setServiceDetails(qualifiedService);
            if (installationData.length) {
                var ref1;
                const qaulifiedServiceBusinessData = (ref1 = installationData.find((item)=>item.masterVariant.sku === productServices[0])) !== null && ref1 !== void 0 ? ref1 : {};
                const { masterVariant: { prices =[]  } = {}  } = qaulifiedServiceBusinessData !== null && qaulifiedServiceBusinessData !== void 0 ? qaulifiedServiceBusinessData : {};
                if (prices.length) {
                    var ref2;
                    const priceObj = (ref2 = prices.find((item)=>item.value.currencyCode === currencyCode)) !== null && ref2 !== void 0 ? ref2 : {};
                    const { value: { centAmount =""  } = {}  } = priceObj;
                    const installationPrice = Number(centAmount / 100).toFixed(2);
                    setServicePrice(installationPrice);
                }
            }
        }
    }, [
        productServices,
        installationData
    ]);
    // useEffect(() => {
    //   if (zipCodeInputVal && colorsData.length) fetchProductsOnDisplayStores()
    // }, [colorsData])
    (0,react.useEffect)(()=>{
        (0,cartHelper/* getPincode */.pf)().then((zip)=>setZipcode(zip));
    }, []);
    const handleFieldInfoMouseOver = function() {
        let tooltipFor = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "buyMoreSaveMore", value = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        setTooltip({
            ...tooltip,
            [tooltipFor]: value
        });
    };
    const handleAddToCart = (e)=>{
        e.preventDefault();
        if (!productServices.length) return;
        const item = {
            sku: productServices[0],
            quantity: 1,
            userZipCode: zipCodeInputVal,
            brand: brandName
        };
        const { quantity  } = item;
        const itemCountMessage = "".concat(quantity, " ");
        const ToasterMsg = "".concat(itemCountMessage);
        (0,addTocart/* addToCartItem */.q)([
            {
                ...item,
                isBundle: false,
                backorder: false
            }
        ]).then((response)=>{
            const body = {
                actions: response
            };
            dispatch((0,cartSlice/* addToCart */.Xq)(body)).unwrap().then((res)=>{
                if (res) {
                    if (dist_lib/* isMobile */.tq) {
                        dispatch((0,genericSlice/* showToast */.CF)({
                            message: ToasterMsg,
                            isVisible: true
                        }));
                    } else {
                        dispatch((0,genericSlice/* showPreviewCart */.z0)());
                    }
                }
            });
        });
    };
    const getProsessionalClickHandler = (e, productInfo)=>{
        const { target: { href ="" , textContent =""  } = {}  } = e;
        addAnalyticsForGetProfessionalClick(textContent, href, productInfo);
        window.open(href);
    };
    const handlerForAddServiceClick = (e)=>{
        handleAddToCart(e);
        addAnalyticsForAddService(addServiceToCart, productInfo, serviceDetails.sectionHeading, servicePrice, productServices[0]);
    };
    const handleChangeZip = ()=>{
        setToggleZipCodeSection(false);
        addAnalyticsForChangeZipCode(changeZipCode, productInfo, zipCodeInputVal);
    };
    const handleZipCodeCallBack = (isZipAvaialbe)=>{
        setShowAddanInstallCard(isZipAvaialbe);
        setToggleZipCodeSection(true);
        if (!isInitionalRender.current) {
            addAnalyticsForUpdate(updateZipTitle, productInfo, zipCodeInputVal, isZipAvaialbe);
        }
    };
    const handleCheckAvailability = function(zipcode) {
        let isInitialCall = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        if (!isInitialCall) localStorage.setItem("currentZipCode", zipCodeInputVal);
        const zipToPass = zipCodeInputVal || zipcode;
        getZipCode(zipToPass, handleZipCodeCallBack);
    // if (zipToPass) {
    //   fetchProductsOnDisplayStores()
    // }
    };
    const [finalUrlStore, setFinalUrlStore] = (0,react.useState)();
    const [finalUrlPro, setFinalUrlPro] = (0,react.useState)();
    const [finalUrlBathroom, setFinalUrlBathroom] = (0,react.useState)();
    (0,react.useEffect)(()=>{
        var ref;
        (0,helper.getShortenedUrl)(pdpJson === null || pdpJson === void 0 ? void 0 : pdpJson.sectionHeadingProductNotAvailable).then((res)=>setFinalUrlStore(res));
        (0,helper.getShortenedUrl)(pdpJson === null || pdpJson === void 0 ? void 0 : pdpJson.localProHeading).then((res)=>setFinalUrlPro(res));
        (0,helper.getShortenedUrl)((ref = pdpJson === null || pdpJson === void 0 ? void 0 : pdpJson.designServices[0]) === null || ref === void 0 ? void 0 : ref.designPlanSectionHeading).then((res)=>setFinalUrlBathroom(res));
    }, [
        pdpJson === null || pdpJson === void 0 ? void 0 : pdpJson.sectionHeadingProductNotAvailable
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "purchase-design",
                ref: learnMoreRef,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "purchase-design__left-side",
                        children: (pdpJson === null || pdpJson === void 0 ? void 0 : pdpJson.designServices.length) > 0 && finalUrlBathroom && (0,html_react_parser/* default */.ZP)((ref = pdpJson === null || pdpJson === void 0 ? void 0 : pdpJson.designServices[0]) === null || ref === void 0 ? void 0 : ref.designPlanTitle)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "purchase-design__right-side",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "design-service",
                                children: (pdpJson === null || pdpJson === void 0 ? void 0 : pdpJson.designServices.length) > 0 && finalUrlBathroom && (0,html_react_parser/* default */.ZP)(finalUrlBathroom ? finalUrlBathroom : "")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "expert-design",
                                children: (pdpJson === null || pdpJson === void 0 ? void 0 : pdpJson.designServices.length) > 0 && (0,html_react_parser/* default */.ZP)((ref1 = pdpJson === null || pdpJson === void 0 ? void 0 : pdpJson.designServices[0]) === null || ref1 === void 0 ? void 0 : ref1.designPlanDescription)
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "add-installation-noservice",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "noservice-title",
                        children: pdpJson === null || pdpJson === void 0 ? void 0 : pdpJson.localProTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "noservice__right-side",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "header",
                                children: finalUrlPro && (0,html_react_parser/* default */.ZP)(finalUrlPro ? finalUrlPro : "")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "desc",
                                children: (0,html_react_parser/* default */.ZP)(pdpJson === null || pdpJson === void 0 ? void 0 : pdpJson.serviceavailable)
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var ProductDisplay = (ProductOnDisplay);

// EXTERNAL MODULE: ./components/Shared/UpsellInstallServices/UpsellServicesMobile/index.jsx
var UpsellServicesMobile = __webpack_require__(41630);
;// CONCATENATED MODULE: ./components/ProductDetail/v3/ProductDetailView/ProductDescription.jsx
/* eslint-disable camelcase */ 











// import ListPrice from "@/components/ProductDetail/v3/ProductDetailView/ListPrice"
























const ProductDescription = /*#__PURE__*/ (0,react.forwardRef)((props, ref)=>{
    const { rightSectionRef , addCartContainer , notifyContainer  } = ref;
    const { config ={} , badgeTxt ="" , isDiscontinued =false , discontinuedProduct =false , staticTexts ={} , name ="" , desc ="" , customerFacingSKU ="" , sku ="" , price =0 , isPersonaANY =false , ProductPriceSpiderIncluded_s =false , discountPercent =0 , discountedPrice =0 , currencySign ="" , isType ="" , persona ="" , productInfo , handleSetPriceTooltip =()=>{} , options =[] , curroptions =[] , facetLabels =[] , selectMoreTooltipData ="" , selectoption =()=>{} , isRegionSoldOnline =true , addToCartProps ={} , addToCartProps: { specialOrder ="" , backOrder =""  } = {} , productOnStock =1 , promoTitle ="" , isProjectPack ="" , disableEcommerce =true , freightPolicyType ="" , overSizedType ="" , excludedState ="" , productAnalyticsData ={} , handleQuantityChange =()=>{} , comparedProductsCount =0 , isColorDiscontinued =false , handleNavChange =()=>{} , onAddToCompare =()=>{} , onRemoveFromCompare =()=>{} , checkProductCategory =()=>{} , compare ={} , isComboSku =false , productCategory ="" , isEnable =true , isParts =false , showToaster =()=>{} , onAvailableColor =()=>{} , findStoreUrl ="" , isFavorite =false , favItem =[] , ctData ={} , customerBrandName ="" , replaceAddToCart =false , disableRatings =false , replaceAddToCartCtaLink ="" , replaceAddToCartCtaLabel ="" , linkNewTab =false , fusionQueryId ="" , docId ="" , narrativeDescription ="" , partReplacementSuggestions ="" , pdpJson ={} , promoDescription ="" , onAddToCart =()=>{} , mboxes =[] , presetConfigObject ={} , productType ="" , installationDataFromProp =[] , designServiceDataFromProp =[] , installationData =[] , locale ="" , productData ={} , businessUnitName ="" , discontinuedProductb ="" , ProductRequiredAccessoriesGroupsList =[] , superSku ="" , designServiceData =[] , productServices =[] , getZipCode =()=>{} , currencyCode ="" , isPdpPropsLoaded =false , isFragile =false , ctLoading , listPrice , installErrorCallback , warehouses , setWareHouses , pinCodeError , setPinCodeError , reqItemLwData =[] , installReq =[] , quantity , setQuantity , handleBuyNow =()=>{} , setPincode =()=>{} , setIsOutOfStock =()=>{} , isOutOfStock =false , installServiceData , setInstallServiceData , isChecked , setIsChecked , bundleItems , setBundleItems , reviews , notifyClicked =false , setIsEtaLoading =()=>{} , upSellData , allVariantDiscotinuedProduct , imagesData  } = props;
    // const { isEnableBrand } = config
    const { InstallationCost_s , InstallationAvailable_s , productInRiverId_s , redirectUrl_s , relatedProductLink_s , relatedProduct_s  } = productData;
    const relatedProductDetails = productData["relatedProduct.Details_ss"];
    const dispatch = (0,es/* useDispatch */.I0)();
    const slickRef = (0,react.useRef)(null);
    const [width, height] = (0,useWindowResize/* default */.Z)();
    const [showPromo, setShowPromo] = (0,react.useState)(false);
    const [descShowMore, setDescShowMore] = (0,react.useState)(false);
    const [allowedDescCount, setAllowedDescCount] = (0,react.useState)(0);
    const [bundleAdditionalFeatures, setBundleAdditionalFeatures] = (0,react.useState)([]);
    const [currentQty, setCurrentQty] = (0,react.useState)(1);
    const [availableQty, setAvailableQty] = (0,react.useState)(0);
    const [installError, setInstallError] = (0,react.useState)(true);
    const [installProductInfo, setInstallProductInfo] = (0,react.useState)({});
    const [installationError, setInstallationError] = (0,react.useState)("");
    const [error, setError] = (0,react.useState)("");
    const [loading, setLoading] = (0,react.useState)(false);
    const [reqItemsError, setReqItemsError] = (0,react.useState)({});
    const { status =""  } = (0,es/* useSelector */.v9)(pdpSlice/* selectPdpState */.BY);
    const [notifySuccess, setNotifySuccess] = (0,react.useState)(false);
    const installCost = InstallationCost_s !== "Not Applicable" ? InstallationCost_s : "";
    const isInstallation = InstallationAvailable_s === "Yes" ? true : false;
    const installService = (0,react.useCallback)(()=>{
        setInstallServiceData({
            isInstallation: InstallationAvailable_s === "Yes" ? true : false
        });
    });
    const setNarrativeDescription = (0,react.useCallback)(()=>{
        if (narrativeDescription) {
            var ref;
            const descCount = (ref = narrativeDescription === null || narrativeDescription === void 0 ? void 0 : narrativeDescription.length) !== null && ref !== void 0 ? ref : 0;
            const allowedCount = width > 1023 && width < 1280 ? 230 : 300;
            setAllowedDescCount(allowedCount);
            setDescShowMore(descCount > allowedCount);
        }
    });
    const formatBundle = (0,react.useCallback)(()=>{
        if (productData.bundleItems && productData.bundleItems.length) {
            (0,product/* formatBundleItems */.In)(productData.bundleItems, productData.BundleList_ss).then((d)=>{
                setBundleItems(d);
            }).catch((ex)=>console.log(ex));
        }
    });
    const getBundleFeatures = ()=>{
        const features = [];
        for (const [key, value] of Object.entries(productData)){
            const match = key.match(/^ProductWebFeatures_(\d+)_Title_s$/);
            if (match) {
                const index = match[1];
                const title = value;
                const descriptionKey = "ProductWebFeatures_".concat(index, "_Description_ss");
                const descriptions = productData[descriptionKey] || [];
                features.push({
                    title,
                    descriptions
                });
            }
        }
        setBundleAdditionalFeatures(features);
    };
    (0,react.useEffect)(()=>{
        installService();
    }, [
        InstallationAvailable_s
    ]);
    (0,react.useEffect)(()=>{
        setNarrativeDescription();
    }, [
        narrativeDescription,
        width
    ]);
    (0,react.useEffect)(()=>{
        window.addEventListener("scroll", handleScrollRight);
        return ()=>{
            window.removeEventListener("scroll", handleScrollRight);
        };
    }, []);
    (0,react.useEffect)(()=>{
        formatBundle();
        getBundleFeatures();
    }, [
        props.productData
    ]);
    const handleSelectoption = (0,react.useCallback)((value, facet, dropdownName)=>{
        (0,analytics/* addAnalyticsForSelectionDropdown */.nr)(value, dropdownName, productInfo);
        selectoption(value, facet);
    });
    const handleScrollRight = (0,react.useCallback)(()=>{
        var ref;
        const rightSecHeight = (ref = rightSectionRef.current) === null || ref === void 0 ? void 0 : ref.clientHeight;
        if (rightSectionRef.current && width >= 1024) {
            rightSectionRef.current.style.top = "-".concat(rightSecHeight - height, "px");
        }
    });
    const onQtyChange = (0,react.useCallback)((qty)=>{
        if (qty) {
            setCurrentQty(qty);
            handleQuantityChange(qty);
        }
    });
    const initPrice = (0,react.useCallback)(()=>{
        if (ProductPriceSpiderIncluded_s) {
            (0,productDetailsHelper/* initPriceSpider */.i8)();
        }
    });
    const setInstallService = (0,react.useCallback)(()=>{
        var ref;
        (ref = window.PriceSpider) === null || ref === void 0 ? void 0 : ref.rebind();
        setInstallServiceData({});
    });
    (0,react.useEffect)(()=>{
        initPrice();
    }, [
        ProductPriceSpiderIncluded_s
    ]);
    (0,react.useEffect)(()=>{
        setInstallService();
    }, [
        sku
    ]);
    let isBrandDiscontinued = isDiscontinued;
    const isBrandOrTransact = (0,utils_0/* isBrandTransact */.AY)();
    if (isDiscontinued && isBrandOrTransact) {
        isBrandDiscontinued = false;
    }
    const setInstallErrorCallback = (0,react.useCallback)(()=>{
        installErrorCallback(installError);
    });
    (0,react.useEffect)(()=>{
        setInstallErrorCallback();
    }, [
        installError
    ]);
    const scrollToSpendSave = (0,react.useCallback)(()=>{
        let element = document.getElementById("spendSaveDisplayDiv");
        let headerOffset = 120;
        let elementPosition = element.getBoundingClientRect().top;
        let offsetPosition = elementPosition + window.scrollY - headerOffset;
        window.scrollTo({
            top: offsetPosition,
            behavior: "smooth"
        });
        (0,analytics/* offerClickEventAnalytics */.Pc)();
    });
    // const productDescriptionSpendSave =
    //   pdpJson.descriptionProductNotAvailable.split("%")[1]
    // const percentValue = productDescriptionSpendSave.substring(
    //   productDescriptionSpendSave.length - 2,
    //   productDescriptionSpendSave.length
    // )
    const triggerSaleAssist = (0,react.useCallback)(()=>{
        const payload = {
            data: {
                code: "mountWidget"
            }
        };
        const jsonPayload = JSON.stringify(payload);
        if (window && window.postMessage) {
            window.postMessage(jsonPayload, window.location.origin);
        }
    });
    const scrollToReviews = ()=>{
        let element = document.getElementsByClassName("review-title")[0];
        let headerOffset = 120;
        let elementPosition = element.getBoundingClientRect().top;
        let offsetPosition = elementPosition + window.scrollY - headerOffset;
        (0,analytics/* reviewClickAnalytics */.CL)();
        window.scrollTo({
            top: offsetPosition,
            behavior: "smooth"
        });
    };
    const seeAvailableOptionClick = ()=>{
        if (relatedProductDetails.length) {
            const relatedProduct = relatedProductDetails.find((ele)=>{
                return sku === ele.split("|")[0];
            });
            const relatedProductLink_s = relatedProduct.split("|")[4];
            const relatedProduct_s = relatedProduct.split("|")[1];
            window.location.href = "".concat(relatedProductLink_s, "?skuId=").concat(relatedProduct_s);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: rightSectionRef,
        className: "product-detail-page__right-sticky",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "row product-detail-page__main",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "col-12",
                    children: [
                        !isBrandOrTransact && (badgeTxt && !isDiscontinued || discontinuedProduct || InstallationAvailable_s) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "product-detail-page__badge",
                            children: [
                                !isDiscontinued && badgeTxt !== "" && /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                    className: "product-detail-page__badge-new",
                                    children: badgeTxt
                                }),
                                isDiscontinued && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "product-detail-page__badge-discontinued",
                                    children: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.discontinued
                                }),
                                !isDiscontinued && isInstallation && InstallationAvailable_s && discountedPrice <= constants.ESTIMATED_TOTAL_FOR_NO_COST_EMI && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "product-detail-page__badge-installation-available",
                                    children: installCost + " " + (staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.installationAvailable)
                                }),
                                bundleItems.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "product-detail-page__badge-installation-available",
                                    children: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.completeSolution
                                }) : null,
                                !isDiscontinued && discountedPrice > constants.ESTIMATED_TOTAL_FOR_NO_COST_EMI ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "product-detail-page__badge-installation-available",
                                    children: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.noCostEmi
                                }) : null
                            ]
                        }),
                        name || desc ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                            className: "product-detail-page__title-desc",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "product-detail-page__title",
                                    children: name ? name : desc
                                }),
                                name && desc && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    className: "product-detail-page__description",
                                    children: [
                                        " ",
                                        desc.replace(/"/g, " inch")
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                            className: "product-detail-page__title-desc",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "product-detail-page__title",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "shimmer-loading__para shimmer width-170"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "shimmer-loading__para shimmer width-170 product-detail-page__description"
                                })
                            ]
                        }),
                        customerFacingSKU || sku ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: "product-detail-page__sku-id",
                            children: [
                                bundleItems.length ? "SKU: " : null,
                                customerFacingSKU || sku
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "product-detail-page__sku-id",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "shimmer-loading__para shimmer width-170"
                            })
                        }),
                        reviews ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "review-stars",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_stars/* default */.Z, {
                                        count: 5,
                                        value: reviews.averageRating.toFixed(1),
                                        size: 24,
                                        edit: false,
                                        isHalf: true,
                                        emptyIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: empty_star/* default.src */.Z.src
                                        }),
                                        halfIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: half_star/* default.src */.Z.src
                                        }),
                                        filledIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: full_star/* default.src */.Z.src
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "review",
                                        onClick: scrollToReviews,
                                        children: "".concat(reviews.averageRating.toFixed(1), "  (").concat(reviews.count, ")")
                                    })
                                ]
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "no-reviews",
                            onClick: scrollToReviews,
                            children: "Rate the Product"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDetailView_SwatchList, {
                productData: productData,
                ...props
            }),
            bundleItems.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BundleList, {
                items: bundleItems,
                title: "Included Items ".concat(discountPercent > 0 ? ": (".concat(isType === "absolute" ? currencySign + discountPercent : discountPercent + "%", "\n        ").concat(staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.discount, " on this bundle)") : null)
            }) : null,
            !bundleItems.length && price > 0 && !isBrandDiscontinued ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()({
                    "row no-gutters product-detail-page__price-main": true,
                    "price-retail-exclusive": ProductPriceSpiderIncluded_s
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "col-12 product-detail-page__price",
                    children: [
                        !isPersonaANY && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "product-detail-page__price-value",
                            tabIndex: "0",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                    value: discountedPrice > 0 ? discountedPrice : price,
                                    displayType: "text",
                                    thousandSeparator: true,
                                    prefix: currencySign,
                                    decimalScale: 2,
                                    fixedDecimalScale: true
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "product-detail-page__price-alltaxes-text",
                                    children: props.staticTexts.inclusiveOfAllTaxes
                                }),
                                discountedPrice > 0 && discountedPrice !== price && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "col-12 product-detail-page__discount",
                                    style: {
                                        display: "flex",
                                        alignItems: "baseline",
                                        marginBottom: "10px",
                                        marginTop: "10px"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            className: "product-detail-page__list-text",
                                            children: [
                                                " ",
                                                props.staticTexts.refPrice
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "product-detail-page__discount-price",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                                value: price,
                                                displayType: "text",
                                                thousandSeparator: true,
                                                prefix: currencySign,
                                                decimalScale: 2,
                                                fixedDecimalScale: true
                                            })
                                        }),
                                        discountPercent > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            className: "product-detail-page__percent-off",
                                            children: [
                                                isType === "absolute" ? currencySign + discountPercent : discountPercent + "%",
                                                " ",
                                                staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.percentOff
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        price && (persona === "FF" || persona === "KEMP") && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "product-detail-page__customer-group",
                            children: [
                                persona === "FF" && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.friendsFamilyPrice
                                }),
                                persona === "KEMP" && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.associatePrice
                                })
                            ]
                        })
                    ]
                })
            }) : null,
            !isDiscontinued && Object.keys(options).length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "row no-gutters",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v3_OptionsSelector, {
                    i18n: staticTexts,
                    data: options,
                    curroptions: curroptions,
                    selectoption: handleSelectoption,
                    facetLabels: facetLabels,
                    tooltipdata: selectMoreTooltipData,
                    selectMoreTooltipHandler: handleSetPriceTooltip,
                    configurationAccordianDataLayer: (title, accordianState)=>(0,analytics/* addDataLayerForConfigurationExapandState */.i3)(title, accordianState, productInfo)
                })
            }) : null,
            !isBrandOrTransact ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDetailView_InstallReqItems, {
                ...props,
                reqItemsError: reqItemsError
            }) : null,
            isRegionSoldOnline && specialOrder === "Yes" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "product-detail-page__discontinued-txt product-detail-page__order-messaging",
                children: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.specialOrder
            }),
            ProductPriceSpiderIncluded_s && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "product-detail-page__price-spider-section",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "product-detail-page__price_spider_title",
                        children: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.priceSpiderTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "ps-widget",
                        "ps-sku": sku
                    })
                ]
            }),
            promoTitle && !ProductPriceSpiderIncluded_s && isRegionSoldOnline && !isDiscontinued && !isProjectPack && (backOrder === "Yes" || productOnStock > 0) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "product-detail-page__promo-section",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* default */.Z, {
                    isOpen: false,
                    title: promoTitle,
                    handleOpen: ()=>setShowPromo(true),
                    handleClose: ()=>setShowPromo(false),
                    isArrow: true,
                    children: showPromo && promoDescription && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "product-detail-page__promo-desc",
                        children: (0,helper.sanitizeInnerHtml)(promoDescription)
                    })
                })
            }),
            !disableEcommerce && !ProductPriceSpiderIncluded_s && isRegionSoldOnline && !isDiscontinued && !isProjectPack && productOnStock > 0 && (isEqual_default()(freightPolicyType, overSizedType) || !isEmpty_default()(excludedState)) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "row no-gutters product-detail-page__oversized-msg-section",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "col-12 oversized-msg-tooltip",
                    children: [
                        isEqual_default()(freightPolicyType, overSizedType) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: "oversized-msg-primary-txt",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    className: "oversized-msg-info-icon",
                                    src: tooltip_info.src,
                                    alt: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.toolTip
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    children: [
                                        (0,helper.sanitizeInnerHtml)(staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.primaryTxt),
                                        " ",
                                        (0,helper.sanitizeInnerHtml)(staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.secondaryTxt)
                                    ]
                                })
                            ]
                        }),
                        !isEmpty_default()(excludedState) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: "oversized-msg-primary-txt",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    className: "oversized-msg-info-icon",
                                    src: tooltip_info.src,
                                    alt: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.toolTip
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: (0,helper.sanitizeInnerHtml)("".concat(staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.shippingTitle, " ").concat(staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.shippingDescription, " ").concat(excludedState, "."))
                                })
                            ]
                        })
                    ]
                })
            }),
            isProjectPack && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "row no-gutters",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-12 product-detail-page__info-mssg",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: (0,helper.sanitizeAndDecodeHtml)(staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.projectPackMssg)
                    })
                })
            }),
            isBrandOrTransact ? /*#__PURE__*/ (0,jsx_runtime.jsx)(v3_CatalogCTA, {
                sku: sku,
                config: config,
                productName: name,
                staticTexts: staticTexts,
                redirectUrl: redirectUrl_s,
                inriverId: productInRiverId_s,
                isDiscontinued: isDiscontinued,
                isSoldOnline: isRegionSoldOnline
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    isRegionSoldOnline && !isDiscontinued && (Boolean(bundleItems.length) || productOnStock > 0) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "row no-gutters",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v3_InstallService, {
                            sku: sku,
                            qty: currentQty,
                            i18n: staticTexts,
                            isError: installError,
                            masterSku: productInRiverId_s,
                            disableCart: setInstallError,
                            setWareHouses: setWareHouses,
                            setAvailableQty: setAvailableQty,
                            installServiceData: installServiceData,
                            setInstallationData: setInstallServiceData,
                            isInstallationAvailable: InstallationAvailable_s,
                            isBundle: Boolean(bundleItems.length),
                            productInfo: productInfo,
                            setInstallProductInfo: setInstallProductInfo,
                            installErrorCallback: installErrorCallback,
                            pinCodeError: pinCodeError,
                            setPinCodeError: setPinCodeError,
                            installationError: installationError,
                            setInstallationError: setInstallationError,
                            error: error,
                            setError: setError,
                            loading: loading,
                            setLoading: setLoading,
                            installReq: installReq,
                            setReqItemsError: setReqItemsError,
                            setPincodeValue: setPincode,
                            setNotifySuccess: setNotifySuccess,
                            setIsOutOfStock: setIsOutOfStock,
                            isOutOfStock: isOutOfStock,
                            setIsEtaLoading: setIsEtaLoading
                        })
                    }) : null,
                    (installServiceData === null || installServiceData === void 0 ? void 0 : installServiceData.isInstallation) && (installServiceData === null || installServiceData === void 0 ? void 0 : installServiceData.name) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(v3_ServiceAvailability, {
                        config: config,
                        i18n: staticTexts,
                        isChecked: isChecked,
                        currencySign: currencySign,
                        setIsChecked: setIsChecked,
                        installationData: installServiceData
                    }) : null,
                    bundleItems.length ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                        className: "bundle-price__wrap",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                className: "bundle-price__item",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "".concat(staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.subTotal, " (").concat(bundleItems.length, " ").concat(staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.items, ")")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        children: [
                                            "MRP",
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                                className: "bundle-price__subtotal ".concat(listPrice > (discountedPrice ? discountedPrice : price) ? "discounted" : ""),
                                                value: listPrice,
                                                displayType: "text",
                                                thousandSeparator: true,
                                                prefix: currencySign,
                                                decimalScale: 2,
                                                fixedDecimalScale: true,
                                                thousandsGroupStyle: "lakh"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            discountedPrice !== price && /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                className: "bundle-price__item",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        children: [
                                            isType === "absolute" ? currencySign + discountPercent : discountPercent + "%",
                                            " ",
                                            staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.discount
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                        value: discountedPrice - price,
                                        displayType: "text",
                                        thousandSeparator: true,
                                        prefix: currencySign,
                                        decimalScale: 2,
                                        fixedDecimalScale: true,
                                        thousandsGroupStyle: "lakh"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                className: "bundle-price__item bundle-price__total",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.total
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                        value: discountedPrice ? discountedPrice : price,
                                        displayType: "text",
                                        thousandSeparator: true,
                                        prefix: currencySign,
                                        decimalScale: 2,
                                        fixedDecimalScale: true,
                                        thousandsGroupStyle: "lakh"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "product-detail-page__price-alltaxes-text-bundle",
                                children: props.staticTexts.inclusiveOfAllTaxes
                            })
                        ]
                    }) : null,
                    !ctLoading && status === "succeeded" && /*#__PURE__*/ (0,jsx_runtime.jsx)(v3_AddToCart, {
                        ref: addCartContainer,
                        setIsOutOfStock: setIsOutOfStock,
                        isOutOfStock: isOutOfStock,
                        notifyContainer: notifyContainer,
                        ...addToCartProps,
                        staticTexts: staticTexts,
                        onQtyChange: onQtyChange,
                        onAddToCart: (cartItemProduct)=>onAddToCart(cartItemProduct),
                        onAdd: ()=>onAddToCompare(),
                        onRemove: ()=>onRemoveFromCompare(),
                        checkCategory: ()=>checkProductCategory(),
                        comparedProductsCount: comparedProductsCount,
                        compareData: compare,
                        sku: sku,
                        isComboSku: isComboSku,
                        productCategory: productCategory,
                        isEnable: isEnable,
                        isParts: isParts,
                        productOnStock: productOnStock,
                        isColorDiscontinued: isColorDiscontinued,
                        isDiscontinued: isDiscontinued,
                        specialOrder: specialOrder,
                        backOrder: backOrder,
                        ProductPriceSpiderIncluded_s: ProductPriceSpiderIncluded_s,
                        showToaster: showToaster,
                        onAvailableColor: ()=>onAvailableColor(),
                        productData: productAnalyticsData,
                        findStoreUrl: findStoreUrl,
                        isFavorite: isFavorite,
                        favItem: favItem,
                        price: price,
                        ctData: ctData,
                        isRegionSoldOnline: isRegionSoldOnline,
                        customerBrandName: customerBrandName,
                        handleNavChange: (navActive)=>handleNavChange(navActive),
                        replaceAddToCart: replaceAddToCart,
                        disableRatings: disableRatings,
                        replaceAddToCartCtaLink: replaceAddToCartCtaLink,
                        replaceAddToCartCtaLabel: replaceAddToCartCtaLabel,
                        linkNewTab: linkNewTab,
                        disableEcommerce: disableEcommerce,
                        fusionQueryId: fusionQueryId,
                        docId: docId,
                        analyticData: productAnalyticsData === null || productAnalyticsData === void 0 ? void 0 : productAnalyticsData.stringProductInfo,
                        isPdpPropsLoaded: isPdpPropsLoaded,
                        installError: installError,
                        masterSku: productInRiverId_s,
                        availableQty: availableQty,
                        installationData: installServiceData,
                        isInstallationAdded: isChecked,
                        isFragile: isFragile,
                        warehouses: warehouses,
                        isBundle: Boolean(bundleItems.length),
                        productInfo: productInfo,
                        installProductInfo: installProductInfo,
                        pinCodeError: pinCodeError,
                        setPinCodeError: setPinCodeError,
                        installationError: installationError,
                        setInstallationError: setInstallationError,
                        error: error,
                        setError: setError,
                        loading: loading,
                        setLoading: setLoading,
                        reqItemsError: !!Object.keys(reqItemsError).length,
                        quantity: quantity,
                        setQuantity: setQuantity,
                        handleBuyNow: handleBuyNow,
                        notifySuccess: notifySuccess,
                        setPincode: setPincode,
                        setNotifySuccess: setNotifySuccess,
                        productAnalyticsData: productAnalyticsData,
                        productInRiverId_s: productInRiverId_s,
                        name: name,
                        desc: desc,
                        notifyClicked: notifyClicked,
                        imagesData: imagesData
                    })
                ]
            }),
            isDiscontinued && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "product-detail-page__discontinued",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                alt: "",
                                src: warning/* default.src */.Z.src
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "product-detail-page__discontinuedText",
                                children: allVariantDiscotinuedProduct ? relatedProductDetails ? staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.alternativeAvailableMsg : staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.itemDiscontinuedMsg : relatedProductDetails ? staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.alternativeOptionAvailableMsg : staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.brandsDiscontinuedMsg
                            })
                        ]
                    }),
                    relatedProductDetails ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "product-detail-page__available-color-section",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            role: "button",
                            className: "product-detail-page__available-option-btn",
                            onClick: seeAvailableOptionClick,
                            flexible: true,
                            label: "See Available Option",
                            size: "large",
                            type: "primary"
                        })
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "saleassist-trigger-parent-div",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: assistance.src,
                        alt: "Phone",
                        className: "saleassist-trigger-image"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "saleassist-trigger-div",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: "Need Assistance?"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: "saleassist-trigger gbh-data-layer",
                                onClick: ()=>triggerSaleAssist(),
                                "data-gbh-data-layer": '{"eventName":"pdp:product details:need assistance","eventAction":"pdp:product details:need assistance","internalLinkName":"need assistance","internalLinkType":"pdp:need assistance","internalLinkZoneName":"pdp:need assistance","clickInternalLinks":"true","eventType":"navigation","internalLinkURL":"n/a","internalLinkPosition":"pdp","eventMsg":"n/a","eventStatus":"n/a"}',
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "Chat now or schedule a meeting"
                                })
                            })
                        ]
                    })
                ]
            }),
            narrativeDescription && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "product-detail-page__narrative-description",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    className: "product-detail-page__narrative-description".concat(descShowMore ? "--show-more" : "--none"),
                    children: [
                        descShowMore ? narrativeDescription.replace(/"/g, " inch").slice(0, allowedDescCount) : narrativeDescription.replace(/"/g, " inch"),
                        descShowMore && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            children: [
                                "...",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: "product-detail-page__narrative-description--show-more-button gbh-data-layer",
                                    onClick: ()=>setDescShowMore(false),
                                    "data-gbh-data-layer": (0,analytics/* getEventInfo */.wQ)(staticTexts.descReadMore.toLowerCase()),
                                    "data-gbh-data-layer-custom": productAnalyticsData === null || productAnalyticsData === void 0 ? void 0 : productAnalyticsData.stringProductInfo,
                                    children: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.descReadMore
                                })
                            ]
                        })
                    ]
                })
            }),
            upSellData.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UpsellServicesMobile/* default */.Z, {
                    upSellData: upSellData,
                    slickRef: slickRef,
                    currency: currencySign
                })
            }),
            discontinuedProduct && isParts && partReplacementSuggestions && /*#__PURE__*/ (0,jsx_runtime.jsx)(v3_MoreFromCollection, {
                pdpJson: pdpJson,
                sku: sku,
                i18n: {
                    title: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.moreCollection,
                    discontinuedTitle: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.moreCollectionDiscontinued,
                    partNumber: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.partNumber,
                    partName: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.partName
                },
                isColorDiscontinued: isColorDiscontinued,
                mboxes: mboxes,
                presetConfigObject: presetConfigObject,
                productType: productType,
                partReplacementSuggestions: partReplacementSuggestions
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductAccordionList/* default */.Z, {
                productData: productData,
                productInfo: productAnalyticsData.stringProductInfo,
                productSku: sku,
                config: config,
                isDiscontinued: isDiscontinued,
                staticTexts: staticTexts,
                accordionList: pdpJson === null || pdpJson === void 0 ? void 0 : pdpJson.accordianLabels,
                installationSupportLinks: pdpJson === null || pdpJson === void 0 ? void 0 : pdpJson.installationSupportLinks,
                installationDataFromProp: installationDataFromProp,
                designServiceDataFromProp: designServiceDataFromProp,
                businessUnitName: businessUnitName,
                ProductPriceSpiderIncluded_s: ProductPriceSpiderIncluded_s,
                discontinuedProductb: discontinuedProductb,
                ProductRequiredAccessoriesGroupsList: ProductRequiredAccessoriesGroupsList,
                superSku: superSku,
                currencySign: currencySign,
                productCategory: productCategory,
                designServiceData: designServiceData,
                productServices: productServices,
                productType: productType,
                getZipCode: getZipCode,
                installationData: installationData,
                persona: persona,
                currencyCode: currencyCode,
                locale: locale,
                width: width,
                replaceAddToCart: replaceAddToCart,
                disableRatings: disableRatings,
                replaceAddToCartCtaLink: replaceAddToCartCtaLink,
                replaceAddToCartCtaLabel: replaceAddToCartCtaLabel,
                linkNewTab: linkNewTab,
                disableEcommerce: disableEcommerce,
                isProjectPack: isProjectPack,
                bundleItems: bundleItems,
                bundleAdditionalFeatures: bundleAdditionalFeatures
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDisplay, {
                pdpJson: pdpJson,
                productServices: productServices,
                installationData: installationData,
                staticTexts: staticTexts,
                currencyCode: currencyCode,
                currencySign: currencySign,
                // brandName={brandName}
                getZipCode: getZipCode,
                // findStores={findStores}
                // colorsData={colorsData}
                // shortendPagePath={shortendPagePath}
                // findStoreDetailsUrl={storeDetailsServletPath}
                productType: productType,
                productInfo: productInfo
            })
        ]
    });
});
ProductDescription.displayName = "ProductDescription";
/* harmony default export */ var ProductDetailView_ProductDescription = (/*#__PURE__*/react.memo(ProductDescription));

// EXTERNAL MODULE: ./components/Shared/ProductSocialShare/v1/ProductSocialShare.jsx
var ProductSocialShare = __webpack_require__(13678);
;// CONCATENATED MODULE: ./components/ProductDetail/v3/ProductDetailView/ProductBreadcrumb.jsx








const ProductBreadcrumb = (param)=>{
    let { staticTexts: { ariaLabel: { breadcrumb ="" , page ="" , print ="" , share =""  } = {} , home ="" , serviceParts ="" , priceFootnoteTitle ="" , priceFootnote ="" , colorFootnoteTitle ="" , colorFootnote =""  } , productCategory ="" , name ="" , config ={} , productAnalyticsData ="" , productData ={} , swatchUrl ="" , imagesData =[] , width =0 , presetConfigObject ={}  } = param;
    const [url, setUrl] = (0,react.useState)("");
    const [plpPagePath, setPlpPagePath] = (0,react.useState)("");
    const [homePagePath, setHomePagePath] = (0,react.useState)("");
    const [plpPaths, setPlpPaths] = (0,react.useState)([]);
    const [serviceLandingPath, setServiceLandingPath] = (0,react.useState)("");
    const [showSocialLink, setShowSocialLink] = (0,react.useState)(false);
    const shareBtn = (0,react.useRef)(null);
    const [localCategory, setLocalCategory] = (0,react.useState)(productCategory || (productData === null || productData === void 0 ? void 0 : productData.ProductLocalCategory_s));
    (0,react.useEffect)(()=>{
        if (!isEmpty_default()(config)) {
            const { general ={} , general: { plpServletPath =""  }  } = config;
            var _homepageUrl;
            (0,helper.getShortenedUrl)((_homepageUrl = general.homepageUrl) !== null && _homepageUrl !== void 0 ? _homepageUrl : "/").then((res)=>setHomePagePath(res ? res : "/"));
            var _plpPagePath;
            (0,helper.getShortenedUrl)((_plpPagePath = general.plpPagePath) !== null && _plpPagePath !== void 0 ? _plpPagePath : "/").then((res)=>setPlpPagePath(res));
            var _servicePartsLandingPath;
            (0,helper.getShortenedUrl)((_servicePartsLandingPath = general.servicePartsLandingPath) !== null && _servicePartsLandingPath !== void 0 ? _servicePartsLandingPath : "/").then((res)=>setServiceLandingPath(res));
            var ref;
            api/* aemAxiosInstance.get */.Gb.get(plpServletPath).then((res)=>{
                var ref1;
                return setPlpPaths((ref = res === null || res === void 0 ? void 0 : (ref1 = res.data) === null || ref1 === void 0 ? void 0 : ref1.pdpURLMapping) !== null && ref !== void 0 ? ref : []);
            });
        }
    }, [
        config
    ]);
    (0,react.useEffect)(()=>{
        setLocalCategory(productCategory || (productData === null || productData === void 0 ? void 0 : productData.ProductLocalCategory_s));
    }, [
        productData,
        productCategory
    ]);
    (0,react.useEffect)(()=>{
        if (plpPaths && productCategory && (plpPagePath || serviceLandingPath)) {
            const path = plpPaths === null || plpPaths === void 0 ? void 0 : plpPaths.find((i)=>i.categories.includes(productCategory));
            let plpUrl;
            if (productCategory) {
                if (path) {
                    if (path.url.includes("bundles")) {
                        plpUrl = "".concat(path.url, "/").concat(productCategory.replace(/ +/g, "-").toLowerCase(), ".html");
                    } else {
                        plpUrl = "".concat(path.url, ".html");
                    }
                } else {
                    var ref;
                    if (path === null || path === void 0 ? void 0 : (ref = path.url) === null || ref === void 0 ? void 0 : ref.include) plpUrl = "".concat(plpPagePath, "/").concat(productCategory.replace(/ +/g, "-").toLowerCase(), ".html");
                }
            } else {
                plpUrl = "".concat(serviceLandingPath, ".html");
            }
            (0,helper.getShortenedUrl)(plpUrl).then((url)=>setUrl(url));
        }
    }, [
        plpPagePath,
        serviceLandingPath,
        productCategory,
        plpPaths
    ]);
    // Hide social share options when user clicks outide the options
    (0,react.useEffect)(()=>{
        window.addEventListener("click", handleClickOutside);
        return ()=>window.removeEventListener("click", handleClickOutside);
    }, []);
    const handleClickOutside = (e)=>{
        const { target  } = e;
        if (!shareBtn.current.contains(target)) {
            setShowSocialLink(false);
        }
    };
    const addAnalytics = function() {
        let internalLinkName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", link = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
        const { adobeDataLayer: { getState  } = {}  } = window;
        const page = getState && getState("page") || {};
        const eventInfo = (0,analytics/* getBreadcrumbEventInfo */.Sg)(internalLinkName, link);
        window.adobeDataLayer.push({
            event: "cmp:click",
            page,
            eventInfo
        });
    };
    const printPDP = ()=>{
        const printNoteLen = document.getElementsByClassName("product-detail-page__print-note").length;
        if (printNoteLen === 0) {
            const printNote = "<div class='product-detail-page__print-note'><div class='container'><div class='row'><div class='col-12'><h6>".concat(priceFootnoteTitle, "</h6><p>").concat(priceFootnote, "</p><h6>").concat(colorFootnoteTitle, "</h6> <p>").concat(colorFootnote, "</p></div></div></div></div>");
            const printNoteDiv = document.createElement("div");
            printNoteDiv.innerHTML = printNote;
            document.body.appendChild(printNoteDiv);
        }
        window.print();
    };
    if (productData) {
        var ref;
        var ref1;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "header-section kf-react-plp-container",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "product-detail-page__breadcrumb",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                        "aria-label": breadcrumb,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
                            role: "list",
                            "data-testid": "bcm-list",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                    role: "listitem",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            "aria-label": "".concat(home, " ").concat(page),
                                            className: "product-detail-page__breadcrumb-link",
                                            onClick: ()=>addAnalytics(home, homePagePath),
                                            href: homePagePath,
                                            children: " ".concat(home)
                                        }),
                                        " / "
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    role: "listitem",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        "aria-label": productCategory ? "".concat(productCategory, " ").concat(page) : "".concat(serviceParts, " ").concat(page),
                                        className: "product-detail-page__breadcrumb-link",
                                        onClick: ()=>addAnalytics("".concat(home, " > ").concat(productCategory), url),
                                        href: url ? url : null,
                                        children: localCategory ? localCategory : serviceParts
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                    role: "listitem",
                                    className: "cursor-disabled",
                                    children: [
                                        " / ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            "aria-label": productCategory ? "".concat(name, " ").concat(page) : "".concat(serviceParts, " ").concat(page),
                                            "aria-current": page,
                                            className: "product-detail-page__breadcrumb-link",
                                            onClick: ()=>addAnalytics("".concat(home, " > ").concat(productCategory, " > ").concat(name), "#"),
                                            href: "#",
                                            children: name
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "product-detail-page__print-share-container",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            role: "list",
                            className: "print-and-share",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    role: "listitem",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                        tabIndex: "0",
                                        className: "gbh-data-layer",
                                        "data-gbh-data-layer": (0,analytics/* getEventInfo */.wQ)("print"),
                                        "data-gbh-data-layer-custom": productAnalyticsData === null || productAnalyticsData === void 0 ? void 0 : productAnalyticsData.stringProductInfo,
                                        "aria-label": print,
                                        onClick: ()=>printPDP(),
                                        children: [
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/icons/print.svg",
                                                alt: "",
                                                role: "presentation",
                                                width: "17",
                                                height: "17"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    role: "listitem",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        tabIndex: "0",
                                        "aria-label": share,
                                        className: "share-button",
                                        ref: shareBtn,
                                        onClick: ()=>setShowSocialLink((prevProp)=>!prevProp),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: "/icons/share.svg",
                                            alt: "",
                                            role: "presentation",
                                            width: "17",
                                            height: "17"
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductSocialShare/* default */.Z, {
                            disableInstagram: true,
                            showModal: showSocialLink,
                            shareBtn: shareBtn,
                            id: "print-and-share",
                            onClose: ()=>{
                                return shareBtn === null || shareBtn === void 0 ? void 0 : shareBtn.current.focus();
                            },
                            asset: {
                                description: (ref1 = productData === null || productData === void 0 ? void 0 : productData.ProductDescriptionProductShort_s) !== null && ref1 !== void 0 ? ref1 : "",
                                url: (0,helper.appendPresetToUrl)(swatchUrl, (ref = imagesData[0]) === null || ref === void 0 ? void 0 : ref.assetId, width, presetConfigObject, true)
                            },
                            analyticData: {
                                eventAction: "pdp:product details:share",
                                eventName: "pdp:product details:share",
                                internalLinkPosition: "pdp",
                                internalLinkType: "pdp:share",
                                internalLinkZoneName: "pdp:product details",
                                custom: productAnalyticsData.stringProductInfo
                            }
                        })
                    ]
                })
            ]
        });
    }
};
/* harmony default export */ var ProductDetailView_ProductBreadcrumb = (ProductBreadcrumb);

// EXTERNAL MODULE: ./node_modules/react-sticky-el/lib/index.js
var react_sticky_el_lib = __webpack_require__(75198);
// EXTERNAL MODULE: ./components/ProductDetail/v3/StickyHeader/index.module.scss
var StickyHeader_index_module = __webpack_require__(2819);
var StickyHeader_index_module_default = /*#__PURE__*/__webpack_require__.n(StickyHeader_index_module);
;// CONCATENATED MODULE: ./components/ProductDetail/v3/StickyHeader/index.jsx












const StickyHeader = (props)=>{
    const { staticTexts: { addToCart ="" , notifyMailCTA ="" , findSimilar ="" , preOrder ="" , specialOrder ="" , availColorCTA =""  } , productStock ="" , backOrder ="" , disableEcommerce ="" , replaceAddToCart =()=>{} , replaceAddToCartCtaLabel ="" , price =0 , onAddToCart =()=>{} , sku ="" , isComboSku ="" , customerBrandName ="" , imgUrl ="" , title ="" , color ="" , currencySign ="" , isDiscontinued ="" , isColorDiscontinued ="" , isRegionSoldOnline ="" , onAvailableColor =()=>{} , handleScroll =()=>{} , replaceAddToCartCtaLink ="" , linkNewTab ="" , description ="" , analyticData ={} , productPriceSpiderIncluded ="" , productInfo ={} , installError , warehouses =[] , setPinCodeError , isOutOfStock , installServiceData , isInstallationAdded , isBundle , pinCodeError , isEtaLoading , isPdpPropsLoaded  } = props;
    const router = (0,next_router.useRouter)();
    const { label , url  } = color;
    const [showBuyBoxArea, setShowBuyBoxArea] = (0,react.useState)(true);
    const itemStatus = get_default()(props, "itemStatus", "available");
    const { cart  } = (0,es/* useSelector */.v9)(cartSlice/* selectCartState */.xw);
    const [loading, setLoading] = (0,react.useState)(false);
    let buttonText = isOutOfStock === "Currently, this product is out of stock for your location" ? notifyMailCTA : addToCart;
    let analyticsAddToCart = '{"eventAction":"pdp:sticky nav:add to cart","eventName":"pdp:sticky nav:add to cart","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"add to cart","internalLinkPosition":"header","internalLinkType":"pdp:add to cart","internalLinkZoneName":"pdp:sticky nav","internalLinkURL":"n/a","clickInternalLinks":"true"}';
    if (itemStatus === "outOfStock" || !(productStock > 0)) {
        buttonText = notifyMailCTA;
        analyticsAddToCart = JSON.stringify({
            clickInternalLinks: "true",
            eventAction: "pdp:sticky nav:notify me",
            eventMsg: "n/a",
            eventName: "pdp:sticky nav:notify me",
            eventStatus: "n/a",
            eventType: "navigation",
            internalLinkName: "notify me",
            internalLinkPosition: "header",
            internalLinkType: "pdp:notify me",
            internalLinkURL: "n/a",
            internalLinkZoneName: "pdp:sticky nav"
        });
        if (props.specialOrder === "Yes" || backOrder === "Yes") {
            buttonText = addToCart;
            analyticsAddToCart = '{"eventAction":"pdp:sticky nav:add to cart","eventName":"pdp:sticky nav:add to cart","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"add to cart","internalLinkPosition":"header","internalLinkType":"pdp:add to cart","internalLinkZoneName":"pdp:sticky nav","internalLinkURL":"n/a","clickInternalLinks":"true"}';
        }
    } else if (itemStatus === "discontinued") {
        buttonText = findSimilar;
        analyticsAddToCart = '{"eventAction":"pdp:find similar items","eventName":"pdp:find similar items","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"find similar items","internalLinkPosition":"pdp","internalLinkType":"pdp:navigation","internalLinkZoneName":"pdp:product details","internalLinkURL":"n/a","clickInternalLinks":"true"}';
    } else if (itemStatus === "preOrder") {
        buttonText = preOrder;
        analyticsAddToCart = '{"eventAction":"pdp:pre order","eventName":"pdp:pre order","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"pre order","internalLinkPosition":"pdp","internalLinkType":"pdp:navigation","internalLinkZoneName":"pdp:product details","internalLinkURL":"n/a","clickInternalLinks":"true"}';
    } else if (itemStatus === "specialOrder") {
        buttonText = specialOrder;
        analyticsAddToCart = '{"eventAction":"pdp:special order","eventName":"pdp:special order","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"special order","internalLinkPosition":"pdp","internalLinkType":"pdp:navigation","internalLinkZoneName":"pdp:product details","internalLinkURL":"n/a","clickInternalLinks":"true"}';
    }
    const analyticsWhereToBuy = disableEcommerce && replaceAddToCart && replaceAddToCartCtaLabel && JSON.stringify({
        clickInternalLinks: "true",
        eventAction: "pdp:sticky nav:".concat(replaceAddToCartCtaLabel),
        eventMsg: "n/a",
        eventName: "pdp:sticky nav:".concat(replaceAddToCartCtaLabel),
        eventStatus: "n/a",
        eventType: "navigation",
        internalLinkName: "".concat(replaceAddToCartCtaLabel),
        internalLinkPosition: "header",
        internalLinkType: "pdp:".concat(replaceAddToCartCtaLabel),
        internalLinkURL: "n/a",
        internalLinkZoneName: "pdp:".concat(replaceAddToCartCtaLabel)
    });
    (0,react.useEffect)(()=>{
        if (productPriceSpiderIncluded) {
            setShowBuyBoxArea(false);
        } else if (!price) {
            setShowBuyBoxArea(false);
        } else {
            setShowBuyBoxArea(true);
        }
    }, [
        productPriceSpiderIncluded,
        price
    ]);
    const onAddToCartCb = ()=>{
        setLoading(false);
    };
    const handleScrollToMsg = ()=>{
        const element = document.querySelector(".pdp-install-service");
        if (element) {
            const offsetPosition = element.offsetTop - 100;
            window.scrollTo({
                top: offsetPosition,
                behavior: "smooth"
            });
        }
    };
    const handleClick = ()=>{
        setLoading(true);
        if (pinCodeError) {
            setPinCodeError(true);
            handleScrollToMsg();
            setLoading(false);
            return;
        }
        if (isEtaLoading || !isPdpPropsLoaded) {
            setLoading(false);
            return;
        }
        if (!pincode) {
            setLoading(false);
            setPinCodeError(true);
            handleScrollToMsg();
            return;
        }
        if (buttonText === notifyMailCTA) {
            window.scroll({
                top: 800,
                left: 0,
                behavior: "smooth"
            });
        } else {
            if (analyticsAddToCart && window.adobeDataLayer) {
                const eventInfo = JSON.parse(analyticsAddToCart);
                const page = window.adobeDataLayer.getState("page");
                const productArray = [
                    productInfo
                ];
                window.adobeDataLayer.push({
                    event: "cmp:click",
                    eventInfo,
                    page,
                    productArray
                });
            }
            (0,utils_cart/* getStock */.K5)(sku).then((stock)=>{
                var ref;
                var ref1;
                const cartItem = (ref1 = (ref = cart.lineItems) === null || ref === void 0 ? void 0 : ref.find((item)=>item.variant.sku === sku)) !== null && ref1 !== void 0 ? ref1 : {};
                var ref2;
                let custom = (ref2 = cartItem === null || cartItem === void 0 ? void 0 : cartItem.custom) !== null && ref2 !== void 0 ? ref2 : {};
                if ((installServiceData === null || installServiceData === void 0 ? void 0 : installServiceData.isInstallation) && isInstallationAdded) {
                    const payload = [
                        {
                            sku: sku,
                            quantity: 1,
                            isBundle: isBundle,
                            brand: customerBrandName === null || customerBrandName === void 0 ? void 0 : customerBrandName.toLowerCase(),
                            isInstallService: true,
                            installServiceName: installServiceData === null || installServiceData === void 0 ? void 0 : installServiceData.sku,
                            installServiceQty: 1,
                            warehouses: warehouses,
                            custom
                        }
                    ];
                    if (!isBundle) {
                        if (Object.keys(cartItem).length === 0) {
                            custom = {
                                fields: {
                                    associatedProduct: sku,
                                    warehouses: warehouses
                                }
                            };
                        }
                        payload.push({
                            sku: installServiceData === null || installServiceData === void 0 ? void 0 : installServiceData.sku,
                            quantity: 1,
                            isBundle: false,
                            brand: customerBrandName === null || customerBrandName === void 0 ? void 0 : customerBrandName.toLowerCase(),
                            warehouses: warehouses,
                            custom
                        });
                    }
                    onAddToCart(payload, onAddToCartCb);
                } else {
                    onAddToCart([
                        {
                            sku: sku,
                            quantity: 1,
                            isBundle: isBundle,
                            backorder: backOrder === "Yes" ? true : false,
                            brand: customerBrandName === null || customerBrandName === void 0 ? void 0 : customerBrandName.toLowerCase(),
                            warehouses: warehouses
                        }
                    ], onAddToCartCb);
                }
            });
        }
    };
    const getCookieValue = (name)=>{
        var ref;
        return ((ref = document.cookie.match("(^|;)\\s*" + name + "\\s*=\\s*([^;]+)")) === null || ref === void 0 ? void 0 : ref.pop()) || "";
    };
    const pincode = getCookieValue("pincode");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (StickyHeader_index_module_default()).pdpStickyHeadWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "pdp-sticky-header container-fluid",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "pdp-sticky-header__details-wrap container-fluid",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "pdp-sticky-header__container kf-react-plp-container",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "pdp-sticky-header__details",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "pdp-sticky-header__brand-name",
                                    children: title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "pdp-sticky-header__description",
                                    children: description
                                })
                            ]
                        }),
                        showBuyBoxArea && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: classnames_default()({
                                "pdp-sticky-header__right": true,
                                "pdp-sticky-header__right--retailers": productPriceSpiderIncluded
                            }),
                            children: [
                                isDiscontinued ? isColorDiscontinued && !disableEcommerce ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    role: "button",
                                    useDefaultClass: true,
                                    label: availColorCTA,
                                    size: "small",
                                    type: "primary",
                                    onClick: ()=>onAvailableColor()
                                }) : null : isRegionSoldOnline && (productStock > 0 || specialOrder === "Yes" || backOrder === "Yes") && !disableEcommerce ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    label: buttonText,
                                    size: "small",
                                    type: "primary",
                                    role: "button",
                                    onClick: handleClick,
                                    loading: loading,
                                    disabled: loading || !price,
                                    customClass: "pdp-sticky-header__button"
                                }) : isRegionSoldOnline && !disableEcommerce ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    role: "button",
                                    className: "".concat(analyticsAddToCart ? "gbh-data-layer" : ""),
                                    "data-gbh-data-layer": "".concat(analyticsAddToCart || null),
                                    "data-gbh-data-layer-custom": analyticData,
                                    label: buttonText,
                                    size: "small",
                                    type: "primary",
                                    disabled: loading || !price,
                                    onClick: handleScroll,
                                    customClass: "pdp-sticky-header__button"
                                }) : null,
                                replaceAddToCart ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    onClick: ()=>{
                                        (0,AddToCart_analytics/* replaceAddToCartDatalayerPush */.ME)(replaceAddToCartCtaLabel, replaceAddToCartCtaLink, analyticData);
                                        router.push(replaceAddToCartCtaLink);
                                    },
                                    useDefaultClass: true,
                                    className: "gbh-data-layer",
                                    "data-gbh-data-layer": analyticsWhereToBuy,
                                    "data-gbh-data-layer-custom": analyticData,
                                    role: "button",
                                    ariaLabel: replaceAddToCartCtaLabel,
                                    label: replaceAddToCartCtaLabel,
                                    size: "small",
                                    type: "primary",
                                    to: replaceAddToCartCtaLink,
                                    target: linkNewTab ? "_blank" : "_self"
                                }) : ""
                            ]
                        })
                    ]
                })
            })
        })
    });
};
StickyHeader.defaultProps = {
    productStock: "",
    backOrder: "",
    disableEcommerce: "",
    replaceAddToCart: "",
    replaceAddToCartCtaLabel: "",
    onAddToCart: "",
    sku: "",
    isComboSku: "",
    customerBrandName: "",
    title: "",
    isDiscontinued: "",
    isColorDiscontinued: "",
    isRegionSoldOnline: "",
    onAvailableColor: "",
    handleScroll: "",
    replaceAddToCartCtaLink: "",
    linkNewTab: "",
    imgUrl: "",
    productSku: "",
    brandName: "",
    description: "",
    currencySign: "",
    price: 0,
    itemStatus: "available",
    color: {
        label: "",
        url: ""
    },
    staticTexts: {
        addToCart: "",
        notifyMailCTA: "",
        findSimilar: "",
        preOrder: "",
        specialOrder: "",
        availColorCTA: ""
    }
};
/* harmony default export */ var v3_StickyHeader = (StickyHeader);

;// CONCATENATED MODULE: ./components/ProductDetail/v3/ProductDetailView/StickyHead.jsx






const StickyHead = (props)=>{
    var ref, ref1;
    const { setSticky , sticky =false , isDiscontinued ="" , stickyHeaderProps ={} , discountedPrice =0 , warehouses =[] , price =0 , staticTexts ={} , onAddToCart , isColorDiscontinued ="" , addToCartProps ={} , productOnStock ="" , sku ="" , customerFacingSKU ="" , isComboSku ="" , handleScroll , onAvailableColor ="" , isRegionSoldOnline ="" , productAnalyticsData ={} , customerBrandName ="" , replaceAddToCart ="" , disableRatings ="" , replaceAddToCartCtaLink ="" , replaceAddToCartCtaLabel ="" , linkNewTab ="" , disableEcommerce ="" , currencySign ="" , swatchUrl ="" , imagesData ={} , presetConfigObject ={} , assetAccountName ="" , productPriceSpiderIncluded ="" , productInfo ={} , installError , setPinCodeError , isBundle =false , isOutOfStock ="" , installServiceData , setInstallServiceData , isChecked , bundleItems ={
        bundleItems
    } , pinCodeError , isEtaLoading =false , isPdpPropsLoaded  } = props;
    const [width] = (0,useWindowResize/* default */.Z)();
    const [isMobile, setIsMobile] = (0,react.useState)(width <= 991);
    (0,react.useEffect)(()=>{
        setIsMobile(width <= 991);
    }, [
        width
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_sticky_el_lib/* default */.ZP, {
        onFixedToggle: ()=>setSticky(!sticky),
        className: "product-detail-page__sticky-wrapper",
        stickyClassName: "sticky sticky-pdp-page",
        children: !isDiscontinued && sticky && isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(v3_StickyHeader, {
            ...stickyHeaderProps,
            currencySign: currencySign,
            price: discountedPrice > 0 ? discountedPrice : price,
            staticTexts: staticTexts,
            warehouses: warehouses,
            imgUrl: (0,utils_0/* getPresetThumbnailUrl */.BB)(swatchUrl, (ref = imagesData[0]) === null || ref === void 0 ? void 0 : ref.assetId, presetConfigObject, assetAccountName, (ref1 = imagesData[0]) === null || ref1 === void 0 ? void 0 : ref1.url),
            onAddToCart: (cartItemProduct, cb)=>onAddToCart(cartItemProduct, cb),
            isDiscontinued: isDiscontinued,
            isColorDiscontinued: isColorDiscontinued,
            specialOrder: addToCartProps.specialOrder,
            backOrder: addToCartProps.backOrder,
            productStock: productOnStock,
            sku: sku,
            customerFacingSKU: customerFacingSKU,
            isComboSku: isComboSku,
            handleScroll: handleScroll,
            onAvailableColor: ()=>onAvailableColor(),
            productPriceSpiderIncluded: productPriceSpiderIncluded,
            isRegionSoldOnline: isRegionSoldOnline,
            analyticData: productAnalyticsData.stringProductInfo,
            customerBrandName: customerBrandName,
            replaceAddToCart: replaceAddToCart,
            disableRatings: disableRatings,
            replaceAddToCartCtaLink: replaceAddToCartCtaLink,
            replaceAddToCartCtaLabel: replaceAddToCartCtaLabel,
            linkNewTab: linkNewTab,
            disableEcommerce: disableEcommerce,
            productInfo: productInfo,
            installError: installError,
            setPinCodeError: setPinCodeError,
            isOutOfStock: isOutOfStock,
            installServiceData: installServiceData,
            setInstallServiceData: setInstallServiceData,
            isInstallationAdded: isChecked,
            isBundle: Boolean(bundleItems.length),
            pinCodeError: pinCodeError,
            isEtaLoading: isEtaLoading,
            isPdpPropsLoaded: isPdpPropsLoaded
        })
    });
};
/* harmony default export */ var ProductDetailView_StickyHead = (StickyHead);

// EXTERNAL MODULE: ./store/features/checkoutSlice.js
var checkoutSlice = __webpack_require__(60475);
;// CONCATENATED MODULE: ./components/ProductDetail/v3/helper.js




const initBuyNow = (atc)=>{
    const { auth ={} , cart ={}  } = store/* store.getState */.h.getState();
    const { user: { sub: email = ""  } = {}  } = auth;
    const { cart: activeCart  } = cart;
    if (email) {
        store/* store.dispatch */.h.dispatch((0,cartSlice/* createCart */.Bk)({
            currency: "INR",
            customerEmail: email
        })).unwrap().then((res)=>{
            window.localStorage.setItem("buy-now-init", true);
            window.localStorage.setItem("buy-now-cart", res.key);
            window.localStorage.setItem("active-cart", activeCart.id);
            window.localStorage.removeItem("regular-checkout");
            atc(setDefaultAddress);
        }).catch((ex)=>console.log(ex));
    }
};
const setDefaultAddress = ()=>{
    store/* store.dispatch */.h.dispatch((0,checkoutSlice/* getProfile */.Ai)()).unwrap().then(async (res)=>{
        try {
            const pincode = await (0,cartHelper/* getPincode */.pf)();
            const { addresses =[] , defaultShippingAddressId =""  } = res;
            let address = addresses.find((item)=>item.postalCode === pincode && item.id === defaultShippingAddressId) || addresses.find((item)=>item.postalCode === pincode);
            if (address) {
                var ref;
                if (!address.phone || address.phone === "") {
                    var ref1, ref2;
                    const customPhone = res === null || res === void 0 ? void 0 : (ref1 = res.custom) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.fields) === null || ref2 === void 0 ? void 0 : ref2.mobile;
                    address = {
                        ...address,
                        phone: customPhone
                    };
                }
                const actions = await (0,cartHelper/* setShippingAddress */.nc)(formatAddress(address));
                actions.push({
                    action: "setBillingAddress",
                    address: (ref = actions[0]) === null || ref === void 0 ? void 0 : ref.address
                });
                actions.push({
                    action: "calculateTax"
                });
                await store/* store.dispatch */.h.dispatch((0,cartSlice/* shipmentUpdate */.NM)({
                    actions
                }));
                redirectOneStepCheckout({
                    addrSet: true
                });
            } else {
                redirectOneStepCheckout({
                    addrSet: false
                });
            }
        } catch (ex) {
            console.log("Error in buy now step", ex);
        }
    });
};
const formatAddress = (addr)=>{
    const address = JSON.parse(JSON.stringify(addr));
    address.custom = {
        fields: {
            label: ""
        },
        type: {
            typeId: "type",
            key: "custom-address"
        }
    };
    delete address.id;
    return address;
};
const redirectOneStepCheckout = (param)=>{
    let { addrSet =true  } = param;
    const formElem = document.createElement("form");
    const modeInputElem = document.createElement("input");
    const addrSetElem = document.createElement("input");
    formElem.method = "POST";
    formElem.action = "/checkout";
    formElem.style.display = "none";
    modeInputElem.type = "hidden";
    modeInputElem.name = "mode";
    modeInputElem.value = "one-step";
    addrSetElem.type = "hidden";
    addrSetElem.name = "addrSet";
    addrSetElem.value = addrSet;
    formElem.appendChild(modeInputElem);
    formElem.appendChild(addrSetElem);
    document.body.appendChild(formElem);
    formElem.submit();
};
function reorderImageData(arr) {
    let orderAttributeName = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "order";
    const newArr = [
        ...arr
    ];
    let elementToMoveIndex = -1;
    let targetOrder = -1;
    for(let i = 0; i < newArr.length; i++){
        if (newArr[i].hasOwnProperty(orderAttributeName)) {
            elementToMoveIndex = i;
            targetOrder = parseInt(newArr[i][orderAttributeName], 10) - 1;
            break;
        }
    }
    if (elementToMoveIndex === -1 || isNaN(targetOrder)) {
        return arr;
    }
    const effectiveNewIndex = Math.max(0, Math.min(targetOrder, newArr.length - 1));
    const [movedElement] = newArr.splice(elementToMoveIndex, 1);
    newArr.splice(effectiveNewIndex, 0, movedElement);
    return newArr;
}

;// CONCATENATED MODULE: ./components/ProductDetail/v3/ProductDetailView/index.jsx
/* eslint-disable camelcase */ 





















const ProductDetailView = (props)=>{
    var ref, ref1, ref2, ref3;
    const { viewLoader =true , config ={} , getReqItemLwData =()=>{} , colorsData =[] , staticTexts ={} , badgesProps ={} , presetConfigObject ={} , discountedPrice ="" , price ="" , productOnStock ="" , sku ="" , customerFacingSKU ="" , isComboSku =false , customerBrandName ="" , disableRatings =false , replaceAddToCartCtaLink ="" , replaceAddToCartCtaLabel ="" , linkNewTab =false , disableEcommerce =false , currencySign ="" , imagesData =[] , onAddToCart =()=>{} , stickyHeaderProps ={} , addToCartProps ={} , onAvailableColor =()=>{} , isRegionSoldOnline =true , replaceAddToCart ="" , assetAccountName ="" , productCategory ="" , name ="" , homePagePath ="" , desc ="" , discountPercent =0 , superSku ="" , selectedColor ="" , businessUnitName ="" , productSaleable ="" , productPartnerBuyNow ="" , productCollectionsName ="" , globalDiscount =0 , cart ={} , ProductPriceSpiderIncluded_s ="" , discontinuedProductb ="" , ProductRequiredAccessoriesGroupsList =[] , loadShowEvent ="" , setProductInfo =()=>{} , clickedProductVariant ="" , removeVariantSelection =()=>{} , requiredItems =[] , addItemsToCart =()=>{} , // discontinuedProduct = false,
    getDiscontinuedProductValue =()=>{} , imageClickCounter =0 , updateImageClickCounter =()=>{} , productData ={} , initialImgAlt ="" , initialImgUrl ="" , pdpJson ={} , waterSenseProduct =[] , isInstock =false , atcLoading =false , ctLoading , handleBuyNow =()=>{} , setPincode =()=>{} , buyNowLoading =false , loadingMessage ="" , isPdpPropsLoaded , upSellData  } = props;
    const dispatch = (0,es/* useDispatch */.I0)();
    const [sticky, setSticky] = (0,react.useState)(true);
    const [priceTooltip, setPriceTooltip] = (0,react.useState)(false);
    const [showPDPInstallModal, setShowPDPInstallModal] = (0,react.useState)(false);
    const [showTooltip, setShowTooltip] = (0,react.useState)(false);
    const [installReq, setInstallReq] = (0,react.useState)([]);
    const [installReqData, setInstallReqData] = (0,react.useState)([]);
    const [reqItemLwData, setReqItemLwData] = (0,react.useState)([]);
    const [currentQuantity, setCurrentQuantity] = (0,react.useState)(1);
    const [priceList, setPriceList] = (0,react.useState)();
    const [subTotal, setSubTotal] = (0,react.useState)();
    const [showStickyHeader, setShowStickyHeader] = (0,react.useState)(true);
    const [isMobileOnly, setIsMobileOnly] = (0,react.useState)(false);
    const [installError, setInstallError] = (0,react.useState)(false);
    const [warehouses, setWareHouses] = (0,react.useState)([]);
    const [pinCodeError, setPinCodeError] = (0,react.useState)(false);
    const [isOutOfStock, setIsOutOfStock] = (0,react.useState)(null);
    const [installServiceData, setInstallServiceData] = (0,react.useState)({});
    const [isChecked, setIsChecked] = (0,react.useState)(false);
    const [bundleItems, setBundleItems] = (0,react.useState)([]);
    const [notifyClicked, setNotifyClicked] = (0,react.useState)(false);
    const addCartContainer = (0,react.useRef)(null);
    const notifyContainer = (0,react.useRef)(null);
    const rightSectionRef = (0,react.useRef)(null);
    const previousSticky = (0,react.useRef)(false);
    const [quantity, setQuantity] = (0,react.useState)(1);
    const [isEtaLoading, setIsEtaLoading] = (0,react.useState)(false);
    const { general , general: { swatchUrl ="" , scene7AccountName =""  } = {} , plpServletPath  } = config || {};
    const isPersonaANY = constants.isANYPersona;
    const badgeTxt = badgesProps.isNewProduct ? badgesProps.exclusiveBadge ? staticTexts.newExclusive : staticTexts.new : badgesProps.exclusiveBadge ? staticTexts.exclusive : badgesProps.badgeVal ? staticTexts.sale : "";
    const [width] = (0,useWindowResize/* default */.Z)();
    (0,react.useEffect)(()=>{
        if (width > 0) {
            setIsMobileOnly(width <= 480);
        }
    }, [
        width
    ]);
    const productAnalyticsData = {
        desc: (0,helper.sanitizeTextForAnalytics)(desc),
        discountPrice: discountedPrice,
        discountPriceState: discountPercent > 0 ? "percentOff|" + discountPercent : "regular price",
        unitPrice: price,
        category: (0,helper.sanitizeTextForAnalytics)(productCategory),
        color: (0,helper.sanitizeTextForAnalytics)(get_default()(colorsData.find((item)=>item.id === sku), "label", "")),
        sku: sku,
        name: (0,helper.sanitizeTextForAnalytics)(name),
        quantity: currentQuantity,
        image: (ref = imagesData[0]) === null || ref === void 0 ? void 0 : ref.url,
        stock: productOnStock,
        availability: isInstock ? "in stock" : "out of stock",
        customerFacingSKU: customerFacingSKU || ((general === null || general === void 0 ? void 0 : general.siteName) ? general.siteName[0] + "-" + sku : ""),
        skuInitials: customerFacingSKU ? customerFacingSKU.split("-")[0] + "-" : (general === null || general === void 0 ? void 0 : general.siteName) ? general.siteName[0] + "-" : "",
        discountName: badgesProps === null || badgesProps === void 0 ? void 0 : badgesProps.badgeVal,
        superSku: superSku,
        selectedColor: (0,helper.sanitizeTextForAnalytics)(selectedColor),
        businessUnitName: (0,helper.sanitizeTextForAnalytics)(businessUnitName),
        productSaleable: productSaleable,
        brandName: general === null || general === void 0 ? void 0 : (ref1 = general.siteName) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase(),
        productPartnerBuyNow: productPartnerBuyNow,
        productCollectionsName: (0,helper.sanitizeTextForAnalytics)(productCollectionsName),
        globalDiscount: globalDiscount || 0
    };
    const { productCouponCode , productCoupondiscount  } = (0,helper.getCurrentSkuCouponDiscounts)({
        cart: cart,
        sku: productAnalyticsData.sku
    });
    const { pdpDesktopImage , pdpMobileImage  } = pdpJson;
    let waterSenseProductVal = false;
    if (waterSenseProduct && waterSenseProduct.length) {
        waterSenseProductVal = waterSenseProduct[0] === "Yes" ? true : false;
    }
    const productInfo = {
        description: productAnalyticsData.desc || "n/a",
        frequency: "n/a",
        globalPromotionPrice: productAnalyticsData.globalDiscount ? Number((productAnalyticsData.unitPrice - productAnalyticsData.globalDiscount).toFixed(2)) : productAnalyticsData.unitPrice,
        isRecommended: false,
        isSendNow: "n/a",
        isSubscription: false,
        priceState: productAnalyticsData.discountPriceState,
        productBasePrice: productAnalyticsData.unitPrice || "n/a",
        productCategory: productAnalyticsData.category || productAnalyticsData.businessUnitName || "n/a",
        productColor: productAnalyticsData.color || "n/a",
        productCoupondiscount: productCoupondiscount,
        productCouponCode: productCouponCode.join("|") || "n/a",
        productID: productAnalyticsData.customerFacingSKU || "n/a",
        productName: productAnalyticsData.name || "n/a",
        productPartnerBuyNow: productAnalyticsData.productPartnerBuyNow,
        productRoom: productAnalyticsData.businessUnitName || productAnalyticsData.category,
        productSalePrice: productAnalyticsData.discountPrice ? productAnalyticsData.discountPrice : productAnalyticsData.unitPrice,
        productSaleable: productAnalyticsData.productSaleable,
        productStatus: productAnalyticsData.stock ? "in stock" : "out of stock",
        productSuperSku: productAnalyticsData.superSku ? true : false,
        productTileName: productAnalyticsData.name || "n/a",
        quantity: productAnalyticsData.quantity || "n/a",
        defaultImageName: productAnalyticsData.image || "n/a",
        ratings: "n/a",
        numberOfReviews: "n/a",
        pdpType: (0,helper.pdpTypeFormat)({
            businessUnitName: businessUnitName,
            ProductPriceSpiderIncluded_s: ProductPriceSpiderIncluded_s,
            discontinuedProductb: discontinuedProductb,
            ProductRequiredAccessoriesGroupsList: ProductRequiredAccessoriesGroupsList,
            superSku: superSku
        }),
        productFindingMethod: "n/a",
        productCollectionsName: productAnalyticsData.productCollectionsName || productAnalyticsData.category || "n/a",
        productBrand: productAnalyticsData.brandName,
        globalOffer: productAnalyticsData.discountName || "n/a",
        globalDiscount: productAnalyticsData.discountPrice ? productAnalyticsData.globalDiscount : 0,
        itemType: (0,helper.getCartItemType)(productAnalyticsData.category, productAnalyticsData.businessUnitName),
        category: productAnalyticsData.category || productAnalyticsData.businessUnitName || "n/a",
        waterSenseProduct: waterSenseProductVal,
        productType: productData["BundleList_ss"] ? "VirtualBundleParent" : "n/a",
        ...!productAnalyticsData.stock && {
            availability: "out_of_stock"
        },
        ...!productAnalyticsData.stock && {
            errorMessage: "This product is currently unavailable. Please check back later."
        },
        pincode: ((ref2 = document.cookie.match("(^|;)\\s*pincode\\s*=\\s*([^;]+)")) === null || ref2 === void 0 ? void 0 : ref2.pop()) || ""
    };
    window.productInfo = JSON.stringify(productInfo);
    window.pageObj.productInfo = productInfo;
    dispatch((0,genericSlice/* setPageObject */.FE)(true));
    disableEcommerce ? productAnalyticsData.stringProductInfo = JSON.stringify({
        productInfo
    }) : productAnalyticsData.stringProductInfo = JSON.stringify({
        page: {
            cart: {
                cartID: cart === null || cart === void 0 ? void 0 : cart.id
            }
        },
        productInfo
    });
    const options = {
        root: null,
        rootMargin: "0px",
        threshold: 1.0
    };
    (0,react.useEffect)(()=>{
        if (installReq.length > 0) {
            (0,productDetailsHelper/* getRequireItems */.yS)(installReq, discountedPrice, price, ()=>setInstallReq(installReq), (subtotal)=>setSubTotal(subtotal), (priceList)=>setPriceList(priceList), (cartItem)=>addItemsToCart(cartItem, false));
        }
    }, [
        sku
    ]);
    let pageLoadAnalyticsTimer;
    const clearPageLoadAnalyticsTimer = ()=>{
        if (pageLoadAnalyticsTimer) {
            clearTimeout(pageLoadAnalyticsTimer);
            pageLoadAnalyticsTimer = undefined;
        }
    };
    const addPageLoadAnalytics = ()=>{
        clearPageLoadAnalyticsTimer();
        if (window.pageObj && loadShowEvent && window.adobeDataLayer.length > 0 && !ctLoading) {
            var ref, ref1, ref2, ref3;
            const page = window.pageObj || {};
            const category = ((ref = window.pageObj) === null || ref === void 0 ? void 0 : ref.category) || {};
            const pageType = ((ref1 = window.pageObj) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.category) === null || ref2 === void 0 ? void 0 : ref2.pageType) || "";
            const siteName = productAnalyticsData.brandName;
            const pageInfo = ((ref3 = window.pageObj) === null || ref3 === void 0 ? void 0 : ref3.pageInfo) || {};
            category["subCategory1"] = pageType + ":" + productAnalyticsData.category;
            category["subCategory2"] = pageType + ":" + productAnalyticsData.category + ":" + productAnalyticsData.customerFacingSKU;
            category["subCategoryID"] = productAnalyticsData.customerFacingSKU;
            category["room"] = (productInfo === null || productInfo === void 0 ? void 0 : productInfo.productRoom) || "";
            if (window.needPdpdata) {
                const { productSubCatergory ="" , skuID =""  } = window.needPdpdata;
                const { pageInfo: { contentType ="pdp"  } = {}  } = page;
                page.category["subCategoryName"] = productSubCatergory;
                page.pageInfo["pageName"] = "".concat(siteName, ":").concat(contentType, ":").concat(productSubCatergory, ":").concat(skuID);
                category["subCategory1"] = pageType + ":" + productSubCatergory;
                category["subCategory2"] = pageType + ":" + productSubCatergory + ":" + productAnalyticsData.customerFacingSKU;
                delete window.needPdpdata;
            }
            pageInfo["defaultImage"] = imagesData.length ? imagesData[0].assetId || imagesData[0].url : "n/a";
            page.category = category;
            if (!(0,helper.isShowAnalyticsEventLoaded)()) {
                page.user = (0,helper.getUserAnalyticsObject)();
                page.productInfo = productInfo;
                if ((!page.user.gId || page.user.gId === "n/a") && (!page.user.commerceToolsID || page.user.commerceToolsID === "n/a")) {
                    page.pageInfo = pageInfo;
                    window.pageObj = page;
                    window.isShowAnalyticsEvent = true;
                } else {
                    window.adobeDataLayer.push({
                        event: "cmp:show",
                        pageInfo,
                        productInfo,
                        page
                    });
                    // delete window.pageObj
                    setProductInfo(productAnalyticsData.stringProductInfo);
                }
            }
        } else {
            pageLoadAnalyticsTimer = setTimeout(()=>addPageLoadAnalytics(), 500);
        }
    };
    (0,react.useEffect)(()=>{
        addPageLoadAnalytics();
        return ()=>{
            setProductInfo(null);
            clearPageLoadAnalyticsTimer();
            delete window.productInfo;
        };
    }, [
        loadShowEvent
    ]);
    (0,react.useEffect)(()=>{
        if (clickedProductVariant) {
            // add a click event as use has selected differenct product color/variant
            removeVariantSelection();
            const { adobeDataLayer: { getState  } = {}  } = window;
            const page = getState && getState("page") || {};
            page.productInfo = productInfo;
            const eventInfo = (0,analytics/* getEventInfo */.wQ)("color selection", true);
            window.adobeDataLayer.push({
                event: "cmp:click",
                page,
                eventInfo,
                productInfo
            });
            setProductInfo(productAnalyticsData.stringProductInfo);
        }
    }, [
        clickedProductVariant
    ]);
    /* PDP required items - Must have order SKU's */ (0,react.useEffect)(()=>{
        const fetchRequiredItems = async ()=>{
            let query = "";
            let lwQuery = "";
            requiredItems.forEach((item, i)=>{
                query = query + '"'.concat(item, '"').concat(i !== requiredItems.length - 1 ? "," : "");
                lwQuery += '"'.concat(item, '" ');
            });
            dispatch((0,pdpSlice/* fetchPdpRequiredItems */.Zp)(query)).unwrap().then((response)=>{
                setInstallReqData(response);
                getReqItemLwData(lwQuery).unwrap().then((lwData)=>setReqItemLwData(lwData !== null && lwData !== void 0 ? lwData : []));
            }).catch((err)=>{
                console.error("Fetching data failed", err);
            });
        };
        if ((requiredItems === null || requiredItems === void 0 ? void 0 : requiredItems.length) > 0) {
            fetchRequiredItems();
        }
    }, [
        requiredItems
    ]);
    (0,react.useEffect)(()=>{
        const observer = new IntersectionObserver((param)=>{
            let [entry] = param;
            setSticky(!entry.isIntersecting);
        });
        if (addCartContainer.current) observer.observe(addCartContainer.current);
        return ()=>{
            if (addCartContainer.current) {
                observer.unobserve(addCartContainer.current);
            }
        };
    }, [
        addCartContainer,
        options
    ]);
    (0,react.useEffect)(()=>{
        const observer = new IntersectionObserver((param)=>{
            let [entry] = param;
            setSticky(!entry.isIntersecting);
        });
        if (notifyContainer.current) observer.observe(notifyContainer.current);
        return ()=>{
            if (notifyContainer.current) {
                observer.unobserve(notifyContainer.current);
            }
        };
    }, [
        notifyContainer,
        options
    ]);
    const onModalClose = ()=>{
        setShowPDPInstallModal(false);
        (0,helper.preventBodyScroll)(false);
    };
    const onInstallCTA = ()=>{
        setShowPDPInstallModal(true);
        (0,helper.preventBodyScroll)(true);
    };
    const handleInfoToolTipHover = (e)=>{
        e.stopPropagation();
        setShowTooltip(true);
        const { adobeDataLayer: { getState  } = {}  } = window;
        const page = getState && getState("page") || {};
        const eventInfo = {
            clickInternalLinks: "true",
            eventAction: "pdp:product details:info tooltip",
            eventName: "pdp:product details:info tooltip",
            eventType: "navigation",
            internalLinkName: "info tooltip",
            internalLinkPosition: "pdp",
            internalLinkType: "pdp:mouseover",
            internalLinkURL: "n/a",
            internalLinkZoneName: "pdp:product details"
        };
        window.adobeDataLayer.push({
            event: "cmp:click",
            page,
            eventInfo,
            productInfo
        });
    };
    const handleRemove = (i)=>{
        const priceListItems = [];
        let requiredItemsPrice = 0;
        let priceLists = 0;
        let baseTotal = 0;
        let subTotalItem = 0;
        let curValue = installReq;
        curValue = installReq.filter((f)=>f.skuid !== i.skuid);
        setInstallReq(curValue);
        const cartItemProduct = [];
        if (curValue.length > 0) {
            curValue && curValue.map((currentItem)=>{
                const product = {};
                product.sku = currentItem.skuid;
                const checkQuantity = get_default()(currentItem.colorsData.find((requiredItem)=>requiredItem.id === currentItem.skuid), "isOutOfStock", false);
                product.quantity = !checkQuantity ? 1 : 0;
                if (!checkQuantity) {
                    cartItemProduct.push(product);
                }
                if (currentItem === null || currentItem === void 0 ? void 0 : currentItem.priceData) {
                    priceLists = get_default()(currentItem.priceData.find((requiredList)=>requiredList.id === currentItem.skuid), "discountedPrice", 0) > 0 ? get_default()(currentItem.priceData.find((requiredList)=>requiredList.id === currentItem.skuid), "discountedPrice", 0) : get_default()(currentItem.priceData.find((requiredList)=>requiredList.id === currentItem.skuid), "price", 0);
                    priceListItems.push(priceLists);
                    if (priceListItems.length >= 0) {
                        requiredItemsPrice = priceListItems.reduce((acc, currentItem)=>{
                            return parseFloat(acc) + parseFloat(currentItem);
                        }, 0);
                    } else {
                        requiredItemsPrice = priceListItems[0];
                    }
                    baseTotal = discountedPrice > 0 ? discountedPrice : price;
                    subTotalItem = baseTotal + requiredItemsPrice;
                    setSubTotal(subTotalItem);
                    setPriceList(requiredItemsPrice);
                }
            });
            addItemsToCart(cartItemProduct, false);
        } else {
            addItemsToCart([], false);
        }
    };
    const comparedProductsCount = Number(get_default()(props, "comparedProductsCount", 0));
    const discontinuedColor = get_default()(colorsData.find((item)=>item.id === sku), "discontinuedColor", "");
    let isDiscontinued = false;
    let isColorDiscontinued = false;
    if (discontinuedColor) {
        isDiscontinued = true;
        isColorDiscontinued = true;
        getDiscontinuedProductValue(discontinuedColor);
    }
    const handleNavChange = function(navActive) {
        let addToDatalayer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        if ((navActive === 4 || addToDatalayer) && window.adobeDataLayer) {
            // adding a click even on Write a review button Requirement#47
            const eventInfo = (0,analytics/* getEventInfo */.wQ)("write a review", true);
            const { adobeDataLayer: { getState  } = {}  } = window;
            const page = getState && getState("page") || {};
            window.adobeDataLayer.push({
                event: "cmp:click",
                eventInfo,
                page,
                productInfo
            });
            (0,helper.closeModalAnalytics)(productAnalyticsData.stringProductInfo);
        }
    };
    const handleQuantityChange = (qty)=>{
        if (qty) {
            setCurrentQuantity(qty);
        }
    };
    const handleScroll = ()=>{
        const element = document.querySelector(".out-of-stock-description");
        if (element) {
            const offsetPosition = element.getBoundingClientRect().top - 150;
            window.scrollTo({
                top: offsetPosition,
                behavior: "smooth"
            });
            setNotifyClicked(true);
        }
    };
    const handleSetPriceTooltip = (type, needsToSetState, tooltipContent)=>{
        if (needsToSetState) setPriceTooltip(true);
        if (!window.isHoverLoaded) {
            window.isHoverLoaded = true;
            setTimeout(()=>{
                const { adobeDataLayer: { getState  } = {}  } = window;
                const page = getState && getState("page") || {};
                const eventInfo = (0,analytics/* getEventInfo */.wQ)(type, true, tooltipContent);
                window.adobeDataLayer.push({
                    event: "cmp:click",
                    eventInfo,
                    page,
                    productInfo
                });
                delete window.isHoverLoaded;
            }, 1400);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageLoader/* default */.Z, {
                loading: atcLoading || buyNowLoading,
                loadingMessage: loadingMessage
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDetailView_StickyHead, {
                setSticky: setSticky,
                sticky: sticky,
                isDiscontinued: isDiscontinued,
                warehouses: warehouses,
                showStickyHeader: showStickyHeader,
                stickyHeaderProps: stickyHeaderProps,
                discountedPrice: discountedPrice,
                price: price,
                staticTexts: staticTexts,
                onAddToCart: onAddToCart,
                isColorDiscontinued: isColorDiscontinued,
                addToCartProps: addToCartProps,
                productOnStock: productOnStock,
                sku: sku,
                customerFacingSKU: customerFacingSKU,
                isComboSku: isComboSku,
                isBundle: Boolean(productData === null || productData === void 0 ? void 0 : (ref3 = productData.bundleItems) === null || ref3 === void 0 ? void 0 : ref3.length),
                handleScroll: handleScroll,
                onAvailableColor: onAvailableColor,
                isRegionSoldOnline: isRegionSoldOnline,
                productAnalyticsData: productAnalyticsData,
                customerBrandName: customerBrandName,
                replaceAddToCart: replaceAddToCart,
                disableRatings: disableRatings,
                replaceAddToCartCtaLink: replaceAddToCartCtaLink,
                replaceAddToCartCtaLabel: replaceAddToCartCtaLabel,
                linkNewTab: linkNewTab,
                disableEcommerce: disableEcommerce,
                currencySign: currencySign,
                swatchUrl: swatchUrl,
                imagesData: imagesData,
                presetConfigObject: presetConfigObject,
                assetAccountName: assetAccountName,
                productPriceSpiderIncluded: ProductPriceSpiderIncluded_s,
                productInfo: productInfo,
                installError: installError,
                pinCodeError: pinCodeError,
                setPinCodeError: setPinCodeError,
                isOutOfStock: isOutOfStock,
                installServiceData: installServiceData,
                setInstallServiceData: setInstallServiceData,
                isChecked: isChecked,
                bundleItems: bundleItems,
                isEtaLoading: isEtaLoading,
                isPdpPropsLoaded: isPdpPropsLoaded
            }),
            viewLoader ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ProgressiveLoader_PdpProgressiveLoader, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (productDetailsView_module_default()).productDetailsV3Wrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "product-detail-page",
                    role: "main",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "container",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDetailView_ProductBreadcrumb, {
                                staticTexts: staticTexts,
                                productCategory: productCategory,
                                name: name,
                                homePagePath: homePagePath,
                                plpServletPath: plpServletPath,
                                config: config,
                                productAnalyticsData: productAnalyticsData,
                                productData: productData,
                                swatchUrl: swatchUrl,
                                imagesData: imagesData,
                                width: width,
                                presetConfigObject: presetConfigObject
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "product-overview print-overview",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "product-detail-page__image-gallery print-overview-left",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "product-detail-page__left-sticky",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v2_ImageGallery, {
                                                data: reorderImageData(imagesData),
                                                imageClickCounter: imageClickCounter,
                                                updateImageClickCounter: updateImageClickCounter,
                                                productInfo: productAnalyticsData.stringProductInfo,
                                                page: "pdp",
                                                staticTexts: staticTexts,
                                                presetConfigObject: presetConfigObject,
                                                swatchUrl: swatchUrl,
                                                assetAccountName: scene7AccountName !== null && scene7AccountName !== void 0 ? scene7AccountName : "PAWEB",
                                                initialImgAlt: initialImgAlt,
                                                initialImgUrl: initialImgUrl,
                                                pdpDesktopImage: pdpDesktopImage,
                                                pdpMobileImage: pdpMobileImage
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "product-detail-page__content-section print-overview-right",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDetailView_ProductDescription, {
                                            ...props,
                                            ref: {
                                                rightSectionRef,
                                                addCartContainer,
                                                notifyContainer
                                            },
                                            badgeTxt: badgeTxt,
                                            isDiscontinued: isDiscontinued,
                                            isPersonaANY: isPersonaANY,
                                            productInfo: productInfo,
                                            priceTooltip: priceTooltip,
                                            handleSetPriceTooltip: handleSetPriceTooltip,
                                            setPriceTooltip: (value)=>setPriceTooltip(value),
                                            installReq: installReq,
                                            productAnalyticsData: productAnalyticsData,
                                            onInstallCTA: onInstallCTA,
                                            toolTipIcon: tooltip,
                                            handleInfoToolTipHover: handleInfoToolTipHover,
                                            setShowTooltip: (value)=>setShowTooltip(value),
                                            showTooltip: showTooltip,
                                            isMobileOnly: isMobileOnly,
                                            handleRemove: handleRemove,
                                            priceList: priceList,
                                            subTotal: subTotal,
                                            getRequireItems: (items)=>(0,productDetailsHelper/* getRequireItems */.yS)(items, discountedPrice, price, ()=>setInstallReq(items), (subtotal)=>setSubTotal(subtotal), (priceList)=>setPriceList(priceList), (cartItem)=>addItemsToCart(cartItem, false)),
                                            installReqData: installReqData,
                                            reqItemLwData: reqItemLwData,
                                            onModalClose: onModalClose,
                                            showPDPInstallModal: showPDPInstallModal,
                                            handleQuantityChange: handleQuantityChange,
                                            comparedProductsCount: comparedProductsCount,
                                            isColorDiscontinued: isColorDiscontinued,
                                            warehouses: warehouses,
                                            setWareHouses: setWareHouses,
                                            handleNavChange: (navActive)=>handleNavChange(navActive),
                                            installErrorCallback: (error)=>{
                                                setInstallError(error);
                                            },
                                            pinCodeError: pinCodeError,
                                            setPinCodeError: setPinCodeError,
                                            installServiceData: installServiceData,
                                            setInstallServiceData: setInstallServiceData,
                                            isChecked: isChecked,
                                            setIsChecked: setIsChecked,
                                            bundleItems: bundleItems,
                                            setBundleItems: setBundleItems,
                                            quantity: quantity,
                                            setQuantity: setQuantity,
                                            handleBuyNow: handleBuyNow,
                                            setPincode: setPincode,
                                            setIsOutOfStock: setIsOutOfStock,
                                            isOutOfStock: isOutOfStock,
                                            notifyClicked: notifyClicked,
                                            setIsEtaLoading: setIsEtaLoading,
                                            upSellData: upSellData,
                                            discontinuedProduct: discontinuedColor,
                                            productCategory: productCategory
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var v3_ProductDetailView = (ProductDetailView);

// EXTERNAL MODULE: ./components/ProductDetail/v3/PDPLoader/index.jsx
var PDPLoader = __webpack_require__(2535);
// EXTERNAL MODULE: ./utils/constants.js
var utils_constants = __webpack_require__(11310);
// EXTERNAL MODULE: ./components/Shared/UpsellInstallServices/api.js
var UpsellInstallServices_api = __webpack_require__(9670);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
// EXTERNAL MODULE: ./utils/findStore.js
var findStore = __webpack_require__(42605);
// EXTERNAL MODULE: ./components/Shared/UpsellInstallServices/analytics/index.js
var UpsellInstallServices_analytics = __webpack_require__(59192);
;// CONCATENATED MODULE: ./components/ProductDetail/v3/ProductDetail.jsx



























//import { cartPrerender } from "@/utils/prerender"











const ProductDetail = (param)=>{
    let { data: authorData = {} , pdpData ={} , slug ="" , skuId ="" , initialImgAlt ="" , initialImgUrl =""  } = param;
    const [width] = (0,useWindowResize/* default */.Z)();
    const dispatch = (0,es/* useDispatch */.I0)();
    const router = (0,next_router.useRouter)();
    const { t  } = (0,esm/* useTranslation */.$G)("pdp");
    const { stateListPath  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const { access_token: accessToken  } = (0,es/* useSelector */.v9)(authSlice/* selectAuthState */._9);
    const { cart , cart: { id: cartLoaded = ""  } = {}  } = (0,es/* useSelector */.v9)(cartSlice/* selectCartState */.xw);
    const { comparedProducts , category: productCategory , isEnable  } = (0,es/* useSelector */.v9)(compareSlice/* compareState */.NP);
    const { ProductBrandName_s: pdpBrnadName = "" , productName_s: productNameInit = "" , ProductLocalCategory_s ="" , category1_s: productRoom = ""  } = pdpData;
    const isParts = false;
    const productName = isParts ? productNameInit : pdpBrnadName;
    const blankState = {
        isProductVariantClicked: false,
        clickedProductVariant: false,
        selectedSku: "",
        customerFacingSKU: "",
        productDetailData: pdpData ? pdpData : {},
        docId: "",
        fusionQueryId: "",
        masterSku: "",
        options: {},
        facetLabels: [],
        currOptions: {},
        selectMoreTooltipData: {},
        reqCartData: [],
        ctData: {},
        persona: "",
        toaster: {
            show: false,
            message: "",
            mobileOnly: false
        },
        reverseGeo: "",
        jsonFileUrl: "",
        zipCodeData: [],
        installationData: [],
        designServiceData: [],
        servicesData: {},
        installationDataFromProp: [],
        designServiceDataFromProp: [],
        availableStock: 1,
        promoTitle: null,
        promoDescription: false,
        enablePromo: false,
        viewLoader: true,
        ctLoading: true,
        findInstallerPath: "",
        loadShowEvent: false,
        installerArea: "",
        statesData: [],
        mboxes: [],
        imageClickCounter: 1,
        variantData: []
    };
    const compare = (0,es/* useSelector */.v9)(compareSlice/* compareState */.NP);
    const { favorites  } = (0,es/* useSelector */.v9)(favoritesSlice/* selectFavoritesState */.Qx);
    const [config, setConfig] = (0,react.useState)({});
    const [state, setState] = (0,react.useState)(blankState);
    const [reviews, setReviews] = (0,react.useState)(null);
    const [brandName, setBrandName] = (0,react.useState)("");
    const [locale, setLocale] = (0,react.useState)("");
    const [currencySign, setCurrencySign] = (0,react.useState)("");
    const [currencyCode, setCurrencyCode] = (0,react.useState)("");
    const [cartUrl, setCartUrl] = (0,react.useState)("");
    const [findProPagePath, setFindProPagePath] = (0,react.useState)("");
    const [findStoreUrl, setFindStoreUrl] = (0,react.useState)("");
    const [badgeText, setBadgeText] = (0,react.useState)({});
    const [superSku, setSuperSku] = (0,react.useState)("");
    const [category, setCategory] = (0,react.useState)(ProductLocalCategory_s);
    const [brandNameDisplay, setBrandNameDisplay] = (0,react.useState)("");
    const [collapseBrandNameDisplay, setCollapseBrandNameDisplay] = (0,react.useState)(null);
    const [availableColorFirstSku, setAvailableColorFirstSku] = (0,react.useState)("");
    const [productServices, setProductServices] = (0,react.useState)("");
    const [name, setName] = (0,react.useState)(productName);
    const [pdprops, setPdprops] = (0,react.useState)({});
    const [comboSku, setComboSku] = (0,react.useState)([]);
    const [isFragile, setIsFragile] = (0,react.useState)(false);
    const [general, setGeneral] = (0,react.useState)(null);
    const [imagesData, setImagesData] = (0,react.useState)([]);
    const [videoIds, setVideoIds] = (0,react.useState)([]);
    const [pricesData, setPricesData] = (0,react.useState)([]);
    const [listPrices, setListPrices] = (0,react.useState)([]);
    const [discountedPrices, setDiscountedPrices] = (0,react.useState)([]);
    const [discountPercent, setDiscountPercent] = (0,react.useState)([]);
    const [isType, setIsType] = (0,react.useState)([]);
    const overSizedType = "4";
    const [badgesProps, setBadgesProps] = (0,react.useState)([]);
    const [excludedStates, setExcludedStates] = (0,react.useState)([]);
    const [presetConfigObject, setPresetConfigObject] = (0,react.useState)({});
    const [partReplacementSuggestions, setPartReplacementSuggestions] = (0,react.useState)([]);
    const [assetAccountName, setAssetAccountName] = (0,react.useState)("");
    const [homePagePath, setHomePagePath] = (0,react.useState)("/");
    const [replaceAddToCartCtaLink, setReplaceAddToCartCtaLink] = (0,react.useState)("");
    const [isPdpPropsLoaded, setIsPdpPropsLoaded] = (0,react.useState)(false);
    const [atcLoading, setAtcLoading] = (0,react.useState)(false);
    const [upSellData, setUpSellData] = (0,react.useState)([]);
    const [inventoryUpdate, setInventoryUpdate] = (0,react.useState)(0);
    const [showModal, setShowModal] = (0,react.useState)(false);
    const [ToasterMssg, setToasterMessage] = (0,react.useState)("");
    const stopATCLoading = new Event("stop-loading-atc");
    const [isMobile, setIsMobile] = (0,react.useState)(width < 992);
    const [pincode, setPincode] = (0,react.useState)(null);
    const [buyNowLoading, setBuyNowLoading] = (0,react.useState)(false);
    const [loadingMessage, setLoadingMessage] = (0,react.useState)("");
    (0,react.useEffect)(()=>{
        setIsMobile(width < 992);
        if (width < 992) setShowModal(false);
    }, [
        width
    ]);
    const staticTexts = (0,usePdpi18n/* default */.Z)(authorData, badgeText, name);
    const getRecommendationsArray = async ()=>{
        const recommendations = await (0,UpsellInstallServices_api/* getProductBySkus */.Ss)([
            state.selectedSku
        ], "sku_s,CrossSellRecommendationSKUList_ss");
        const listOfRequiredSkus = recommendations.filter((item)=>item.CrossSellRecommendationSKUList_ss).map((item)=>({
                parentSku: item.sku_s,
                requiredSkus: item.CrossSellRecommendationSKUList_ss
            }));
        const requiredSkus = listOfRequiredSkus.map((item)=>item.requiredSkus).flat(1);
        var ref;
        // Executing second API...
        const { data ={}  } = (ref = await (0,UpsellInstallServices_api/* getProductDataFromSkuIds */.fh)(state.persona, requiredSkus)) !== null && ref !== void 0 ? ref : {};
        const skuidString = requiredSkus.join(",");
        if (!isEmpty_default()(data) && skuidString) {
            const { response: { docs: requiredSkusProductData = []  } = {}  } = data;
            if (requiredSkusProductData.length) {
                const item = listOfRequiredSkus[0];
                const requiredItemsProductData = requiredSkusProductData.filter((productItem)=>{
                    var ref;
                    return (ref = item.requiredSkus) === null || ref === void 0 ? void 0 : ref.includes(productItem.sku_s);
                });
                setUpSellData(requiredItemsProductData);
            }
        }
    };
    (0,react.useEffect)(()=>{
        (0,constants_config/* getConfig */.i)().then(async (res)=>{
            setConfig(res);
        });
    }, []);
    (0,react.useEffect)(()=>{
        let pdpPropsLoadedTimer;
        if (!isEmpty_default()(pdprops)) {
            pdpPropsLoadedTimer = setTimeout(()=>{
                setIsPdpPropsLoaded(true);
            }, 1000);
        }
        return ()=>{
            if (pdpPropsLoadedTimer) {
                clearTimeout(pdpPropsLoadedTimer);
            }
        };
    }, [
        pdprops
    ]);
    (0,react.useEffect)(()=>{
        getServiceData();
        setSuperSku("");
        setBrandNameDisplay("");
        setCollapseBrandNameDisplay(null);
        setAvailableColorFirstSku("");
        setProductServices("");
        setComboSku([]);
        setImagesData([]);
        setVideoIds([]);
        setPricesData([]);
        setListPrices([]);
        setDiscountedPrices([]);
        setDiscountPercent([]);
        setIsType([]);
        setBadgesProps([]);
        setExcludedStates([]);
        setPartReplacementSuggestions([]);
    }, [
        slug
    ]);
    (0,react.useEffect)(()=>{
        if (accessToken) {
            const persona = (0,helper.getUserPersona)();
            setState((prevState)=>{
                return {
                    ...prevState,
                    persona: persona
                };
            });
        }
    }, [
        accessToken,
        slug
    ]);
    (0,react.useEffect)(()=>{
        if (!stateListPath) {
            dispatch((0,genericSlice/* getGenericListPath */.Ln)());
        } else {
            dispatch((0,genericSlice/* getstateList */.lK)()).unwrap().then((res)=>setState((prevState)=>{
                    return {
                        ...prevState,
                        statesData: res
                    };
                }));
        }
    }, [
        stateListPath
    ]);
    (0,react.useEffect)(()=>{
        const url = new URL(window.location.href);
        if (skuId && !url.searchParams.get("skuNumber")) {
            setState((prevState)=>{
                return {
                    ...prevState,
                    selectedSku: skuId
                };
            });
        }
    }, [
        skuId
    ]);
    (0,react.useEffect)(()=>{
        if (state.selectedSku != "") getRecommendationsArray();
    }, [
        state.selectedSku
    ]);
    (0,react.useEffect)(()=>{
        if (!isEmpty_default()(config)) {
            var ref, ref1;
            setGeneral(config === null || config === void 0 ? void 0 : config.general);
            var ref2;
            setBrandName((ref2 = (ref = config.general) === null || ref === void 0 ? void 0 : ref.siteName) !== null && ref2 !== void 0 ? ref2 : "");
            setLocale(get_default()(config, "internationalization.locale", ""));
            setCurrencySign(get_default()(config, "internationalization.currencySign", ""));
            setCurrencyCode(get_default()(config, "internationalization.currencyCode", ""));
            setCartUrl((0,helper.getShortenedUrlwithGeneral)(config.general.cartLandingPagePath, config.general));
            setFindProPagePath((0,helper.getShortenedUrlwithGeneral)(get_default()(config, "general.findProPagePath", "/"), config === null || config === void 0 ? void 0 : config.general));
            setFindStoreUrl((0,helper.getShortenedUrlwithGeneral)(get_default()(get_default()(config, "general.findStorePagePath", ""), config === null || config === void 0 ? void 0 : config.general)));
            var ref3;
            setHomePagePath((0,helper.getShortenedUrlwithGeneral)((ref3 = config === null || config === void 0 ? void 0 : (ref1 = config.general) === null || ref1 === void 0 ? void 0 : ref1.homepageUrl) !== null && ref3 !== void 0 ? ref3 : "/", config === null || config === void 0 ? void 0 : config.general));
            setBadgeText({
                new: get_default()(config, "general.newBadgeName", ""),
                onSale: get_default()(config, "general.saleBadgeName", ""),
                exclusive: get_default()(config, "general.exclusiveBadgeName", ""),
                discontinued: get_default()(config, "general.discontinuedBadgeName", "")
            });
            setState((prevState)=>{
                return {
                    ...prevState,
                    reverseGeo: get_default()(config, "apiEndpoints.reverseGeo", "")
                };
            });
            setAssetAccountName(get_default()(config, "general.scene7AccountName", "PAWEB"));
        }
    }, [
        config
    ]);
    (0,react.useEffect)(()=>{
        if (!isEmpty_default()(authorData) && !isEmpty_default()(general)) {
            setReplaceAddToCartCtaLink((0,helper.getShortenedUrlwithGeneral)(authorData === null || authorData === void 0 ? void 0 : authorData.replaceAddToCartCtaLink, general));
            const { presetConfigs ="{}"  } = authorData !== null && authorData !== void 0 ? authorData : {
                presetConfigs: "{}"
            };
            const presetConfigObject = JSON.parse(presetConfigs);
            setPresetConfigObject(presetConfigObject);
        }
    }, [
        authorData,
        general
    ]);
    (0,react.useEffect)(()=>{
        if (brandName && accessToken) {
            try {
                const payload = {
                    slug,
                    isParts,
                    brandName,
                    selectedSku: state.selectedSku,
                    setSkuVariantCb: (initSku)=>setSkuVariant(initSku)
                };
                // Get product data from LucidWorks
                dispatch((0,pdpSlice/* searchPdp */.zF)(payload)).unwrap().then((res)=>{
                    if (res) {
                        const { productData ={} , sku ="" , fusionQueryId ="" , customerFacingSKU =""  } = res;
                        // set product category
                        setCategory(get_default()(productData, "Product_Category", "Service Parts"));
                        setProductServices(get_default()(productData, "ProductServices_ss", ""));
                        // get product options
                        if (productData["ProductIsRetail"] !== "true" && productData["ProductBrandNameDisplay_s"] && productData["Product_Category"]) {
                            setSuperSku(productData["Super_Sku"]);
                            var ref;
                            setBrandNameDisplay((ref = productData["ProductBrandNameDisplay_s"]) !== null && ref !== void 0 ? ref : "");
                            // adding new filter in get options.
                            if (productData["Collapse_Field_s"]) {
                                setCollapseBrandNameDisplay(productData["Collapse_Field_s"]);
                            } else {
                                setCollapseBrandNameDisplay(null);
                            }
                        }
                        setState((prevState)=>{
                            return {
                                ...prevState,
                                productDetailData: productData,
                                selectedSku: sku,
                                customerFacingSKU: customerFacingSKU,
                                masterSku: get_default()(productData, "masterSKU_s", ""),
                                fusionQueryId: fusionQueryId
                            };
                        });
                        window.addEventListener("popstate", ()=>{
                            fetchSkuFromUrl();
                        });
                        setState((prevState)=>{
                            return {
                                ...prevState,
                                viewLoader: false
                            };
                        });
                    } else {
                        console.error("Error occured while fetching product data");
                    }
                });
            } catch (error) {
                console.error(error);
            }
            if (authorData) {
                const { promoConfigTitle ="" , promoConfigDesc ="" , enablePromo ="" , installServices =[] , designServices =[] , findAnInstaller , installerArea , mboxIdList =[]  } = authorData;
                setState((prevState)=>{
                    var ref;
                    var ref1;
                    return {
                        ...prevState,
                        promoTitle: promoConfigTitle,
                        promoDescription: promoConfigDesc,
                        enablePromo,
                        installationDataFromProp: installServices,
                        designServiceDataFromProp: designServices,
                        jsonFileUrl: (ref1 = (ref = installServices[0]) === null || ref === void 0 ? void 0 : ref.jsonPath) !== null && ref1 !== void 0 ? ref1 : "",
                        findInstallerPath: findAnInstaller,
                        installerArea,
                        mboxes: mboxIdList
                    };
                });
            } else {
                // Get product data from CommerceTools
                const payload1 = {
                    slug
                };
                dispatch((0,pdpSlice/* getProductBySlug */.Co)(payload1)).unwrap().then((product)=>{
                    if (product.id) setState((prevState)=>{
                        return {
                            ...prevState,
                            ctData: product
                        };
                    });
                });
            }
        }
    }, [
        brandName,
        accessToken,
        slug
    ]);
    (0,react.useEffect)(()=>{
        if (pdpData) {
            setState((prevState)=>{
                return {
                    ...prevState,
                    productDetailData: pdpData,
                    viewLoader: false
                };
            });
        }
    }, [
        pdpData
    ]);
    (0,react.useEffect)(()=>{
        if (state.promoTitle !== null) {
            getServiceData();
            (0,productDetailsHelper/* getZipCodeJsonFile */.O1)(state.jsonFileUrl, (data)=>{
                const { zipcode =[]  } = data;
                setState((prevState)=>{
                    return {
                        ...prevState,
                        zipCodeData: zipcode
                    };
                });
            });
        }
    }, [
        state.promoTitle
    ]);
    (0,react.useEffect)(()=>{
        const { productDetailData  } = state;
        const name = isParts ? get_default()(productDetailData, "productName_s", "") : get_default()(productDetailData, "ProductBrandName_s", "");
        setName(name);
    }, [
        state.productDetailData
    ]);
    (0,react.useEffect)(()=>{
        if (!isEmpty_default()(state.productDetailData)) {
            var ref, ref1;
            let imagesData = [];
            let videoIds = [];
            const pricesData = [];
            const listPrices = [];
            let colorsData = [];
            let variants = [];
            let colors = [];
            const comboSku = [];
            const discountedPrices = [];
            const discountPercent = [];
            let requiredItemstoInstall = [];
            const availableColors = [];
            const disContinuedColors = [];
            const customerSkus = [];
            const isType = [];
            const partReplacementSuggestions = [];
            // get list of variants
            if (state.productDetailData["variantList.sku_s"]) {
                variants = [
                    state.productDetailData["variantList.sku_s"]
                ];
            } else if (state.productDetailData["variantList.sku_ss"]) {
                variants = state.productDetailData["variantList.sku_ss"];
            }
            // get list of variant colors
            if (state.productDetailData["Color.SKU.Details_ss"]) {
                colors = state.productDetailData["Color.SKU.Details_ss"].map((color)=>{
                    const d = color.split("|");
                    return {
                        name: d[0],
                        swatch: d[1],
                        sku: d[2],
                        isStock: d[3],
                        discontinued: !(d[4] === "false" || Date.parse(d[4]) > Date.now()),
                        customerSku: d[5]
                    };
                });
            } else if (state.productDetailData["Color.SKU.Details_s"]) {
                const d = state.productDetailData["Color.SKU.Details_s"].split("|");
                colors = [
                    {
                        name: d[0],
                        swatch: d[1],
                        sku: d[2],
                        isStock: d[3],
                        discontinued: !(d[4] === "false" || Date.parse(d[4]) > Date.now()),
                        customerSku: d[5]
                    }
                ];
            } else if (state.productDetailData["SKU.Details_ss"]) {
                colors = state.productDetailData["SKU.Details_ss"].map((color)=>{
                    const d = color.split("|");
                    return {
                        name: staticTexts.notApplicable,
                        swatch: constants.SWATCH_NA,
                        sku: d[0],
                        isStock: d[1],
                        discontinued: !(d[2] === "false" || Date.parse(d[2]) > Date.now()),
                        customerSku: d[3]
                    };
                });
            }
            // get required items to install
            if (state.productDetailData["RequiredAccessoryGroupProduct_ss"]) {
                requiredItemstoInstall = state.productDetailData["RequiredAccessoryGroupProduct_ss"];
            }
            // get Youtube Url's
            // if (
            //   state.productDetailData[
            //     "ProductResource.YouTubeInstallVideo.resourceName_ss"
            //   ]
            // ) {
            //   videoIds = state.productDetailData[
            //     "ProductResource.YouTubeInstallVideo.resourceName_ss"
            //   ].map(v => ({ type: "video", url: v }))
            //   setVideoIds(videoIds)
            // }
            // get video with position
            if (state.productDetailData["productVideos.labelWithUrl_ss"]) {
                let videoIds1 = state.productDetailData["productVideos.labelWithUrl_ss"].map((v)=>{
                    return {
                        type: "video",
                        url: v === null || v === void 0 ? void 0 : v.split("|")[0],
                        order: v === null || v === void 0 ? void 0 : v.split("|")[3]
                    };
                });
                setVideoIds((prevState)=>[
                        ...prevState,
                        ...videoIds1
                    ]);
            }
            if (cart.lineItems && cart.lineItems.length > 0) {
                cart.lineItems.filter((item)=>item.productSlug["en-US"] === slug).map((product)=>{
                    if (product.discountedPrice) {
                        var ref, ref1, ref2, ref3, ref4;
                        discountedPrices[product.variant.sku] = Number((product.discountedPrice.value.centAmount / 100).toFixed(2));
                        setDiscountedPrices(discountedPrices);
                        let percentOff;
                        if (((ref1 = product === null || product === void 0 ? void 0 : (ref = product.discountedPrice) === null || ref === void 0 ? void 0 : ref.includedDiscounts[0]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.discount) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.obj) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.value) === null || ref4 === void 0 ? void 0 : ref4.type) === "absolute") {
                            percentOff = get_default()(product.discountedPrice, "includedDiscounts[0].discount.obj.value.money[0].centAmount", 0);
                            isType[product.variant.sku] = "absolute";
                            setIsType(isType);
                        } else {
                            percentOff = get_default()(product.discountedPrice, "includedDiscounts[0].discount.obj.value.permyriad", 0);
                            isType[product.variant.sku] = "relative";
                            setIsType(isType);
                        }
                        discountPercent[product.variant.sku] = percentOff > 0 ? Number(percentOff / 100) : 0;
                        setDiscountPercent(discountPercent);
                    }
                });
            }
            // get data related to each color variant
            colors.forEach((color)=>{
                const colorObj = {
                    id: color.sku,
                    name: "product-color",
                    value: color.sku,
                    label: color.name,
                    notApplicable: colors.length > 1 ? false : color.swatch.toLowerCase() === constants.SWATCH_NA.toLowerCase(),
                    colorUrl: constants["default"].COLOR_FILE_URL + color.swatch,
                    checked: color.sku === state.selectedSku ? true : false,
                    discontinuedColor: color.discontinued
                };
                color.discontinued ? disContinuedColors.push(colorObj) : availableColors.push(colorObj);
                customerSkus[color.sku] = color.customerSku;
            });
            const isDisContinuedColor = (ref = colors.find((color)=>color.sku === state.selectedSku)) === null || ref === void 0 ? void 0 : ref.discontinued;
            colorsData = [
                ...disContinuedColors,
                ...availableColors
            ];
            var _id;
            if (availableColors && availableColors[0]) setAvailableColorFirstSku((_id = availableColors[0].id) !== null && _id !== void 0 ? _id : "");
            const variantImages = state.productDetailData["productImages.labelWithUrl_s"] ? [
                state.productDetailData["productImages.labelWithUrl_s"]
            ] : state.productDetailData["productImages.labelWithUrl_ss"];
            let variantImageLabels = [];
            let variantImageURLs = [];
            if (state.selectedSku) {
                if (variantImages === null || variantImages === void 0 ? void 0 : variantImages.length) {
                    const selVarImageUrls = [];
                    const selVarImageLabels = [];
                    variantImages.map((img)=>{
                        const imgDetail = img.split("|");
                        if (state.selectedSku === imgDetail[0]) {
                            var ref;
                            selVarImageLabels.push((ref = imgDetail[4]) !== null && ref !== void 0 ? ref : "");
                            selVarImageUrls.push(imgDetail[imgDetail.length - 1] ? imgDetail[imgDetail.length - 1] : image_missing/* default */.Z === null || image_missing/* default */.Z === void 0 ? void 0 : image_missing/* default.src */.Z.src);
                        } else if (!variants.find((v)=>v === imgDetail[0])) {
                            var ref1;
                            variantImageLabels.push((ref1 = imgDetail[4]) !== null && ref1 !== void 0 ? ref1 : "");
                            variantImageURLs.push(imgDetail[imgDetail.length - 1] ? imgDetail[imgDetail.length - 1] : image_missing/* default */.Z === null || image_missing/* default */.Z === void 0 ? void 0 : image_missing/* default.src */.Z.src);
                        }
                    });
                    variantImageLabels = [
                        ...selVarImageLabels,
                        ...variantImageLabels
                    ];
                    variantImageURLs = [
                        ...selVarImageUrls,
                        ...variantImageURLs
                    ];
                    if (variantImageURLs.length < 1) {
                        variantImageLabels.push(state.selectedSku);
                        variantImageURLs.push(image_missing/* default */.Z === null || image_missing/* default */.Z === void 0 ? void 0 : image_missing/* default.src */.Z.src);
                    }
                } else {
                    variantImageLabels.push(state.selectedSku);
                    variantImageURLs.push(image_missing/* default */.Z === null || image_missing/* default */.Z === void 0 ? void 0 : image_missing/* default.src */.Z.src);
                }
            }
            imagesData = formatImages(variantImageLabels, variantImageURLs);
            setImagesData(imagesData);
            for (const element of variants){
                const variantSku = element;
                if (state.ctData.masterVariant) {
                    var ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
                    let product = {};
                    if (variantSku === state.ctData.masterVariant.sku) product = state.ctData.masterVariant;
                    else product = state.ctData.variants.find((variant)=>variantSku === variant.sku);
                    // Get variant prices from CT data
                    let priceObj = product === null || product === void 0 ? void 0 : (ref2 = product.prices) === null || ref2 === void 0 ? void 0 : ref2.find((price)=>{
                        var ref, ref1, ref2;
                        return ((ref = price.value) === null || ref === void 0 ? void 0 : ref.currencyCode) === currencyCode && ((ref1 = price.customerGroup) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.obj) === null || ref2 === void 0 ? void 0 : ref2.key) === state.persona;
                    });
                    let mrpObj = product === null || product === void 0 ? void 0 : (ref3 = product.prices) === null || ref3 === void 0 ? void 0 : ref3.find((price)=>{
                        var ref;
                        return ((ref = price.value) === null || ref === void 0 ? void 0 : ref.currencyCode) === currencyCode && !price.customerGroup;
                    });
                    if (!(priceObj === null || priceObj === void 0 ? void 0 : priceObj.value)) priceObj = product === null || product === void 0 ? void 0 : (ref4 = product.prices) === null || ref4 === void 0 ? void 0 : ref4.find((price)=>{
                        var ref;
                        return ((ref = price.value) === null || ref === void 0 ? void 0 : ref.currencyCode) === currencyCode && !price.customerGroup;
                    });
                    var ref10;
                    pricesData[variantSku] = Number((((ref10 = mrpObj === null || mrpObj === void 0 ? void 0 : (ref5 = mrpObj.value) === null || ref5 === void 0 ? void 0 : ref5.centAmount) !== null && ref10 !== void 0 ? ref10 : 0) / 100).toFixed(2));
                    setPricesData(pricesData);
                    if (discountedPrices[variantSku] === 0 || !discountedPrices[variantSku]) {
                        var ref11, ref12, ref13, ref14;
                        var ref15;
                        discountedPrices[variantSku] = Number((((ref15 = priceObj === null || priceObj === void 0 ? void 0 : (ref11 = priceObj.value) === null || ref11 === void 0 ? void 0 : ref11.centAmount) !== null && ref15 !== void 0 ? ref15 : 0) / 100).toFixed(2));
                        // Pricing Change
                        // discountedPrices[variantSku] = Number(
                        //   ((priceObj?.discounted?.value?.centAmount ?? 0) / 100).toFixed(2)
                        // )
                        setDiscountedPrices(discountedPrices);
                        if ((priceObj === null || priceObj === void 0 ? void 0 : (ref12 = priceObj.discounted) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.discount) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.obj) === null || ref14 === void 0 ? void 0 : ref14.value.type) === "absolute") {
                            var ref16, ref17, ref18, ref19, ref20;
                            var ref21;
                            discountPercent[variantSku] = Number(((ref21 = (ref20 = priceObj === null || priceObj === void 0 ? void 0 : (ref16 = priceObj.discounted) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.discount) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.obj) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.value) === null || ref19 === void 0 ? void 0 : ref19.money[0]) === null || ref20 === void 0 ? void 0 : ref20.centAmount) !== null && ref21 !== void 0 ? ref21 : 0) / 100);
                            setDiscountPercent(discountPercent);
                            isType[variantSku] = "absolute";
                            setIsType(isType);
                        } else {
                            var ref22;
                            let salePrice = 0;
                            if (priceObj === null || priceObj === void 0 ? void 0 : (ref22 = priceObj.discounted) === null || ref22 === void 0 ? void 0 : ref22.value) {
                                salePrice = Number(priceObj === null || priceObj === void 0 ? void 0 : priceObj.discounted.value.centAmount);
                            } else {
                                salePrice = Number(priceObj === null || priceObj === void 0 ? void 0 : priceObj.value.centAmount);
                            }
                            discountPercent[variantSku] = Number((Number(mrpObj === null || mrpObj === void 0 ? void 0 : mrpObj.value.centAmount) - salePrice) / Number(mrpObj === null || mrpObj === void 0 ? void 0 : mrpObj.value.centAmount) * 100).toFixed();
                            setDiscountPercent(discountPercent);
                            isType[variantSku] = "relative";
                            setIsType(isType);
                        }
                    }
                    const listPrice = product === null || product === void 0 ? void 0 : (ref6 = product.prices) === null || ref6 === void 0 ? void 0 : ref6.find((price)=>{
                        var ref, ref1, ref2;
                        return ((ref = price.value) === null || ref === void 0 ? void 0 : ref.currencyCode) === currencyCode && !(price === null || price === void 0 ? void 0 : (ref1 = price.customerGroup) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.obj) === null || ref2 === void 0 ? void 0 : ref2.key);
                    });
                    var ref23;
                    listPrices[variantSku] = Number((((ref23 = listPrice === null || listPrice === void 0 ? void 0 : (ref7 = listPrice.value) === null || ref7 === void 0 ? void 0 : ref7.centAmount) !== null && ref23 !== void 0 ? ref23 : 0) / 100).toFixed(2));
                    setListPrices(listPrices);
                    // Check if variant is a Combo SKU
                    comboSku[variantSku] = (product === null || product === void 0 ? void 0 : product.attributes.find((attr)=>attr.name === "ComboSKU")) ? true : false;
                    setComboSku(comboSku);
                    // check if product is fragile
                    const fragile = ((ref9 = product === null || product === void 0 ? void 0 : (ref8 = product.attributes) === null || ref8 === void 0 ? void 0 : ref8.filter((attr)=>{
                        var ref;
                        return (ref = Object.values(attr)) === null || ref === void 0 ? void 0 : ref.includes("Fragile");
                    })) === null || ref9 === void 0 ? void 0 : ref9.length) !== 0;
                    setIsFragile(fragile);
                    // Check if Service Part have replacement suggestion
                    if (authorData.ctRecommendations) {
                        if (0 in authorData.ctRecommendations) {
                            partReplacementSuggestions[variantSku] = get_default()(product === null || product === void 0 ? void 0 : product.attributes.find((attr)=>attr.name === authorData.ctRecommendations[0].fieldname), "value", "");
                            setPartReplacementSuggestions(partReplacementSuggestions);
                        }
                    }
                }
            }
            const selectedColor = get_default()(colorsData.find((item)=>item.id === state.selectedSku), "label", "");
            var ref24;
            const pdprops = {
                sku: state.selectedSku,
                customerFacingSKU: customerSkus[state.selectedSku],
                name: isParts ? get_default()(state.productDetailData, "productName_s", "") : get_default()(state.productDetailData, "ProductBrandName_s", get_default()(state.productDetailData, "productName_s", "")),
                desc: get_default()(state.productDetailData, "ProductDescriptionProductShort_s", get_default()(state.productDetailData, "title_s", "")),
                narrativeDescription: get_default()(state.productDetailData, "ProductNarrativeDescription_s", ""),
                customerBrandName: get_default()(state.productDetailData, "CustomerFacingBrand_s", ""),
                currencySign: currencySign,
                allVariantDiscotinuedProduct: get_default()(state.productDetailData, "productRegionAllVariantDiscontinued_b", false),
                ProductRequiredAccessoriesGroupsList: get_default()(state.productDetailData, "ProductProductRecommendedAccessories_ss", []),
                stickyHeaderProps: {
                    productSku: state.selectedSku,
                    title: isParts ? get_default()(state.productDetailData, "productName_s", "") : get_default()(state.productDetailData, "ProductBrandName_s", get_default()(state.productDetailData, "productName_s", "")),
                    description: get_default()(state.productDetailData, "ProductDescriptionProductShort_s", ""),
                    itemStatus: "available",
                    color: {
                        label: selectedColor,
                        url: get_default()(colorsData.find((item)=>item.id === state.selectedSku), "colorUrl", "")
                    }
                },
                requiredItems: requiredItemstoInstall !== null && requiredItemstoInstall !== void 0 ? requiredItemstoInstall : [],
                productOnStock: state.availableStock,
                colorsData: colorsData,
                addToCartProps: {
                    compareChecked: Boolean(comparedProducts.find((prod)=>state.masterSku === prod["masterSKU_s"])),
                    backOrder: get_default()(state.productDetailData, "RegionOnBackOrder_s", "No"),
                    specialOrder: get_default()(state.variantData.find((item)=>item.sku_s === state.selectedSku), "RegionSpecialOrder_s", "No")
                },
                detailsProps: {
                    length: get_default()(state.productDetailData, "ProductOverallLengthInches_s", 0),
                    width: get_default()(state.productDetailData, "ProductOverallWidthInches_s", 0),
                    height: get_default()(state.productDetailData, "ProductOverallHeightInches_s", 0),
                    dimensionUnit: "in",
                    detailsData: get_default()(state.productDetailData, "ProductWebFeatures_ss", [])
                },
                ProductPriceSpiderIncluded_s: ((ref1 = state.productDetailData) === null || ref1 === void 0 ? void 0 : ref1.ProductPriceSpiderIncluded_s) === "true" ? true : false,
                isProjectPack: state.productDetailData["SKUIsProjectPack_s"] === "Yes",
                freightPolicyType: get_default()(state.productDetailData, "ProductFreightPolicyType_s", ""),
                isFavorite: !isEmpty_default()(favorites) && (favorites === null || favorites === void 0 ? void 0 : favorites.lineItems.find((vl)=>vl.productId === state.ctData.id)) ? true : false,
                favItem: (ref24 = favorites === null || favorites === void 0 ? void 0 : favorites.lineItems) !== null && ref24 !== void 0 ? ref24 : [],
                ctData: state.ctData.id,
                isFragile: isFragile,
                isRegionSoldOnline: get_default()(state.productDetailData, "RegionSoldOnline_b", true),
                superSku: superSku,
                loadShowEvent: cartLoaded || state.loadShowEvent,
                cart: cart,
                clickedProductVariant: state.clickedProductVariant,
                selectedColor: selectedColor,
                globalDiscount: Number((pricesData[state.selectedSku] - get_default()(state.productDetailData, "priceList.".concat(state.persona, ".finalPrice_d"), pricesData[state.selectedSku])).toFixed(2)),
                productSaleable: true,
                productPartnerBuyNow: false,
                productType: get_default()(state.productDetailData, "ctProductType_s", ""),
                ...state.productDetailData
            };
            if (pdprops.ProductPriceSpiderIncluded_s || isDisContinuedColor || pdprops.isRegionSoldOnline) {
                if (pdprops.ProductPriceSpiderIncluded_s) {
                    pdprops.productPartnerBuyNow = true;
                }
                pdprops.productSaleable = false;
            }
            setPdprops(pdprops);
            const excludedStates = get_default()(state.variantData.find((item)=>item.sku_s === state.selectedSku), "RegionStatesExcluded_ss", []);
            setExcludedStates(excludedStates);
            // Get badge values for product
            const shipmentDate = get_default()(state.productDetailData, "RegionReleaseforShipment_dt", "");
            const badgesProps = {
                isNewProduct: (0,helper.showNewBadge)(shipmentDate),
                badgeVal: get_default()(state.productDetailData, "priceList.".concat(state.persona, ".saleOffer_s"), ""),
                exclusiveBadge: get_default()(state.productDetailData, "ProductIsExclusive_s", "")
            };
            setBadgesProps(badgesProps);
            const { presetConfigs ="{}"  } = authorData !== null && authorData !== void 0 ? authorData : {
                presetConfigs: "{}"
            };
            const presetConfigObject = JSON.parse(presetConfigs);
            setPresetConfigObject(presetConfigObject);
        }
    }, [
        state.productDetailData,
        state.selectedSku,
        state.persona,
        state.variantData,
        state.ctData,
        state.loadShowEvent,
        state.clickedProductVariant,
        state.availableStock,
        state.persona,
        favorites
    ]);
    (0,react.useEffect)(()=>{
        if (state.selectedSku) {
            const sku = state.selectedSku;
            getAvailableStock(sku);
            dispatch((0,pdpSlice/* setPDP */.qK)({
                sku
            }));
        }
    }, [
        state.selectedSku
    ]);
    const updateImageClickCounter = ()=>{
        const { imageClickCounter  } = state;
        setState((prevState)=>{
            return {
                ...prevState,
                imageClickCounter: imageClickCounter + 1
            };
        });
    };
    const setSkuVariant = (sku)=>{
        sku && setState((prevState)=>{
            return {
                ...prevState,
                selectedSku: sku,
                isProductVariantClicked: true,
                clickedProductVariant: false
            };
        });
        const url = new URL(window.location.href);
        const searchParams = url.searchParams;
        const skuNumber = searchParams.get("skuNumber");
        skuNumber ? searchParams.set("skuNumber", sku) : searchParams.set("skuId", sku);
        const query = "?" + searchParams.toString();
        window.history.replaceState(window.location.pathname, document.title, query);
        dispatch((0,pdpSlice/* setPDP */.qK)({
            sku
        }));
    };
    const formatImages = (labels, urls)=>{
        const images = [];
        if (authorData) {
            for(let i = 0; i < urls.length; i++){
                var ref;
                const urlPaths = (ref = urls[i].split("?")[0]) === null || ref === void 0 ? void 0 : ref.split("/");
                const assetId = urlPaths[urlPaths.length - 1];
                var _i, _i1;
                images.push({
                    label: (_i = labels[i]) !== null && _i !== void 0 ? _i : "",
                    assetId,
                    url: (_i1 = urls[i]) !== null && _i1 !== void 0 ? _i1 : ""
                });
            }
        }
        return images;
    };
    const addRequiredItems = (list)=>{
        setState((prevState)=>{
            return {
                ...prevState,
                reqCartData: list
            };
        });
    };
    const addToCart = async function(items) {
        let cb = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ()=>{}, showPreview = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
        var ref;
        let totalAdded = 0;
        let products = [
            ...items,
            ...(0,utils/* attachWarehouseData */.F2)((ref = state.reqCartData) === null || ref === void 0 ? void 0 : ref.map((p)=>({
                    ...p,
                    section: utils_constants/* productSections.MUST_ORDER */.Oy.MUST_ORDER
                })), items[0])
        ];
        products.forEach((item)=>{
            if (item.isBundle && item.isInstallService) {
                return totalAdded += item.quantity * 2;
            }
            return totalAdded += item.quantity;
        });
        const itemCountMessage = totalAdded === 1 ? "".concat(totalAdded, " ").concat(t("kf.pdp.label.itemAdded"), " ") : "".concat(totalAdded, " ").concat(t("kf.pdp.label.itemsAdded"), " ");
        const ToasterMssg = "<a href=".concat(cartUrl, ">").concat(itemCountMessage, " ").concat(t("kf.pdp.label.yourCart"), "</a>");
        const callbackFun = (data)=>{
            const { res: { lineItems =[]  } = {}  } = data;
            if (lineItems.length > 0) {
                if (!isEmpty_default()(authorData)) {
                    const { hapticFeedbackTimer =0  } = authorData;
                    window.navigator.vibrate(Number(hapticFeedbackTimer));
                }
            }
            if (isMobile && showPreview) {
                dispatch((0,genericSlice/* showToast */.CF)({
                    message: ToasterMssg,
                    isVisible: true
                }));
            }
            if (!showPreview) {
                setLoadingMessage("Redirecting to checkout page...");
            }
            cb();
        };
        (0,utils/* addToCart */.Xq)(products, showPreview, "", (obj)=>{
            setAtcLoading(false);
            callbackFun(obj);
            document.dispatchEvent(stopATCLoading);
        }).catch((err)=>{
            console.log(err);
        }).finally(()=>{
            //cartPrerender()
            setAtcLoading(false);
        });
    };
    const showToaster = (mssg)=>{
        dispatch((0,genericSlice/* showToast */.CF)({
            message: mssg,
            isVisible: true
        }));
        setTimeout(()=>dispatch((0,genericSlice/* showToast */.CF)({
                message: mssg,
                isVisible: false
            })), 3000);
    };
    const fetchSkuFromUrl = ()=>{
        setState((prevState)=>{
            return {
                ...prevState,
                selectedSku: skuId ? skuId : state.selectedSku
            };
        });
    };
    (0,react.useEffect)(()=>{
        if ((collapseBrandNameDisplay || brandNameDisplay) && category && brandName && state.productDetailData && state.productDetailData["ProductPriceSpiderIncluded_s"] !== "true" && state.productDetailData["Product_Category"] && state.productDetailData["isCollapsedPDP_b"]) {
        // Options selector can be enabled in future if any product has the required data
        // getOptions()
        }
    }, [
        collapseBrandNameDisplay,
        brandNameDisplay,
        category,
        brandName,
        state.productDetailData
    ]);
    // Get list of available options to be shown under Select More Options
    const getOptions = async ()=>{
        var ref;
        const { data  } = await api/* apim.get */.TH.get("/search/plp", {
            params: {
                fl: "Super_Sku",
                q: "*:*",
                fq: [
                    "".concat(collapseBrandNameDisplay ? "Collapse_Field_s" : "ProductBrandNameDisplay_s", ':("').concat(collapseBrandNameDisplay !== null && collapseBrandNameDisplay !== void 0 ? collapseBrandNameDisplay : brandNameDisplay, '")'),
                    'ProductLocalCategory_s:("'.concat(category, '")'),
                    '-(productRegionAllVariantDiscontinued_b:("true") OR RegionDiscontinuedDate_dt:[* TO NOW])',
                    '-ProductIsRetail:("true")',
                    '-ATTR_SPEC_TankLocks_s:("Yes")',
                    '-SKUIsProjectPack_s:"Yes"'
                ],
                profilename: "profile_".concat(brandName.toLowerCase(), "_PDP"),
                collections: brandName.toLowerCase()
            },
            paramsSerializer: (params)=>{
                return lib_default().stringify(params, {
                    arrayFormat: "repeat",
                    encode: false
                });
            }
        });
        const curOptions = {};
        if (data === null || data === void 0 ? void 0 : (ref = data.facet_counts) === null || ref === void 0 ? void 0 : ref.facet_fields) {
            var ref1;
            var _facet_fields;
            const facets = (_facet_fields = data.facet_counts.facet_fields) !== null && _facet_fields !== void 0 ? _facet_fields : {};
            // This request is required to fetch current product options
            const { data: { response: { docs: optionsData  }  }  } = await api/* apim.post */.TH.post("search/pdp/".concat(slug), {
                q: "*:*",
                fl: Object.keys((ref1 = data.fusion) === null || ref1 === void 0 ? void 0 : ref1.facet_labels).map((key)=>key).join(","),
                collections: isParts ? "service_parts" : brandName === null || brandName === void 0 ? void 0 : brandName.toLowerCase(),
                profilename: isParts ? "profile_service_parts_PDP" : "profile_".concat(brandName.toLowerCase(), "_PDP"),
                search_type: "product_options"
            });
            delete facets["New_Products"];
            delete facets["Available_Now"];
            delete facets["Product_Family"];
            delete facets["Product_Category"];
            delete facets["Color"];
            delete facets["Finish"];
            delete facets["Color.Finish"];
            Object.entries(facets).map((facet)=>{
                if (facet[1].length <= 2) {
                    delete facets[facet[0]];
                }
            });
            Object.entries(facets).map((facet)=>{
                if (optionsData[0][facet[0]]) {
                    var ref;
                    curOptions[facet[0]] = (ref = optionsData[0][facet[0]]) !== null && ref !== void 0 ? ref : "";
                }
            });
            setState((prevState)=>{
                var ref;
                var ref1;
                return {
                    ...prevState,
                    options: facets,
                    currOptions: curOptions,
                    facetLabels: (ref1 = (ref = data.fusion) === null || ref === void 0 ? void 0 : ref.facet_labels) !== null && ref1 !== void 0 ? ref1 : []
                };
            });
        }
        const payload = {
            brandName
        };
        dispatch((0,pdpSlice/* getPdpTooltip */.n_)(payload)).unwrap().then((res)=>{
            const tooltipData = res !== null && res !== void 0 ? res : {};
            setState((prevState)=>{
                return {
                    ...prevState,
                    selectMoreTooltipData: tooltipData
                };
            });
        });
    };
    // Search for product variant based on selected option and redirect to that PDP
    const selectOption = async function() {
        let value = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", facet = arguments.length > 1 ? arguments[1] : void 0;
        const { options , currOptions  } = state;
        let slug = "";
        let skuIdMaster = "";
        let bq = "";
        Object.entries(options).map((f)=>{
            if (f[0] !== facet && currOptions[f[0]]) {
                bq = bq + "".concat(f[0], ':"').concat(currOptions[f[0]], '"^50 ');
            }
        });
        if (bq) {
            bq = "(".concat(bq.trim(), ")");
        }
        const { data  } = await api/* apim.get */.TH.get("/search/plp", {
            params: {
                fl: "Super_Sku, slug_s,masterSKU_s",
                q: "*:*",
                fq: [
                    "".concat(collapseBrandNameDisplay ? "Collapse_Field_s" : "ProductBrandNameDisplay_s", ':("').concat(collapseBrandNameDisplay !== null && collapseBrandNameDisplay !== void 0 ? collapseBrandNameDisplay : brandNameDisplay, '")'),
                    "".concat(facet, ':("').concat(value.replace(/"/g, '\\"'), '")'),
                    'ProductLocalCategory_s:("'.concat(category, '")'),
                    '-(productRegionAllVariantDiscontinued_b:("true") OR RegionDiscontinuedDate_dt:[* TO NOW])',
                    '-ProductIsRetail:("true")',
                    '-ATTR_SPEC_TankLocks_s:("Yes")',
                    '-SKUIsProjectPack_s:"Yes"'
                ],
                profilename: "profile_".concat(brandName.toLowerCase(), "_PDP"),
                collections: brandName.toLowerCase(),
                ...bq ? {
                    bq
                } : {}
            },
            paramsSerializer: (params)=>{
                return lib_default().stringify(params, {
                    arrayFormat: "repeat",
                    encode: false
                });
            }
        });
        const groupedSlug = get_default()(data, "grouped.Product_Family.groups[0].doclist.docs[0].slug_s", "");
        slug = groupedSlug ? groupedSlug : get_default()(data, "response.docs[0].slug_s", "");
        skuIdMaster = get_default()(data, "response.docs[0].masterSKU_s", "");
        if (slug) {
            let pdpUrlTmp = await (0,helper.getPDPUrl)(category, slug);
            pdpUrlTmp = pdpUrlTmp + (pdpUrlTmp.indexOf("?") > -1 ? "&" : "?") + "skuId=" + skuIdMaster;
            router.push(pdpUrlTmp);
        }
    };
    const seeAvailableColor = ()=>{
        setSkuVariant(availableColorFirstSku);
        dispatch((0,pdpSlice/* getDiscontinuedProductValue */.B$)(""));
    };
    const getZipCode = (userZipCode, handleZipCodeAvailabilityCallBack)=>{
        checkUserZipCode(userZipCode, handleZipCodeAvailabilityCallBack);
    };
    const getAvailableStock = async (sku)=>{
        try {
            const stock = await (0,utils_cart/* getStock */.K5)(sku);
            setState((prevState)=>{
                return {
                    ...prevState,
                    availableStock: stock
                };
            });
        } catch (err) {
            console.error("Error | getStock | getAvailablesStock | ProductDetails | ", err);
        }
        setState((prevState)=>{
            return {
                ...prevState,
                loadShowEvent: true,
                clickedProductVariant: state.isProductVariantClicked
            };
        });
    };
    const getServiceData = async ()=>{
        let designServiceSkus = [];
        let installationServiceSkus = [];
        if (!isEmpty_default()(state.designServiceDataFromProp)) {
            designServiceSkus = state.designServiceDataFromProp.map((product)=>{
                if (product.sku) {
                    return product.sku;
                }
            });
        }
        if (!isEmpty_default()(state.installationDataFromProp)) {
            installationServiceSkus = state.installationDataFromProp.map((list)=>{
                if (list.sku) {
                    return list.sku;
                }
            });
        }
        if (designServiceSkus.length === 0 && installationServiceSkus.length === 0) {
            setState((prevState)=>({
                    ...prevState,
                    ctLoading: false
                }));
            return;
        }
        const payload = {
            slug,
            skus: [
                ...designServiceSkus,
                ...installationServiceSkus
            ]
        };
        dispatch((0,pdpSlice/* getProductBySlugAndSku */.bF)(payload)).unwrap().then((productServices)=>{
            var ref, ref1, ref2, ref3;
            const installationServices = [
                ...productServices
            ].filter((product)=>{
                var ref;
                return installationServiceSkus.includes(product === null || product === void 0 ? void 0 : (ref = product.masterVariant) === null || ref === void 0 ? void 0 : ref.sku);
            });
            const designServices = [
                ...productServices
            ].filter((product)=>{
                var ref;
                return designServiceSkus.includes(product === null || product === void 0 ? void 0 : (ref = product.masterVariant) === null || ref === void 0 ? void 0 : ref.sku);
            });
            const ctData = [
                ...productServices
            ].filter((product)=>{
                var ref, ref1;
                return !installationServiceSkus.includes(product === null || product === void 0 ? void 0 : (ref = product.masterVariant) === null || ref === void 0 ? void 0 : ref.sku) && !designServiceSkus.includes(product === null || product === void 0 ? void 0 : (ref1 = product.masterVariant) === null || ref1 === void 0 ? void 0 : ref1.sku);
            });
            const productId = ctData === null || ctData === void 0 ? void 0 : (ref = ctData[0]) === null || ref === void 0 ? void 0 : ref.id;
            const productName = ctData === null || ctData === void 0 ? void 0 : (ref1 = ctData[0]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.name) === null || ref2 === void 0 ? void 0 : ref2["en-IN"];
            dispatch((0,pdpSlice/* setProductId */.WT)({
                productId: productId,
                productName: productName
            }));
            if (ctData === null || ctData === void 0 ? void 0 : (ref3 = ctData[0]) === null || ref3 === void 0 ? void 0 : ref3.reviewRatingStatistics) {
                var ref4;
                setReviews(ctData === null || ctData === void 0 ? void 0 : ctData[0].reviewRatingStatistics);
                const reviewObject = {
                    reviews: ctData === null || ctData === void 0 ? void 0 : (ref4 = ctData[0]) === null || ref4 === void 0 ? void 0 : ref4.reviewRatingStatistics
                };
                dispatch((0,pdpSlice/* setReviewDetails */.mP)(reviewObject));
            }
            setState((prevState)=>{
                return {
                    ...prevState,
                    designServiceData: designServices,
                    installationData: installationServices,
                    ctData: ctData.length > 0 ? ctData[0] : {},
                    ctLoading: false
                };
            });
            if (installationServices.length > 0) {
                getUserLocation();
            }
        }).catch((err)=>{
            setState((prevState)=>{
                return {
                    ...prevState,
                    ctLoading: false
                };
            });
        });
    };
    const getUserLocation = ()=>{
        (0,helper.getLocationByCookies)().then((getLocation)=>{
            var _zipcode;
            const userZipCode = (_zipcode = getLocation.zipcode) !== null && _zipcode !== void 0 ? _zipcode : "";
            checkUserZipCode(userZipCode);
        });
    };
    const checkUserZipCode = (userZipCodeVal, callBack)=>{
        const newCodes = [];
        state.zipCodeData.map((codes)=>{
            Object.keys(codes).forEach((key)=>{
                newCodes.push(codes[key].includes(userZipCodeVal));
            });
        });
        const isNearest = newCodes.find((result)=>result === true) ? true : false;
        callBack && callBack(isNearest);
    };
    const removeVariantSelection = ()=>{
        setState((prevState)=>{
            return {
                ...prevState,
                clickedProductVariant: false,
                isProductVariantClicked: false
            };
        });
    };
    const handleBuyNow = (items)=>{
        setBuyNowLoading(true);
        setLoadingMessage("Preparing your cart...");
        const atc = (cb)=>{
            addToCart(items, cb, false);
        };
        initBuyNow(atc);
    };
    if (!isEmpty_default()(state.productDetailData) && !state.viewLoader && (pdprops.name || pdprops.desc) && (discountedPrices[state.selectedSku] > 0 || pricesData[state.selectedSku] > 0)) {
        var _selectedSku, _selectedSku1, _replaceAddToCartCtaLabel;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v3_ProductDetailView, {
                ...pdprops,
                setPincode: setPincode,
                isPdpPropsLoaded: isPdpPropsLoaded,
                persona: state.persona,
                toaster: state.toaster,
                staticTexts: staticTexts,
                options: state.options,
                facetLabels: state.facetLabels,
                curroptions: state.currOptions,
                productCategory: category,
                productServices: productServices,
                isComboSku: comboSku[state.selectedSku],
                imagesData: [
                    ...imagesData,
                    ...videoIds
                ],
                price: pricesData[state.selectedSku],
                listPrice: listPrices[state.selectedSku],
                discountedPrice: (_selectedSku = discountedPrices[state.selectedSku]) !== null && _selectedSku !== void 0 ? _selectedSku : 0,
                discountPercent: (_selectedSku1 = discountPercent[state.selectedSku]) !== null && _selectedSku1 !== void 0 ? _selectedSku1 : 0,
                isType: isType[state.selectedSku],
                setSkuVariant: setSkuVariant,
                selectoption: selectOption,
                getStock: ()=>(0,utils_cart/* getStock */.K5)(state.selectedSku),
                onAddToCart: function(cartValue) {
                    let cb = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ()=>{};
                    return addToCart(cartValue, cb);
                },
                onAddToCompare: ()=>{
                    var ref;
                    return (0,product/* addToCompareProduct */.dX)(state.selectedSku, (ref = pdprops.addToCartProps) === null || ref === void 0 ? void 0 : ref.backOrder);
                },
                onRemoveFromCompare: ()=>(0,product/* removeFromCompareProduct */.Zj)(state.selectedSku),
                checkProductCategory: ()=>(0,productDetailsHelper/* checkProductCategory */.tz)(productCategory, category),
                comparedProductsCount: comparedProducts.length,
                compare: compare,
                isEnable: isEnable,
                isParts: isParts,
                findProPagePath: findProPagePath,
                locale: locale,
                currencySign: currencySign,
                currencyCode: currencyCode,
                addItemsToCart: addRequiredItems,
                showToaster: showToaster,
                onAvailableColor: ()=>seeAvailableColor(),
                overSizedType: overSizedType,
                cart: cart,
                getZipCode: getZipCode,
                servicesData: state.servicesData,
                installationData: state.installationData,
                designServiceData: state.designServiceData,
                installationDataFromProp: state.installationDataFromProp,
                designServiceDataFromProp: state.designServiceDataFromProp,
                findStoreUrl: findStoreUrl,
                promoTitle: state.promoTitle,
                promoDescription: state.promoDescription,
                enablePromo: state.enablePromo,
                getDiscontinuedProductValue: pdpSlice/* getDiscontinuedProductValue */.B$,
                selectMoreTooltipData: state.selectMoreTooltipData,
                badgesProps: badgesProps,
                viewLoader: state.viewLoader,
                findInstallerPath: (0,helper.getShortenedUrlwithGeneral)(state.findInstallerPath, general),
                removeVariantSelection: removeVariantSelection,
                excludedState: (0,productDetailsHelper/* getShippingLocations */.lk)(state.statesData, excludedStates),
                mboxes: state.mboxes,
                pdpJson: authorData,
                presetConfigObject: presetConfigObject,
                setProductInfo: (data)=>dispatch((0,pdpSlice/* setProductInfo */.CC)(data)),
                partReplacementSuggestions: partReplacementSuggestions[state.selectedSku],
                updateImageClickCounter: updateImageClickCounter,
                imageClickCounter: state.imageClickCounter,
                getReqItemLwData: (query)=>dispatch((0,pdpSlice/* getReqItemLwData */.gP)({
                        query,
                        brandName
                    })),
                productData: state.productDetailData,
                replaceAddToCart: Boolean(authorData.replaceAddToCart),
                disableRatings: Boolean(authorData.disableRatings),
                replaceAddToCartCtaLink: replaceAddToCartCtaLink !== null && replaceAddToCartCtaLink !== void 0 ? replaceAddToCartCtaLink : findStoreUrl,
                linkNewTab: Boolean(authorData.linkNewTab),
                replaceAddToCartCtaLabel: (_replaceAddToCartCtaLabel = authorData.replaceAddToCartCtaLabel) !== null && _replaceAddToCartCtaLabel !== void 0 ? _replaceAddToCartCtaLabel : t("kf.global.label.findStore"),
                disableEcommerce: Boolean(authorData.disableEcommerce),
                fusionQueryId: state.fusionQueryId,
                docId: state.productDetailData.id,
                config: config,
                assetAccountName: assetAccountName,
                homePagePath: homePagePath,
                initialImgAlt: initialImgAlt,
                initialImgUrl: initialImgUrl,
                waterSenseProduct: pdpData["ProductWaterSense_ss"] || [],
                isInstock: pdpData["productIsInStock_b"] || false,
                ctLoading: state.ctLoading,
                atcLoading: atcLoading,
                productCollectionsName: pdpBrnadName,
                businessUnitName: productRoom,
                handleBuyNow: handleBuyNow,
                buyNowLoading: buyNowLoading,
                loadingMessage: loadingMessage,
                reviews: reviews,
                upSellData: upSellData
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PDPLoader/* default */.Z, {
        pdpJson: authorData,
        pdpData: pdpData,
        skuId: skuId,
        initialImgAlt: initialImgAlt,
        initialImgUrl: initialImgUrl
    });
};
/* harmony default export */ var v3_ProductDetail = (ProductDetail);


/***/ }),

/***/ 16709:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ v1_Review; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./utils/helper.js + 2 modules
var helper = __webpack_require__(34326);
;// CONCATENATED MODULE: ./components/Review/v1/analytics.js

const addReviewClickAnalytics = ()=>{
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "pdp:review ratings:stars click",
        eventName: "pdp:review ratings:stars click",
        eventType: "interaction",
        internalLinkName: "review stars",
        internalLinkPosition: "pdp",
        internalLinkType: "pdp:ratings:stars",
        internalLinkZoneName: "pdp:review section",
        internalLinkURL: "n/a"
    };
    window.adobeDataLayer.push({
        event: "cmp:click",
        page,
        eventInfo
    });
};
const reviewFieldClickAnalytics = (name)=>{
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "review modal:review ".concat(name === "review" ? "field" : "title", " click"),
        eventName: "review modal:review ".concat(name === "review" ? "field" : "title", " click"),
        eventType: "interaction",
        internalLinkName: "review ".concat(name === "review" ? "field" : "title"),
        internalLinkPosition: "review modal",
        internalLinkType: "modal:review",
        internalLinkZoneName: "review modal",
        internalLinkURL: "n/a"
    };
    window.adobeDataLayer.push({
        event: "cmp:click",
        page,
        eventInfo
    });
};
const closeReviewModalAnalytics = ()=>{
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "review modal:close button click",
        eventName: "review modal:close button click",
        eventType: "interaction",
        internalLinkName: "close button",
        internalLinkPosition: "review modal",
        internalLinkType: "modal:close",
        internalLinkZoneName: "review modal",
        internalLinkURL: "n/a"
    };
    window.adobeDataLayer.push({
        event: "cmp:click",
        page,
        eventInfo
    });
};
const submitReviewAnalytics = ()=>{
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "review modal:submit cta click",
        eventName: "review modal:submit cta click",
        eventType: "interaction",
        internalLinkName: "submit cta",
        internalLinkPosition: "review modal",
        internalLinkType: "modal:cta",
        internalLinkZoneName: "review modal",
        internalLinkURL: "n/a"
    };
    window.adobeDataLayer.push({
        event: "cmp:click",
        page,
        eventInfo
    });
};
const closeSuccessReviewModalAnalytics = ()=>{
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "review success message:close click",
        eventName: "review success message:close click",
        eventType: "interaction",
        internalLinkName: "success message close",
        internalLinkPosition: "review modal",
        internalLinkType: "modal:message",
        internalLinkZoneName: "review modal",
        internalLinkURL: "n/a"
    };
    window.adobeDataLayer.push({
        event: "cmp:click",
        page,
        eventInfo
    });
};

// EXTERNAL MODULE: ./components/Review/v1/review.module.scss
var review_module = __webpack_require__(46665);
var review_module_default = /*#__PURE__*/__webpack_require__.n(review_module);
// EXTERNAL MODULE: ./node_modules/react-rating-stars-component/dist/react-stars.js
var react_stars = __webpack_require__(11312);
// EXTERNAL MODULE: ./public/icons/half-star.svg
var half_star = __webpack_require__(56878);
// EXTERNAL MODULE: ./public/icons/full-star.svg
var full_star = __webpack_require__(41165);
;// CONCATENATED MODULE: ./public/icons/white-star.svg
/* harmony default export */ var white_star = ({"src":"/_next/static/media/white-star.1651a460.svg","height":17,"width":16});
// EXTERNAL MODULE: ./public/icons/empty-star.svg
var empty_star = __webpack_require__(20822);
// EXTERNAL MODULE: ./components/core/SelectDropdown/SelectDropdown.jsx
var SelectDropdown = __webpack_require__(77860);
// EXTERNAL MODULE: ./components/core/Modal/Modal.jsx + 2 modules
var Modal = __webpack_require__(95357);
// EXTERNAL MODULE: ./components/core/Input/Input.jsx
var Input = __webpack_require__(3372);
// EXTERNAL MODULE: ./components/core/TextArea/TextArea.jsx
var TextArea = __webpack_require__(29707);
// EXTERNAL MODULE: ./src/components/core/Button/Button.jsx
var Button = __webpack_require__(82476);
// EXTERNAL MODULE: ./utils/validate.js
var validate = __webpack_require__(45648);
// EXTERNAL MODULE: ./store/features/pdpSlice.js
var pdpSlice = __webpack_require__(44561);
// EXTERNAL MODULE: ./store/features/authSlice.js
var authSlice = __webpack_require__(24899);
;// CONCATENATED MODULE: ./components/Review/v1/ReviewModal.jsx
















const ReviewModal = (props)=>{
    var ref;
    const { showModal , closeModal , ratingValue , setRatingValue , productId , setSuccess , productName , setIsOpen  } = props;
    const [data, setData] = (0,react.useState)({});
    const [error, setError] = (0,react.useState)({});
    const [loading, setLoading] = (0,react.useState)(false);
    const dispatch = (0,es/* useDispatch */.I0)();
    const { isAuth , user  } = (0,es/* useSelector */.v9)(authSlice/* selectAuthState */._9);
    const validateExist = (field)=>{
        if (field === "review") {
            var ref, ref1;
            if (!(data === null || data === void 0 ? void 0 : (ref = data[field]) === null || ref === void 0 ? void 0 : ref.trim())) {
                return "Please Enter Review";
            } else if ((data === null || data === void 0 ? void 0 : (ref1 = data[field]) === null || ref1 === void 0 ? void 0 : ref1.length) < 50) return "Please enter at least 50 characters";
            else return "";
        } else if (field === "reviewTitle") {
            var ref2;
            if (!(data === null || data === void 0 ? void 0 : (ref2 = data[field]) === null || ref2 === void 0 ? void 0 : ref2.trim())) {
                return "Please Enter Review Title";
            } else return "";
        }
    };
    const handleChange = (e, name)=>{
        const { value  } = e.target;
        if (value === "" || value.length) {
            setData({
                ...data,
                [name]: value
            });
            if (name === "reviewTitle") if (value === "") setError({
                ...error,
                [name]: "Please Enter Review Title"
            });
            else setError({
                ...error,
                [name]: ""
            });
            else if (name === "review") {
                if (value === "") {
                    setError({
                        ...error,
                        [name]: "Please Enter Review"
                    });
                } else if (value.length < 50) {
                    setError({
                        ...error,
                        [name]: "Please enter at least 50 characters"
                    });
                } else setError({
                    ...error,
                    [name]: ""
                });
            }
        }
    };
    const onBlur = (field)=>{
        setError({
            ...error,
            [field]: validateExist(field)
        });
    };
    const getErrorList = ()=>{
        const errorList = {
            review: validateExist("review"),
            reviewTitle: validateExist("reviewTitle")
        };
        return errorList;
    };
    const handleSubmit = ()=>{
        setLoading(true);
        const authorName = isAuth ? "".concat(user.firstName, " ").concat(user.lastName) : "Guest";
        const customerId = isAuth ? user.commercetoolsID : "";
        dispatch((0,pdpSlice/* postProductReview */.pN)({
            authorName: authorName,
            title: data === null || data === void 0 ? void 0 : data.reviewTitle,
            text: data === null || data === void 0 ? void 0 : data.review,
            rating: ratingValue,
            productId: productId,
            ...customerId !== "" && {
                customerId: customerId
            }
        })).then((response)=>{
            var ref;
            if ((response === null || response === void 0 ? void 0 : (ref = response.payload) === null || ref === void 0 ? void 0 : ref.status) === 200) {
                setSuccess(true);
                setLoading(false);
                submitReviewAnalytics();
                setIsOpen(false);
                setRatingValue(0);
            } else {
                setSuccess(false);
                closeModal();
                setLoading(false);
            }
        }).catch((err)=>{
            setLoading(false);
            console.log(err);
        });
    };
    const isEnabled = ((ref = Object === null || Object === void 0 ? void 0 : Object.values(getErrorList())) === null || ref === void 0 ? void 0 : ref.find((el)=>el)) ? true : false;
    const handleFocus = (name)=>{
        reviewFieldClickAnalytics(name);
    };
    const productRating = ()=>{
        if (ratingValue === 5) return "Excellent";
        else if (ratingValue === 4) return "Good";
        else if (ratingValue === 3) return "Average";
        else if (ratingValue === 2) return "Fair";
        else if (ratingValue === 1) return "Poor";
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
            showModal: showModal,
            onModalClose: closeModal,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "review-modal",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "title",
                        children: "My Review"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "product-heading",
                        children: productName
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "title",
                        children: "Required fields are marked with *"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "overall-rating",
                        children: "Overall Rating"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_stars/* default */.Z, {
                        count: 5,
                        size: 24,
                        emptyIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: empty_star/* default.src */.Z.src,
                            className: "empty-reviews"
                        }),
                        halfIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: half_star/* default.src */.Z.src
                        }),
                        filledIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: white_star.src,
                            className: "filled-reviews"
                        }),
                        onChange: (rating)=>setRatingValue(rating),
                        value: ratingValue
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "title",
                        children: "".concat(ratingValue, " out of 5 stars selected. Product is ").concat(productRating())
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "review-title-heading",
                        children: "Review Title*"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "review-title-input",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                            type: "text",
                            value: data === null || data === void 0 ? void 0 : data.reviewTitle,
                            name: "reviewTitle",
                            label: "Example: Great Features",
                            onChange: (e)=>handleChange(e, "reviewTitle"),
                            maxLength: 50,
                            customClass: "review-title-input",
                            onBlur: ()=>onBlur("reviewTitle"),
                            showError: (error === null || error === void 0 ? void 0 : error.reviewTitle) !== "" && (error === null || error === void 0 ? void 0 : error.reviewTitle),
                            errorMessage: error === null || error === void 0 ? void 0 : error.reviewTitle,
                            onFocus: ()=>handleFocus("reviewTitle"),
                            hideLabelOnFocus: true
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "review-title-heading",
                        children: "Review*"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "review-title-input resizable",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextArea/* default */.Z, {
                            name: "review",
                            label: "Example: I bought this a month and.....",
                            placeholder: "Example: I bought this a month and.....",
                            value: data === null || data === void 0 ? void 0 : data.review,
                            onChange: (e)=>handleChange(e, "review"),
                            customClass: "review-title-input resizable",
                            onBlur: ()=>onBlur("review"),
                            showError: (error === null || error === void 0 ? void 0 : error.review) !== "" && (error === null || error === void 0 ? void 0 : error.review),
                            errorMessage: error === null || error === void 0 ? void 0 : error.review,
                            onFocus: ()=>handleFocus("review"),
                            hideLabelOnFocus: true
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        label: "Submit",
                        className: "submit-cta",
                        type: "black",
                        size: "large",
                        role: "button",
                        disabled: isEnabled,
                        onClick: handleSubmit,
                        loading: loading
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var v1_ReviewModal = (ReviewModal);

;// CONCATENATED MODULE: ./components/Review/v1/ReviewList.jsx






const ReviewList = (props)=>{
    const { reviewsList  } = props;
    const getDate = (date)=>{
        const currentDate = new Date();
        const targetDate = new Date(date);
        const timeDifference = currentDate.getTime() - targetDate.getTime();
        const seconds = Math.floor(timeDifference / 1000);
        const minutes = Math.floor(seconds / 60);
        const hours = Math.floor(minutes / 60);
        const days = Math.floor(hours / 24);
        const months = Math.floor(days / 30.44) // Approximate
        ;
        const years = Math.floor(days / 365.25) // Approximate
        ;
        if (years > 0) {
            return "".concat(years, " year").concat(years === 1 ? "" : "s", " ago");
        } else if (months > 0) {
            return "".concat(months, " month").concat(months === 1 ? "" : "s", " ago");
        } else if (days > 0) {
            return "".concat(days, " day").concat(days === 1 ? "" : "s", " ago");
        } else if (hours > 0) {
            return "".concat(hours, " hour").concat(hours === 1 ? "" : "s", " ago");
        } else if (minutes > 0) {
            return "".concat(minutes, " minute").concat(minutes === 1 ? "" : "s", " ago");
        } else {
            return "".concat(seconds, " second").concat(seconds === 1 ? "" : "s", " ago");
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "review-content-parent",
        children: reviewsList === null || reviewsList === void 0 ? void 0 : reviewsList.map((item, i)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "review-content",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "user-name",
                        children: item.authorName
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "title-rating-container",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_stars/* default */.Z, {
                                count: 5,
                                value: item.rating,
                                size: 24,
                                edit: false,
                                isHalf: true,
                                emptyIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: empty_star/* default.src */.Z.src
                                }),
                                halfIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: half_star/* default.src */.Z.src
                                }),
                                filledIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: full_star/* default.src */.Z.src
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "rating-title",
                                children: item.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "rating-star",
                                children: getDate(item.createdAt)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "rating-description",
                                children: item.text
                            })
                        ]
                    })
                ]
            }, i))
    });
};
/* harmony default export */ var v1_ReviewList = (ReviewList);

// EXTERNAL MODULE: ./hooks/useWindowResize.js
var useWindowResize = __webpack_require__(11859);
;// CONCATENATED MODULE: ./components/Review/v1/Review.view.jsx

















const ReviewDetail = (props)=>{
    var ref, ref1;
    const { data  } = props;
    const [totalReviews, setTotalReviews] = (0,react.useState)(null);
    const [reviewsList, setReviewsList] = (0,react.useState)([]);
    const [filterList, setFilterList] = (0,react.useState)([]);
    const [selected, setSelected] = (0,react.useState)("Most Recent");
    const [isOpen, setIsOpen] = (0,react.useState)(false);
    const [ratingValue, setRatingValue] = (0,react.useState)(0);
    const [width] = (0,useWindowResize/* default */.Z)();
    const [isMobile, setIsMobile] = (0,react.useState)(width < 480);
    const { reviewDetails , productId , productName  } = (0,es/* useSelector */.v9)(pdpSlice/* selectPdpState */.BY);
    const [reviewObject, setReviewObject] = (0,react.useState)(null);
    const [filterRating, setFilterRating] = (0,react.useState)(null);
    const [offset, setOffset] = (0,react.useState)(0);
    const [success, setSuccess] = (0,react.useState)(false);
    const [reviewsCount, setReviewsCount] = (0,react.useState)(null);
    const dispatch = (0,es/* useDispatch */.I0)();
    const { reviews  } = reviewDetails || {};
    const REVIEWS_PER_PAGE = 5;
    (0,react.useEffect)(()=>{
        setIsMobile(width < 480);
    }, [
        width
    ]);
    // const reviews = []
    const element = document.getElementsByClassName("select-dropdown__display");
    if (element.length) {
        if (width < 480) {
            document.getElementsByClassName("select-dropdown__display")[0].style.display = "none";
        } else {
            document.getElementsByClassName("select-dropdown__display")[0].style.display = "block";
        }
    }
    (0,react.useEffect)(()=>{
        if (data) {
            const { sortItems  } = data;
            let filters = sortItems.map((ele)=>ele.sortItems);
            // filters = ["Select Option", ...filters]
            setFilterList(filters);
        }
        const element = document.getElementsByClassName("select-dropdown__display");
        if (element.length) {
            if (width < 480) {
                document.getElementsByClassName("select-dropdown__display")[0].style.display = "none";
            } else {
                document.getElementsByClassName("select-dropdown__display")[0].style.display = "block";
            }
        }
    }, []);
    const getCount = (star)=>{
        if (reviewObject) {
            const obj = reviewObject === null || reviewObject === void 0 ? void 0 : reviewObject.ratingsDistribution;
            const keys = Object.keys(obj);
            const foundKey = keys === null || keys === void 0 ? void 0 : keys.find((key)=>key == star);
            if (foundKey) return obj[foundKey];
            else return 0;
        } else return 0;
    };
    const ratingChanged = (newRating)=>{
        setRatingValue(newRating);
        setIsOpen(true);
        addReviewClickAnalytics();
    };
    const loadMore = ()=>{
        setOffset(offset + REVIEWS_PER_PAGE);
        dispatch((0,pdpSlice/* getProductReviews */.mk)({
            productId: productId,
            offset: offset + REVIEWS_PER_PAGE,
            selected: selected,
            rating: filterRating
        })).then((response)=>{
            var ref, ref1;
            setTotalReviews(response === null || response === void 0 ? void 0 : (ref = response.payload) === null || ref === void 0 ? void 0 : ref.total);
            setReviewsList([
                ...reviewsList,
                ...response === null || response === void 0 ? void 0 : (ref1 = response.payload) === null || ref1 === void 0 ? void 0 : ref1.results
            ]);
        }).catch((err)=>{
            console.error("Fetching data failed", err);
        });
    };
    (0,react.useEffect)(()=>{
        if (productId) {
            dispatch((0,pdpSlice/* getProductReviews */.mk)({
                productId: productId,
                offset: offset,
                selected: selected,
                rating: filterRating
            })).then((response)=>{
                var ref, ref1;
                setTotalReviews(response === null || response === void 0 ? void 0 : (ref = response.payload) === null || ref === void 0 ? void 0 : ref.total);
                setReviewsList(response === null || response === void 0 ? void 0 : (ref1 = response.payload) === null || ref1 === void 0 ? void 0 : ref1.results);
            }).catch((err)=>{
                console.error("Fetching data failed", err);
            });
        }
    }, [
        productId
    ]);
    (0,react.useEffect)(()=>{
        if (success) {
            setOffset(0);
            dispatch((0,pdpSlice/* getProductReviews */.mk)({
                productId: productId,
                offset: 0,
                selected: selected,
                rating: filterRating
            })).then((response)=>{
                var ref, ref1;
                setTotalReviews(response === null || response === void 0 ? void 0 : (ref = response.payload) === null || ref === void 0 ? void 0 : ref.total);
                setReviewsList(response === null || response === void 0 ? void 0 : (ref1 = response.payload) === null || ref1 === void 0 ? void 0 : ref1.results);
            }).catch((err)=>{
                console.error("Fetching data failed", err);
            });
        }
    }, [
        success
    ]);
    (0,react.useEffect)(()=>{
        if (reviews) {
            setReviewsCount(reviews.count);
            setReviewObject(reviews);
        }
    }, [
        reviews
    ]);
    const getPercentage = (star)=>{
        const { ratingsDistribution  } = reviewObject || {};
        const ratingCount = ratingsDistribution === null || ratingsDistribution === void 0 ? void 0 : ratingsDistribution[star];
        if (ratingCount) {
            const element = document.getElementById("myBar-".concat(star));
            // if (element) element.style.cursor = "pointer"
            return ratingCount / reviewsCount * 100;
        } else return 0;
    };
    const filterBasedOnRating = (rating)=>{
        setFilterRating(rating);
        dispatch((0,pdpSlice/* getProductReviews */.mk)({
            productId: productId,
            offset: offset,
            rating: rating,
            selected: selected
        })).then((response)=>{
            var ref, ref1;
            setTotalReviews(response === null || response === void 0 ? void 0 : (ref = response.payload) === null || ref === void 0 ? void 0 : ref.total);
            setReviewsList(response === null || response === void 0 ? void 0 : (ref1 = response.payload) === null || ref1 === void 0 ? void 0 : ref1.results);
        }).catch((err)=>{
            console.error("Fetching data failed", err);
        });
    };
    const sortHandler = (selectedOption)=>{
        setSelected(selectedOption);
        dispatch((0,pdpSlice/* getProductReviews */.mk)({
            productId: productId,
            offset: offset,
            rating: filterRating,
            selected: selectedOption
        })).then((response)=>{
            var ref, ref1;
            setTotalReviews(response === null || response === void 0 ? void 0 : (ref = response.payload) === null || ref === void 0 ? void 0 : ref.total);
            setReviewsList(response === null || response === void 0 ? void 0 : (ref1 = response.payload) === null || ref1 === void 0 ? void 0 : ref1.results);
        }).catch((err)=>{
            console.error("Fetching data failed", err);
        });
    };
    const closeSuccessModal = ()=>{
        setSuccess(false);
        closeSuccessReviewModalAnalytics();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (review_module_default()).reviewContainer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "review-title",
                children: "Reviews"
            }),
            (reviewsList === null || reviewsList === void 0 ? void 0 : reviewsList.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "rating-container",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "individual-container-1",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "rating-snapshot",
                                        children: "Rating Snapshot"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: [
                                            5,
                                            4,
                                            3,
                                            2,
                                            1
                                        ].map((star)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "individual-rating",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "star-rating",
                                                        children: "".concat(star, " star").concat(star === 1 ? "" : "s")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "myBar",
                                                        id: "myBar-".concat(star),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "rating-bar",
                                                            id: "rating-bar-".concat(star),
                                                            style: {
                                                                width: "".concat(getPercentage(star), "%")
                                                            }
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "count",
                                                        children: getCount(star)
                                                    })
                                                ]
                                            }))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "individual-container",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "rating-snapshot",
                                        children: "Overall Rating"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "rating-div",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "rating",
                                                children: "".concat(reviewObject === null || reviewObject === void 0 ? void 0 : (ref = reviewObject.averageRating) === null || ref === void 0 ? void 0 : ref.toFixed(1))
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_stars/* default */.Z, {
                                                        count: 5,
                                                        value: reviewObject === null || reviewObject === void 0 ? void 0 : (ref1 = reviewObject.averageRating) === null || ref1 === void 0 ? void 0 : ref1.toFixed(1),
                                                        size: 24,
                                                        edit: false,
                                                        isHalf: true,
                                                        emptyIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: empty_star/* default.src */.Z.src
                                                        }),
                                                        halfIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: half_star/* default.src */.Z.src
                                                        }),
                                                        filledIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: full_star/* default.src */.Z.src
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "review-number",
                                                        children: "".concat(reviewsCount, " Reviews")
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "rating-desc",
                                        children: "".concat(Math.floor(reviewObject === null || reviewObject === void 0 ? void 0 : reviewObject.averageRating), " out of 5 (").concat(Math.floor(reviewObject === null || reviewObject === void 0 ? void 0 : reviewObject.averageRating) / 5 * 100, "%) reviewers recommend this product")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "individual-container",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "rating-snapshot",
                                        children: "Review this product"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "filter-title",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_stars/* default */.Z, {
                                                count: 5,
                                                size: 24,
                                                emptyIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: empty_star/* default.src */.Z.src,
                                                    className: "empty-reviews"
                                                }),
                                                halfIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: half_star/* default.src */.Z.src
                                                }),
                                                filledIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: white_star.src,
                                                    className: "filled-reviews"
                                                }),
                                                onChange: ratingChanged
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "rating-filter-container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "rating-heading",
                            children: "1 - ".concat(reviewsList === null || reviewsList === void 0 ? void 0 : reviewsList.length, " of ").concat(totalReviews, " Reviews")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_ReviewList, {
                        reviewsList: reviewsList
                    }),
                    totalReviews > offset + REVIEWS_PER_PAGE && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        label: "Load More",
                        className: "load-more-cta",
                        customClass: "load-more-cta",
                        type: "black",
                        role: "button",
                        size: "small",
                        onClick: loadMore
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "no-reviews-text",
                        children: "No Reviews Yet!"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "first-to-review",
                        children: "Be the first to share your thoughts on this product."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_stars/* default */.Z, {
                        count: 5,
                        size: 24,
                        emptyIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: empty_star/* default.src */.Z.src,
                            className: "empty-reviews"
                        }),
                        halfIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: half_star/* default.src */.Z.src
                        }),
                        filledIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: white_star.src,
                            className: "filled-reviews"
                        }),
                        onChange: ratingChanged
                    })
                ]
            }),
            isOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_ReviewModal, {
                showModal: isOpen,
                closeModal: ()=>{
                    setIsOpen(false);
                    setRatingValue(0);
                    closeReviewModalAnalytics();
                },
                setRatingValue: setRatingValue,
                ratingValue: ratingValue,
                productId: productId,
                setSuccess: setSuccess,
                productName: productName,
                setIsOpen: setIsOpen
            }),
            success && /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
                showModal: success,
                onModalClose: closeSuccessModal,
                hideCloseIcon: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "review-modal",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "success-review",
                            children: "Your review was submitted!"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            label: "Close",
                            className: "submit-cta",
                            type: "black",
                            size: "large",
                            role: "button",
                            onClick: closeSuccessModal
                        })
                    ]
                })
            })
        ]
    });
};
ReviewDetail.defaultProps = {
    bazaarVoiceProductId: "",
    productInfo: {}
};
/* harmony default export */ var Review_view = (ReviewDetail);

;// CONCATENATED MODULE: ./components/Review/v1/Review.jsx





const Review = (props)=>{
    const { data  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Review_view, {
        data: data
    });
};
/* harmony default export */ var v1_Review = (Review);


/***/ }),

/***/ 41630:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_cart_QuantitySelector__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75653);
/* harmony import */ var _components_core_Button_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82476);
/* harmony import */ var _components_Default_CarouselSlick_v1_SlickSettings__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86466);
/* harmony import */ var _components_Shared_DisplayDiscountPrice__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71025);
/* harmony import */ var _components_Shared_UpsellInstallServices_analytics__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(59192);
/* harmony import */ var _components_Shared_UpsellInstallServices_index_module_scss__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(48320);
/* harmony import */ var _components_Shared_UpsellInstallServices_index_module_scss__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(_components_Shared_UpsellInstallServices_index_module_scss__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var _components_Shared_UpsellInstallServices_RequiredProductItem_index_module_scss__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(77145);
/* harmony import */ var _components_Shared_UpsellInstallServices_RequiredProductItem_index_module_scss__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(_components_Shared_UpsellInstallServices_RequiredProductItem_index_module_scss__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(19514);
/* harmony import */ var _hooks_useWindowResize__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11859);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(34326);
/* harmony import */ var _utils_index__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(20558);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(67294);
/* harmony import */ var react_slick__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(46066);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _components_core_Checkbox_Checkbox__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(34846);
/* harmony import */ var _components_ProductDetail_v3_AddToCart_utils__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(29885);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(52786);
/* harmony import */ var _components_Shared_UpsellInstallServices_localization__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(5600);
/* harmony import */ var react_number_format__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(57333);






















const UpsellServicesMobile = (props)=>{
    const { upSellData , slickRef  } = props;
    var ref;
    const persona = (ref = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_8__.getUserPersona)()) !== null && ref !== void 0 ? ref : "GST";
    const { t  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_16__/* .useTranslation */ .$G)("common");
    const staticText = (0,_components_Shared_UpsellInstallServices_localization__WEBPACK_IMPORTED_MODULE_18__/* .getTranslations */ .F)(t);
    const [width] = (0,_hooks_useWindowResize__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)();
    const [tileUrls, setTileUrls] = (0,react__WEBPACK_IMPORTED_MODULE_10__.useState)({});
    const slickSettings = (0,_components_Default_CarouselSlick_v1_SlickSettings__WEBPACK_IMPORTED_MODULE_3__/* .singleSliderSettings */ .N)((_, current)=>{}, 0, false, 500, (label)=>{
        staticText.arrowLabel = label;
    }, false, (currentIndexAfterChange)=>{
        const currentSlideServiceData = upSellData[eval(currentIndexAfterChange)];
        if (!isSearchClick) {
            addAnalyticsForArrows(staticText.arrowLabel, currentSlideServiceData, currentIndexAfterChange, persona, staticText.serviceAvailableTitleUpSell, staticText.recommendationTitle);
        }
    });
    const [currency, setCurrencySign] = (0,react__WEBPACK_IMPORTED_MODULE_10__.useState)("");
    const [skuPrependName, setSkuPrependName] = (0,react__WEBPACK_IMPORTED_MODULE_10__.useState)("");
    const [isMobile, setIsMobile] = (0,react__WEBPACK_IMPORTED_MODULE_10__.useState)(width <= 1203);
    (0,react__WEBPACK_IMPORTED_MODULE_10__.useEffect)(()=>{
        checkSkuKPrepend();
        callToConfiguration();
        const el = document.querySelector(".required-item");
        let scrollTimeout;
        el.addEventListener("scroll", ()=>{
            clearTimeout(scrollTimeout);
            scrollTimeout = setTimeout(()=>{
                (0,_components_Shared_UpsellInstallServices_analytics__WEBPACK_IMPORTED_MODULE_5__/* .addAnalyticsForSlider */ .U8)();
            }, 200);
        });
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_10__.useEffect)(()=>{
        if (!(upSellData === null || upSellData === void 0 ? void 0 : upSellData.length)) return;
        upSellData.forEach((item)=>{
            (0,_utils_helper__WEBPACK_IMPORTED_MODULE_8__.getPDPUrlForProductTile)(item, item.sku_s).then((ret)=>{
                setTileUrls((prev)=>({
                        ...prev,
                        [item.sku_s]: "".concat(ret, "?skuId=").concat(item.sku_s)
                    }));
            });
        });
    }, [
        upSellData
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_10__.useEffect)(()=>{
        setIsMobile(width <= 1024);
    }, [
        width
    ]);
    const callToConfiguration = async ()=>{
        const config = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_6__/* .getConfig */ .i)();
        const { general: { siteName ="kohler"  } = {}  } = config !== null && config !== void 0 ? config : {};
        const currency = lodash_get__WEBPACK_IMPORTED_MODULE_13___default()(config, "internationalization.currencySign", "");
        setCurrencySign(currency);
    };
    const checkSkuKPrepend = async ()=>{
        var ref;
        const { apiEndpoints: { skuPrepend =""  } = {}  } = (ref = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_6__/* .getConfig */ .i)()) !== null && ref !== void 0 ? ref : {};
        setSkuPrependName(skuPrepend);
    };
    slickSettings["infinite"] = false;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_components_Shared_UpsellInstallServices_index_module_scss__WEBPACK_IMPORTED_MODULE_19___default().upsellmodal),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "upsell-modal-header__title mb-20",
                    children: "Make It a Perfect Match"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "upsell-modal-header__text",
                    children: "Thoughtfully paired products customers usually choose together"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "upsell-modal-header",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_slick__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                        ref: slickRef,
                        ...slickSettings,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_10__.Fragment, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "upsell-modal__container no-margin",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "right-side no-line",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "required-parts-right-side",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "required-item-header",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "required-item recommended-item",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "required-item-list required-item-gap",
                                                    children: upSellData ? upSellData === null || upSellData === void 0 ? void 0 : upSellData.map((item, upSellDataIndex)=>{
                                                        const productVariantImages = item["productImages.labelWithUrl_s"] ? [
                                                            item["productImages.labelWithUrl_s"]
                                                        ] : item["productImages.labelWithUrl_ss"] || [];
                                                        const variantImages = productVariantImages.filter((img)=>item.sku_s === img.split("|")[0]);
                                                        const imgUrl = variantImages && variantImages.length > 0 && variantImages[0].split("|")[5];
                                                        const { sku_s: skuId = "" , ProductBrandName_s: productBrandName = "" , productName_s: productName = "" , ["Color.".concat(persona, ".Details_ss")]: colorPricing = ""  } = item;
                                                        const selSkuDetails = colorPricing.find((ele)=>{
                                                            return ele.split("|")[0] === item.sku_s;
                                                        });
                                                        const productPrice = selSkuDetails ? selSkuDetails.split("|")[2] || 0 : 0;
                                                        const discountedPrice = selSkuDetails ? selSkuDetails.split("|")[3] || 0 : 0;
                                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_10__.Fragment, {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                className: (_components_Shared_UpsellInstallServices_RequiredProductItem_index_module_scss__WEBPACK_IMPORTED_MODULE_20___default().requireditem),
                                                                style: {
                                                                    width: "100%",
                                                                    cursor: "pointer"
                                                                },
                                                                tabIndex: "-1",
                                                                role: "link",
                                                                href: tileUrls[item.sku_s] || "#",
                                                                onClick: ()=>(0,_components_Shared_UpsellInstallServices_analytics__WEBPACK_IMPORTED_MODULE_5__/* .addAnalyticsForNavigateToPDP */ .eH)(item),
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                    className: "required-item-for-install-service required-item-reduce-padding",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                            className: "required-item-for-install-service__img",
                                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                                src: imgUrl,
                                                                                alt: productBrandName
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                            className: "required-item-for-install-service__title",
                                                                            children: productBrandName || productName
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                            className: "required-item-for-install-service__sku",
                                                                            children: skuPrependName.toLowerCase() === skuId.substring(0, 2).toLowerCase() ? skuId : "".concat(skuPrependName ? skuPrependName : "").concat(skuId)
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                            className: "required-item-for-install-service__price-quantity",
                                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                                className: "required-item-for-install-service__price",
                                                                                children: [
                                                                                    discountedPrice !== productPrice && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                                                className: "product-list-tile__mrp-section",
                                                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_number_format__WEBPACK_IMPORTED_MODULE_17__/* .NumericFormat */ .h3, {
                                                                                                    value: parseFloat(discountedPrice !== null && discountedPrice !== void 0 ? discountedPrice : 0),
                                                                                                    displayType: "text",
                                                                                                    thousandSeparator: true,
                                                                                                    prefix: currency,
                                                                                                    decimalScale: 2,
                                                                                                    fixedDecimalScale: true
                                                                                                })
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                                                className: "required-item-for-install-service__price-strike",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                                        className: "product-list-tile__mrp",
                                                                                                        children: "MRP "
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_number_format__WEBPACK_IMPORTED_MODULE_17__/* .NumericFormat */ .h3, {
                                                                                                        value: parseFloat(productPrice),
                                                                                                        displayType: "text",
                                                                                                        thousandSeparator: true,
                                                                                                        prefix: "".concat(currency),
                                                                                                        decimalScale: 2,
                                                                                                        fixedDecimalScale: true
                                                                                                    })
                                                                                                ]
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    discountedPrice === productPrice && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_number_format__WEBPACK_IMPORTED_MODULE_17__/* .NumericFormat */ .h3, {
                                                                                            value: parseFloat(productPrice),
                                                                                            displayType: "text",
                                                                                            thousandSeparator: true,
                                                                                            prefix: "".concat(currency),
                                                                                            decimalScale: 2,
                                                                                            fixedDecimalScale: true
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            }, item.sku_s)
                                                        }, item.sku_s);
                                                    }) : null
                                                })
                                            })
                                        })
                                    })
                                })
                            })
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (UpsellServicesMobile);


/***/ }),

/***/ 48375:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9473);
/* harmony import */ var _store_features_authSlice__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24899);
/* harmony import */ var _store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46201);
/* harmony import */ var _hooks_usePrevious__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97349);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(34326);
/* harmony import */ var _utils_cart__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(33273);
/* harmony import */ var _hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7154);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(19514);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(55111);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _utils_downloadFile__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(58589);












const usePageAuth = ()=>{
    const isSsr = (0,_hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)();
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useDispatch */ .I0)();
    const { access_token: accessToken  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(_store_features_authSlice__WEBPACK_IMPORTED_MODULE_2__/* .selectAuthState */ ._9);
    const { cart: activeCart  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .selectCartState */ .xw);
    const prevToken = (0,_hooks_usePrevious__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        accessToken
    });
    // just for the dev testing purpose, if works fine then can only be proceed otherwise
    // one more pr will be raised to revert the change
    // useEffect(() => {
    //   let timeoutId
    //   if (!isSsr) {
    //     timeoutId = setTimeout(() => {
    //       if (!accessToken || !isGuestTokenValid()) {
    //         dispatch(getOktaToken("guest"))
    //       }
    //     }, 5000)
    //   }
    //   ;() => {
    //     clearTimeout(timeoutId)
    //   }
    // }, [accessToken, isSsr])
    // useEffect(() => {
    //   const userLoggedIn = localStorage.getItem("userLoggedIn")
    //   if (userLoggedIn === "false" || userLoggedIn === null) {
    //     if (!isGuestTokenValid()) {
    //       dispatch(getAnonymousGuestToken())
    //     }
    //   }
    // }, [])
    const callInitAuth = async ()=>{
        var ref;
        const config = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_8__/* .getConfig */ .i)();
        const disableCommerce = (config === null || config === void 0 ? void 0 : (ref = config.general) === null || ref === void 0 ? void 0 : ref.disableCommerce) || false;
        if (disableCommerce) return;
        const hasNoActiveCart = ()=>{
            return (0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__.isGuestTokenValid)() && accessToken && !(activeCart === null || activeCart === void 0 ? void 0 : activeCart.id) && !(activeCart === null || activeCart === void 0 ? void 0 : activeCart.cartExists);
        };
        if (hasNoActiveCart() || hasNoActiveCart() && (prevToken === null || prevToken === void 0 ? void 0 : prevToken.accessToken) !== accessToken) {
            dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .setCardStatus */ .YZ)(true));
            dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .getCart */ .dv)()).unwrap().then((res)=>{
                if ((0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__.isGuestTokenValid)() && accessToken && (res === null || res === void 0 ? void 0 : res.cartExists) && (res === null || res === void 0 ? void 0 : res.cartExists) === "false" && (res === null || res === void 0 ? void 0 : res.error) === "No active cart exists.") {
                    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__.getCurrency)().then((currency)=>{
                        const cartPayload = {
                            currency: currency
                        };
                        dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .createCart */ .Bk)(cartPayload)).unwrap().then(()=>{
                            dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .setCardStatus */ .YZ)(false));
                        });
                    });
                }
            });
        }
        (0,_utils_cart__WEBPACK_IMPORTED_MODULE_6__/* .setCartLandingPagePath */ .NS)();
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (isSsr) return;
        callInitAuth();
    }, [
        accessToken,
        isSsr
    ]);
};
/* harmony default export */ __webpack_exports__["Z"] = (usePageAuth);


/***/ }),

/***/ 58886:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52786);

const usePdpi18n = (authorData, badgeText, name)=>{
    const { t  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_0__/* .useTranslation */ .$G)("pdp");
    var _listpricelabel, _colorlabel, ref, _professionalService, _installationHelp, _installerArea, _maxProducts, _superskulabel, _priceFootnoteTitle, _priceFootnote, _colorFootnoteTitle, _colorFootnote, _discontinueProductMsg, _discontinueColorMsg, _onPdpCtaLabel, _colorOrFinish, _outofStockTitle, _noEmailCTA, _nonSellable, _welcomeMsg, _findLocalStore, _backOrder, _specialOrder, _discontinueColorLabel, _discontinueColorFinishLabel, _modalRightSectionTitle, _modalRightSectionDesc, _modalRighttSectionCtaLabel, _modalLeftSectionTitle, _onPdpTooltip, _priceSpiderTitle, _oversizeMsgTitle, _oversizeMsgDesc, _noPriceMsg, _listpricetooltip, _subCopy, _subCopy1, _serviceavailable, _errorMessage, _zipcodevalidationmessage, _zipcodevalidationmessage1, _new, _onSale, _exclusive, _shippingTitle, _shippingDescription, _modalRightSectionNoStockMsg, _customerCare, _disclaimer, _sparepartsinfolabel, _importedbylabel;
    const i18n = {
        home: t("kf.global.label.home"),
        viewLink: t("kf.pdp.label.viewGallery"),
        linkMore: t("kf.pdp.label.morePhotos"),
        moreCollection: t("kf.pdp.label.moreFromCollection"),
        moreCollectionDiscontinued: t("kf.pdp.label.moreFromCollectionDiscontinued"),
        shopText: t("kf.pdp.label.shopAll"),
        listPrice: t("kf.pdp.label.listPrice"),
        refPrice: (_listpricelabel = authorData.listpricelabel) !== null && _listpricelabel !== void 0 ? _listpricelabel : t("kf.pdp.label.refPrice"),
        startingAt: t("kf.pdp.label.startingAt"),
        finish: (_colorlabel = authorData.colorlabel) !== null && _colorlabel !== void 0 ? _colorlabel : t("kf.pdp.label.finish"),
        orderSample: t("kf.pdp.label.orderSample"),
        dimensions: t("kf.pdp.label.dimensions"),
        details: t("kf.pdp.label.details"),
        viewAllSpecs: t("kf.pdp.label.viewAllSpecs"),
        viewMore: t("kf.pdp.label.viewMore"),
        viewGallery: (ref = authorData === null || authorData === void 0 ? void 0 : authorData.viewgalleryctalabel) !== null && ref !== void 0 ? ref : t("kf.pdp.label.viewGallery"),
        length: t("kf.pdp.label.length"),
        width: t("kf.pdp.label.width"),
        height: t("kf.pdp.label.height"),
        smLength: t("kf.pdp.label.smLength"),
        smWidth: t("kf.pdp.label.smWidth"),
        smHeight: t("kf.pdp.label.smHeight"),
        learnMore: t("kf.pdp.label.learnMore"),
        addToCart: t("kf.cart.label.addToCart"),
        addService: t("kf.cart.label.addService"),
        print: t("kf.plp.label.print"),
        wishlist: t("kf.pdp.label.wishlist"),
        share: t("kf.plp.label.share"),
        addToCompare: t("kf.compare.label.addToCompare"),
        nearByStoreLink: t("kf.pdp.label.nearByStoreLink"),
        professionalService: (_professionalService = authorData.professionalService) !== null && _professionalService !== void 0 ? _professionalService : t("kf.pdp.label.professionalService"),
        installationHelp: (_installationHelp = authorData.installationHelp) !== null && _installationHelp !== void 0 ? _installationHelp : t("kf.pdp.label.installationHelp"),
        installationAvailable: t("kf.pdp.label.installationAvailable"),
        installerArea: (_installerArea = authorData.installerArea) !== null && _installerArea !== void 0 ? _installerArea : t("kf.pdp.label.installerArea"),
        sameCategory: t("kf.compare.validation.sameCategory"),
        maxProduct: (_maxProducts = authorData.maxProducts) !== null && _maxProducts !== void 0 ? _maxProducts : t("kf.compare.validation.maxProducts"),
        itemAdded: t("kf.pdp.label.itemAdded"),
        itemsAdded: t("kf.pdp.label.itemsAdded"),
        yourCart: t("kf.pdp.label.yourCart"),
        selectMoreOptions: t("kf.pdp.label.selectMoreOptions"),
        productOptions: (_superskulabel = authorData.superskulabel) !== null && _superskulabel !== void 0 ? _superskulabel : t("kf.pdp.label.productOptions"),
        priceFootnoteTitle: (_priceFootnoteTitle = authorData.priceFootnoteTitle) !== null && _priceFootnoteTitle !== void 0 ? _priceFootnoteTitle : t("kf.pdp.label.priceFootnoteTitle"),
        priceFootnote: (_priceFootnote = authorData.priceFootnote) !== null && _priceFootnote !== void 0 ? _priceFootnote : t("kf.pdp.label.priceFootnote"),
        colorFootnoteTitle: (_colorFootnoteTitle = authorData.colorFootnoteTitle) !== null && _colorFootnoteTitle !== void 0 ? _colorFootnoteTitle : t("kf.pdp.label.colorFootnoteTitle"),
        colorFootnote: (_colorFootnote = authorData.colorFootnote) !== null && _colorFootnote !== void 0 ? _colorFootnote : t("kf.pdp.label.colorFootnote"),
        discontinueProductMsg: (_discontinueProductMsg = authorData.discontinueProductMsg) !== null && _discontinueProductMsg !== void 0 ? _discontinueProductMsg : t("kf.pdp.label.discontinueProductMsg"),
        discontinueColorMsg: (_discontinueColorMsg = authorData.discontinueColorMsg) !== null && _discontinueColorMsg !== void 0 ? _discontinueColorMsg : t("kf.pdp.label.discontinueColorMsg"),
        itemReqCTA: (_onPdpCtaLabel = authorData.onPdpCtaLabel) !== null && _onPdpCtaLabel !== void 0 ? _onPdpCtaLabel : t("kf.pdp.label.itemReqCTA"),
        mustItemCTA: t("kf.pdp.label.mustItemCTA"),
        editItemReqCTA: authorData.onPdpCtaLabel ? "".concat(t("kf.pdp.label.edit"), " ").concat(authorData.onPdpCtaLabel) : t("kf.pdp.label.editItemReqCTA"),
        colorOrFinish: (_colorOrFinish = authorData.colorOrFinish) !== null && _colorOrFinish !== void 0 ? _colorOrFinish : t("kf.pdp.label.colorOrFinish"),
        outOfStockMsg: authorData.outofStockDesc,
        outOfStock: (_outofStockTitle = authorData.outofStockTitle) !== null && _outofStockTitle !== void 0 ? _outofStockTitle : t("kf.pdp.label.outOfStockMsg"),
        notifyMailCTA: t("kf.pdp.label.notifyMailCTA"),
        noEmailCTA: (_noEmailCTA = authorData.noEmailCTA) !== null && _noEmailCTA !== void 0 ? _noEmailCTA : t("kf.pdp.label.noEmailCTA"),
        createLeadCTA: t("kf.pdp.label.createLeadCTA"),
        nonSellable: (_nonSellable = authorData.nonSellable) !== null && _nonSellable !== void 0 ? _nonSellable : t("kf.pdp.label.nonSellable"),
        nonSellableMsg: t("kf.pdp.label.nonSellableMsg"),
        leadSuccessTxt: t("kf.pdp.lead.leadSuccessTxt"),
        leadSuccessMsg: authorData.leadSuccessMsg ? authorData.leadSuccessMsg : t("kf.pdp.lead.leadSuccessMsg"),
        welcomeMsg: (_welcomeMsg = authorData.welcomeMsg) !== null && _welcomeMsg !== void 0 ? _welcomeMsg : t("kf.pdp.label.welcomeMsg"),
        discontinuedTxt: t("kf.pdp.label.discontinuedTxt"),
        compareTxt: t("kf.pdp.label.compareTxt"),
        favTxt: t("kf.pdp.label.favTxt"),
        projectTxt: t("kf.pdp.label.projectTxt"),
        findItemCTA: t("kf.pdp.label.findItemCTA"),
        availColorCTA: authorData.discontinuePartialCtaLabel ? authorData.discontinuePartialCtaLabel : t("kf.pdp.label.availColorCTA"),
        notifyEmailTxt: t("kf.pdp.label.notifyEmailTxt"),
        notifyEmailOosTxt: t("kf.pdp.label.notifyEmailOosTxt"),
        findLocalStore: (_findLocalStore = authorData.findLocalStore) !== null && _findLocalStore !== void 0 ? _findLocalStore : t("kf.pdp.label.findLocalStore"),
        toCheckAvailability: t("kf.pdp.label.toCheckAvailability"),
        backOrder: (_backOrder = authorData.backOrder) !== null && _backOrder !== void 0 ? _backOrder : t("kf.pdp.label.backOrder"),
        specialOrder: (_specialOrder = authorData.specialOrder) !== null && _specialOrder !== void 0 ? _specialOrder : t("kf.pdp.label.specialOrder"),
        discontinuedColor: (_discontinueColorLabel = authorData.discontinueColorLabel) !== null && _discontinueColorLabel !== void 0 ? _discontinueColorLabel : t("kf.pdp.label.discontinuedColor"),
        discontinuedColorFinish: (_discontinueColorFinishLabel = authorData.discontinueColorFinishLabel) !== null && _discontinueColorFinishLabel !== void 0 ? _discontinueColorFinishLabel : t("kf.pdp.label.discontinuedColorFinish"),
        toolTip: t("kf.pdp.label.toolTip"),
        requiredProductTitle: (_modalRightSectionTitle = authorData.modalRightSectionTitle) !== null && _modalRightSectionTitle !== void 0 ? _modalRightSectionTitle : t("kf.pdp.label.requiredProductTitle"),
        requiredProductDescription: (_modalRightSectionDesc = authorData.modalRightSectionDesc) !== null && _modalRightSectionDesc !== void 0 ? _modalRightSectionDesc : t("kf.pdp.label.requiredProductDescription"),
        productText: t("kf.pdp.label.productText"),
        includesText: t("kf.pdp.label.includesText"),
        includeTextCTA: (_modalRighttSectionCtaLabel = authorData.modalRighttSectionCtaLabel) !== null && _modalRighttSectionCtaLabel !== void 0 ? _modalRighttSectionCtaLabel : t("kf.pdp.label.includeTextCTA"),
        title: (_modalLeftSectionTitle = authorData.modalLeftSectionTitle) !== null && _modalLeftSectionTitle !== void 0 ? _modalLeftSectionTitle : t("kf.pdp.label.title"),
        remove: t("kf.pdp.label.remove"),
        tooltipMsg: (_onPdpTooltip = authorData.onPdpTooltip) !== null && _onPdpTooltip !== void 0 ? _onPdpTooltip : t("kf.pdp.label.tooltipMsg"),
        priceSpiderTitle: (_priceSpiderTitle = authorData.priceSpiderTitle) !== null && _priceSpiderTitle !== void 0 ? _priceSpiderTitle : t("kf.pdp.label.priceSpiderTitle"),
        primaryTxt: (_oversizeMsgTitle = authorData.oversizeMsgTitle) !== null && _oversizeMsgTitle !== void 0 ? _oversizeMsgTitle : t("kf.pdp.label.alert.primaryMsg"),
        secondaryTxt: (_oversizeMsgDesc = authorData.oversizeMsgDesc) !== null && _oversizeMsgDesc !== void 0 ? _oversizeMsgDesc : t("kf.pdp.label.alert.secondaryMsg"),
        withoutPriceTxt: (_noPriceMsg = authorData.noPriceMsg) !== null && _noPriceMsg !== void 0 ? _noPriceMsg : t("kf.pdp.label.withoutPriceTxt"),
        projectPackMssg: authorData.projectPackMssg ? authorData.projectPackMssg : t("kf.pdp.label.projectPackMssg"),
        qtyMoreThanStock: t("kf.pdp.label.qtyMoreThanStock"),
        associatePrice: t("kf.pdp.label.associatePrice"),
        friendsFamilyPrice: t("kf.pdp.label.friendsFamilyPrice"),
        listPriceInfo: (_listpricetooltip = authorData.listpricetooltip) !== null && _listpricetooltip !== void 0 ? _listpricetooltip : t("kf.pdp.label.listPriceInfo"),
        favSuccessMsg: t("kf.favorites.success"),
        favErrorMsg: t("kf.favorites.error"),
        installationTitle: t("kf.pdp.label.installationTitle"),
        nearestService: (_subCopy = authorData.subCopy) !== null && _subCopy !== void 0 ? _subCopy : t("kf.pdp.label.nearestService"),
        nearestInPerson: (_subCopy1 = authorData.subCopy) !== null && _subCopy1 !== void 0 ? _subCopy1 : t("kf.pdp.label.nearestInPerson"),
        edit: t("kf.pdp.label.edit"),
        change: t("kf.pdp.label.change"),
        eligibleZipCodeSuccess: (_serviceavailable = authorData.serviceavailable) !== null && _serviceavailable !== void 0 ? _serviceavailable : t("kf.pdp.label.eligibleZipCodeSuccess"),
        eligibleZipCodeError: (_errorMessage = authorData.errorMessage) !== null && _errorMessage !== void 0 ? _errorMessage : t("kf.pdp.label.eligibleZipCodeError"),
        findaPro: t("kf.pdp.label.findaPro"),
        zipcode: t("kf.pdp.label.zipcode"),
        checkAvailability: t("kf.pdp.label.checkAvailability"),
        zipCodeGuidText: t("kf.pdp.label.zipCodeGuidText"),
        update: t("kf.pdp.label.updateBtn"),
        search: t("kf.pdp.label.searchBtn"),
        forText: t("kf.pdp.label.forText"),
        pincodeLabel: t("kf.pdp.label.pincode"),
        serviceDesc: t("kf.pdp.label.serviceDesc"),
        installServiceAvailableMsg: t("kf.pdp.label.installServiceAvailableMsg"),
        installServiceNotAvailableMsg: t("kf.pdp.label.installServiceNotAvailableMsg"),
        installServiceNotAvailableforProductMsg: t("kf.pdp.label.installServiceNotAvailableforProductMsg"),
        notDeliverErrorMsg: t("kf.pdp.label.notDeliverErrorMsg"),
        notDeliverBundleMsg: t("kf.pdp.label.notDeliverBundleErrorMsg"),
        pincodeApiFailMsg: t("kf.pdp.label.pincodeApiFailMsg"),
        serviceTitle: t("kf.pdp.label.serviceTitle"),
        eta: (params)=>t("kf.pdp.label.eta", params),
        etaMessage: (params)=>t("kf.pdp.label.etaMessage", params),
        installServiceAvailableDesc: (params)=>t("kf.pdp.label.installServiceAvailableDesc", params),
        memberShipPrice: t("kf.pdp.label.memberShipPrice"),
        bathroomDesignService: t("kf.pdp.label.bathroomDesignService"),
        maxInventory: t("kf.pdp.label.maxInventory"),
        zipcodeEmptyError: (_zipcodevalidationmessage = authorData.zipcodevalidationmessage) !== null && _zipcodevalidationmessage !== void 0 ? _zipcodevalidationmessage : t("kf.pdp.label.zipcodeEmptyError"),
        validZipcode: (_zipcodevalidationmessage1 = authorData.zipcodevalidationmessage) !== null && _zipcodevalidationmessage1 !== void 0 ? _zipcodevalidationmessage1 : t("kf.pdp.label.validZipcode"),
        percentOff: t("kf.pdp.label.percentOff"),
        serviceItemAdded: t("kf.pdp.label.serviceItemAdded"),
        serviceItemsAdded: t("kf.pdp.label.serviceItemsAdded"),
        serviceParts: t("kf.pdp.label.serviceParts"),
        outOfStockError: authorData.invalidEmailMessage ? authorData.invalidEmailMessage : t("kf.pdp.error.outOfStock"),
        successTxt: t("kf.pdp.outOfStock.successTxt"),
        successMsg: authorData.outofStockConfirmMsg ? authorData.outofStockConfirmMsg : t("kf.pdp.outOfStock.thankMsg"),
        thanksMessage: t("kf.pdp.outOfStock.thanksMessage"),
        doneCTA: t("kf.pdp.outOfStock.doneCTA"),
        new: (_new = badgeText.new) !== null && _new !== void 0 ? _new : t("kf.plp.label.new"),
        sale: (_onSale = badgeText.onSale) !== null && _onSale !== void 0 ? _onSale : t("kf.plp.label.onSale"),
        exclusive: (_exclusive = badgeText.exclusive) !== null && _exclusive !== void 0 ? _exclusive : t("kf.plp.label.exclusive"),
        newExclusive: t("kf.plp.label.newExclusive"),
        discontinued: badgeText.discontinued ? badgeText.discontinued : t("kf.plp.label.discontinued"),
        shippingTitle: (_shippingTitle = authorData.shippingTitle) !== null && _shippingTitle !== void 0 ? _shippingTitle : t("kf.pdp.label.alert.shippingRestrictions"),
        shippingDescription: (_shippingDescription = authorData.shippingDescription) !== null && _shippingDescription !== void 0 ? _shippingDescription : t("kf.pdp.label.alert.shippingRestrictionsDesc"),
        ariaLabel: {
            serviceAddToCart: t("kf.pdp.aria.label.addServiceToCart"),
            serviceLearnMore: t("kf.pdp.aria.label.serviceLearnMore"),
            designServiceAddToCart: t("kf.pdp.aria.label.addDesignServiceToCart"),
            designServiceLearnMore: t("kf.pdp.aria.label.designServiceLearnMore"),
            addProductToCart: t("kf.pdp.aria.label.addProductToCart", {
                name
            }),
            addProductService: t("kf.pdp.aria.label.addProductService", {
                name
            }),
            print: t("kf.pdp.label.aria.print", {
                productName: name
            }),
            share: t("kf.pdp.label.aria.share", {
                productName: name
            }),
            currentPage: t("kf.pdp.label.aria.currentPage"),
            page: t("kf.pdp.label.aria.page"),
            breadcrumb: t("kf.pdp.label.aria.breadcrumb")
        },
        outOfStockErr: (_modalRightSectionNoStockMsg = authorData.modalRightSectionNoStockMsg) !== null && _modalRightSectionNoStockMsg !== void 0 ? _modalRightSectionNoStockMsg : t("kf.pdp.label.reqItem.err.outOfStockErrMsg"),
        removeItem: t("kf.favorites.removeItem"),
        removeItemError: t("kf.favorites.removeItemError"),
        backInStock: t("kf.pdp.label.backInStock"),
        notApplicable: t("kf.pdp.label.notApplicable"),
        partNumber: t("kf.pdp.label.partNumber"),
        partName: t("kf.pdp.label.partName"),
        descReadMore: t("kf.pdp.label.descReadMore"),
        productAccordionText: {
            features: t("kf.pdp.label.features"),
            specs: t("kf.pdp.label.specs"),
            addOnServices: t("kf.pdp.label.addOnServices"),
            technologies: t("kf.pdp.label.technology"),
            productDetails: t("kf.pdp.label.productDetails"),
            material: t("kf.pdp.label.material"),
            installation: t("kf.pdp.label.installation"),
            hydrotherapy: t("kf.pdp.label.hydrotherapy"),
            rebates: t("kf.pdp.label.rebates"),
            props65Warning: t("kf.pdp.label.props65Warning"),
            selectAll: t("kf.technical.label.selectAll"),
            download: t("kf.technical.label.download"),
            installationSupport: t("kf.pdp.label.installationSupport"),
            designFiles: t("kf.technical.label.designFiles"),
            technicalInfo: t("kf.technical.label.technicalInfo"),
            file: t("kf.technical.label.file"),
            files: t("kf.technical.label.files"),
            specsSheet: t("kf.technical.label.specsSheet"),
            guides: t("kf.technical.label.guides"),
            installVideo: t("kf.technical.label.installVideo"),
            helpfulLinks: authorData.sectionHeading ? authorData.sectionHeading : t("kf.technical.label.helpfulLinks"),
            envDeclaration: t("kf.technical.label.envDeclaration"),
            installationGuide: t("kf.technical.label.installationGuide"),
            installationVideo: t("kf.technical.label.installationVideo"),
            userGuide: t("kf.technical.label.userGuide"),
            homeOwnerGuide: t("kf.technical.label.homeOwnerGuide"),
            homeOwnerGuideWithoutSPPDF: t("kf.technical.label.homeOwnerGuideWithoutSPPDF"),
            declareLabel: t("kf.technical.label.declareLabel"),
            tearSheet: t("kf.technical.label.tearSheet"),
            quickReference: t("kf.technical.label.quickReference"),
            warranty: t("kf.technical.label.warranty"),
            serviceParts: t("kf.technical.label.serviceParts"),
            twoDplan: t("kf.technical.label.twoDplan"),
            twoDside: t("kf.technical.label.twoDside"),
            twoDfront: t("kf.technical.label.twoDfront"),
            threeDfile: t("kf.technical.label.threeDfile"),
            bimFile: t("kf.technical.label.bimFile"),
            cutoutTemplate: t("kf.technical.label.cutoutTemplate"),
            partsDiagram: t("kf.pdp.label.partsDiagram"),
            installationGuidesSubTitle: t("kf.technical.label.installationGuidesSubTitle"),
            supportSubTitle: t("kf.technical.label.supportSubTitle"),
            icon: t("kf.technical.label.icon"),
            pdf: t("kf.literature.aria.label.pdf"),
            video: t("kf.technical.label.video"),
            viewMore: t("kf.pdp.label.viewMore"),
            additionalInfo: {
                title: t("kf.pdp.addInfo.title"),
                productCode: t("kf.pdp.addInfo.productCode"),
                countryOfOrigin: t("kf.pdp.addInfo.countryOfOrigin"),
                dimensions: t("kf.pdp.addInfo.dimensions"),
                manufacturedBy: t("kf.pdp.addInfo.manufacturedBy"),
                qty: t("kf.pdp.addInfo.qty"),
                package: t("kf.pdp.addInfo.package"),
                contact: t("kf.pdp.addInfo.contact"),
                disclaimer: t("kf.pdp.addInfo.disclaimer"),
                oneUnit: t("kf.pdp.addInfo.oneUnit"),
                customerCare: (_customerCare = authorData.customerCare) !== null && _customerCare !== void 0 ? _customerCare : "",
                disclaimerMsg: (_disclaimer = authorData.disclaimer) !== null && _disclaimer !== void 0 ? _disclaimer : t("kf.pdp.addInfo.disclaimerMsg"),
                spareParts: t("kf.pdp.addInfo.spareParts"),
                sparePartsMsg: (_sparepartsinfolabel = authorData.sparepartsinfolabel) !== null && _sparepartsinfolabel !== void 0 ? _sparepartsinfolabel : t("kf.pdp.addInfo.sparePartsMsg"),
                importedBy: (_importedbylabel = authorData.importedbylabel) !== null && _importedbylabel !== void 0 ? _importedbylabel : t("kf.pdp.addInfo.importedBy")
            },
            policies: {
                title: t("kf.pdp.policies.title"),
                returnTitle: t("kf.pdp.policies.returnTitle"),
                returnDesc: t("kf.pdp.policies.returnDesc"),
                findMore: t("kf.pdp.policies.findMore"),
                warrantyTitle: t("kf.pdp.policies.warrantyTitle"),
                warrantyDesc: t("kf.pdp.policies.warrantyDesc")
            }
        },
        baseProduct: t("kf.pdp.label.baseProduct"),
        subTotal: t("kf.pdp.label.subTotal"),
        requiredItems: t("kf.pdp.label.requiredItems"),
        requiredItemsProduct: t("kf.pdp.label.productRequiredItem"),
        requiredItemsPrice: t("kf.pdp.label.priceRequiredItem"),
        emailAddress: t("kf.checkout.label.emailAddress"),
        name: t("kf.pdp.label.username"),
        phoneNumber: t("kf.leadGeneration.phoneNumber"),
        pincode: t("kf.pdp.notifyme.label.pincode"),
        validEmail: t("kf.pdp.label.validEmail"),
        validName: t("kf.pdp.label.validName"),
        validPhoneNumber: t("kf.pdp.label.validPhoneNumber"),
        validPincode: t("kf.pdp.label.invalidPincode"),
        inclusiveOfAllTaxes: t("kf.pdp.label.inclusiveOfAllTaxes"),
        findStore: t("kf.global.label.findStore"),
        productEnquiry: t("kf.pdp.productEnquiry"),
        shopKohler: t("kf.pdp.shopKohler"),
        brandsDiscontinuedMsg: t("kf.pdp.discontinued.msg"),
        itemDiscontinuedMsg: t("kf.pdp.itemDiscontinued.msg"),
        alternativeAvailableMsg: t("kf.pdp.alternativeAvailable.msg"),
        alternativeOptionAvailableMsg: t("kf.pdp.alternativeOptionAvailable.msg"),
        completeSolution: t("kf.pdp.completeSolution"),
        items: t("kf.pdp.items"),
        total: t("kf.pdp.total"),
        viewRemaining: t("kf.pdp.viewRemaining"),
        discount: t("kf.pdp.discount"),
        // spendSaveDescription: params =>
        //   t("kf.pdp.label.spendSaveDescription", params),
        spendSaveDescription: t("kf.pdp.label.spendSaveDescription"),
        noCostEmi: t("kf.pdp.noCostEmi"),
        tc: t("kf.pdp.label.tc"),
        mrp: t("kf.pdp.label.mrp")
    };
    return i18n;
};
/* harmony default export */ __webpack_exports__["Z"] = (usePdpi18n);


/***/ }),

/***/ 75058:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ getFindAStoresResult; },
/* harmony export */   "T": function() { return /* binding */ getAutoSuggestionsInputBased; }
/* harmony export */ });
/* harmony import */ var _constants_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73350);

const getFindAStoresResult = function() {
    let url = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", address = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", brand = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", disMiles = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 100, maxStorePerPage = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 10, locationType = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : "", page = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : 1, sku = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : "";
    const params = {
        address,
        brand: brand.toLowerCase(),
        disMiles,
        maxItemPerPage: maxStorePerPage,
        locationType: locationType.toLowerCase(),
        page
    };
    if (sku) params["sku"] = sku;
    return _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.get */ .TH.get(url, {
        params
    });
};
const getAutoSuggestionsInputBased = function() {
    let url = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", brand = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", input = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
    return _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.get */ .TH.get(url, {
        params: {
            $format: "json",
            brand: brand.toLowerCase(),
            $select: "Locality",
            $filter: "StartsWith(Locality,'".concat(input, "') eq true")
        }
    });
};


/***/ }),

/***/ 96005:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73935);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9473);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _components_core_Modal_Modal__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(95357);
/* harmony import */ var _components_Shared_ProductSocialShare_v1_ProductSocialShare__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(13678);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(19514);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(34326);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(20558);
/* harmony import */ var _store_features_genericSlice__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(88751);












const PartsViewer = (param)=>{
    let { page ="" , i18n ={} , productId ="" , partId ="" , analyticsCustomData =null , onClose , showModal =false  } = param;
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useDispatch */ .I0)();
    const iframeRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
    const [svgViewerPath, setSvgViewerPath] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [currencySign, setCurrencySign] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [general, setGeneral] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const [plpServletPath, setPlpServletPath] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const [salesChannelConfig, setSalesChannelConfig] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({});
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        (0,_constants_config__WEBPACK_IMPORTED_MODULE_8__/* .getConfig */ .i)().then(async (config)=>{
            var ref;
            const svgViewerPath = await (0,_utils_helper__WEBPACK_IMPORTED_MODULE_9__.getShortenedUrl)(lodash_get__WEBPACK_IMPORTED_MODULE_4___default()(config, "general.svgViewerPath", ""));
            var ref1;
            setSalesChannelConfig((ref1 = config === null || config === void 0 ? void 0 : (ref = config.salesChannelConfig) === null || ref === void 0 ? void 0 : ref.map) !== null && ref1 !== void 0 ? ref1 : {});
            const currencySign = lodash_get__WEBPACK_IMPORTED_MODULE_4___default()(config, "internationalization.currencySign", "");
            setCurrencySign(currencySign);
            setSvgViewerPath(svgViewerPath);
            setGeneral(config.general);
            setPlpServletPath(config.plpServletPath);
        });
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (showModal) {
            (0,_utils_helper__WEBPACK_IMPORTED_MODULE_9__.preventBodyScroll)(true);
        }
    }, [
        showModal
    ]);
    const persona = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_9__.getUserPersona)();
    const [showShare, setShowShare] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const getPDPUrlForViewer = (category, slug)=>{
        const pdpdUrl = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_9__.getPDPUrlWithConfig)(category, slug, plpServletPath, general);
        return pdpdUrl;
    };
    const addToCartTrigger = async (data)=>{
        const actions = [];
        data.forEach((product)=>{
            var ref;
            const fields = {
                salesChannel: (ref = salesChannelConfig[product === null || product === void 0 ? void 0 : product.brand]) !== null && ref !== void 0 ? ref : "KOUS"
            };
            actions.push({
                action: product.isBundle ? "addbundle" : "addLineItem",
                sku: product.sku,
                quantity: product.quantity,
                custom: {
                    type: {
                        key: "lineItemShipping"
                    },
                    fields: fields
                }
            });
        });
        const reqData = {};
        reqData["actions"] = actions;
        const cartObj = dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_11__/* .searchPlp */ .tK)(reqData)).unwrap().then((res)=>{
            const respVal = {};
            respVal.status = 200;
            return respVal;
        }).catch((err)=>{
            const respVal = {};
            respVal.status = 500;
            return respVal;
        }) || {};
        return cartObj;
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (currencySign !== "" && persona && plpServletPath && !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_5___default()(general)) {
            var ref;
            window.partViewer = {
                atc: addToCartTrigger,
                getPDPUrl: getPDPUrlForViewer,
                persona,
                currencySign,
                setShowShare
            };
            (ref = iframeRef.current) === null || ref === void 0 ? void 0 : ref.focus();
            return ()=>(0,_utils_helper__WEBPACK_IMPORTED_MODULE_9__.preventBodyScroll)(false);
        }
    }, [
        currencySign,
        persona,
        general
    ]);
    const filename = (0,_utils__WEBPACK_IMPORTED_MODULE_10__/* .getExtention */ .fN)(partId) ? partId : partId + ".svg";
    const closeModal = ()=>{
        (0,_utils_helper__WEBPACK_IMPORTED_MODULE_9__.preventBodyScroll)(false);
        onClose();
    };
    const getPartDiagramCloseEventInfo = JSON.stringify({
        eventAction: page + ":modal:interactive parts diagram:close",
        eventName: page + ":modal:interactive parts diagram:close",
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "close",
        internalLinkPosition: page,
        internalLinkType: page + ":close",
        internalLinkZoneName: page + ":modal:interactive parts diagram",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_core_Modal_Modal__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        showModal: showModal,
        onModalClose: closeModal,
        closeButtonAnalytics: getPartDiagramCloseEventInfo,
        analyticsCustomData: analyticsCustomData || null,
        children: [
            svgViewerPath && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("iframe", {
                id: "svg-viewer-iframe",
                ref: iframeRef,
                allowFullScreen: true,
                scrolling: "auto",
                src: "".concat(svgViewerPath, "?productId=").concat(productId, "&filename=").concat(filename, "&diagram=0&origin=").concat(window.location.href)
            }),
            showShare && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PartSocialShare, {
                showShare: showShare,
                setShowShare: setShowShare,
                iframeId: "svg-viewer-iframe",
                i18n: i18n,
                iframeRef: iframeRef.current
            })
        ]
    });
};
const PartSocialShare = (param)=>{
    let { showShare , setShowShare , iframeId , i18n , iframeRef  } = param;
    return /*#__PURE__*/ react_dom__WEBPACK_IMPORTED_MODULE_2__.createPortal(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Shared_ProductSocialShare_v1_ProductSocialShare__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
        showModal: showShare,
        id: "social-share-iframe",
        onClose: ()=>setShowShare(false),
        iframeId: iframeId,
        iframeRef: iframeRef,
        disableInstagram: true,
        mailSubject: i18n.mailSubject,
        mailBody: i18n.mailBody
    }), iframeRef.contentDocument.getElementById("social-share-gbh"));
};
/* harmony default export */ __webpack_exports__["Z"] = (PartsViewer);


/***/ }),

/***/ 92762:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9473);
/* harmony import */ var _components_AemGrid__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72960);
/* harmony import */ var _store_features_pdpSlice__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(44561);





const ProductExf = ()=>{
    const { teaserContent =[]  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(_store_features_pdpSlice__WEBPACK_IMPORTED_MODULE_4__/* .selectPdpState */ .BY);
    return teaserContent.length ? teaserContent.map((item, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "exfpdp",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "xfpage",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_AemGrid__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    data: item,
                    count: 0
                })
            })
        }, "".concat(item["title"], "-").concat(index))) : null;
};
/* harmony default export */ __webpack_exports__["Z"] = (ProductExf);


/***/ }),

/***/ 38279:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ VideoWrapper_VideoWrapper; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./public/icons/youtube-play.svg
/* harmony default export */ var youtube_play = ({"src":"/_next/static/media/youtube-play.fcf5eeeb.svg","height":64,"width":64});
// EXTERNAL MODULE: ./node_modules/react-youtube/dist/YouTube.esm.js
var YouTube_esm = __webpack_require__(13913);
;// CONCATENATED MODULE: ./src/components/VideoWrapper/VideoWrapper.jsx




const waitTimeForResetingIsClick = 500;
const VideoWrapper = (props)=>{
    const { videoId ="" , thumb ="" , height ="100%" , width =0 , alt ="image" , playThumb =false , onClick =()=>{}  } = props;
    const addAnalyticsData = (type, event)=>{
        const { adobeDataLayer: { getState  } = {}  } = window;
        const { videoTitle ="" , title =""  } = event === null || event === void 0 ? void 0 : event.target;
        const videoName = type === "fullscreen" ? title : videoTitle;
        const page = getState && getState("page") || {};
        const { imageSequence  } = props;
        const eventInfo = {
            eventAction: "pdp:product details:carousel image click:video ".concat(type),
            eventName: "pdp:product details:carousel image click:video ".concat(type),
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: "video ".concat(type),
            internalLinkPosition: "pdp",
            internalLinkType: "pdp:video navigation",
            internalLinkZoneName: "pdp:product details",
            internalLinkURL: "n/a",
            videoId,
            clickInternalLinks: "true",
            imageSequence,
            videoName
        };
        window.adobeDataLayer.push({
            event: "cmp:click",
            eventInfo,
            page
        });
    };
    const youtubePlayerPayload = {
        height,
        width,
        videoId,
        playerVars: {
            rel: 0,
            frameBorder: 0,
            allowFullScreen: true
        }
    };
    const videoFullScreenCallback = (event)=>{
        if (window.isClick === true) {
            return;
        }
        window.isClick = true;
        setTimeout(()=>{
            delete window.isClick;
        }, waitTimeForResetingIsClick);
        if (document.webkitIsFullScreen || document.mozFullScreen || document.fullScreen) {
            if (event.target.tagName === "IFRAME") {
                addAnalyticsData("fullscreen", event);
            }
        }
    };
    (0,react.useEffect)(()=>{
        document.addEventListener("fullscreenchange", videoFullScreenCallback);
        document.addEventListener("webkitfullscreenchange", videoFullScreenCallback);
    }, []);
    return thumb || playThumb ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                role: "button",
                onClick: ()=>playThumb && onClick(videoId),
                src: "https://i.ytimg.com/vi/".concat(videoId, "/").concat(playThumb ? "hqdefault" : "default", ".jpg"),
                alt: alt,
                tabIndex: 0,
                className: "img-fluid"
            }),
            playThumb && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: youtube_play === null || youtube_play === void 0 ? void 0 : youtube_play.src,
                onClick: ()=>onClick(videoId),
                className: "img-play-button",
                alt: alt
            }),
            " "
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(YouTube_esm/* default */.Z, {
        videoId: videoId,
        opts: youtubePlayerPayload,
        onPlay: (e)=>addAnalyticsData("play", e),
        onEnd: (e)=>addAnalyticsData("complete", e),
        className: "pdp-image-reel__image-list pdp-image-reel__modal-image"
    });
};
/* harmony default export */ var VideoWrapper_VideoWrapper = (VideoWrapper);


/***/ }),

/***/ 46760:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29238);
/* harmony import */ var isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_3__);




const NextHead = (param)=>{
    let { title ="" , description ="" , templateName ="" , fullUrl ="" , psKey ="" , psCountry ="" , psLanguage ="" , pageUrl ="" , metaLanguage ="" , pdpData: { ProductBrandName_s: productName = "" , productName_s: partsName = "" , ProductDescriptionProductShort_s: productDescription = "" , "Color.SKU.Details_ss": skuDetails = []  } = {} , initialImageFullUrl ="" , isPart =false , skuId ="" , siteName =""  } = param;
    var ref;
    const selectedSkuDetails = (ref = skuDetails === null || skuDetails === void 0 ? void 0 : skuDetails.find((item)=>item.includes(skuId))) !== null && ref !== void 0 ? ref : "";
    var ref1;
    const selectSkuList = (ref1 = selectedSkuDetails === null || selectedSkuDetails === void 0 ? void 0 : selectedSkuDetails.split("|")) !== null && ref1 !== void 0 ? ref1 : [];
    var ref2;
    const selectedSku = (ref2 = selectSkuList[selectSkuList.length - 1]) !== null && ref2 !== void 0 ? ref2 : "";
    const productSchema = {
        "@context": "https://schema.org",
        "@type": "Product",
        "@id": fullUrl,
        additionalType: isPart ? "Service Part" : "",
        name: isPart ? partsName : productName,
        image: initialImageFullUrl,
        description: productDescription,
        sku: selectedSku,
        brand: {
            "@type": "Brand",
            name: siteName
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: [
            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: title
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "keywords",
                content: "Kohler US Plumbing Bathroom Kitchen"
            }),
            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: description
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: description
                    })
                ]
            }),
            pageUrl ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: pageUrl
            }) : null,
            templateName ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: templateName
            }) : null,
            metaLanguage ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:locale",
                content: metaLanguage === null || metaLanguage === void 0 ? void 0 : metaLanguage.toLocaleLowerCase()
            }) : null,
            fullUrl ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: fullUrl
            }) : null,
            psKey ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "ps-key",
                content: psKey
            }) : null,
            psCountry ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "ps-country",
                content: psCountry
            }) : null,
            psLanguage ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "ps-language",
                content: psLanguage
            }) : null,
            productName || partsName ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_3___default().sanitize(JSON.stringify(productSchema))
                }
            }, "structured-data") : null
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (NextHead);


/***/ }),

/***/ 58589:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ getToken; },
/* harmony export */   "S": function() { return /* binding */ downloadFile; }
/* harmony export */ });
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55111);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19514);



const downloadFile = (path, accessToken)=>{
    return new Promise(async (resolve, reject)=>{
        try {
            const response = await axios__WEBPACK_IMPORTED_MODULE_0___default().get("".concat(_constants__WEBPACK_IMPORTED_MODULE_1__.apiBaseUrl).concat(_constants__WEBPACK_IMPORTED_MODULE_1__.downloadFileURL, "?fileName=").concat(path), {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer ".concat(accessToken)
                },
                responseType: "blob"
            });
            resolve(response);
        } catch (error) {
            reject(error);
        }
    });
};
const getToken = async ()=>{
    return new Promise(async (resolve, reject)=>{
        try {
            const response = await axios__WEBPACK_IMPORTED_MODULE_0___default().post("".concat(_constants__WEBPACK_IMPORTED_MODULE_1__.apiBaseUrl).concat(_constants__WEBPACK_IMPORTED_MODULE_1__.oktaTokenEndpoint, "?scope=guest&channel=india"));
            resolve(response);
        } catch (error) {
            reject(error);
        }
    });
};


/***/ }),

/***/ 98185:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"addToCartWrapper":"AddToCart_addToCartWrapper__XoveX"};

/***/ }),

/***/ 24064:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"catalogCtaWrapper":"CatalogCTA_catalogCtaWrapper__EYdF5"};

/***/ }),

/***/ 47848:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"pdpInstallServiceWrapper":"InstallService_pdpInstallServiceWrapper__B_Xuh"};

/***/ }),

/***/ 61184:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"pdpRequiredItemModalWrapper":"PDPRequiredItemModal_pdpRequiredItemModalWrapper__SYOuq"};

/***/ }),

/***/ 92555:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"productAccordionListWrapper":"ProductAccordionList_productAccordionListWrapper__xrgw8"};

/***/ }),

/***/ 14427:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"productDetailsV3Wrapper":"productDetailsView_productDetailsV3Wrapper__IsX6B"};

/***/ }),

/***/ 27003:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"pdpServiceAvailabilityWrapper":"ServiceAvailability_pdpServiceAvailabilityWrapper__PDj5C"};

/***/ }),

/***/ 2819:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"pdpStickyHeadWrapper":"StickyHeader_pdpStickyHeadWrapper__IJA5F"};

/***/ }),

/***/ 46665:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"reviewContainer":"review_reviewContainer__od0Tn"};

/***/ }),

/***/ 21901:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"bundleList":"bundle-list_bundleList__hibTc"};

/***/ }),

/***/ 14804:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"addAnInstallationWrapper":"AddanInstallation_addAnInstallationWrapper__uzWno"};

/***/ }),

/***/ 35825:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"designServicesWrapper":"DesignServices_designServicesWrapper__cKWP1"};

/***/ }),

/***/ 41415:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"moreFromCollectionWrapper":"MoreFromCollection_moreFromCollectionWrapper__s8um3"};

/***/ }),

/***/ 49262:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"optionsSelectorWrapper":"OptionsSelector_optionsSelectorWrapper__BWQpN"};

/***/ }),

/***/ 76631:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"videoModalWrapper":"VideoWrapper_videoModalWrapper__gqgn2"};

/***/ })

}]);